
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire49d7"];
var parcelRegister = parcelRequire.register;
parcelRegister("8vvws", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "FiltersDirectory", () => $f91671c8355d1d34$export$c47481051d3723fd);
$parcel$export(module.exports, "default", () => $f91671c8355d1d34$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");
parcelRequire("3avtZ");

var $hVCgF = parcelRequire("hVCgF");

var $dFtHW = parcelRequire("dFtHW");

var $790bS = parcelRequire("790bS");

var $6UU7v = parcelRequire("6UU7v");

var $jBMV2 = parcelRequire("jBMV2");

var $fmhfo = parcelRequire("fmhfo");

var $akiS9 = parcelRequire("akiS9");

var $lvKO5 = parcelRequire("lvKO5");

var $16sa1 = parcelRequire("16sa1");

var $eJrcF = parcelRequire("eJrcF");
var $jJaSe = parcelRequire("jJaSe");

var $iQ6JJ = parcelRequire("iQ6JJ");
const $f91671c8355d1d34$var$useFiltersDirectoryResource = (0, $6UU7v.withSuspense)(()=>(0, $eJrcF.useResource)((0, $jBMV2.filtersDirectoryResource)));
const $f91671c8355d1d34$export$c47481051d3723fd = ({ location: location })=>{
    const state = $f91671c8355d1d34$var$useFiltersDirectoryResource();
    const tenantContext = (0, $lvKO5.useTenantContext)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $790bS.default), {
        location: location
    }, ({ query: query, onQueryChanged: onQueryChanged })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dFtHW.FavoriteChangeConsumer), null, (favoriteChangeContext)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $16sa1.default), {
                name: "filters-directory"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $iQ6JJ.default), {
                tenantContext: tenantContext,
                prefetchResult: {
                    ...state
                },
                favoriteChangeContext: favoriteChangeContext,
                query: query,
                onQueryChanged: onQueryChanged
            }))));
};
// @ts-expect-error - TS2322 - Type '{ (props: RouteContext & { history: BrowserHistory; }): Element; displayName: string; }' is not assignable to type 'ComponentType<Record<any, any>>'.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $f91671c8355d1d34$var$RouterWrapper = (0, $jJaSe.withRouter)($f91671c8355d1d34$export$c47481051d3723fd);
var // eslint-disable-next-line @typescript-eslint/no-explicit-any, jira/import/no-anonymous-default-export
$f91671c8355d1d34$export$2e2bcd8739ae039 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $akiS9.MarkProductStart), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fmhfo.default), {
        id: "spa-app-bootstrap.directories.filters"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $hVCgF.default), {
        appNameSuffixForV2Event: "directory.filters",
        appNameForV3OperationalEvent: "filtersDirectory"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($f91671c8355d1d34$var$RouterWrapper, props)));

});
parcelRegister("hVCgF", function(module, exports) {

$parcel$export(module.exports, "default", () => $aeb7896d17d4ecc0$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $4xbv3 = parcelRequire("4xbv3");
var $gCeeo = parcelRequire("gCeeo");
var $8Plmb = parcelRequire("8Plmb");
const $aeb7896d17d4ecc0$var$fireGasV2AndGasV3Analytics = (appNameSuffixForV2Event, appNameForV3OperationalEvent)=>(analyticsEvent)=>{
        (0, $gCeeo.fireOperationalAnalytics)(analyticsEvent, `${appNameForV3OperationalEvent} pageInitialised`);
    };
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$aeb7896d17d4ecc0$export$2e2bcd8739ae039 = ({ appNameSuffixForV2Event: appNameSuffixForV2Event, appNameForV3OperationalEvent: appNameForV3OperationalEvent })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4xbv3.ContextualAnalyticsData), {
        sourceType: (0, $466f60259c330878$export$f636b5b56f1d624a),
        sourceName: ""
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8Plmb.MountEvent), {
        onMount: $aeb7896d17d4ecc0$var$fireGasV2AndGasV3Analytics(appNameSuffixForV2Event, appNameForV3OperationalEvent)
    }));

});
// SCREENS
const $466f60259c330878$export$f636b5b56f1d624a = 'Screen';
const $466f60259c330878$export$9d2de6eebf7462b5 = 'Drawer';
const $466f60259c330878$export$1171103ea9083ffa = 'Modal';
const $466f60259c330878$export$cae2783c9279926 = 'InlineDialog';
const $466f60259c330878$export$d1123261ca8831d2 = 'Dropdown';
const $466f60259c330878$export$238d30785c4bca84 = 'Banner';
const $466f60259c330878$export$a1562d08625f5d7e = 'UI';
const $466f60259c330878$export$947dac6c72b26f81 = 'TRACK';
const $466f60259c330878$export$f1d537d508d2945a = 'SCREEN';
const $466f60259c330878$export$12346a674644c156 = 'OPERATIONAL';


parcelRegister("790bS", function(module, exports) {

$parcel$export(module.exports, "default", () => $8b2b2a3a34139d06$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $97OFh = parcelRequire("97OFh");

var $jIOdj = parcelRequire("jIOdj");

var $6Ygge = parcelRequire("6Ygge");

var $2LVoL = parcelRequire("2LVoL");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$8b2b2a3a34139d06$export$2e2bcd8739ae039 = ({ location: location, children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $97OFh.default), {
        location: location,
        sortFieldToParam: (0, $2LVoL.sortFieldToParam),
        sortFieldFromParam: (0, $2LVoL.sortFieldFromParam),
        filterFromParams: (0, $6Ygge.filterFromParams),
        filterToParams: (0, $6Ygge.filterToParams),
        defaultQuery: (0, $jIOdj.initialQuery)
    }, children);

});
parcelRegister("97OFh", function(module, exports) {

$parcel$export(module.exports, "default", () => $556c18568dff142c$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $4cuZm = parcelRequire("4cuZm");

var $4l9z6 = parcelRequire("4l9z6");

var $lg6iR = parcelRequire("lg6iR");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$556c18568dff142c$export$2e2bcd8739ae039 = ({ location: location, children: children, sortFieldFromParam: sortFieldFromParam, filterFromParams: filterFromParams, sortFieldToParam: sortFieldToParam, filterToParams: filterToParams, defaultQuery: defaultQuery })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4cuZm.default), {
        location: location,
        queryFromUrl: (0, $lg6iR.default)(sortFieldFromParam, filterFromParams),
        queryToUrl: (0, $4l9z6.default)(sortFieldToParam, filterToParams),
        defaultQuery: defaultQuery
    }, children);

});
parcelRegister("4cuZm", function(module, exports) {

$parcel$export(module.exports, "default", () => $446b3862e19b2a93$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $k4x9q = parcelRequire("k4x9q");

var $12DRg = parcelRequire("12DRg");

var $b5RwB = parcelRequire("b5RwB");

var $lcB5K = parcelRequire("lcB5K");

var $eoPnG = parcelRequire("eoPnG");

var $kuiVs = parcelRequire("kuiVs");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$446b3862e19b2a93$export$2e2bcd8739ae039 = ({ location: location, children: children, queryToUrl: queryToUrl, queryFromUrl: queryFromUrl, defaultQuery: defaultQuery })=>{
    const toQuery = (search)=>(0, (/*@__PURE__*/$parcel$interopDefault($k4x9q)))((0, $eoPnG.default)(queryFromUrl)((0, (/*@__PURE__*/$parcel$interopDefault($b5RwB))).parse(search)), defaultQuery);
    const replaceUrl = (// @ts-expect-error - TS2304 - Cannot find name 'Href'.
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    replace, query, prevParams)=>replace(`?${(0, (/*@__PURE__*/$parcel$interopDefault($b5RwB))).stringify({
            ...prevParams,
            ...queryToUrl(query)
        })}`, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lcB5K.RouterActions), null, ({ replace: replace })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kuiVs.AdapterWithState), {
            search: location.search,
            toQuery: (search)=>toQuery(search),
            onChange: false ? (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))) : (query, prevParams)=>replaceUrl(replace, query, prevParams)
        }, children));
};

});
parcelRegister("eoPnG", function(module, exports) {

$parcel$export(module.exports, "default", () => $c36cbf0efe48d029$export$2e2bcd8739ae039);

var $eq3Hf = parcelRequire("eq3Hf");

var $huH03 = parcelRequire("huH03");
const $c36cbf0efe48d029$var$fromUrlTransformerFactory = (transformer)=>(0, (/*@__PURE__*/$parcel$interopDefault($eq3Hf)))([
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        (params)=>(0, (/*@__PURE__*/$parcel$interopDefault($huH03)))(params, (p)=>Array.isArray(p) ? p[0] : p),
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        (params)=>transformer(params)
    ]);
var $c36cbf0efe48d029$export$2e2bcd8739ae039 = $c36cbf0efe48d029$var$fromUrlTransformerFactory;

});
parcelRegister("huH03", function(module, exports) {

var $iBJlb = parcelRequire("iBJlb");

var $75Jcs = parcelRequire("75Jcs");

var $1lM9j = parcelRequire("1lM9j");
/**
 * Creates an object with the same keys as `object` and values generated
 * by running each own enumerable string keyed property of `object` thru
 * `iteratee`. The iteratee is invoked with three arguments:
 * (value, key, object).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Object} Returns the new mapped object.
 * @see _.mapKeys
 * @example
 *
 * var users = {
 *   'fred':    { 'user': 'fred',    'age': 40 },
 *   'pebbles': { 'user': 'pebbles', 'age': 1 }
 * };
 *
 * _.mapValues(users, function(o) { return o.age; });
 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
 *
 * // The `_.property` iteratee shorthand.
 * _.mapValues(users, 'age');
 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
 */ function $cbc697e9f663ba19$var$mapValues(object, iteratee) {
    var result = {};
    iteratee = $1lM9j(iteratee, 3);
    $75Jcs(object, function(value, key, object) {
        $iBJlb(result, key, iteratee(value, key, object));
    });
    return result;
}
module.exports = $cbc697e9f663ba19$var$mapValues;

});


parcelRegister("kuiVs", function(module, exports) {

$parcel$export(module.exports, "AdapterWithState", () => $2b09358ce6ec78a3$export$2fcc0cb3ae18b63e);

var $eJOHy = parcelRequire("eJOHy");

var $cSmYj = parcelRequire("cSmYj");

var $b5RwB = parcelRequire("b5RwB");
class $2b09358ce6ec78a3$export$2fcc0cb3ae18b63e extends (0, $eJOHy.Component) {
    static getDerivedStateFromProps(props, state) {
        if (props.search !== state.prevSearch) return {
            query: props.toQuery(props.search),
            prevSearch: props.search
        };
        return null;
    }
    componentDidUpdate(prevProps, prevState) {
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($cSmYj)))(prevState.query, this.state.query)) {
            const prevParams = (0, (/*@__PURE__*/$parcel$interopDefault($b5RwB))).parse(prevState.prevSearch);
            this.props.onChange(this.state.query, prevParams);
        }
    }
    render() {
        return this.props.children({
            query: this.state.query,
            onQueryChanged: this.onQueryChanged
        });
    }
    constructor(...args){
        super(...args), this.state = {
            query: this.props.toQuery(this.props.search),
            prevSearch: this.props.search
        }, this.onQueryChanged = (query)=>{
            this.setState({
                query: query
            });
        };
    }
}

});


parcelRegister("4l9z6", function(module, exports) {

$parcel$export(module.exports, "default", () => $796340d1cc38288a$export$2e2bcd8739ae039);

var $3zv7S = parcelRequire("3zv7S");

var $bOEO3 = parcelRequire("bOEO3");
const $796340d1cc38288a$var$toUrlTransformerFactory = (sortFieldTransformer, filterTransformer)=>{
    const valueTransformers = {
        // @ts-expect-error - TS7006 - Parameter 'page' implicitly has an 'any' type.
        page: (page)=>({
                page: (0, $bOEO3.number).stringify(page)
            }),
        // @ts-expect-error - TS7006 - Parameter 'dir' implicitly has an 'any' type.
        sortDirection: (dir)=>({
                sortOrder: (0, $bOEO3.string).stringify(dir)
            }),
        // @ts-expect-error - TS7006 - Parameter 'field' implicitly has an 'any' type.
        sortField: (field)=>({
                sortKey: sortFieldTransformer(field)
            }),
        filter: filterTransformer
    };
    return (query)=>(0, (/*@__PURE__*/$parcel$interopDefault($3zv7S)))(query, (params, value, key)=>// @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ page: (page: any) => { page: string; }; sortDirection: (dir: any) => { sortOrder: any; }; sortField: (field: any) => { sortKey: string; }; filter: FilterToParamTransformer<TFilter>; }'. | TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ page: (page: any) => { page: string; }; sortDirection: (dir: any) => { sortOrder: any; }; sortField: (field: any) => { sortKey: string; }; filter: FilterToParamTransformer<TFilter>; }'.
            valueTransformers[key] ? {
                ...params,
                ...valueTransformers[key](value)
            } : params, {});
};
var $796340d1cc38288a$export$2e2bcd8739ae039 = $796340d1cc38288a$var$toUrlTransformerFactory;

});
parcelRegister("3zv7S", function(module, exports) {

var $2x6Yt = parcelRequire("2x6Yt");

var $c3u3c = parcelRequire("c3u3c");

var $1lM9j = parcelRequire("1lM9j");

var $aiJg7 = parcelRequire("aiJg7");

var $4sprp = parcelRequire("4sprp");
/**
 * Reduces `collection` to a value which is the accumulated result of running
 * each element in `collection` thru `iteratee`, where each successive
 * invocation is supplied the return value of the previous. If `accumulator`
 * is not given, the first element of `collection` is used as the initial
 * value. The iteratee is invoked with four arguments:
 * (accumulator, value, index|key, collection).
 *
 * Many lodash methods are guarded to work as iteratees for methods like
 * `_.reduce`, `_.reduceRight`, and `_.transform`.
 *
 * The guarded methods are:
 * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
 * and `sortBy`
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @returns {*} Returns the accumulated value.
 * @see _.reduceRight
 * @example
 *
 * _.reduce([1, 2], function(sum, n) {
 *   return sum + n;
 * }, 0);
 * // => 3
 *
 * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
 *   (result[value] || (result[value] = [])).push(key);
 *   return result;
 * }, {});
 * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
 */ function $299cc8f655bd088e$var$reduce(collection, iteratee, accumulator) {
    var func = $4sprp(collection) ? $2x6Yt : $aiJg7, initAccum = arguments.length < 3;
    return func(collection, $1lM9j(iteratee, 4), accumulator, initAccum, $c3u3c);
}
module.exports = $299cc8f655bd088e$var$reduce;

});
parcelRegister("aiJg7", function(module, exports) {
/**
 * The base implementation of `_.reduce` and `_.reduceRight`, without support
 * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {*} accumulator The initial value.
 * @param {boolean} initAccum Specify using the first or last element of
 *  `collection` as the initial value.
 * @param {Function} eachFunc The function to iterate over `collection`.
 * @returns {*} Returns the accumulated value.
 */ function $77feb151e6770379$var$baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
    eachFunc(collection, function(value, index, collection) {
        accumulator = initAccum ? (initAccum = false, value) : iteratee(accumulator, value, index, collection);
    });
    return accumulator;
}
module.exports = $77feb151e6770379$var$baseReduce;

});



parcelRegister("lg6iR", function(module, exports) {

$parcel$export(module.exports, "default", () => $ba0ec9813bfa2405$export$2e2bcd8739ae039);

var $eq3Hf = parcelRequire("eq3Hf");

var $huH03 = parcelRequire("huH03");

var $3zv7S = parcelRequire("3zv7S");

var $2CrAx = parcelRequire("2CrAx");

var $bOEO3 = parcelRequire("bOEO3");
const $ba0ec9813bfa2405$var$fromUrlTransformerFactory = (sortFieldTransformer, filterTransformer)=>{
    const transformers = {
        // @ts-expect-error - TS7006 - Parameter 'page' implicitly has an 'any' type.
        page: (page)=>(0, $2CrAx.validatePageNumber)((0, $bOEO3.number).parse(page)) ? {
                page: (0, $bOEO3.number).parse(page)
            } : {},
        // @ts-expect-error - TS7006 - Parameter 'order' implicitly has an 'any' type.
        sortOrder: (order)=>(0, $2CrAx.validateSortDirection)(order) ? {
                sortDirection: order
            } : {},
        // @ts-expect-error - TS7006 - Parameter 'key' implicitly has an 'any' type.
        sortKey: (key)=>sortFieldTransformer(key) ? {
                sortField: sortFieldTransformer(key)
            } : {}
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($eq3Hf)))([
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        (params)=>(0, (/*@__PURE__*/$parcel$interopDefault($huH03)))(params, (p)=>Array.isArray(p) ? p[0] : p),
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        (params)=>(0, (/*@__PURE__*/$parcel$interopDefault($3zv7S)))(params, (query, value, key)=>// @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ page: (page: any) => { page: number; } | { page?: undefined; }; sortOrder: (order: any) => { sortDirection: any; } | { sortDirection?: undefined; }; sortKey: (key: any) => { sortField: TSortField | null; } | { ...; }; }'. | TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ page: (page: any) => { page: number; } | { page?: undefined; }; sortOrder: (order: any) => { sortDirection: any; } | { sortDirection?: undefined; }; sortKey: (key: any) => { sortField: TSortField | null; } | { ...; }; }'.
                transformers[key] ? {
                    ...query,
                    ...transformers[key](value)
                } : query, {
                filter: filterTransformer(params)
            })
    ]);
};
var $ba0ec9813bfa2405$export$2e2bcd8739ae039 = $ba0ec9813bfa2405$var$fromUrlTransformerFactory;

});
parcelRegister("2CrAx", function(module, exports) {

$parcel$export(module.exports, "calculateTotalPages", () => $e8881310cdd77edc$export$fba88641b8ab6cd8);
$parcel$export(module.exports, "predictPageToRequestAfterItemDeletion", () => $e8881310cdd77edc$export$3179e82a0f1565e1);
$parcel$export(module.exports, "validatePageNumber", () => $e8881310cdd77edc$export$231cde03e0d8b537);
$parcel$export(module.exports, "validateSortDirection", () => $e8881310cdd77edc$export$407c10b4791d7a16);

const $e8881310cdd77edc$export$fba88641b8ab6cd8 = (totalItems, itemsPerPage)=>Math.max(Math.ceil(totalItems / itemsPerPage), 1);
const $e8881310cdd77edc$export$3179e82a0f1565e1 = (itemsPerPage, totalItems, currentPage = 1, itemsRemoved = 1)=>{
    const maxPossiblePage = $e8881310cdd77edc$export$fba88641b8ab6cd8(totalItems - itemsRemoved, itemsPerPage);
    return currentPage > maxPossiblePage ? maxPossiblePage : currentPage;
};
const $e8881310cdd77edc$export$231cde03e0d8b537 = (input)=>typeof input === 'number' && Number.isInteger(input) && input >= 1;
const $e8881310cdd77edc$export$407c10b4791d7a16 = (input)=>[
        (0, $a535a1c1a5d4d33f$export$1dee026a19752d6b),
        (0, $a535a1c1a5d4d33f$export$b6abcf7fa1d94f65)
    ].includes(input);

});
const $a535a1c1a5d4d33f$export$1dee026a19752d6b = 'ASC';
const $a535a1c1a5d4d33f$export$b6abcf7fa1d94f65 = 'DESC';




parcelRegister("jIOdj", function(module, exports) {

$parcel$export(module.exports, "ITEMS_PER_PAGE", () => $bcb64d7025594d96$export$ec93a669a20aa982);
$parcel$export(module.exports, "initialQuery", () => $bcb64d7025594d96$export$8af7177c92ae79e3);
$parcel$export(module.exports, "EXPAND_PARAMETERS", () => $bcb64d7025594d96$export$ac5ed0fd17aacb1c);


var $3gN48 = parcelRequire("3gN48");
const $bcb64d7025594d96$export$ec93a669a20aa982 = 25;
const $bcb64d7025594d96$export$8af7177c92ae79e3 = {
    sortField: (0, $3gN48.NAME),
    sortDirection: (0, $a535a1c1a5d4d33f$export$1dee026a19752d6b),
    page: 1,
    filter: {
        query: undefined,
        project: undefined,
        group: undefined,
        owner: undefined
    }
};
const $bcb64d7025594d96$export$ac5ed0fd17aacb1c = [
    'owner',
    'favourite',
    'favouritedCount',
    'sharePermissions',
    'editPermissions',
    'description',
    'isWritable'
];

});
parcelRegister("3gN48", function(module, exports) {

$parcel$export(module.exports, "FAVOURITED", () => $e9f4c66bde1f5323$export$fdb541a0853ce91e);
$parcel$export(module.exports, "NAME", () => $e9f4c66bde1f5323$export$3c5e605ca7ade9f2);
$parcel$export(module.exports, "OWNER", () => $e9f4c66bde1f5323$export$8c6af90262e3c6cd);
$parcel$export(module.exports, "POPULARITY", () => $e9f4c66bde1f5323$export$baf77a5a5061f88f);
const $e9f4c66bde1f5323$export$fdb541a0853ce91e = 'favourite';
const $e9f4c66bde1f5323$export$3c5e605ca7ade9f2 = 'name';
const $e9f4c66bde1f5323$export$8c6af90262e3c6cd = 'owner';
const $e9f4c66bde1f5323$export$baf77a5a5061f88f = 'popularity';
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$e9f4c66bde1f5323$export$2e2bcd8739ae039 = [
    $e9f4c66bde1f5323$export$3c5e605ca7ade9f2,
    $e9f4c66bde1f5323$export$8c6af90262e3c6cd,
    $e9f4c66bde1f5323$export$baf77a5a5061f88f,
    $e9f4c66bde1f5323$export$fdb541a0853ce91e
];

});


parcelRegister("6Ygge", function(module, exports) {

$parcel$export(module.exports, "filterToParams", () => $0411d292e18d16bb$export$cb128e46cc7ba0f1);
$parcel$export(module.exports, "filterFromParams", () => $0411d292e18d16bb$export$f6542f27c27241c6);

var $ljej9 = parcelRequire("ljej9");
const $0411d292e18d16bb$export$cb128e46cc7ba0f1 = (filter = {})=>({
        name: filter.query || undefined,
        owner: filter.owner && filter.owner.accountId || undefined,
        selectedProject: filter.project && filter.project.value || 'anything',
        selectedGroup: filter.group && filter.group.value || 'anything'
    });
const $0411d292e18d16bb$var$transformSelectedOwner = (input)=>input ? {
        accountId: (0, $ljej9.toAccountId)(input)
    } : undefined;
const $0411d292e18d16bb$var$transformSelectedProject = (input)=>input && input !== 'anything' ? {
        value: input
    } : undefined;
const $0411d292e18d16bb$var$transformSelectedGroup = (input)=>input && input !== 'anything' ? {
        value: input,
        name: input
    } : undefined;
const $0411d292e18d16bb$export$f6542f27c27241c6 = (params)=>({
        query: params.name || params.searchName || undefined,
        owner: $0411d292e18d16bb$var$transformSelectedOwner(params.owner),
        project: $0411d292e18d16bb$var$transformSelectedProject(params.selectedProject),
        group: $0411d292e18d16bb$var$transformSelectedGroup(params.selectedGroup)
    });

});

parcelRegister("2LVoL", function(module, exports) {

$parcel$export(module.exports, "sortFieldToParam", () => $d4a25c886c7dbbad$export$9a7ae3517c7d79c2);
$parcel$export(module.exports, "sortFieldFromParam", () => $d4a25c886c7dbbad$export$307ee63ec20d9c92);

var $3gN48 = parcelRequire("3gN48");
const $d4a25c886c7dbbad$var$sortFieldMap = {
    [(0, $3gN48.NAME).toLowerCase()]: (0, $3gN48.NAME),
    [(0, $3gN48.OWNER).toLowerCase()]: (0, $3gN48.OWNER),
    [(0, $3gN48.POPULARITY).toLowerCase()]: (0, $3gN48.POPULARITY),
    [(0, $3gN48.FAVOURITED).toLowerCase()]: (0, $3gN48.FAVOURITED)
};
const $d4a25c886c7dbbad$export$9a7ae3517c7d79c2 = (field)=>field.toLowerCase();
const $d4a25c886c7dbbad$export$307ee63ec20d9c92 = (param)=>$d4a25c886c7dbbad$var$sortFieldMap[param] ? $d4a25c886c7dbbad$var$sortFieldMap[param] : null;

});


parcelRegister("6UU7v", function(module, exports) {

$parcel$export(module.exports, "withSuspense", () => $d591853152e8b41d$export$a3bce93d4fb4eda6);
const $d591853152e8b41d$var$isDataEmpty = (data)=>data == null;
function $d591853152e8b41d$export$a3bce93d4fb4eda6(theHook) {
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return (...args)=>{
        const result = theHook(...args);
        if (!false && $d591853152e8b41d$var$isDataEmpty(result.data) && result.loading) throw result.promise;
        return result;
    };
}

});

parcelRegister("fmhfo", function(module, exports) {

$parcel$export(module.exports, "default", () => $2682a2794dec76a0$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $1qbKn = parcelRequire("1qbKn");

var $iIqWW = parcelRequire("iIqWW");
const $2682a2794dec76a0$var$ErrorBoundaryWithExtraEventData = ({ children: children, id: id })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1qbKn.ErrorBoundaryFlag), {
        id: "spa-apps.error-boundary"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $iIqWW.default), null, ({ transitionsCount: transitionsCount = 0, lastTransition: lastTransition = '', navigationStart: navigationStart = '' })=>{
        const extraEventData = {
            transitionsCount: transitionsCount,
            lastTransition: lastTransition,
            navigationStart: navigationStart
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1qbKn.ErrorBoundaryFlag), {
            id: id,
            extraEventData: extraEventData
        }, children);
    }));
const $2682a2794dec76a0$var$SpaErrorBoundary = $2682a2794dec76a0$var$ErrorBoundaryWithExtraEventData;
var $2682a2794dec76a0$export$2e2bcd8739ae039 = $2682a2794dec76a0$var$SpaErrorBoundary;

});

parcelRegister("akiS9", function(module, exports) {

$parcel$export(module.exports, "PRODUCT_START_MARK", () => $50b865cde2c2d004$export$8e54fca0a680fdfd);
$parcel$export(module.exports, "MarkProductStart", () => $50b865cde2c2d004$export$2a999c5f84501025);

var $6uWhG = parcelRequire("6uWhG");
const $50b865cde2c2d004$export$8e54fca0a680fdfd = 'PRODUCT_START';
const $50b865cde2c2d004$export$2a999c5f84501025 = ()=>{
    if (!false) {
        performance.clearMarks($50b865cde2c2d004$export$8e54fca0a680fdfd);
        (0, $6uWhG.setMark)($50b865cde2c2d004$export$8e54fca0a680fdfd);
    }
    return null;
};

});

parcelRegister("iQ6JJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $2eafba4cc841ee7d$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $2QUmO = parcelRequire("2QUmO");

var $cZTMg = parcelRequire("cZTMg");

var $kt1B9 = parcelRequire("kt1B9");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $2eafba4cc841ee7d$var$Updater = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cZTMg.SubProductUpdater), {
        subProduct: "platform"
    });
var $2eafba4cc841ee7d$export$2e2bcd8739ae039 = (0, $2QUmO.default)((0, $kt1B9.default), {
    Updater: $2eafba4cc841ee7d$var$Updater
});

});
parcelRegister("cZTMg", function(module, exports) {

$parcel$export(module.exports, "SubProductUpdater", () => $e3e218a75c21102a$export$eb40d3df56aa5c53);

var $eJOHy = parcelRequire("eJOHy");

var $5onjV = parcelRequire("5onjV");

var $figsJ = parcelRequire("figsJ");

var $5nYJB = parcelRequire("5nYJB");

var $aO6tw = parcelRequire("aO6tw");

var $adiVF = parcelRequire("adiVF");
const $e3e218a75c21102a$export$eb40d3df56aa5c53 = ({ allowMonolithDeferral: allowMonolithDeferral = false, ...props })=>{
    const subProduct = (0, $adiVF.isSubProductProps)(props) ? props.subProduct : (0, $figsJ.subProductFromProjectTypeForAnalytics)(props.projectType);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5onjV.default), {
        op: (0, $aO6tw.default),
        args: [
            subProduct,
            allowMonolithDeferral
        ]
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5nYJB.default), {
        subProduct: subProduct
    }));
};

});
parcelRegister("5nYJB", function(module, exports) {

$parcel$export(module.exports, "default", () => $82e051cbb2adac57$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $3aa9n = parcelRequire("3aa9n");

var $8VfmF = parcelRequire("8VfmF");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$82e051cbb2adac57$export$2e2bcd8739ae039 = ({ subProduct: subProduct })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3aa9n.default), {
        op: (0, $8VfmF.default),
        args: [
            subProduct
        ]
    });

});
parcelRegister("8VfmF", function(module, exports) {

$parcel$export(module.exports, "default", () => $811461c69dc55236$export$2e2bcd8739ae039);

var $eSnSE = parcelRequire("eSnSE");

var $jGzN3 = parcelRequire("jGzN3");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$811461c69dc55236$export$2e2bcd8739ae039 = (subProduct)=>{
    (0, $jGzN3.performGetRequest)(`/rest/internal/2/mauTag/${subProduct}`).catch((err)=>{
        (0, $eSnSE.default).safeErrorWithoutCustomerData('common.tag-mau.tag-mau-event', 'Error connecting to monolith mau tag endpoint', err);
    });
};

});


parcelRegister("aO6tw", function(module, exports) {

$parcel$export(module.exports, "default", () => $53a2c520c0b2b632$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/wrm/no-load-bridge

var $97BGz = parcelRequire("97BGz");
var $iyT45 = parcelRequire("iyT45");
var $4T9yL = parcelRequire("4T9yL");


var $eSnSE = parcelRequire("eSnSE");

var $2Mqjh = parcelRequire("2Mqjh");
const $53a2c520c0b2b632$var$maybeDelayAndRace = (// @ts-expect-error - TS2304 - Cannot find name 'Deferred'.
maybeWaitPromise, getDefaultPromise, getRacePromise)=>maybeWaitPromise ? Promise.race([
        maybeWaitPromise.then(getDefaultPromise),
        getRacePromise()
    ]) : getDefaultPromise();
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$53a2c520c0b2b632$export$2e2bcd8739ae039 = async (subProduct, allowMonolithDeferral)=>{
    (0, $2Mqjh.getAnalyticsWebClientPromise)().then((client)=>{
        client.setSubProduct(subProduct);
        if (subProduct === 'serviceDesk') client.setUIViewedAttributes({
            solutions: [
                (0, $99993c16fc53d6ec$export$c8b406ad8ee0dab9)
            ]
        });
        else client.removeUIViewedAttribute('solutions');
    });
    // IMPORTANT -
    // Until such time as all pre-TTI WRM loads are removed we find that waitForHeritage() then
    // loadBridgeStrict() is too slow, resulting in `subproduct:unknown` for analytics events.
    // In that same case however, profiling shows us that polling in loadBridgeWeak() somehow
    // resolves the same AMD code faster.
    // This is not well understood, but it does allow us to work around the issue by racing these
    // two techniques.
    // Once there is no pre-TTI WRM loads we the waitForHeritage() then loadBridgeStrict() does seem
    // to be faster such that we can remove the `Promise.race()`.
    /* eslint-disable jira/wrm/no-load-bridge */ $53a2c520c0b2b632$var$maybeDelayAndRace(allowMonolithDeferral ? (0, $4T9yL.waitForHeritage)() : null, ()=>(0, $97BGz.loadBridgeStrict)({
            name: 'jira/analytics/sub-product-resolver',
            wrmKeys: [
                'wrc!com.atlassian.jira.jira-client-analytics-plugin:analytics-web-client'
            ]
        }), ()=>(0, $iyT45.loadBridgeWeak)({
            name: 'jira/analytics/sub-product-resolver'
        })).then((subProductResolver)=>{
        subProductResolver.setSubProduct(subProduct);
    }).catch((e)=>(0, $eSnSE.default).safeErrorWithoutCustomerData('common.analytics-sub-product.sub-product-updater', 'Error connecting to monolith sub product resolver', e));
/* eslint-enable jira/wrm/no-load-bridge */ };

});
const $99993c16fc53d6ec$export$c8b406ad8ee0dab9 = 'jiraServiceManagement';


parcelRegister("adiVF", function(module, exports) {

$parcel$export(module.exports, "isSubProductProps", () => $b41c599c0dbb9c69$export$c3063d6d7a8c075f);
const $b41c599c0dbb9c69$export$c3063d6d7a8c075f = (props)=>'subProduct' in props && typeof props.subProduct === 'string';

});


parcelRegister("kt1B9", function(module, exports) {

$parcel$export(module.exports, "default", () => $61699a9389e714b6$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $BwaQq = parcelRequire("BwaQq");

var $1qbKn = parcelRequire("1qbKn");

var $5kYyR = parcelRequire("5kYyR");

var $8lEb8 = parcelRequire("8lEb8");


var $4kMB4 = parcelRequire("4kMB4");

var $lA4uT = parcelRequire("lA4uT");

var $ljej9 = parcelRequire("ljej9");

var $iMFdk = parcelRequire("iMFdk");

var $gWu57 = parcelRequire("gWu57");

var $68uoM = parcelRequire("68uoM");
// Replace with lodash/noop
// eslint-disable-next-line @typescript-eslint/no-empty-function
const $61699a9389e714b6$var$noop = ()=>{};
function $61699a9389e714b6$var$FiltersDirectory({ Updater: Updater, tenantContext: tenantContext, prefetchResult: prefetchResult, favoriteChangeContext: favoriteChangeContext, query: query, onQueryChanged: onQueryChanged }) {
    const { xsrfToken: xsrfToken, atlassianAccountId: atlassianAccountId } = tenantContext;
    const { error: prefetchError, loading: loading, data: data } = prefetchResult;
    if (prefetchError && !loading) // @ts-expect-error - TS2322 - Type 'Error | Record<string, any> | (Error & Record<string, any>) | (Record<string, any> & Error)' is not assignable to type 'Error | null'.
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1qbKn.ErrorFlagRenderer), {
        id: "directories-filters",
        error: prefetchError
    });
    if (!data) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $iMFdk.FiltersDirectorySkeleton), null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gWu57.PageLayout), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5kYyR.default), {
        id: "unhandled",
        packageName: "jiraSpaAppsDirectoriesFilters",
        teamName: "jira-cosmos"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(Updater, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8lEb8.default), {
        isServer: false,
        atlassianAccountId: atlassianAccountId ? (0, $ljej9.toAccountId)(atlassianAccountId) : undefined,
        // @ts-expect-error - TS2322 - Type 'string | null' is not assignable to type 'string'.
        xsrfToken: xsrfToken,
        query: query,
        favoriteChangeContext: favoriteChangeContext,
        prefetchedData: data,
        onQueryChanged: onQueryChanged,
        onUnmount: $61699a9389e714b6$var$noop,
        withPageReadyMetrics: false,
        withoutHeader: false
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lA4uT.default), {
        metricKey: "jira.directories.filters",
        metric: (0, $68uoM.filtersDirectoryPageLoad),
        isExpectedToHaveSsr: true,
        withMarks: [
            (0, $4kMB4.appBundleReadyMark),
            (0, $4kMB4.prefetchApiReadyMark)
        ]
    })));
}
var $61699a9389e714b6$export$2e2bcd8739ae039 = (0, $BwaQq.AnalyticsSource)('filters', (0, $466f60259c330878$export$f636b5b56f1d624a))($61699a9389e714b6$var$FiltersDirectory);

});
parcelRegister("8lEb8", function(module, exports) {

$parcel$export(module.exports, "default", () => $3b066107cc127b15$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/restricted/react-component-props

var $eJOHy = parcelRequire("eJOHy");

var $cSmYj = parcelRequire("cSmYj");

var $12DRg = parcelRequire("12DRg");

var $jtIA2 = parcelRequire("jtIA2");

var $7iHUq = parcelRequire("7iHUq");

var $aP411 = parcelRequire("aP411");

var $5kYyR = parcelRequire("5kYyR");

var $1YQf5 = parcelRequire("1YQf5");

var $aBIfT = parcelRequire("aBIfT");

var $dTocu = parcelRequire("dTocu");

var $gZTP9 = parcelRequire("gZTP9");

var $bHEnV = parcelRequire("bHEnV");

var $jIOdj = parcelRequire("jIOdj");

var $kcP89 = parcelRequire("kcP89");

var $iXY2d = parcelRequire("iXY2d");

var $6RVHf = parcelRequire("6RVHf");

var $4ETME = parcelRequire("4ETME");

var $4IANj = parcelRequire("4IANj");

var $7jNZd = parcelRequire("7jNZd");

var $kycze = parcelRequire("kycze");

var $6JT0c = parcelRequire("6JT0c");

var $7nCDL = parcelRequire("7nCDL");
// eslint-disable-next-line jira/react/no-class-components
class $3b066107cc127b15$var$Filters extends (0, $eJOHy.Component) {
    static{
        this.defaultProps = {
            query: undefined,
            prefetchedData: {},
            withoutHeader: false,
            withPageReadyMetrics: true,
            onQueryChanged: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
            onUnmount: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
            isAdmin: false
        };
    }
    constructor(props){
        super(props);
        this.store = (0, $7jNZd.default)((0, $iXY2d.default));
        const { filters: filters } = props.prefetchedData;
        const { dispatch: dispatch } = this.store;
        dispatch((0, $6RVHf.setAppProps)(props));
        dispatch((0, $4IANj.setQuery)(props.query || (0, $jIOdj.initialQuery)));
        dispatch(filters ? (0, $4ETME.retrieved)(filters) : (0, $4ETME.retrieve)());
    }
    componentDidUpdate(prevProps) {
        const { dispatch: dispatch, getState: getState } = this.store;
        const { query: query } = this.props;
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($cSmYj)))(prevProps, this.props)) dispatch((0, $6RVHf.setAppProps)(this.props));
        /**
     * We compare this.props.query against what's being stored inside the store ONLY IF the query prop is specified
     * i.e. NOT undefined. When query is passed in as a prop, the expectation is onQueryChanged is also passed in as
     * a prop. Using these two props, the parent component has the ability to control this component's "current query".
     * Note that this component is capable to manage its own query independently, which is why the two aforementioned
     * props are actually optional.
     */ // @ts-expect-error - TS2345 - Argument of type 'Partial<Query>' is not assignable to parameter of type 'Query'.
        if (query && (0, $kcP89.isQueryChanged)(query, (0, $kycze.getQuery)(getState()))) {
            dispatch((0, $4IANj.setQuery)(query));
            dispatch((0, $4ETME.retrieve)());
        }
    }
    componentWillUnmount() {
        this.props.onUnmount();
    }
    render() {
        const { intl: { formatMessage: formatMessage } } = this.props;
        const headerConfiguration = (0, $7nCDL.getHeaderConfiguration)();
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7iHUq.default), {
            store: this.store,
            id: "filter-directory-main",
            hasErrorBoundary: false
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5kYyR.default), {
            id: "unhandled",
            packageName: "jiraFiltersMain",
            teamName: "jira-cosmos"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aBIfT.DocumentTitle), {
            title: // @ts-expect-error - TS2339 - Property 'caption' does not exist on type 'HeaderConfiguration<string>'.
            headerConfiguration.caption ? // @ts-expect-error - TS2339 - Property 'caption' does not exist on type 'HeaderConfiguration<string>'.
            formatMessage(headerConfiguration.caption) : ''
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1YQf5.FlagsDispatcher), {
            mapper: (0, $bHEnV.default)
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jtIA2.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aP411.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6JT0c.default), null))));
    }
}
const $3b066107cc127b15$var$FiltersWithContext = (props)=>{
    const isAdmin = (0, $gZTP9.useIsAdmin)();
    const intl = (0, $dTocu.useIntlV2)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($3b066107cc127b15$var$Filters, {
        ...props,
        isAdmin: isAdmin,
        intl: intl
    });
};
var $3b066107cc127b15$export$2e2bcd8739ae039 = $3b066107cc127b15$var$FiltersWithContext;

});
parcelRegister("jtIA2", function(module, exports) {

$parcel$export(module.exports, "default", () => $d1b00c14168b4301$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $12DRg = parcelRequire("12DRg");

var $dUaMU = parcelRequire("dUaMU");
var $4J0ad = parcelRequire("4J0ad");

var $iM63C = parcelRequire("iM63C");
// eslint-disable-next-line jira/react/no-class-components
class $d1b00c14168b4301$var$ViewTracker extends (0, $eJOHy.Component) {
    componentDidMount() {
        this.props.onMount();
    }
    render() {
        return null;
    }
}
const $d1b00c14168b4301$var$ViewTrackerWithAnalytics = (0, $dUaMU.default)({
    componentName: 'view-tracker'
})((0, $4J0ad.default)({
    onMount: (createEvent)=>createEvent({
            action: (0, $iM63C.PAGE_EVENT_ACTION)
        }).fire()
})($d1b00c14168b4301$var$ViewTracker));
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$d1b00c14168b4301$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($d1b00c14168b4301$var$ViewTrackerWithAnalytics, {
        onMount: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg)))
    });

});

parcelRegister("aP411", function(module, exports) {

$parcel$export(module.exports, "default", () => $02914045d75bc0a9$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
const $02914045d75bc0a9$var$AppStyle = ({ children: children })=>/*#__PURE__*/ $eJOHy.createElement("div", {
        className: (0, $hcewu.default)([
            "_11c82smr _4t3i1kw7"
        ])
    }, children);
const $02914045d75bc0a9$var$appStyles = null;
var $02914045d75bc0a9$export$2e2bcd8739ae039 = $02914045d75bc0a9$var$AppStyle;

});

parcelRegister("1YQf5", function(module, exports) {

$parcel$export(module.exports, "FlagsDispatcher", () => $efc9940212e6c758$export$9e60e3d40b6e758f);

var $eJOHy = parcelRequire("eJOHy");

var $bILK0 = parcelRequire("bILK0");

var $6o3qp = parcelRequire("6o3qp");
const $efc9940212e6c758$export$9e60e3d40b6e758f = ({ store: store, mapper: mapper })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6o3qp.Dispatcher), {
        store: store,
        mapper: mapper,
        showFlag: (0, $bILK0.showFlag),
        dismissFlag: (0, $bILK0.dismissFlag)
    });

});
parcelRegister("6o3qp", function(module, exports) {

$parcel$export(module.exports, "Dispatcher", () => $bf8b530c8a1446b5$export$ab054a1ef92eeb01);

var $eJOHy = parcelRequire("eJOHy");

var $4g5x4 = parcelRequire("4g5x4");
const $bf8b530c8a1446b5$export$ab054a1ef92eeb01 = (props)=>{
    const { store: store, ...dispatcherProps } = props;
    const [lastStore, setLastStore] = (0, $eJOHy.useState)(store);
    if (store !== lastStore) setLastStore(store);
    const DispatcherComponent = (0, $eJOHy.useMemo)(()=>(0, $4g5x4.createDispatcher)(store), [
        store
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(DispatcherComponent, dispatcherProps);
};

});
parcelRegister("4g5x4", function(module, exports) {

$parcel$export(module.exports, "createDispatcher", () => $7918981ceb228aac$export$7b259d28468da15b);

var $eJOHy = parcelRequire("eJOHy");

var $dyOHn = parcelRequire("dyOHn");

var $bILK0 = parcelRequire("bILK0");
const $7918981ceb228aac$export$81c2f3c810206fa9 = (store)=>{
    if (!store) throw new Error('Store not available through direct injection or Provider context');
    if (!('addActionListener' in store) || !('removeActionListener' in store) || typeof store.addActionListener !== 'function' || typeof store.removeActionListener !== 'function') throw new Error("Your store doesn't support action listeners; please use the Tangerine store initialiser.");
    return store;
};
const $7918981ceb228aac$export$8a44987212de21b = (store, result, showFlag, dismissFlag)=>{
    if (!result) return;
    if ((0, $bILK0.isDismissFlag)(result)) dismissFlag(result);
    else if ((0, $bILK0.isFlagComponent)(result)) {
        const FlagComponent = result;
        const FlagComponentWithProvider = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dyOHn.Provider), {
                store: store
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(FlagComponent, props));
        showFlag(FlagComponentWithProvider);
    } else showFlag(result);
};
const $7918981ceb228aac$export$2bedce6f5250e28d = (action, state, store, mapper, showFlag, dismissFlag)=>{
    // handle batch middleware
    if ((0, $bILK0.isBatchAction)(action)) action.payload.forEach((childAction)=>{
        if (childAction.type && typeof childAction.type === 'string') {
            const childResult = mapper(childAction, state);
            $7918981ceb228aac$export$8a44987212de21b(store, childResult, showFlag, dismissFlag);
        }
    });
    else {
        const result = mapper(action, state);
        $7918981ceb228aac$export$8a44987212de21b(store, result, showFlag, dismissFlag);
    }
};
const $7918981ceb228aac$var$Dispatcher8 = (props)=>{
    const { store: storeUnchecked, mapper: mapper, showFlag: showFlag, dismissFlag: dismissFlag } = props;
    const store = (0, $eJOHy.useMemo)(()=>$7918981ceb228aac$export$81c2f3c810206fa9(storeUnchecked), [
        storeUnchecked
    ]);
    (0, $eJOHy.useEffect)(()=>{
        const handleAction = (action, state)=>{
            $7918981ceb228aac$export$2bedce6f5250e28d(action, state, store, mapper, showFlag, dismissFlag);
        };
        store.addActionListener(handleAction);
        return ()=>store.removeActionListener(handleAction);
    }, [
        store,
        mapper,
        showFlag,
        dismissFlag
    ]);
    return null;
};
const $7918981ceb228aac$var$Dispatcher8DefaultStore = (props)=>{
    const store = (0, $dyOHn.useStore)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($7918981ceb228aac$var$Dispatcher8, {
        ...props,
        store: store
    });
};
const $7918981ceb228aac$export$7b259d28468da15b = (customStore)=>{
    const Dispatcher8CustomStore = (props)=>customStore ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($7918981ceb228aac$var$Dispatcher8, {
            ...props,
            store: customStore
        }) : null;
    return customStore ? Dispatcher8CustomStore : $7918981ceb228aac$var$Dispatcher8DefaultStore;
};

});



parcelRegister("aBIfT", function(module, exports) {

$parcel$export(module.exports, "DocumentTitle", () => $730554390b82eb2a$export$dd5ad0b65cf665da);

var $eJOHy = parcelRequire("eJOHy");

var $bJscI = parcelRequire("bJscI");

var $baxYj = parcelRequire("baxYj");
// eslint-disable-next-line jira/react/no-class-components
class $730554390b82eb2a$var$DocumentTitleOld extends (0, $eJOHy.Component) {
    static{
        this.defaultProps = {
            TitleSubscriber: (0, $baxYj.DocumentTitleSubscriber)
        };
    }
    shouldComponentUpdate(nextProps) {
        return nextProps.title !== this.props.title;
    }
    render() {
        const { title: title, TitleSubscriber: TitleSubscriber = (0, $baxYj.DocumentTitleSubscriber) } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(TitleSubscriber, null, ({ contextArray: contextArray }, { setTitle: setTitle, addDocumentTitle: addDocumentTitle, removeDocumentTitle: removeDocumentTitle })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $baxYj.DocumentTitleHelperOld), {
                title: title,
                setTitle: setTitle,
                addDocumentTitle: addDocumentTitle,
                contextArray: contextArray,
                removeDocumentTitle: removeDocumentTitle,
                TitleSubscriber: TitleSubscriber
            }));
    }
}
const $730554390b82eb2a$export$dd5ad0b65cf665da = (0, $bJscI.componentWithFG)('jira-concurrent-document-title', (0, $baxYj.DocumentTitleHelper), $730554390b82eb2a$var$DocumentTitleOld);

});

parcelRegister("bHEnV", function(module, exports) {

$parcel$export(module.exports, "default", () => $a0a6bd6c8f75eb7c$export$2e2bcd8739ae039);

var $82lMK = parcelRequire("82lMK");

var $6dsEx = parcelRequire("6dsEx");

var $xhcco = parcelRequire("xhcco");

var $gOygZ = parcelRequire("gOygZ");

var $7aaKo = parcelRequire("7aaKo");

var $bKZjk = parcelRequire("bKZjk");

var $kGpwJ = parcelRequire("kGpwJ");
const $a0a6bd6c8f75eb7c$var$flagsMapper = (action)=>{
    switch(action.type){
        // @ts-expect-error - TS2678 - Type '"state.actions.copy.COPY_INITIATE_FAILED"' is not comparable to type '"state.actions.operations.DELETED" | "state.actions.operations.DELETE_FAILED" | "state.actions.operations.COPIED" | "state.actions.operations.COPY_FAILED"'.
        case 0, $82lMK.COPY_INITIATE_FAILED:
            return (0, $kGpwJ.default)();
        case 0, $6dsEx.COPIED:
            return (0, $gOygZ.default)({
                name: action.payload.originalItemName
            });
        case 0, $6dsEx.COPY_FAILED:
            return (0, $xhcco.default)(action.payload);
        case 0, $6dsEx.DELETED:
            return (0, $bKZjk.default)(action.payload);
        case 0, $6dsEx.DELETE_FAILED:
            return (0, $7aaKo.default)(action.payload);
        default:
            {
                const _exhaustiveCheck = action;
                return undefined;
            }
    }
};
var $a0a6bd6c8f75eb7c$export$2e2bcd8739ae039 = $a0a6bd6c8f75eb7c$var$flagsMapper;

});
parcelRegister("82lMK", function(module, exports) {

$parcel$export(module.exports, "COPY_INITIATE_FAILED", () => $1de8fb800561d368$export$eff7a7b152af4c1);
const $1de8fb800561d368$export$eff7a7b152af4c1 = 'state.actions.copy.COPY_INITIATE_FAILED';
const $1de8fb800561d368$export$3f5c30a007387562 = ()=>({
        type: $1de8fb800561d368$export$eff7a7b152af4c1
    });

});

parcelRegister("6dsEx", function(module, exports) {

$parcel$export(module.exports, "DELETED", () => $df70f3fafaae8b68$export$1cc76b53f23597de);
$parcel$export(module.exports, "deleted", () => $df70f3fafaae8b68$export$bccbf0c716f226f4);
$parcel$export(module.exports, "DELETE_FAILED", () => $df70f3fafaae8b68$export$ae082348f4557243);
$parcel$export(module.exports, "deleteFailed", () => $df70f3fafaae8b68$export$8830effd508d9f31);
$parcel$export(module.exports, "COPIED", () => $df70f3fafaae8b68$export$ab06cbdc503432af);
$parcel$export(module.exports, "COPY_FAILED", () => $df70f3fafaae8b68$export$9db31c0e010caedf);
// DELETED
const $df70f3fafaae8b68$export$1cc76b53f23597de = 'state.actions.operations.DELETED';
const $df70f3fafaae8b68$export$bccbf0c716f226f4 = (name)=>({
        type: $df70f3fafaae8b68$export$1cc76b53f23597de,
        payload: {
            name: name
        }
    });
const $df70f3fafaae8b68$export$ae082348f4557243 = 'state.actions.operations.DELETE_FAILED';
const $df70f3fafaae8b68$export$8830effd508d9f31 = (name)=>({
        type: $df70f3fafaae8b68$export$ae082348f4557243,
        payload: {
            name: name
        }
    });
const $df70f3fafaae8b68$export$ab06cbdc503432af = 'state.actions.operations.COPIED';
const $df70f3fafaae8b68$export$a92b46551664f4e = (payload)=>({
        type: $df70f3fafaae8b68$export$ab06cbdc503432af,
        payload: payload
    });
const $df70f3fafaae8b68$export$9db31c0e010caedf = 'state.actions.operations.COPY_FAILED';
const $df70f3fafaae8b68$export$5d8d1af388d10413 = (payload)=>({
        type: $df70f3fafaae8b68$export$9db31c0e010caedf,
        payload: payload
    });

});

parcelRegister("xhcco", function(module, exports) {

$parcel$export(module.exports, "default", () => $4f44bfcea97e3302$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $4f44bfcea97e3302$var$messages = (0, $7qGN1.defineMessages)({
    title: {
        "id": "directories.filters-v2.main.flags.copy.error.title",
        "defaultMessage": "We couldn't create {name}"
    },
    description: {
        "id": "directories.filters-v2.main.flags.copy.error.description",
        "defaultMessage": "There was an error, please try again."
    }
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$4f44bfcea97e3302$export$2e2bcd8739ae039 = (name)=>({
        type: 'error',
        title: [
            $4f44bfcea97e3302$var$messages.title,
            {
                name: name
            }
        ],
        description: $4f44bfcea97e3302$var$messages.description,
        messageId: 'filters-main.flags.copy.flag.error',
        messageType: 'transactional'
    });

});

parcelRegister("gOygZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $a64447113423f5c4$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $a64447113423f5c4$var$messages = (0, $7qGN1.defineMessages)({
    title: {
        "id": "directories.filters-v2.main.flags.copy.success.title",
        "defaultMessage": "A copy of {name} was successfully created."
    }
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$a64447113423f5c4$export$2e2bcd8739ae039 = ({ name: name })=>({
        type: 'success',
        title: [
            $a64447113423f5c4$var$messages.title,
            {
                name: name
            }
        ],
        isAutoDismiss: true,
        messageId: 'filters-main.flags.copy.flag.success',
        messageType: 'transactional'
    });

});

parcelRegister("7aaKo", function(module, exports) {

$parcel$export(module.exports, "default", () => $e926e58d9b0c6175$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $e926e58d9b0c6175$var$messages = (0, $7qGN1.defineMessages)({
    title: {
        "id": "directories.filters-v2.main.flags.delete.error.title",
        "defaultMessage": "We couldn't delete {name}"
    },
    description: {
        "id": "directories.filters-v2.main.flags.delete.error.description",
        "defaultMessage": "There was an error, please try again."
    }
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$e926e58d9b0c6175$export$2e2bcd8739ae039 = ({ name: name })=>({
        type: 'error',
        title: [
            $e926e58d9b0c6175$var$messages.title,
            {
                name: name
            }
        ],
        description: $e926e58d9b0c6175$var$messages.description,
        messageId: 'filters-main.flags.delete.flag.error',
        messageType: 'transactional'
    });

});

parcelRegister("bKZjk", function(module, exports) {

$parcel$export(module.exports, "default", () => $be65a0ca9c7a2c1b$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $be65a0ca9c7a2c1b$var$messages = (0, $7qGN1.defineMessages)({
    title: {
        "id": "directories.filters-v2.main.flags.delete.success.title",
        "defaultMessage": "{name} was deleted"
    }
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$be65a0ca9c7a2c1b$export$2e2bcd8739ae039 = ({ name: name })=>({
        type: 'success',
        title: [
            $be65a0ca9c7a2c1b$var$messages.title,
            {
                name: name
            }
        ],
        isAutoDismiss: true,
        messageId: 'filters-main.flags.delete.flag.success',
        messageType: 'transactional'
    });

});

parcelRegister("kGpwJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $b97b4c55195ab266$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $b97b4c55195ab266$var$messages = (0, $7qGN1.defineMessages)({
    title: {
        "id": "directories.filters-v2.main.flags.initiate-copy-modal.error.title",
        "defaultMessage": "We couldn't get filter data"
    },
    description: {
        "id": "directories.filters-v2.main.flags.initiate-copy-modal.error.description",
        "defaultMessage": "Something went wrong. Try again."
    }
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$b97b4c55195ab266$export$2e2bcd8739ae039 = ()=>({
        type: 'error',
        title: $b97b4c55195ab266$var$messages.title,
        description: $b97b4c55195ab266$var$messages.description,
        messageId: 'filters-main.flags.initiate-copy-modal.flag.error',
        messageType: 'transactional'
    });

});


parcelRegister("kcP89", function(module, exports) {

$parcel$export(module.exports, "isQueryChanged", () => $80c1357307cbe1c3$export$dcc7e61e8982458d);

var $cSmYj = parcelRequire("cSmYj");
const $80c1357307cbe1c3$var$getOwnerIdentifier = (owner)=>owner.accountId;
const $80c1357307cbe1c3$var$getQueryValues = (target)=>{
    const { page: page, sortField: sortField, sortDirection: sortDirection, filter: filter } = target;
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const { query: query, owner: owner, project: project, group: group } = filter;
    return {
        page: page,
        sortField: sortField,
        sortDirection: sortDirection,
        filter: {
            query: query,
            owner: owner && $80c1357307cbe1c3$var$getOwnerIdentifier(owner),
            project: project && project.value,
            group: group && group.value
        }
    };
};
const $80c1357307cbe1c3$export$dcc7e61e8982458d = (newQuery, prevQuery)=>!(0, (/*@__PURE__*/$parcel$interopDefault($cSmYj)))($80c1357307cbe1c3$var$getQueryValues(newQuery), $80c1357307cbe1c3$var$getQueryValues(prevQuery));

});

parcelRegister("iXY2d", function(module, exports) {

$parcel$export(module.exports, "default", () => $cf3a41469a939530$export$2e2bcd8739ae039);

var $4tM8k = parcelRequire("4tM8k");

var $12mPO = parcelRequire("12mPO");

var $jvvA6 = parcelRequire("jvvA6");
var $cf3a41469a939530$export$2e2bcd8739ae039 = (0, $4tM8k.combineEpics)((0, $12mPO.default), (0, $jvvA6.default));

});
parcelRegister("12mPO", function(module, exports) {

$parcel$export(module.exports, "default", () => $ed8e7c52a95aefae$export$2e2bcd8739ae039);

var $4tM8k = parcelRequire("4tM8k");
parcelRequire("1AyD5");
parcelRequire("6cJUr");

var $k4x9q = parcelRequire("k4x9q");

var $7kixv = parcelRequire("7kixv");

var $4IANj = parcelRequire("4IANj");

var $7MYNw = parcelRequire("7MYNw");

var $kycze = parcelRequire("kycze");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $ed8e7c52a95aefae$var$querySet = (action$, store)=>action$.ofType((0, $4IANj.SET_QUERY)).mergeMap(({ payload: payload })=>{
        const state = store.getState();
        const callback = (0, $7MYNw.getOnQueryChanged)(state);
        if (typeof callback === 'function') callback(payload);
        return (0, $7kixv.Observable).empty();
    });
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $ed8e7c52a95aefae$var$queryPatched = (action$, store)=>action$.ofType((0, $4IANj.PATCH_QUERY)).mergeMap(({ payload: payload })=>{
        const state = store.getState();
        const callback = (0, $7MYNw.getOnQueryChanged)(state);
        if (typeof callback === 'function') callback((0, (/*@__PURE__*/$parcel$interopDefault($k4x9q)))(payload, (0, $kycze.getQuery)(state)));
        return (0, $7kixv.Observable).empty();
    });
var $ed8e7c52a95aefae$export$2e2bcd8739ae039 = (0, $4tM8k.combineEpics)($ed8e7c52a95aefae$var$querySet, $ed8e7c52a95aefae$var$queryPatched);

});
parcelRegister("4IANj", function(module, exports) {

$parcel$export(module.exports, "SET_QUERY", () => $50617dbf175cb5b1$export$11bcea24b35a126f);
$parcel$export(module.exports, "setQuery", () => $50617dbf175cb5b1$export$f3b215b0b382f63b);
$parcel$export(module.exports, "PATCH_QUERY", () => $50617dbf175cb5b1$export$403065a1ff0b1663);
$parcel$export(module.exports, "patchQuery", () => $50617dbf175cb5b1$export$8a4e224aafd3a2bf);
const $50617dbf175cb5b1$export$11bcea24b35a126f = 'state.actions.query.SET_QUERY';
const $50617dbf175cb5b1$export$f3b215b0b382f63b = (payload)=>({
        type: $50617dbf175cb5b1$export$11bcea24b35a126f,
        payload: payload
    });
const $50617dbf175cb5b1$export$403065a1ff0b1663 = 'state.actions.query.PATCH_QUERY';
const $50617dbf175cb5b1$export$8a4e224aafd3a2bf = (payload)=>({
        type: $50617dbf175cb5b1$export$403065a1ff0b1663,
        payload: payload
    });

});

parcelRegister("7MYNw", function(module, exports) {

$parcel$export(module.exports, "getAtlassianAccountId", () => $1dd19dd9847a5cb2$export$f5baf4f0aaa47428);
$parcel$export(module.exports, "getIsAdmin", () => $1dd19dd9847a5cb2$export$7d046765d192af80);
$parcel$export(module.exports, "getOnQueryChanged", () => $1dd19dd9847a5cb2$export$59e4f8ebf6520bf7);
$parcel$export(module.exports, "getXsrfToken", () => $1dd19dd9847a5cb2$export$14407a25c57e1f92);
$parcel$export(module.exports, "isWithoutHeader", () => $1dd19dd9847a5cb2$export$ac359c528ee5de31);
const $1dd19dd9847a5cb2$export$f5baf4f0aaa47428 = (state)=>state.app.props.atlassianAccountId;
const $1dd19dd9847a5cb2$export$7d046765d192af80 = (state)=>state.app.props.isAdmin;
const $1dd19dd9847a5cb2$export$59e4f8ebf6520bf7 = (state)=>state.app.props.onQueryChanged;
const $1dd19dd9847a5cb2$export$14407a25c57e1f92 = (state)=>state.app.props.xsrfToken;
const $1dd19dd9847a5cb2$export$ac359c528ee5de31 = (state)=>state.app.props.withoutHeader;
const $1dd19dd9847a5cb2$export$29e8a85166eb4498 = (state)=>state.app.props.withPageReadyMetrics;

});

parcelRegister("kycze", function(module, exports) {

$parcel$export(module.exports, "getQuery", () => $4db09d0eaae76b8d$export$71eec30d9db46a56);
$parcel$export(module.exports, "getSortField", () => $4db09d0eaae76b8d$export$9b753af5a9fb5911);
$parcel$export(module.exports, "getSortDirection", () => $4db09d0eaae76b8d$export$509e2b9937961873);
$parcel$export(module.exports, "getPage", () => $4db09d0eaae76b8d$export$c2a6433281518c91);
$parcel$export(module.exports, "getFilter", () => $4db09d0eaae76b8d$export$61ec8404f465cd36);
$parcel$export(module.exports, "getSearchQuery", () => $4db09d0eaae76b8d$export$1664b92369554829);
$parcel$export(module.exports, "getSelectedProject", () => $4db09d0eaae76b8d$export$1ebc7a42c839af66);
$parcel$export(module.exports, "getSelectedGroup", () => $4db09d0eaae76b8d$export$27ee39f0d715ac22);
$parcel$export(module.exports, "getSelectedOwner", () => $4db09d0eaae76b8d$export$858444e3fc2798fd);
$parcel$export(module.exports, "isFilterApplied", () => $4db09d0eaae76b8d$export$980aed36f19060a5);

var $ahm5r = parcelRequire("ahm5r");
const $4db09d0eaae76b8d$export$71eec30d9db46a56 = (state)=>state.query;
const $4db09d0eaae76b8d$export$9b753af5a9fb5911 = (state)=>state.query.sortField;
const $4db09d0eaae76b8d$export$509e2b9937961873 = (state)=>state.query.sortDirection;
const $4db09d0eaae76b8d$export$c2a6433281518c91 = (state)=>state.query.page;
const $4db09d0eaae76b8d$export$61ec8404f465cd36 = (state)=>state.query.filter;
const $4db09d0eaae76b8d$export$1664b92369554829 = (state)=>$4db09d0eaae76b8d$export$61ec8404f465cd36(state)?.query || '';
const $4db09d0eaae76b8d$export$1ebc7a42c839af66 = (state)=>$4db09d0eaae76b8d$export$61ec8404f465cd36(state)?.project;
const $4db09d0eaae76b8d$export$27ee39f0d715ac22 = (state)=>$4db09d0eaae76b8d$export$61ec8404f465cd36(state)?.group;
const $4db09d0eaae76b8d$export$858444e3fc2798fd = (state)=>$4db09d0eaae76b8d$export$61ec8404f465cd36(state)?.owner;
const $4db09d0eaae76b8d$export$980aed36f19060a5 = (0, $ahm5r.createSelector)($4db09d0eaae76b8d$export$1664b92369554829, $4db09d0eaae76b8d$export$1ebc7a42c839af66, $4db09d0eaae76b8d$export$27ee39f0d715ac22, $4db09d0eaae76b8d$export$858444e3fc2798fd, (queryValue, projectValue, groupValue, ownerValue)=>!!queryValue || !!projectValue || !!groupValue || !!ownerValue);

});


parcelRegister("jvvA6", function(module, exports) {

$parcel$export(module.exports, "default", () => $a6a8328beb9250c1$export$2e2bcd8739ae039);
parcelRequire("9BkTq");
parcelRequire("cBiei");
parcelRequire("hfuHK");
parcelRequire("c1D7V");
parcelRequire("6cJUr");

var $7kixv = parcelRequire("7kixv");

var $gYnSx = parcelRequire("gYnSx");

var $7jp3Y = parcelRequire("7jp3Y");

var $4ETME = parcelRequire("4ETME");

var $7MYNw = parcelRequire("7MYNw");

var $kycze = parcelRequire("kycze");

var $fguXv = parcelRequire("fguXv");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$a6a8328beb9250c1$export$2e2bcd8739ae039 = (action$, store)=>{
    const getFiltersRequestAction$ = action$.ofType((0, $4ETME.RETRIEVE));
    return getFiltersRequestAction$.mergeMap(()=>{
        const state = store.getState();
        const request = (0, $fguXv.getServiceRequest)(state);
        const filter = (0, $kycze.getFilter)(state);
        const isAdmin = (0, $7MYNw.getIsAdmin)(state);
        // @ts-expect-error - TS2345 - Type 'undefined' is not assignable to type 'Filter'.
        return (0, $7kixv.Observable).fromPromise((0, $7jp3Y.default)(request, filter, isAdmin)).mergeMap((result)=>(0, $7kixv.Observable).of((0, $4ETME.retrieved)(result))).takeUntil(getFiltersRequestAction$).catch((error)=>{
            (0, $gYnSx.default)({
                error: error,
                meta: {
                    id: 'retrieveFilters',
                    packageName: 'jiraFiltersMain',
                    teamName: 'jira-cosmos'
                }
            });
            return (0, $7kixv.Observable).of((0, $4ETME.retrieveFailed)());
        });
    });
};

});
parcelRegister("7jp3Y", function(module, exports) {

$parcel$export(module.exports, "default", () => $bca13703f45d1ca3$export$2e2bcd8739ae039);

var $cPtZS = parcelRequire("cPtZS");

var $j5FS3 = parcelRequire("j5FS3");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$bca13703f45d1ca3$export$2e2bcd8739ae039 = async (request, filter, isAdmin)=>{
    const restResponse = await (0, $cPtZS.default)(request, filter, isAdmin);
    return (0, $j5FS3.transformFilters)(restResponse.values, restResponse.total);
};

});
parcelRegister("cPtZS", function(module, exports) {

$parcel$export(module.exports, "default", () => $2ddce2e86558d137$export$2e2bcd8739ae039);

var $8sbs2 = parcelRequire("8sbs2");

var $b5RwB = parcelRequire("b5RwB");

var $k6LT0 = parcelRequire("k6LT0");

var $a571L = parcelRequire("a571L");

var $eSnSE = parcelRequire("eSnSE");

var $1oMOM = parcelRequire("1oMOM");
const $2ddce2e86558d137$var$createQueryFilter = (filter)=>({
        filterName: filter.query,
        isSubstringMatch: true
    });
const $2ddce2e86558d137$var$createProjectFilter = (filter)=>({
        projectId: filter.project ? filter.project.value : undefined
    });
const $2ddce2e86558d137$var$createGroupFilter = (filter)=>({
        groupname: filter.group ? filter.group.value : undefined
    });
const $2ddce2e86558d137$var$createOwnerFilter = (filter)=>({
        accountId: filter.owner ? filter.owner.accountId : undefined,
        owner: undefined
    });
const $2ddce2e86558d137$var$logError = async (error, currentTry)=>{
    (0, $eSnSE.default).safeErrorWithoutCustomerData('ops.rest.filters.get', `Cannot fetch filters - is SSR: ${String(false)}, attempt: ${currentTry}`, error);
};
const $2ddce2e86558d137$export$20e00d0048bb5104 = ()=>'/rest/api/2/filter/search';
const $2ddce2e86558d137$export$7138c24907de3954 = (request, filter, isAdmin)=>{
    const queryParams = {
        ...(0, (/*@__PURE__*/$parcel$interopDefault($8sbs2)))(request, 'startAt', 'maxResults', 'orderBy', 'expand'),
        ...filter.query ? $2ddce2e86558d137$var$createQueryFilter(filter) : undefined,
        ...filter.project ? $2ddce2e86558d137$var$createProjectFilter(filter) : undefined,
        ...filter.group ? $2ddce2e86558d137$var$createGroupFilter(filter) : undefined,
        ...filter.owner ? $2ddce2e86558d137$var$createOwnerFilter(filter) : undefined
    };
    return `${$2ddce2e86558d137$export$20e00d0048bb5104()}?${(0, $b5RwB.stringify)(queryParams)}${isAdmin ? '&overrideSharePermissions=true' : ''}`;
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$2ddce2e86558d137$export$2e2bcd8739ae039 = async (request, filter, isAdmin)=>{
    const url = $2ddce2e86558d137$export$7138c24907de3954(request, filter, isAdmin);
    const response = await (0, $a571L.fetchWithRetry)(url, (0, $1oMOM.getDefaultOptions)(url), $2ddce2e86558d137$var$logError);
    if (response.ok) return response.json();
    throw await (0, $k6LT0.getErrorFromResponse)(response, 'Cannot fetch filters');
};

});
parcelRegister("8sbs2", function(module, exports) {

var $d3Wo8 = parcelRequire("d3Wo8");

var $lgI96 = parcelRequire("lgI96");
/**
 * Creates an object composed of the picked `object` properties.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The source object.
 * @param {...(string|string[])} [paths] The property paths to pick.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.pick(object, ['a', 'c']);
 * // => { 'a': 1, 'c': 3 }
 */ var $01969c2a577eb827$var$pick = $lgI96(function(object, paths) {
    return object == null ? {} : $d3Wo8(object, paths);
});
module.exports = $01969c2a577eb827$var$pick;

});
parcelRegister("d3Wo8", function(module, exports) {

var $8WT03 = parcelRequire("8WT03");

var $4tuSC = parcelRequire("4tuSC");
/**
 * The base implementation of `_.pick` without support for individual
 * property identifiers.
 *
 * @private
 * @param {Object} object The source object.
 * @param {string[]} paths The property paths to pick.
 * @returns {Object} Returns the new object.
 */ function $9828d8da72c16145$var$basePick(object, paths) {
    return $8WT03(object, paths, function(value, path) {
        return $4tuSC(object, path);
    });
}
module.exports = $9828d8da72c16145$var$basePick;

});


parcelRegister("k6LT0", function(module, exports) {

$parcel$export(module.exports, "getErrorFromResponse", () => $79c4b7796896939e$export$7780d7826aafbede);

var $1uIew = parcelRequire("1uIew");

var $jGzN3 = parcelRequire("jGzN3");
const $79c4b7796896939e$export$7780d7826aafbede = async (response, defaultMessage)=>{
    let errorMessage = defaultMessage;
    try {
        const json = await response.json();
        const { errors: errors, errorMessages: errorMessages } = json;
        if (errors && Object.keys(errors).length) return (0, $jGzN3.transformValidationErrorFromServer)(json);
        errorMessage = errorMessages[0];
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
    /**/ }
    return new (0, $1uIew.default)(response.status, errorMessage);
};

});

parcelRegister("a571L", function(module, exports) {

$parcel$export(module.exports, "fetchWithRetry", () => $5dd1c9e5c72ce527$export$cffaac380b94df26);

var $1oMOM = parcelRequire("1oMOM");

var $k6LT0 = parcelRequire("k6LT0");
const $5dd1c9e5c72ce527$export$fbc55f9ab8ae7207 = false ? 1 : 3;
const $5dd1c9e5c72ce527$var$logResponseError = async (logSafeErrorWithoutCustomerData, response, currentTry)=>{
    const error = await (0, $k6LT0.getErrorFromResponse)(response, 'Directory fetch with retry failed');
    await logSafeErrorWithoutCustomerData(error, currentTry);
};
const $5dd1c9e5c72ce527$export$cffaac380b94df26 = async (url, options, logSafeErrorWithoutCustomerData, currentTry = 1)=>{
    try {
        const response = await fetch(url, (0, $1oMOM.getDefaultOptions)(url));
        if (!response.ok) {
            await $5dd1c9e5c72ce527$var$logResponseError(logSafeErrorWithoutCustomerData, response, currentTry);
            if (currentTry < $5dd1c9e5c72ce527$export$fbc55f9ab8ae7207) return $5dd1c9e5c72ce527$export$cffaac380b94df26(url, options, logSafeErrorWithoutCustomerData, currentTry + 1);
        }
        return response;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        await logSafeErrorWithoutCustomerData(error, currentTry);
        if (currentTry < $5dd1c9e5c72ce527$export$fbc55f9ab8ae7207) return $5dd1c9e5c72ce527$export$cffaac380b94df26(url, options, logSafeErrorWithoutCustomerData, currentTry + 1);
        throw error;
    }
};

});


parcelRegister("j5FS3", function(module, exports) {

$parcel$export(module.exports, "transformFilters", () => $0f70041d988be99a$export$6b801750e47278fe);

var $9g7yh = parcelRequire("9g7yh");

var $huH03 = parcelRequire("huH03");

var $8nDSw = parcelRequire("8nDSw");
const $0f70041d988be99a$export$6b801750e47278fe = (filters, total)=>{
    const order = filters.map((i)=>i.id);
    const responsesById = (0, (/*@__PURE__*/$parcel$interopDefault($9g7yh)))(filters, (filter)=>filter.id);
    const page = (0, (/*@__PURE__*/$parcel$interopDefault($huH03)))(responsesById, (response)=>(0, $8nDSw.transformFilter)(response));
    return {
        page: page,
        order: order,
        total: total
    };
};

});
parcelRegister("9g7yh", function(module, exports) {

var $iBJlb = parcelRequire("iBJlb");

var $a9KaZ = parcelRequire("a9KaZ");
/**
 * Creates an object composed of keys generated from the results of running
 * each element of `collection` thru `iteratee`. The corresponding value of
 * each key is the last element responsible for generating the key. The
 * iteratee is invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
 * @returns {Object} Returns the composed aggregate object.
 * @example
 *
 * var array = [
 *   { 'dir': 'left', 'code': 97 },
 *   { 'dir': 'right', 'code': 100 }
 * ];
 *
 * _.keyBy(array, function(o) {
 *   return String.fromCharCode(o.code);
 * });
 * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
 *
 * _.keyBy(array, 'dir');
 * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
 */ var $6bdb775087644ec3$var$keyBy = $a9KaZ(function(result, value, key) {
    $iBJlb(result, key, value);
});
module.exports = $6bdb775087644ec3$var$keyBy;

});

parcelRegister("8nDSw", function(module, exports) {

$parcel$export(module.exports, "transformFilter", () => $348ac611d5c5bc5d$export$4f94cef62d9cfa51);

var $5DL51 = parcelRequire("5DL51");
const $348ac611d5c5bc5d$export$4f94cef62d9cfa51 = (item)=>({
        id: item.id,
        name: item.name,
        viewUrl: `/issues/?filter=${item.id}`,
        owner: item.owner ? (0, $5DL51.transformUser)(item.owner) : null,
        isFavourite: item.favourite,
        popularity: item.favouritedCount || 0,
        shares: item.sharePermissions ? item.sharePermissions.map((0, $5DL51.transformSharePermission)).filter(Boolean) : [],
        edits: item.editPermissions ? item.editPermissions.map((0, $5DL51.transformSharePermission)).filter(Boolean) : [],
        description: item.description,
        jql: item.jql,
        isWritable: item.isWritable === true
    });

});
parcelRegister("5DL51", function(module, exports) {

$parcel$export(module.exports, "transformUser", () => $6e6cbad6f60e414e$export$88dcd5c1adae8021);
$parcel$export(module.exports, "transformSharePermission", () => $6e6cbad6f60e414e$export$443a799045209d52);
$parcel$export(module.exports, "transformSharePermissionsToServer", () => $6e6cbad6f60e414e$export$e05899da868da914);


var $a62R3 = parcelRequire("a62R3");

var $7jTnu = parcelRequire("7jTnu");

const $6e6cbad6f60e414e$var$assertUnreachable = (_x)=>{
    throw new Error("Didn't expect to get here");
};
const $6e6cbad6f60e414e$export$88dcd5c1adae8021 = (user)=>{
    let profileUrl;
    if ((0, $7jTnu.fg)('jira-adopt-teams-nav-config')) {
        const { href: href } = (0, $a62R3.getNavigateToTeamsApp)({
            type: 'USER',
            payload: {
                userId: user.accountId
            }
        });
        profileUrl = href;
    } else profileUrl = `/jira/people/${user.accountId}`;
    return {
        displayName: user.displayName,
        avatarUrl: user.avatarUrls && user.avatarUrls['48x48'],
        accountId: user.accountId,
        profileUrl: profileUrl
    };
};
const $6e6cbad6f60e414e$export$443a799045209d52 = (sharePermission)=>{
    switch(sharePermission.type){
        case 0, $f461f432d18e9f64$export$86517eb0163ef745:
            return {
                type: (0, $f461f432d18e9f64$export$86517eb0163ef745)
            };
        case 0, $f461f432d18e9f64$export$b0a0e62d9b1a8269:
            return {
                type: (0, $f461f432d18e9f64$export$b0a0e62d9b1a8269)
            };
        case 0, $f461f432d18e9f64$export$b02d7412182d1bce:
            return {
                type: (0, $f461f432d18e9f64$export$b02d7412182d1bce),
                group: {
                    ...sharePermission.group
                }
            };
        case 0, $f461f432d18e9f64$export$5ef95a67b8fd1ff6:
            {
                const { project: project, role: role } = sharePermission;
                return {
                    type: (0, $f461f432d18e9f64$export$5ef95a67b8fd1ff6),
                    project: {
                        id: project.id,
                        name: project.name,
                        avatarUrl: project.avatarUrls['48x48']
                    },
                    role: role && {
                        id: role.id,
                        name: role.name
                    }
                };
            }
        case 0, $f461f432d18e9f64$export$487da0972e3459fe:
            return sharePermission;
        case 0, $f461f432d18e9f64$export$aea0835048e1c730:
            {
                const { user: user } = sharePermission;
                return {
                    type: (0, $f461f432d18e9f64$export$aea0835048e1c730),
                    user: {
                        accountId: user.accountId,
                        displayName: user.displayName,
                        avatarUrl: user.avatarUrls['48x48']
                    }
                };
            }
        default:
            $6e6cbad6f60e414e$var$assertUnreachable(sharePermission);
            return null;
    }
};
const $6e6cbad6f60e414e$export$e05899da868da914 = (sharePermissions, shouldReturnGroupIdForGroupIfAvailable = false)=>sharePermissions.map((sharePermission)=>{
        switch(sharePermission.type){
            case 0, $f461f432d18e9f64$export$b02d7412182d1bce:
                {
                    let group = {
                        name: sharePermission.group.name
                    };
                    if (shouldReturnGroupIdForGroupIfAvailable && sharePermission.group.groupId) group = {
                        groupId: sharePermission.group.groupId
                    };
                    return {
                        type: sharePermission.type,
                        group: group
                    };
                }
            case 0, $f461f432d18e9f64$export$aea0835048e1c730:
                return {
                    type: sharePermission.type,
                    user: {
                        accountId: sharePermission.user.accountId
                    }
                };
            case 0, $f461f432d18e9f64$export$5ef95a67b8fd1ff6:
                {
                    const permission = {
                        type: sharePermission.role ? (0, $72721d8cb7d8a0db$export$4d955b5fb0c1d4d7) : (0, $f461f432d18e9f64$export$5ef95a67b8fd1ff6),
                        project: {
                            id: sharePermission.project.id
                        }
                    };
                    if (sharePermission.role) permission.role = {
                        id: sharePermission.role.id
                    };
                    return permission;
                }
            case 0, $f461f432d18e9f64$export$487da0972e3459fe:
                return sharePermission;
            case 0, $f461f432d18e9f64$export$b0a0e62d9b1a8269:
                return {
                    type: (0, $72721d8cb7d8a0db$export$e2fe9963c33d5918)
                };
            case 0, $f461f432d18e9f64$export$86517eb0163ef745:
                return sharePermission;
            default:
                $6e6cbad6f60e414e$var$assertUnreachable(sharePermission);
                return sharePermission;
        }
    });

});
const $f461f432d18e9f64$export$b02d7412182d1bce = 'group';
const $f461f432d18e9f64$export$5ef95a67b8fd1ff6 = 'project';
const $f461f432d18e9f64$export$487da0972e3459fe = 'project-unknown';
const $f461f432d18e9f64$export$b0a0e62d9b1a8269 = 'loggedin';
const $f461f432d18e9f64$export$86517eb0163ef745 = 'global';
const $f461f432d18e9f64$export$aea0835048e1c730 = 'user';
 // this is what can come from backend

parcelRegister("a62R3", function(module, exports) {

$parcel$export(module.exports, "useNavigateToTeamsApp", () => $4bdb55387d231b38$export$520a42ab062954ec);
$parcel$export(module.exports, "getNavigateToTeamsApp", () => $4bdb55387d231b38$export$cfadab73fb247145);
$parcel$export(module.exports, "useTransformToTeamsAppUrl", () => $4bdb55387d231b38$export$dc7e633fb6368a43);
$parcel$export(module.exports, "toTeamsAppURL", () => $4bdb55387d231b38$export$196b2cec97b1c87c);
$parcel$export(module.exports, "isTeamsAppEnabled", () => $4bdb55387d231b38$export$5921b2a93a401547);

var $fvpPO = parcelRequire("fvpPO");

var $j19W0 = parcelRequire("j19W0");

var $g9Vr6 = parcelRequire("g9Vr6");

var $kEUB1 = parcelRequire("kEUB1");

var $83DiZ = parcelRequire("83DiZ");

var $6zXPf = parcelRequire("6zXPf");

var $hWeHP = parcelRequire("hWeHP");
const $4bdb55387d231b38$export$520a42ab062954ec = (navActionPayload, shouldOpenInSameTab)=>{
    const { data: orgId } = (0, $g9Vr6.useOrgId)();
    const cloudId = (0, $kEUB1.useCloudId)();
    const { push: push } = (0, $83DiZ.useRouterActions)();
    if (!orgId && !cloudId) throw new Error('Org ID or Cloud ID is required to navigate to Teams App');
    return (0, $j19W0.navigateToTeamsApp)({
        push: push,
        hostProduct: 'jira',
        orgId: orgId,
        cloudId: cloudId,
        userHasNav4Enabled: (0, $6zXPf.getWillShowNav4)(),
        shouldOpenInSameTab: shouldOpenInSameTab,
        ...navActionPayload
    });
};
const $4bdb55387d231b38$export$cfadab73fb247145 = (navActionPayload, shouldOpenInSameTab)=>{
    const orgId = (0, $hWeHP.default)('ajs-org-id');
    const cloudId = (0, $hWeHP.default)('ajs-cloud-id');
    return (0, $j19W0.navigateToTeamsApp)({
        hostProduct: 'jira',
        orgId: orgId || '',
        cloudId: cloudId || undefined,
        userHasNav4Enabled: (0, $6zXPf.getWillShowNav4)(),
        shouldOpenInSameTab: shouldOpenInSameTab,
        ...navActionPayload
    });
};
const $4bdb55387d231b38$export$dc7e633fb6368a43 = (path, search = '')=>{
    const { data: orgId } = (0, $g9Vr6.useOrgId)();
    const cloudId = (0, $kEUB1.useCloudId)();
    return (0, $j19W0.toTeamsAppURL)(path, search, {
        orgId: orgId,
        cloudId: cloudId
    });
};
const $4bdb55387d231b38$export$196b2cec97b1c87c = (path, search = '')=>{
    const orgId = (0, $hWeHP.default)('ajs-org-id');
    const cloudId = (0, $hWeHP.default)('ajs-cloud-id');
    return (0, $j19W0.toTeamsAppURL)(path, search, {
        orgId: orgId ?? '',
        cloudId: cloudId ?? ''
    });
};
const $4bdb55387d231b38$export$5921b2a93a401547 = ()=>{
    return (0, $fvpPO.isTeamsAppEnabled)({
        hostProduct: 'jira',
        userHasNav4Enabled: (0, $6zXPf.getWillShowNav4)()
    });
};

});
parcelRegister("fvpPO", function(module, exports) {

$parcel$export(module.exports, "isTeamsAppEnabled", () => $e45f3caa2e661ed2$export$5921b2a93a401547);

var $lopBx = parcelRequire("lopBx");
var $7pw1V = parcelRequire("7pw1V");

var $59rsN = parcelRequire("59rsN");

var $eGOwo = parcelRequire("eGOwo");
function $e45f3caa2e661ed2$export$5921b2a93a401547(config) {
    //  Hard kill switch for isolated cloud until Standalone directory is deployed
    if ((0, $7pw1V.isIsolatedCloud)()) return false;
    // Due to experiment exposures, we need to first check if Nav4 is enabled to see if the user is in the cohort
    // In FedRamp, we are ignoring the Nav4 dependency
    if (!(0, $lopBx.isFedRamp)() && config.userHasNav4Enabled !== undefined && !config.userHasNav4Enabled) return false;
    if ((0, $59rsN.default).initializeCompleted()) {
        // Next we check the experiment value based on the host product
        if (config.hostProduct === 'jira' && (0, $59rsN.default).getExperimentValue('migrate-jira-people-directory-to-teams-app', 'isEnabled', false)) return true;
        if (config.hostProduct === 'confluence' && (0, $59rsN.default).getExperimentValue('migrate-confluence-people-directory-to-teams-app', 'isEnabled', false)) return true;
    }
    // Lastly we check the feature gate which we are using for dogfooding, we won't roll this flag out in production.
    return (0, $eGOwo.fg)('should-redirect-directory-to-teams-app');
}

});
parcelRegister("7pw1V", function(module, exports) {

$parcel$export(module.exports, "isIsolatedCloud", () => $d69f5d46c1cc4180$export$9186ccba8effc5de);
$parcel$export(module.exports, "isFedrampModerate", () => $d69f5d46c1cc4180$export$104cb891a6e90b3a);
$parcel$export(module.exports, "isolatedCloudDomain", () => $d69f5d46c1cc4180$export$80638ee198476daf);

var $2NMzR = parcelRequire("2NMzR");

var $dEAD4 = parcelRequire("dEAD4");
function $d69f5d46c1cc4180$export$9186ccba8effc5de() {
    if (typeof document === 'undefined') // @ts-ignore
    return globalThis.ssrContext.isInIC;
    const atlCtxCookieValues = (0, $dEAD4.parseAtlCtxCookies)();
    if (!atlCtxCookieValues) // If the cookies are not set, the current perimeter is non-isolated commercial
    return false;
    // The icDomain check is needed for when federal perimeters are eventually added to Isolated Cloud as well
    return (0, $2NMzR.ISOLATED_CLOUD_PERIMETERS).includes(atlCtxCookieValues.perimeter) && atlCtxCookieValues.icDomain !== undefined;
}
function $d69f5d46c1cc4180$export$104cb891a6e90b3a() {
    if (typeof document === 'undefined') // @ts-ignore
    return globalThis.ssrContext.isInFedramp;
    const atlCtxCookieValues = (0, $dEAD4.parseAtlCtxCookies)();
    if (!atlCtxCookieValues) // If the cookies are not set, the current perimeter is non-isolated commercial
    return false;
    return atlCtxCookieValues.perimeter === (0, $2NMzR.FEDRAMP_MODERATE);
}
function $d69f5d46c1cc4180$export$80638ee198476daf() {
    const atlCtxCookieValues = (0, $dEAD4.parseAtlCtxCookies)();
    return atlCtxCookieValues?.icDomain;
}
function $d69f5d46c1cc4180$export$839b022803d38d4d() {
    if (typeof document === 'undefined') // @ts-ignore
    return $d69f5d46c1cc4180$export$9186ccba8effc5de() ? globalThis.ssrContext.icName : undefined;
    const atlCtxCookieValues = (0, $dEAD4.parseAtlCtxCookies)();
    return atlCtxCookieValues?.icId;
}

});
parcelRegister("2NMzR", function(module, exports) {

$parcel$export(module.exports, "FEDRAMP_MODERATE", () => $5643fc3819312a1c$export$ce553301d55c2fd8);
$parcel$export(module.exports, "COMMERCIAL", () => $5643fc3819312a1c$export$f005e2e9f707cb5f);
$parcel$export(module.exports, "STAGING", () => $5643fc3819312a1c$export$a739cd5aac835909);
$parcel$export(module.exports, "PRODUCTION", () => $5643fc3819312a1c$export$42dd0cdd351a4a9);
$parcel$export(module.exports, "DEV", () => $5643fc3819312a1c$export$404582bc18fe4d9e);
$parcel$export(module.exports, "ISOLATED_CLOUD_PERIMETERS", () => $5643fc3819312a1c$export$d8347b4aae768c2d);
$parcel$export(module.exports, "NON_ISOLATED_CLOUD_PERIMETERS", () => $5643fc3819312a1c$export$b1b1ccc8f3e7f954);
$parcel$export(module.exports, "ATL_CTX_PERIMETER", () => $5643fc3819312a1c$export$87285944378c596);
$parcel$export(module.exports, "ATL_CTX_ISOLATION_CONTEXT_DOMAIN", () => $5643fc3819312a1c$export$715603e81922c3ec);
$parcel$export(module.exports, "ATL_CTX_ISOLATION_CONTEXT_ID", () => $5643fc3819312a1c$export$a0ffa0598c95dfb7);
const $5643fc3819312a1c$export$ce553301d55c2fd8 = 'fedramp-moderate';
const $5643fc3819312a1c$export$f005e2e9f707cb5f = 'commercial';
const $5643fc3819312a1c$export$a739cd5aac835909 = 'staging';
const $5643fc3819312a1c$export$42dd0cdd351a4a9 = 'prod';
const $5643fc3819312a1c$export$404582bc18fe4d9e = 'dev';
const $5643fc3819312a1c$export$d8347b4aae768c2d = [
    $5643fc3819312a1c$export$f005e2e9f707cb5f
];
const $5643fc3819312a1c$export$b1b1ccc8f3e7f954 = [
    $5643fc3819312a1c$export$f005e2e9f707cb5f,
    $5643fc3819312a1c$export$ce553301d55c2fd8
];
const $5643fc3819312a1c$export$87285944378c596 = 'Atl-Ctx-Perimeter';
const $5643fc3819312a1c$export$715603e81922c3ec = 'Atl-Ctx-Isolation-Context-Domain';
const $5643fc3819312a1c$export$a0ffa0598c95dfb7 = 'Atl-Ctx-Isolation-Context-Id';

});

parcelRegister("dEAD4", function(module, exports) {

$parcel$export(module.exports, "parseAtlCtxCookies", () => $7a89cf9f35259f20$export$3fa7b7af96286cc9);

var $2NMzR = parcelRequire("2NMzR");
/**
 * Internal helper function used to parse cookie values and extract value of provided cookie name
 * @param {AtlCtxCookieName} cookieName - The name of the cookie to extract
 * @param {string} cookieString - The full cookie string
 * @returns {string | undefined} - The cookie value if present, undefined otherwise
 */ function $7a89cf9f35259f20$var$getRawCookieValue(cookieName, cookieString) {
    if (!cookieString) return undefined;
    const cookies = cookieString.split(';');
    for (const cookie of cookies){
        const [name, value] = cookie.trim().split('=');
        if (name === cookieName) return value;
    }
    return undefined;
}
function $7a89cf9f35259f20$export$3fa7b7af96286cc9() {
    const global = globalThis;
    try {
        // HOT-118791: the code below doesn't work on the server, and creates log spam in the catch block - "Cannot read properties of undefined (reading 'cookie')"
        if (typeof globalThis.document === 'undefined') return undefined;
        const cookies = global.document.cookie;
        const perimeter = $7a89cf9f35259f20$var$getRawCookieValue((0, $2NMzR.ATL_CTX_PERIMETER), cookies);
        if (!perimeter) // Indicative of non-isolated commercial perimeter
        return undefined;
        const icDomain = $7a89cf9f35259f20$var$getRawCookieValue((0, $2NMzR.ATL_CTX_ISOLATION_CONTEXT_DOMAIN), cookies);
        const icId = $7a89cf9f35259f20$var$getRawCookieValue((0, $2NMzR.ATL_CTX_ISOLATION_CONTEXT_ID), cookies);
        // The IC Domain and IC Id cookie values are empty strings for non Isolated Cloud
        const emptyIcDomain = !icDomain || icDomain.length === 0;
        const emptyIcId = !icId || icId.length === 0;
        return {
            perimeter: perimeter,
            icDomain: emptyIcDomain ? undefined : icDomain,
            icId: emptyIcId ? undefined : icId
        };
    } catch (e) {
        console.warn('Failed to parse atl-ctx cookies:', e);
        return undefined;
    }
}

});



parcelRegister("j19W0", function(module, exports) {

$parcel$export(module.exports, "navigateToTeamsApp", () => $bcd485df6c831087$export$cd99a4ca8e852372);
$parcel$export(module.exports, "toTeamsAppURL", () => $bcd485df6c831087$export$196b2cec97b1c87c);

var $fvpPO = parcelRequire("fvpPO");

var $0FujR = parcelRequire("0FujR");
const $bcd485df6c831087$export$cd99a4ca8e852372 = (action)=>{
    const { hostProduct: hostProduct, shouldOpenInSameTab: shouldOpenInSameTab } = action;
    const actionWithDefaults = {
        ...action,
        /**
		 * If teams app is enabled, default to opening in new tab.
		 */ shouldOpenInSameTab: shouldOpenInSameTab === undefined ? !(0, $fvpPO.isTeamsAppEnabled)(action) : shouldOpenInSameTab,
        hostProduct: hostProduct || (0, $0FujR.getHostProductFromPath)()
    };
    const { path: path, query: query } = (0, $0FujR.getPathAndQuery)(actionWithDefaults);
    const href = (0, $0FujR.generatePath)(path, actionWithDefaults, query);
    const onNavigate = (0, $0FujR.onNavigateBase)(href, actionWithDefaults);
    const result = {
        onNavigate: onNavigate,
        href: href,
        target: actionWithDefaults.shouldOpenInSameTab ? '_self' : '_blank'
    };
    return result;
};
const $bcd485df6c831087$export$196b2cec97b1c87c = (path, search, config)=>{
    return (0, $0FujR.generateTeamsAppPath)(path, config, new URLSearchParams(search));
};

});
parcelRegister("0FujR", function(module, exports) {

$parcel$export(module.exports, "generateTeamsAppPath", () => $a228ae66ede9224c$export$9665cb78fbba2c92);
$parcel$export(module.exports, "generatePath", () => $a228ae66ede9224c$export$82476f982757e71e);
$parcel$export(module.exports, "onNavigateBase", () => $a228ae66ede9224c$export$39f25014273b0a58);
$parcel$export(module.exports, "getPathAndQuery", () => $a228ae66ede9224c$export$b406f12e2156b3fe);
$parcel$export(module.exports, "getHostProductFromPath", () => $a228ae66ede9224c$export$a792d22ca73cc3ca);

var $8RHPx = parcelRequire("8RHPx");
var $lopBx = parcelRequire("lopBx");

var $chYv1 = parcelRequire("chYv1");

var $fvpPO = parcelRequire("fvpPO");
function $a228ae66ede9224c$export$9665cb78fbba2c92(path, config, query = new URLSearchParams(), anchor) {
    if (config.cloudId) query.set('cloudId', config.cloudId);
    const pathWithLeadingSlash = path.startsWith('/') ? path : `/${path}`;
    const pathWithPeoplePrefix = pathWithLeadingSlash.startsWith('/people') ? pathWithLeadingSlash : `/people${pathWithLeadingSlash}`;
    const pathWithoutPeoplePrefix = pathWithLeadingSlash.startsWith('/people') ? pathWithLeadingSlash.replace(/^\/people\//, '/') : pathWithLeadingSlash;
    // URLSearchParams.size doesn't work in jest
    const queryString = [
        ...new Set(query.keys())
    ].length > 0 ? `?${query.toString()}` : '';
    // Home & therefore the Teams app, is not deployed to FedRamp, instead we have deployed Standalone directory.
    // At some point, likely both Commercial & FedRamp will follow the same URL convention and we can remove this,
    // but for now, we need to generate a different URL for FedRamp.
    if ((0, $lopBx.isFedRamp)()) // We can't use getATLContextUrl here as the URL doesn't yet exist in commercial. When it does, we should properly define it there.
    return `https://teams${$a228ae66ede9224c$export$a9f2c34176fff494() ? '.stg' : ''}.atlassian-us-gov.com${pathWithoutPeoplePrefix}${anchor ? `#${anchor}` : ''}${queryString}`;
    const orgIdString = config.orgId ? `/o/${config.orgId}` : '';
    return `${(0, $8RHPx.getATLContextUrl)('home')}${orgIdString}${pathWithPeoplePrefix}${anchor ? `#${anchor}` : ''}${queryString}`;
}
function $a228ae66ede9224c$export$82476f982757e71e(path, config, query = new URLSearchParams(), anchor) {
    if ((0, $fvpPO.isTeamsAppEnabled)(config) || config.hostProduct === 'home' || !config.hostProduct) return $a228ae66ede9224c$export$9665cb78fbba2c92(path, config, query, anchor);
    const queryString = [
        ...new Set(query.keys())
    ].length > 0 ? `?${query.toString()}` : '';
    return `${(0, $chYv1.origin)()}/${config.hostProduct === 'confluence' ? 'wiki' : 'jira'}/people/${path}${queryString}`;
}
const $a228ae66ede9224c$export$39f25014273b0a58 = (href, config)=>(e)=>{
        if (e) e.preventDefault();
        if ((0, $fvpPO.isTeamsAppEnabled)(config)) {
            if (config.shouldOpenInSameTab) {
                (0, $chYv1.redirect)(href);
                return;
            }
            (0, $chYv1.openInNewTab)(href);
            return;
        } else if (config.shouldOpenInSameTab) {
            if (config.push) {
                config.push(href);
                return;
            }
            (0, $chYv1.redirect)(href);
            return;
        } else {
            (0, $chYv1.openInNewTab)(href);
            return;
        }
    };
function $a228ae66ede9224c$var$stripAriFromId(id) {
    // Return everything after the last slash
    return id.includes('/') ? id.split('/').pop() || '' : id;
}
function $a228ae66ede9224c$export$b406f12e2156b3fe(action) {
    switch(action.type){
        case 'LANDING':
        case 'DIRECTORY':
            return {
                path: ''
            };
        case 'USER':
            // Safety check for undefined userId, just redirect to the landing page as the profile redirect will fail
            if (!action.payload?.userId) return {
                path: ''
            };
            return {
                path: `${$a228ae66ede9224c$var$stripAriFromId(action.payload.userId)}`,
                anchor: action.payload.section
            };
        case 'TEAM':
            // Safety check for undefined teamId, just redirect to the landing page as the team redirect will fail
            if (!action.payload?.teamId) return {
                path: ''
            };
            return {
                path: `team/${$a228ae66ede9224c$var$stripAriFromId(action.payload.teamId)}`
            };
        case 'AGENT':
            // Safety check for undefined agentId, just redirect to the landing page as the agent redirect will fail
            if (!action.payload?.agentId) return {
                path: ''
            };
            return {
                path: `agent/${$a228ae66ede9224c$var$stripAriFromId(action.payload.agentId)}`
            };
        case 'KUDOS':
            // Safety check for undefined kudosId, just redirect to the landing page as the kudos redirect will fail
            if (!action.payload?.kudosId) return {
                path: ''
            };
            return {
                path: `kudos/${$a228ae66ede9224c$var$stripAriFromId(action.payload.kudosId)}`
            };
        case 'TEAMS_DIRECTORY':
            return {
                path: '',
                query: new URLSearchParams({
                    screen: 'SEARCH_TEAMS'
                })
            };
        case 'PEOPLE_DIRECTORY':
            return {
                path: `search/people`,
                query: new URLSearchParams(action.payload.query)
            };
        case 'USER_WORK':
            return {
                path: `${$a228ae66ede9224c$var$stripAriFromId(action.payload.userId)}/work`
            };
        case 'CURRENT_USER_PROFILE':
            return {
                path: 'me'
            };
        default:
            return {
                path: ''
            };
    }
}
function $a228ae66ede9224c$export$a9f2c34176fff494() {
    const host = (0, $chYv1.hostname)();
    // *.stg.atlassian-us-gov-mod.com OR *.stg.atlassian-us-gov-mod.net
    if (host.match(/stg\.atlassian-us-gov-mod\.(com|net)/)) return true;
    return false;
}
function $a228ae66ede9224c$export$a792d22ca73cc3ca() {
    const path = (0, $chYv1.pathname)();
    if (path.startsWith('/wiki')) return 'confluence';
    if (path.startsWith('/jira')) return 'jira';
    if ((0, $chYv1.hostname)().startsWith('home')) return 'home';
    return undefined;
}

});
parcelRegister("chYv1", function(module, exports) {

$parcel$export(module.exports, "redirect", () => $c76ad79e98e47bfd$export$89e12c5b50f7529d);
$parcel$export(module.exports, "openInNewTab", () => $c76ad79e98e47bfd$export$9e52b10d57ddf9e3);
$parcel$export(module.exports, "hostname", () => $c76ad79e98e47bfd$export$640106f6dc7d2706);
$parcel$export(module.exports, "origin", () => $c76ad79e98e47bfd$export$f710a83a91838a36);
$parcel$export(module.exports, "pathname", () => $c76ad79e98e47bfd$export$7333db99aa99d383);
function $c76ad79e98e47bfd$export$89e12c5b50f7529d(url) {
    window.location.href = url;
}
const $c76ad79e98e47bfd$export$9e52b10d57ddf9e3 = (url)=>window.open(url, '_blank', 'noopener noreferrer');
const $c76ad79e98e47bfd$export$640106f6dc7d2706 = ()=>globalThis.location?.hostname;
const $c76ad79e98e47bfd$export$f710a83a91838a36 = ()=>globalThis.location?.origin;
const $c76ad79e98e47bfd$export$7333db99aa99d383 = ()=>globalThis.location?.pathname;

});




const $72721d8cb7d8a0db$export$e2fe9963c33d5918 = 'authenticated';
const $72721d8cb7d8a0db$export$4d955b5fb0c1d4d7 = 'projectRole';





parcelRegister("4ETME", function(module, exports) {

$parcel$export(module.exports, "RETRIEVE", () => $e8d5feb116c9c037$export$7bf2c28a4e08c796);
$parcel$export(module.exports, "retrieve", () => $e8d5feb116c9c037$export$8a4d17b6e8486e66);
$parcel$export(module.exports, "RETRIEVED", () => $e8d5feb116c9c037$export$1a07e8ff5bab976c);
$parcel$export(module.exports, "retrieved", () => $e8d5feb116c9c037$export$4058166ec369dd8);
$parcel$export(module.exports, "RETRIEVE_FAILED", () => $e8d5feb116c9c037$export$26e5d507c83e3d5a);
$parcel$export(module.exports, "retrieveFailed", () => $e8d5feb116c9c037$export$1c9b9c3d8868d26f);
$parcel$export(module.exports, "PATCH", () => $e8d5feb116c9c037$export$54950d96c4d7b0);
$parcel$export(module.exports, "patch", () => $e8d5feb116c9c037$export$b76953f99ab2be78);
const $e8d5feb116c9c037$export$7bf2c28a4e08c796 = 'state.actions.filters.RETRIEVE';
const $e8d5feb116c9c037$export$8a4d17b6e8486e66 = ()=>({
        type: $e8d5feb116c9c037$export$7bf2c28a4e08c796
    });
const $e8d5feb116c9c037$export$1a07e8ff5bab976c = 'state.actions.filters.RETRIEVED';
const $e8d5feb116c9c037$export$4058166ec369dd8 = (payload)=>({
        type: $e8d5feb116c9c037$export$1a07e8ff5bab976c,
        payload: payload
    });
const $e8d5feb116c9c037$export$26e5d507c83e3d5a = 'state.actions.filters.RETRIEVE_FAILED';
const $e8d5feb116c9c037$export$1c9b9c3d8868d26f = ()=>({
        type: $e8d5feb116c9c037$export$26e5d507c83e3d5a
    });
const $e8d5feb116c9c037$export$54950d96c4d7b0 = 'state.actions.filters.PATCH';
const $e8d5feb116c9c037$export$b76953f99ab2be78 = (payload)=>({
        type: $e8d5feb116c9c037$export$54950d96c4d7b0,
        payload: payload
    });

});

parcelRegister("fguXv", function(module, exports) {

$parcel$export(module.exports, "getServiceRequest", () => $d78fc3973b51847c$export$d7889f7cae5c51ff);

var $5Bmee = parcelRequire("5Bmee");

var $jIOdj = parcelRequire("jIOdj");

var $3gN48 = parcelRequire("3gN48");

var $kycze = parcelRequire("kycze");
const $d78fc3973b51847c$var$SORT_FIELDS = {
    [(0, $3gN48.NAME)]: 'NAME',
    [(0, $3gN48.OWNER)]: 'OWNER',
    [(0, $3gN48.FAVOURITED)]: 'IS_FAVOURITE',
    [(0, $3gN48.POPULARITY)]: 'FAVOURITE_COUNT'
};
const $d78fc3973b51847c$var$getSort = (state)=>({
        direction: (0, $kycze.getSortDirection)(state),
        field: $d78fc3973b51847c$var$SORT_FIELDS[(0, $kycze.getSortField)(state)]
    });
const $d78fc3973b51847c$export$d7889f7cae5c51ff = (state)=>(0, $5Bmee.createPageRequest)((0, $kycze.getPage)(state), (0, $jIOdj.ITEMS_PER_PAGE), $d78fc3973b51847c$var$getSort(state), (0, $jIOdj.EXPAND_PARAMETERS));

});
parcelRegister("5Bmee", function(module, exports) {

$parcel$export(module.exports, "createPageRequest", () => $145bc599a27835a5$export$6c268d1798324d1);
const $145bc599a27835a5$export$a2b44ae778ac3391 = (startAt, maxResults, order, expand)=>{
    const pageRequest = {
        maxResults: maxResults,
        startAt: startAt
    };
    if (order) {
        const orderString = `${order.direction === 'ASC' ? '+' : '-'}${order.field}`;
        pageRequest.orderBy = orderString;
    }
    if (expand && expand.length) pageRequest.expand = expand.join(',');
    return pageRequest;
};
const $145bc599a27835a5$export$2db35c6ee4729a76 = (startAt, maxResults, order, expand, // @ts-expect-error - TS1016 - A required parameter cannot follow an optional parameter.
searchBy)=>{
    const pageRequest = {
        maxResults: maxResults,
        startAt: startAt
    };
    if (order) {
        const orderString = `${order.direction === 'ASC' ? '+' : '-'}${order.field}`;
        pageRequest.orderBy = orderString;
    }
    if (expand && expand.length) pageRequest.expand = expand.join(',');
    if (searchBy && searchBy.length) pageRequest.searchBy = searchBy.join(',');
    return pageRequest;
};
const $145bc599a27835a5$export$6c268d1798324d1 = (page, itemsPerPage, order, expand)=>$145bc599a27835a5$export$a2b44ae778ac3391(itemsPerPage * (page - 1), itemsPerPage, order, expand);
const $145bc599a27835a5$export$98ffd4f2a2fa32d7 = (page, itemsPerPage, order, expand, // @ts-expect-error - TS1016 - A required parameter cannot follow an optional parameter.
searchBy)=>$145bc599a27835a5$export$2db35c6ee4729a76(itemsPerPage * (page - 1), itemsPerPage, order, expand, searchBy);

});




parcelRegister("6RVHf", function(module, exports) {

$parcel$export(module.exports, "SET_APP_PROPS", () => $1427493426bce8cd$export$8aefe701a6f431e0);
$parcel$export(module.exports, "setAppProps", () => $1427493426bce8cd$export$cfda7627848a58cd);
const $1427493426bce8cd$export$8aefe701a6f431e0 = 'state.actions.app.SET_APP_PROPS';
const $1427493426bce8cd$export$cfda7627848a58cd = (payload)=>({
        type: $1427493426bce8cd$export$8aefe701a6f431e0,
        payload: payload
    });

});

parcelRegister("7jNZd", function(module, exports) {

$parcel$export(module.exports, "default", () => $4b9d3e647583b349$export$2e2bcd8739ae039);

var $gs6vs = parcelRequire("gs6vs");

var $6YDwj = parcelRequire("6YDwj");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$4b9d3e647583b349$export$2e2bcd8739ae039 = (rootEpic, initialState)=>(0, $gs6vs.default)({
        initialState: initialState,
        appName: 'directories/filters',
        rootReducer: $6YDwj.default,
        rootEpic: rootEpic
    });

});
parcelRegister("6YDwj", function(module, exports) {

$parcel$export(module.exports, "default", () => $b46db39e5776a152$export$2e2bcd8739ae039);

var $7HHI1 = parcelRequire("7HHI1");

var $cIPW5 = parcelRequire("cIPW5");

var $iiO19 = parcelRequire("iiO19");

var $fphPK = parcelRequire("fphPK");

var $bHek5 = parcelRequire("bHek5");
var $b46db39e5776a152$export$2e2bcd8739ae039 = (0, $7HHI1.combineReducers)({
    app: $cIPW5.default,
    filters: $fphPK.default,
    query: $bHek5.default,
    copyFilterModal: $iiO19.default
});

});
parcelRegister("cIPW5", function(module, exports) {

$parcel$export(module.exports, "default", () => $823d9cd17462ab2d$export$2e2bcd8739ae039);

var $jFHCE = parcelRequire("jFHCE");

var $6RVHf = parcelRequire("6RVHf");
const $823d9cd17462ab2d$export$d4c72bab9d6cc13a = {
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
    props: undefined
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$823d9cd17462ab2d$export$2e2bcd8739ae039 = (state = $823d9cd17462ab2d$export$d4c72bab9d6cc13a, action)=>{
    switch(action.type){
        case 0, $6RVHf.SET_APP_PROPS:
            return {
                ...state,
                props: (0, (/*@__PURE__*/$parcel$interopDefault($jFHCE)))(action.payload, 'query')
            };
        default:
            {
                const _exhaustiveCheck = action.type;
                return state;
            }
    }
};

});

parcelRegister("iiO19", function(module, exports) {

$parcel$export(module.exports, "default", () => $7147a04e65e10281$export$2e2bcd8739ae039);

var $dH9V1 = parcelRequire("dH9V1");
const $7147a04e65e10281$export$d4c72bab9d6cc13a = {
    isCopyFilterModalOpen: false
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$7147a04e65e10281$export$2e2bcd8739ae039 = (state = $7147a04e65e10281$export$d4c72bab9d6cc13a, action)=>{
    switch(action.type){
        case 0, $dH9V1.OPEN_COPY_FILTER_MODAL:
            return {
                isCopyFilterModalOpen: true
            };
        case 0, $dH9V1.CLOSE_COPY_FILTER_MODAL:
            return {
                isCopyFilterModalOpen: false
            };
        default:
            {
                const _exhaustiveCheck = action;
                return state;
            }
    }
};

});
parcelRegister("dH9V1", function(module, exports) {

$parcel$export(module.exports, "OPEN_COPY_FILTER_MODAL", () => $a9d87d6bc6036ebe$export$ffe8b20c0eaae005);
$parcel$export(module.exports, "openCopyFilterModal", () => $a9d87d6bc6036ebe$export$444d12d73e6452c6);
$parcel$export(module.exports, "CLOSE_COPY_FILTER_MODAL", () => $a9d87d6bc6036ebe$export$4ef64fde5562fa6a);
$parcel$export(module.exports, "closeCopyFilterModal", () => $a9d87d6bc6036ebe$export$fa2b70863b7e4314);
const $a9d87d6bc6036ebe$export$ffe8b20c0eaae005 = 'state.actions.copy-filter-modal.OPEN_COPY_FILTER_MODAL';
const $a9d87d6bc6036ebe$export$444d12d73e6452c6 = ()=>({
        type: $a9d87d6bc6036ebe$export$ffe8b20c0eaae005
    });
const $a9d87d6bc6036ebe$export$4ef64fde5562fa6a = 'state.actions.copy-filter-modal.CLOSE_COPY_FILTER_MODAL';
const $a9d87d6bc6036ebe$export$fa2b70863b7e4314 = ()=>({
        type: $a9d87d6bc6036ebe$export$4ef64fde5562fa6a
    });

});


parcelRegister("fphPK", function(module, exports) {

$parcel$export(module.exports, "default", () => $555c9b0c409d536b$export$2e2bcd8739ae039);

var $4ETME = parcelRequire("4ETME");
const $555c9b0c409d536b$export$d4c72bab9d6cc13a = {
    page: {},
    order: [],
    total: 0,
    isLoading: true,
    isError: false
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$555c9b0c409d536b$export$2e2bcd8739ae039 = (state = $555c9b0c409d536b$export$d4c72bab9d6cc13a, action)=>{
    switch(action.type){
        case 0, $4ETME.RETRIEVE:
            return {
                ...state,
                isLoading: true
            };
        case 0, $4ETME.RETRIEVED:
            return {
                ...state,
                page: action.payload.page,
                order: action.payload.order,
                total: action.payload.total,
                isLoading: false,
                isError: false
            };
        case 0, $4ETME.RETRIEVE_FAILED:
            return {
                ...state,
                isLoading: false,
                isError: true
            };
        case 0, $4ETME.PATCH:
            return {
                ...state,
                page: {
                    ...state.page,
                    [action.payload.id]: {
                        ...state.page[action.payload.id],
                        ...action.payload.patch
                    }
                }
            };
        default:
            {
                const _exhaustiveCheck = action;
                return state;
            }
    }
};

});

parcelRegister("bHek5", function(module, exports) {

$parcel$export(module.exports, "default", () => $2c45f8fec3063e94$export$2e2bcd8739ae039);

var $jIOdj = parcelRequire("jIOdj");

var $4IANj = parcelRequire("4IANj");
const $2c45f8fec3063e94$export$d4c72bab9d6cc13a = (0, $jIOdj.initialQuery);
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$2c45f8fec3063e94$export$2e2bcd8739ae039 = (state = $2c45f8fec3063e94$export$d4c72bab9d6cc13a, action)=>{
    switch(action.type){
        case 0, $4IANj.SET_QUERY:
            return action.payload;
        case 0, $4IANj.PATCH_QUERY:
            return {
                ...state,
                ...action.payload,
                filter: {
                    ...state.filter,
                    ...action.payload.filter ? action.payload.filter : undefined
                }
            };
        default:
            {
                const _exhaustiveCheck = action;
                return state;
            }
    }
};

});



parcelRegister("6JT0c", function(module, exports) {

$parcel$export(module.exports, "default", () => $d0b97b24c754159c$export$2e2bcd8739ae039);

var $ahm5r = parcelRequire("ahm5r");

var $3PAYT = parcelRequire("3PAYT");

var $gnQAk = parcelRequire("gnQAk");

var $jIOdj = parcelRequire("jIOdj");

var $4ETME = parcelRequire("4ETME");

var $4IANj = parcelRequire("4IANj");

var $7MYNw = parcelRequire("7MYNw");

var $iYaR3 = parcelRequire("iYaR3");

var $kycze = parcelRequire("kycze");

var $hBxux = parcelRequire("hBxux");

var $e6mG7 = parcelRequire("e6mG7");

var $iFREh = parcelRequire("iFREh");

var $7nCDL = parcelRequire("7nCDL");
const $d0b97b24c754159c$var$getHeaderConfigurationMemoized = ()=>(0, $ahm5r.createSelector)((state)=>(0, $7MYNw.isWithoutHeader)(state) ? {
            FilterView: $iFREh.default
        } : {
            headerConfiguration: (0, $7nCDL.getHeaderConfiguration)()
        }, (res)=>res);
const $d0b97b24c754159c$var$mapStateToPropsFactory = ()=>{
    const getHeaderConfigurationInstance = $d0b97b24c754159c$var$getHeaderConfigurationMemoized();
    return (state)=>({
            // data
            entityIds: (0, $iYaR3.getIds)(state),
            totalItems: (0, $iYaR3.getTotal)(state),
            itemsPerPage: (0, $jIOdj.ITEMS_PER_PAGE),
            isLoading: (0, $iYaR3.isLoading)(state),
            isError: (0, $iYaR3.isError)(state),
            page: (0, $kycze.getPage)(state),
            sortField: (0, $kycze.getSortField)(state),
            sortDirection: (0, $kycze.getSortDirection)(state),
            filter: (0, $kycze.isFilterApplied)(state) ? (0, $kycze.getFilter)(state) : undefined,
            // ui
            firstColumnHeadingAlignment: 'center',
            // views
            ...getHeaderConfigurationInstance(state),
            tableConfiguration: (0, $7nCDL.getTableConfiguration)(state),
            tableLabel: (0, $7nCDL.getTableLabel)(),
            resultsAnnouncerMessage: (0, $7nCDL.getResultsAnnouncerMessage)(),
            emptyFilterResultConfiguration: $7nCDL.emptyFilterResultConfiguration,
            operationModals: $7nCDL.operationModals,
            EmptyView: $hBxux.default,
            ErrorView: $e6mG7.default
        });
};
const $d0b97b24c754159c$var$mapDispatchToProps = (dispatch)=>({
        // @ts-expect-error - TS7031 - Binding element 'id' implicitly has an 'any' type. | TS7031 - Binding element 'patch' implicitly has an 'any' type.
        onPatch: ({ id: id, patch: patch })=>dispatch((0, $4ETME.patch)({
                id: id,
                patch: patch
            })),
        onReload: (query)=>{
            dispatch((0, $4IANj.patchQuery)(query));
            dispatch((0, $4ETME.retrieve)());
        }
    });
var $d0b97b24c754159c$export$2e2bcd8739ae039 = (0, $gnQAk.connect)($d0b97b24c754159c$var$mapStateToPropsFactory, $d0b97b24c754159c$var$mapDispatchToProps)((0, $3PAYT.default));

});
parcelRegister("3PAYT", function(module, exports) {

$parcel$export(module.exports, "default", () => $53c8e3e55d4aeb5e$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $12DRg = parcelRequire("12DRg");

var $eSnSE = parcelRequire("eSnSE");

var $dTqD3 = parcelRequire("dTqD3");

var $5HL8i = parcelRequire("5HL8i");

var $91zZ6 = parcelRequire("91zZ6");

var $f5HHa = parcelRequire("f5HHa");

var $llsfE = parcelRequire("llsfE");

var $jZqH9 = parcelRequire("jZqH9");

var $9UtD0 = parcelRequire("9UtD0");

const $53c8e3e55d4aeb5e$var$defaultEntityIds = [];
class $53c8e3e55d4aeb5e$export$2e2bcd8739ae039 extends (0, $eJOHy.Component) {
    static{
        this.defaultProps = {
            isOnboardingEnabled: false,
            headerConfiguration: undefined,
            FilterView: undefined,
            TableMaskView: undefined,
            CreateModal: undefined,
            metrics: {
                tableMounted: undefined
            },
            entityIds: $53c8e3e55d4aeb5e$var$defaultEntityIds,
            dataProvider: undefined,
            renderOnboardingSpotlight: ()=>null,
            tableLabel: undefined,
            onboardingSpotlightTargets: [],
            onFirstRender: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg)))
        };
    }
    constructor(props){
        super(props);
        if (props.entityIds !== $53c8e3e55d4aeb5e$var$defaultEntityIds && props.dataProvider) (0, $eSnSE.default).safeErrorWithoutCustomerData('directory.base', 'Please provide only one of props: [entityIds] or [dataProvider], dataProvider will be used');
        this.store = (0, $jZqH9.default)((0, $f5HHa.default));
        this.store.dispatch((0, $llsfE.setAppProps)(props));
    }
    componentDidUpdate() {
        this.store.dispatch((0, $llsfE.setAppProps)(this.props));
    }
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $91zZ6.Provider), {
            store: this.store
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5HL8i.default), {
            onFirstMount: this.props.onFirstRender
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9UtD0.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dTqD3.SpaStatePageReady), null)));
    }
}

});
parcelRegister("5HL8i", function(module, exports) {

$parcel$export(module.exports, "default", () => $651368c8da8f3dac$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $5yd4l = parcelRequire("5yd4l");
class $651368c8da8f3dac$export$2e2bcd8739ae039 extends (0, $eJOHy.Component) {
    render() {
        const { children: children } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5yd4l.default).Provider, {
            value: {
                reportMount: this.onSubtreeMount
            }
        }, children);
    }
    constructor(...args){
        super(...args), this.onSubtreeMount = ()=>{
            if (!this.hasAnyMounted) {
                this.hasAnyMounted = true;
                this.props.onFirstMount();
            }
        }, this.hasAnyMounted = false;
    }
}

});
parcelRegister("5yd4l", function(module, exports) {

$parcel$export(module.exports, "default", () => $702adc31848c45b7$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $12DRg = parcelRequire("12DRg");
var $702adc31848c45b7$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eJOHy.createContext)({
    reportMount: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg)))
});

});


parcelRegister("91zZ6", function(module, exports) {

$parcel$export(module.exports, "useDirectoryDispatch", () => $8f86e69c8ed7499f$export$98942df89ffbd315);
$parcel$export(module.exports, "storeOptions", () => $8f86e69c8ed7499f$export$12cf63d9f5bd0793);
$parcel$export(module.exports, "Provider", () => $8f86e69c8ed7499f$export$2881499e37b75b9a);
$parcel$export(module.exports, "connect", () => $8f86e69c8ed7499f$export$64605811ab45167f);

var $eJOHy = parcelRequire("eJOHy");

var $dyOHn = parcelRequire("dyOHn");

var $gnQAk = parcelRequire("gnQAk");
const $8f86e69c8ed7499f$var$STORE_KEY = 'project-directories.directory.story';
const $8f86e69c8ed7499f$export$d03cc44e35038f93 = /*#__PURE__*/ (0, $eJOHy.createContext)(null);
const $8f86e69c8ed7499f$export$98942df89ffbd315 = (0, $dyOHn.createDispatchHook)($8f86e69c8ed7499f$export$d03cc44e35038f93);
const $8f86e69c8ed7499f$export$12cf63d9f5bd0793 = {
    storeKey: $8f86e69c8ed7499f$var$STORE_KEY,
    context: $8f86e69c8ed7499f$export$d03cc44e35038f93
};
const $8f86e69c8ed7499f$export$2881499e37b75b9a = (0, $gnQAk.createProvider)($8f86e69c8ed7499f$export$d03cc44e35038f93);
const $8f86e69c8ed7499f$export$64605811ab45167f = (// eslint-disable-next-line @typescript-eslint/no-explicit-any
mapStateToProps, // eslint-disable-next-line @typescript-eslint/no-explicit-any
mapDispatchToProps, // eslint-disable-next-line @typescript-eslint/no-explicit-any
mergeProps, // eslint-disable-next-line @typescript-eslint/no-explicit-any
options = Object.freeze({}))=>(0, $gnQAk.connect)(mapStateToProps, mapDispatchToProps, mergeProps, {
        ...options,
        context: $8f86e69c8ed7499f$export$d03cc44e35038f93,
        storeKey: $8f86e69c8ed7499f$var$STORE_KEY
    });

});

parcelRegister("f5HHa", function(module, exports) {

$parcel$export(module.exports, "default", () => $2c081aa275619817$export$2e2bcd8739ae039);

var $4tM8k = parcelRequire("4tM8k");

var $hTgaW = parcelRequire("hTgaW");

var $kobzH = parcelRequire("kobzH");
var $2c081aa275619817$export$2e2bcd8739ae039 = (0, $4tM8k.combineEpics)((0, $hTgaW.default), (0, $kobzH.default));

});
parcelRegister("hTgaW", function(module, exports) {

$parcel$export(module.exports, "default", () => $8af2749c3fdf06e7$export$2e2bcd8739ae039);
parcelRequire("1AyD5");
parcelRequire("6cJUr");

var $7kixv = parcelRequire("7kixv");

var $4wOQJ = parcelRequire("4wOQJ");

var $6SY0Q = parcelRequire("6SY0Q");
var // flow can't deal with the generics here
// eslint-disable-next-line @typescript-eslint/no-explicit-any, jira/import/no-anonymous-default-export
$8af2749c3fdf06e7$export$2e2bcd8739ae039 = (action$, store)=>action$.ofType((0, $4wOQJ.ENTITY_CREATED)).mergeMap(()=>{
        const state = store.getState();
        const page = (0, $6SY0Q.getPage)(state);
        (0, $6SY0Q.getOnReload)(state)({
            page: page
        });
        return (0, $7kixv.Observable).empty();
    });

});
parcelRegister("4wOQJ", function(module, exports) {

$parcel$export(module.exports, "INITIATE", () => $465651927b7e774a$export$643daa42aa3148d5);
$parcel$export(module.exports, "initiate", () => $465651927b7e774a$export$b14c4413e822aa8d);
$parcel$export(module.exports, "ENTITY_CREATED", () => $465651927b7e774a$export$61bc72c2b62d14ed);
$parcel$export(module.exports, "entityCreated", () => $465651927b7e774a$export$5e2c0a0dc191dd3e);
$parcel$export(module.exports, "ENTITY_CREATE_FAILED", () => $465651927b7e774a$export$ac0dd97afb285388);
$parcel$export(module.exports, "entityCreateFailed", () => $465651927b7e774a$export$b71626a5d7099742);
$parcel$export(module.exports, "CANCELLED", () => $465651927b7e774a$export$6b4658081fcf1aed);
$parcel$export(module.exports, "cancelled", () => $465651927b7e774a$export$b108ea1063c657e3);
const $465651927b7e774a$export$643daa42aa3148d5 = 'state.actions.create.INITIATE';
const $465651927b7e774a$export$b14c4413e822aa8d = ()=>({
        type: $465651927b7e774a$export$643daa42aa3148d5
    });
const $465651927b7e774a$export$61bc72c2b62d14ed = 'state.actions.create.ENTITY_CREATED';
const $465651927b7e774a$export$5e2c0a0dc191dd3e = (payload)=>({
        type: $465651927b7e774a$export$61bc72c2b62d14ed,
        payload: payload
    });
const $465651927b7e774a$export$ac0dd97afb285388 = 'state.actions.create.ENTITY_CREATE_FAILED';
const $465651927b7e774a$export$b71626a5d7099742 = (payload)=>({
        type: $465651927b7e774a$export$ac0dd97afb285388,
        payload: payload
    });
const $465651927b7e774a$export$6b4658081fcf1aed = 'state.actions.create.CANCELLED';
const $465651927b7e774a$export$b108ea1063c657e3 = ()=>({
        type: $465651927b7e774a$export$6b4658081fcf1aed
    });

});

parcelRegister("6SY0Q", function(module, exports) {

$parcel$export(module.exports, "getEntityIds", () => $e7e252b338858314$export$1fe43832be7d1fcb);
$parcel$export(module.exports, "getDataProvider", () => $e7e252b338858314$export$add6bf8e4261fead);
$parcel$export(module.exports, "getTotalItems", () => $e7e252b338858314$export$cbc4bdd6c02fac4d);
$parcel$export(module.exports, "getPage", () => $e7e252b338858314$export$c2a6433281518c91);
$parcel$export(module.exports, "getItemsPerPage", () => $e7e252b338858314$export$347447940701b338);
$parcel$export(module.exports, "getSortField", () => $e7e252b338858314$export$9b753af5a9fb5911);
$parcel$export(module.exports, "getSortDirection", () => $e7e252b338858314$export$509e2b9937961873);
$parcel$export(module.exports, "getFilter", () => $e7e252b338858314$export$61ec8404f465cd36);
$parcel$export(module.exports, "getHeaderConfiguration", () => $e7e252b338858314$export$60b0ef02721854ed);
$parcel$export(module.exports, "getFilterView", () => $e7e252b338858314$export$4a62b01f13af161e);
$parcel$export(module.exports, "getTableConfiguration", () => $e7e252b338858314$export$6847365bea1c5392);
$parcel$export(module.exports, "getTableLabel", () => $e7e252b338858314$export$b2d196af18e06ad6);
$parcel$export(module.exports, "getResultsAnnouncerMessage", () => $e7e252b338858314$export$64df75861e57fb7f);
$parcel$export(module.exports, "getEmptyView", () => $e7e252b338858314$export$6ad7beec028137c);
$parcel$export(module.exports, "getErrorView", () => $e7e252b338858314$export$67942d5525c28c28);
$parcel$export(module.exports, "getEmptyFilterResultConfiguration", () => $e7e252b338858314$export$dae3c68be4c9569d);
$parcel$export(module.exports, "getTableMaskView", () => $e7e252b338858314$export$7a35128187f8245c);
$parcel$export(module.exports, "getCreateModal", () => $e7e252b338858314$export$be5bc82ccf7ca5ca);
$parcel$export(module.exports, "getOperationModal", () => $e7e252b338858314$export$3f5ae3b2bfec9457);
$parcel$export(module.exports, "getOnReload", () => $e7e252b338858314$export$7158eb69f7a0b59);
$parcel$export(module.exports, "getOnPatch", () => $e7e252b338858314$export$944f52419ab8e737);
$parcel$export(module.exports, "isLoading", () => $e7e252b338858314$export$20bb0d907fbbe433);
$parcel$export(module.exports, "isError", () => $e7e252b338858314$export$e6127cc7fe7395c3);
$parcel$export(module.exports, "getTotalPages", () => $e7e252b338858314$export$652b307566494a6);
$parcel$export(module.exports, "getFirstColumnHeadingAlignment", () => $e7e252b338858314$export$22b039be773dbf63);
$parcel$export(module.exports, "getLastColumnHeadingAlignment", () => $e7e252b338858314$export$affaf5a34a669e16);
$parcel$export(module.exports, "isCreateOpen", () => $e7e252b338858314$export$996a71275221ab9e);
$parcel$export(module.exports, "getOperations", () => $e7e252b338858314$export$acc17f62bededcaf);
$parcel$export(module.exports, "getOperationInitializationStatusPerEntity", () => $e7e252b338858314$export$69a0d9b5be75b55d);
$parcel$export(module.exports, "getIsOnboardingEnabled", () => $e7e252b338858314$export$65890ce3309e3ccf);
$parcel$export(module.exports, "getRenderOnboardingSpotlight", () => $e7e252b338858314$export$98db60f26810390);
$parcel$export(module.exports, "getSpotlightForCell", () => $e7e252b338858314$export$1faee8e10b588885);
$parcel$export(module.exports, "getAvailableSpotlightTargets", () => $e7e252b338858314$export$7eda79d5ce9a0b8b);

var $ahm5r = parcelRequire("ahm5r");

var $9g7yh = parcelRequire("9g7yh");

var $huH03 = parcelRequire("huH03");

var $2CrAx = parcelRequire("2CrAx");
const $e7e252b338858314$export$876089ea65adc54 = (state)=>state.app.props;
const $e7e252b338858314$export$1fe43832be7d1fcb = (state)=>state.app.props.entityIds;
const $e7e252b338858314$export$add6bf8e4261fead = (state)=>state.app.props.dataProvider || undefined;
const $e7e252b338858314$export$cbc4bdd6c02fac4d = (state)=>state.app.props.totalItems;
const $e7e252b338858314$export$c2a6433281518c91 = (state)=>state.app.props.page;
const $e7e252b338858314$export$347447940701b338 = (state)=>state.app.props.itemsPerPage;
const $e7e252b338858314$export$9b753af5a9fb5911 = (state)=>state.app.props.sortField;
const $e7e252b338858314$export$509e2b9937961873 = (state)=>state.app.props.sortDirection;
const $e7e252b338858314$export$61ec8404f465cd36 = (state)=>state.app.props.filter;
const $e7e252b338858314$export$60b0ef02721854ed = (state)=>state.app.props.headerConfiguration;
const $e7e252b338858314$export$4a62b01f13af161e = (state)=>state.app.props.FilterView;
const $e7e252b338858314$export$6847365bea1c5392 = (state)=>state.app.props.tableConfiguration;
const $e7e252b338858314$export$b2d196af18e06ad6 = (state)=>state.app.props.tableLabel;
const $e7e252b338858314$export$64df75861e57fb7f = (state)=>state.app.props.resultsAnnouncerMessage;
const $e7e252b338858314$export$6ad7beec028137c = (state)=>state.app.props.EmptyView;
const $e7e252b338858314$export$67942d5525c28c28 = (state)=>state.app.props.ErrorView;
const $e7e252b338858314$export$dae3c68be4c9569d = (state)=>state.app.props.emptyFilterResultConfiguration;
const $e7e252b338858314$export$7a35128187f8245c = (state)=>state.app.props.TableMaskView;
const $e7e252b338858314$export$be5bc82ccf7ca5ca = (state)=>state.app.props.CreateModal;
const $e7e252b338858314$export$3f5ae3b2bfec9457 = (state, operation)=>state.app.props.operationModals[operation];
const $e7e252b338858314$export$7158eb69f7a0b59 = (state)=>state.app.props.onReload;
const $e7e252b338858314$export$944f52419ab8e737 = (state)=>state.app.props.onPatch;
const $e7e252b338858314$export$20bb0d907fbbe433 = (state)=>state.app.props.isLoading;
const $e7e252b338858314$export$e6127cc7fe7395c3 = (state)=>state.app.props.isError;
const $e7e252b338858314$var$getTotalPagesInternal = (0, $ahm5r.createSelector)(// @ts-expect-error - TS2769 - No overload matches this call.
$e7e252b338858314$export$cbc4bdd6c02fac4d, $e7e252b338858314$export$347447940701b338, (totalItems, itemsOnPage)=>(0, $2CrAx.calculateTotalPages)(totalItems, itemsOnPage));
const $e7e252b338858314$export$652b307566494a6 = (state)=>$e7e252b338858314$var$getTotalPagesInternal(state);
const $e7e252b338858314$export$22b039be773dbf63 = (state)=>state.app.props.firstColumnHeadingAlignment;
const $e7e252b338858314$export$affaf5a34a669e16 = (state)=>state.app.props.lastColumnHeadingAlignment;
const $e7e252b338858314$export$996a71275221ab9e = (state)=>state.create.isOpen;
const $e7e252b338858314$export$acc17f62bededcaf = (state)=>state.operations;
const $e7e252b338858314$var$getOperationInitializationStatusPerEntityInternal = (0, $ahm5r.createSelector)(// @ts-expect-error - TS2571 - Object is of type 'unknown'.
(state)=>state.operations, (operations)=>(0, (/*@__PURE__*/$parcel$interopDefault($huH03)))((0, (/*@__PURE__*/$parcel$interopDefault($9g7yh)))(operations, ({ id: id })=>id), ({ isInitializing: isInitializing })=>isInitializing));
const $e7e252b338858314$export$69a0d9b5be75b55d = (state)=>$e7e252b338858314$var$getOperationInitializationStatusPerEntityInternal(state);
const $e7e252b338858314$export$65890ce3309e3ccf = (state)=>state.app.props.isOnboardingEnabled;
const $e7e252b338858314$export$ee9bc95b4b33fe7b = (state)=>state.app.props.onboardingSpotlightTargets;
const $e7e252b338858314$export$98db60f26810390 = (state)=>state.app.props.renderOnboardingSpotlight;
const $e7e252b338858314$export$1faee8e10b588885 = (state)=>(id, colIndex)=>$e7e252b338858314$export$ee9bc95b4b33fe7b(state).find((c)=>c.entityId === id && c.colIndex === colIndex);
const $e7e252b338858314$export$7eda79d5ce9a0b8b = (state)=>// @ts-expect-error - TS2322 - Type 'unknown' is not assignable to type 'string[]'.
    (0, $ahm5r.createSelector)(// @ts-expect-error - TS2769 - No overload matches this call.
    $e7e252b338858314$export$6847365bea1c5392, $e7e252b338858314$export$add6bf8e4261fead, $e7e252b338858314$export$1fe43832be7d1fcb, $e7e252b338858314$export$1faee8e10b588885, (tableConfig, dataProvider, entitiesIds, getSpotlightCellTarget)=>{
        const availableSpotlightTargets = [];
        const ids = dataProvider ? dataProvider.getData().map((entity)=>dataProvider.idSelector(entity)) : entitiesIds;
        if (ids && tableConfig) ids.forEach((entityId)=>{
            for(let i = 0; i < tableConfig.length; i += 1){
                const cellMatch = getSpotlightCellTarget(entityId, i);
                if (cellMatch && cellMatch.spotlightId) availableSpotlightTargets.push(entityId);
            }
        });
        return availableSpotlightTargets;
    })(state);

});


parcelRegister("kobzH", function(module, exports) {

$parcel$export(module.exports, "default", () => $4eb7e9d263f87a09$export$2e2bcd8739ae039);
parcelRequire("1AyD5");
parcelRequire("6cJUr");

var $7kixv = parcelRequire("7kixv");

var $2CrAx = parcelRequire("2CrAx");


var $5cBQu = parcelRequire("5cBQu");

var $6SY0Q = parcelRequire("6SY0Q");
var // eslint-disable-next-line @typescript-eslint/no-explicit-any, jira/import/no-anonymous-default-export
$4eb7e9d263f87a09$export$2e2bcd8739ae039 = (action$, store)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    action$.ofType((0, $5cBQu.ENTITY_UPDATED)).mergeMap((action)=>{
        const { id: id, operation: operation, patch: patch } = action.payload;
        const state = store.getState();
        const currentPage = (0, $6SY0Q.getPage)(state);
        if (patch) {
            (0, $6SY0Q.getOnPatch)(state)({
                id: id,
                patch: patch
            }); // change page's state with a patch instead of reloading a table's page
            return (0, $7kixv.Observable).empty();
        }
        if (operation === (0, $85bfce414eef38c7$export$4bd2facc4a3e6aa1)) {
            const itemsPerPage = (0, $6SY0Q.getItemsPerPage)(state);
            const totalItems = (0, $6SY0Q.getTotalItems)(state);
            const predictedPage = (0, $2CrAx.predictPageToRequestAfterItemDeletion)(itemsPerPage, totalItems, currentPage);
            (0, $6SY0Q.getOnReload)(state)({
                page: predictedPage
            });
        } else (0, $6SY0Q.getOnReload)(state)({
            page: currentPage
        });
        return (0, $7kixv.Observable).empty();
    });

});
const $85bfce414eef38c7$export$250171a898bf7ef = 'EDIT';
const $85bfce414eef38c7$export$4bd2facc4a3e6aa1 = 'DELETE';
const $85bfce414eef38c7$export$257be95a51c84145 = 'DUPLICATE';
const $85bfce414eef38c7$export$a7c1ec142e70d69d = 'ARCHIVE';
const $85bfce414eef38c7$export$92f9e1ed9114d3a6 = 'COPY';
const $85bfce414eef38c7$export$346f08c1f0d0fe41 = 'MOVE';
const $85bfce414eef38c7$export$bbf2495ca7d54c9f = 'SHOW_DETAILS';
const $85bfce414eef38c7$export$39d2a7fb21967424 = 'CHANGE_OWNER';
const $85bfce414eef38c7$export$2b848a0670941e75 = 'TRASH';
const $85bfce414eef38c7$export$aeed50488a8a79d7 = 'RESTORE';

parcelRegister("5cBQu", function(module, exports) {

$parcel$export(module.exports, "INITIATE", () => $2081d7c120cf42cb$export$643daa42aa3148d5);
$parcel$export(module.exports, "initiate", () => $2081d7c120cf42cb$export$b14c4413e822aa8d);
$parcel$export(module.exports, "ENTITY_DATA_RETRIEVE_FAILED", () => $2081d7c120cf42cb$export$d5657bfeb6a06769);
$parcel$export(module.exports, "entityDataRetrieveFailed", () => $2081d7c120cf42cb$export$7771a5f3a1cb2756);
$parcel$export(module.exports, "DIALOG_SHOWN", () => $2081d7c120cf42cb$export$54e32bf20c0b405b);
$parcel$export(module.exports, "dialogShown", () => $2081d7c120cf42cb$export$7aca9ee5930fa3ea);
$parcel$export(module.exports, "ENTITY_UPDATED", () => $2081d7c120cf42cb$export$93e8e914b5b8b20d);
$parcel$export(module.exports, "entityUpdated", () => $2081d7c120cf42cb$export$c0932263cb70e08f);
$parcel$export(module.exports, "ENTITY_UPDATE_FAILED", () => $2081d7c120cf42cb$export$d2d41c22dcb7b1db);
$parcel$export(module.exports, "entityUpdateFailed", () => $2081d7c120cf42cb$export$fbb84be2ae83b4ed);
$parcel$export(module.exports, "CANCELLED", () => $2081d7c120cf42cb$export$6b4658081fcf1aed);
$parcel$export(module.exports, "cancelled", () => $2081d7c120cf42cb$export$b108ea1063c657e3);
// initiate
const $2081d7c120cf42cb$export$643daa42aa3148d5 = 'state.actions.operation.INITIATE';
const $2081d7c120cf42cb$export$b14c4413e822aa8d = (payload)=>({
        type: $2081d7c120cf42cb$export$643daa42aa3148d5,
        payload: payload
    });
const $2081d7c120cf42cb$export$d5657bfeb6a06769 = 'state.actions.operation.ENTITY_DATA_RETRIEVE_FAILED';
const $2081d7c120cf42cb$export$7771a5f3a1cb2756 = (payload)=>({
        type: $2081d7c120cf42cb$export$d5657bfeb6a06769,
        payload: payload
    });
const $2081d7c120cf42cb$export$54e32bf20c0b405b = 'state.actions.operation.DIALOG_SHOWN';
const $2081d7c120cf42cb$export$7aca9ee5930fa3ea = (payload)=>({
        type: $2081d7c120cf42cb$export$54e32bf20c0b405b,
        payload: payload
    });
const $2081d7c120cf42cb$export$93e8e914b5b8b20d = 'state.actions.operation.ENTITY_UPDATED';
const $2081d7c120cf42cb$export$c0932263cb70e08f = (payload)=>({
        type: $2081d7c120cf42cb$export$93e8e914b5b8b20d,
        payload: payload
    });
const $2081d7c120cf42cb$export$d2d41c22dcb7b1db = 'state.actions.operation.ENTITY_UPDATE_FAILED';
const $2081d7c120cf42cb$export$fbb84be2ae83b4ed = (payload)=>({
        type: $2081d7c120cf42cb$export$d2d41c22dcb7b1db,
        payload: payload
    });
const $2081d7c120cf42cb$export$6b4658081fcf1aed = 'state.actions.operation.CANCELLED';
const $2081d7c120cf42cb$export$b108ea1063c657e3 = (payload)=>({
        type: $2081d7c120cf42cb$export$6b4658081fcf1aed,
        payload: payload
    });

});



parcelRegister("llsfE", function(module, exports) {

$parcel$export(module.exports, "SET_APP_PROPS", () => $c40c7b4c0b8c00a8$export$8aefe701a6f431e0);
$parcel$export(module.exports, "setAppProps", () => $c40c7b4c0b8c00a8$export$cfda7627848a58cd);
const $c40c7b4c0b8c00a8$export$8aefe701a6f431e0 = 'state.actions.app.SET_APP_PROPS';
const $c40c7b4c0b8c00a8$export$cfda7627848a58cd = (payload)=>({
        type: $c40c7b4c0b8c00a8$export$8aefe701a6f431e0,
        payload: payload
    });

});

parcelRegister("jZqH9", function(module, exports) {

$parcel$export(module.exports, "default", () => $c497e626334b193e$export$2e2bcd8739ae039);

var $gs6vs = parcelRequire("gs6vs");

var $g7VIj = parcelRequire("g7VIj");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$c497e626334b193e$export$2e2bcd8739ae039 = (rootEpic)=>{
    // @ts-expect-error - TS2322 - Type 'Reducer<unknown>' is not assignable to type 'Reducer<TState>'.
    const fixedTypeRootReducer = (0, $g7VIj.default);
    // @ts-expect-error - TS2344 - Type 'TAction' does not satisfy the constraint '{ type: any; }'.
    return (0, $gs6vs.default)({
        appName: 'directory-base',
        rootReducer: fixedTypeRootReducer,
        rootEpic: rootEpic
    });
};

});
parcelRegister("g7VIj", function(module, exports) {

$parcel$export(module.exports, "default", () => $3895fd1311d5eb92$export$2e2bcd8739ae039);

var $7HHI1 = parcelRequire("7HHI1");

var $hLCQ2 = parcelRequire("hLCQ2");

var $4YoOg = parcelRequire("4YoOg");

var $2ReZV = parcelRequire("2ReZV");
var $3895fd1311d5eb92$export$2e2bcd8739ae039 = (0, $7HHI1.combineReducers)({
    app: $hLCQ2.default,
    create: $4YoOg.default,
    operations: $2ReZV.default
});

});
parcelRegister("hLCQ2", function(module, exports) {

$parcel$export(module.exports, "default", () => $a5feebf187192e75$export$2e2bcd8739ae039);

var $llsfE = parcelRequire("llsfE");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$a5feebf187192e75$export$2e2bcd8739ae039 = (state = {
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
    props: undefined
}, action)=>{
    switch(action.type){
        case 0, $llsfE.SET_APP_PROPS:
            return {
                ...state,
                props: action.payload
            };
        default:
            {
                const _exhaustiveCheck = action.type;
                return state;
            }
    }
};

});

parcelRegister("4YoOg", function(module, exports) {

$parcel$export(module.exports, "default", () => $de678fc2cad6993c$export$2e2bcd8739ae039);

var $4wOQJ = parcelRequire("4wOQJ");
const $de678fc2cad6993c$var$initialState = {
    isOpen: false
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$de678fc2cad6993c$export$2e2bcd8739ae039 = (state = $de678fc2cad6993c$var$initialState, action)=>{
    switch(action.type){
        case 0, $4wOQJ.INITIATE:
            return {
                isOpen: true
            };
        case 0, $4wOQJ.ENTITY_CREATED:
        case 0, $4wOQJ.ENTITY_CREATE_FAILED:
        case 0, $4wOQJ.CANCELLED:
            return {
                isOpen: false
            };
        default:
            {
                const _exhaustiveCheck = action;
                return state;
            }
    }
};

});

parcelRegister("2ReZV", function(module, exports) {

$parcel$export(module.exports, "default", () => $d3ec6054d969c464$export$2e2bcd8739ae039);

var $5cBQu = parcelRequire("5cBQu");
const $d3ec6054d969c464$var$reducer = (state = [], action)=>{
    switch(action.type){
        case 0, $5cBQu.INITIATE:
            // adding new operation to array will render new <OperationModal>, showing new dialog/modal in UI
            return [
                ...state,
                {
                    ...action.payload,
                    isInitializing: true
                }
            ];
        case 0, $5cBQu.DIALOG_SHOWN:
            // change isInitializing from true to false
            return [
                ...state.filter(({ id: id, operation: operation })=>id !== action.payload.id || operation !== action.payload.operation),
                {
                    ...action.payload,
                    isInitializing: false
                }
            ];
        case 0, $5cBQu.ENTITY_DATA_RETRIEVE_FAILED:
        case 0, $5cBQu.ENTITY_UPDATED:
        case 0, $5cBQu.ENTITY_UPDATE_FAILED:
        case 0, $5cBQu.CANCELLED:
            return state.filter(({ id: id, operation: operation })=>id !== action.payload.id || operation !== action.payload.operation);
        default:
            {
                const _exhaustiveCheck = action;
                return state;
            }
    }
};
var $d3ec6054d969c464$export$2e2bcd8739ae039 = $d3ec6054d969c464$var$reducer;

});



parcelRegister("9UtD0", function(module, exports) {

$parcel$export(module.exports, "default", () => $b32baacdda11dc59$export$2e2bcd8739ae039);

var $gnQAk = parcelRequire("gnQAk");

var $91zZ6 = parcelRequire("91zZ6");

var $adOqF = parcelRequire("adOqF");

var $54lJh = parcelRequire("54lJh");

var $dIYLk = parcelRequire("dIYLk");
var $b32baacdda11dc59$export$2e2bcd8739ae039 = (0, $gnQAk.connect)(()=>({
        Content: $adOqF.default,
        Modals: $54lJh.default
    }), null, null, (0, $91zZ6.storeOptions))((0, $dIYLk.default));

});
parcelRegister("adOqF", function(module, exports) {

$parcel$export(module.exports, "default", () => $eca44ecd751fd778$export$2e2bcd8739ae039);

var $LFmXM = parcelRequire("LFmXM");

var $gnQAk = parcelRequire("gnQAk");

var $4MchI = parcelRequire("4MchI");

var $eS6Sp = parcelRequire("eS6Sp");

var $91zZ6 = parcelRequire("91zZ6");

var $4wOQJ = parcelRequire("4wOQJ");

var $6SY0Q = parcelRequire("6SY0Q");

var $bt4Z6 = parcelRequire("bt4Z6");

var $6FHTv = parcelRequire("6FHTv");

var $jCVOe = parcelRequire("jCVOe");

var $1YsZU = parcelRequire("1YsZU");

var $lzizg = parcelRequire("lzizg");

var $5FTzj = parcelRequire("5FTzj");

var $bj0qr = parcelRequire("bj0qr");
const $eca44ecd751fd778$var$getEmptyViewSelectorMemoized = ()=>(0, $4MchI.createSelector)((state)=>(0, $eS6Sp.withMountReporting)((0, $6SY0Q.getEmptyView)(state)), (res)=>res);
const $eca44ecd751fd778$var$getErrorViewSelectorMemoized = ()=>(0, $4MchI.createSelector)((state)=>(0, $eS6Sp.withMountReporting)((0, $6SY0Q.getErrorView)(state)), (res)=>res);
const $eca44ecd751fd778$var$getAvailableSpotlightTargetsSelectorMemoized = ()=>(0, $4MchI.createSelector)((state)=>(0, $6SY0Q.getAvailableSpotlightTargets)(state), (res)=>res);
const $eca44ecd751fd778$var$mapStateToPropsFactory = ()=>{
    const getEmptyViewSelectorInstance = $eca44ecd751fd778$var$getEmptyViewSelectorMemoized();
    const getErrorViewSelectorInstance = $eca44ecd751fd778$var$getErrorViewSelectorMemoized();
    const getAvailableSpotlightTargetsSelectorInstance = $eca44ecd751fd778$var$getAvailableSpotlightTargetsSelectorMemoized();
    const onRetryFactory = (0, $LFmXM.default)((state)=>()=>(0, $6SY0Q.getOnReload)(state)({}));
    return (state)=>{
        let Header;
        const FilterView = (0, $6SY0Q.getFilterView)(state);
        if (FilterView) Header = (0, $6FHTv.default);
        else {
            const headerConfiguration = (0, $6SY0Q.getHeaderConfiguration)(state);
            if (headerConfiguration) {
                // @ts-expect-error - TS2339 - Property 'View' does not exist on type 'HeaderConfiguration<TFilter>'.
                if (headerConfiguration.View) Header = (0, $1YsZU.default);
                else Header = (0, $jCVOe.default);
            }
        }
        return {
            Header: Header,
            Table: $5FTzj.default,
            Paginator: $lzizg.default,
            Empty: getEmptyViewSelectorInstance(state),
            Error: getErrorViewSelectorInstance(state),
            status: (0, $bt4Z6.getStatus)(state),
            onRetry: onRetryFactory(state),
            isOnboardingEnabled: (0, $6SY0Q.getIsOnboardingEnabled)(state),
            renderOnboardingSpotlight: (0, $6SY0Q.getRenderOnboardingSpotlight)(state),
            availableSpotlightTargets: getAvailableSpotlightTargetsSelectorInstance(state)
        };
    };
};
const $eca44ecd751fd778$var$mapDispatchToProps = {
    onAdd: (0, $4wOQJ.initiate)
};
var $eca44ecd751fd778$export$2e2bcd8739ae039 = (0, $gnQAk.connect)($eca44ecd751fd778$var$mapStateToPropsFactory, $eca44ecd751fd778$var$mapDispatchToProps, null, (0, $91zZ6.storeOptions))((0, $bj0qr.default));

});
parcelRegister("eS6Sp", function(module, exports) {

$parcel$export(module.exports, "withMountReporting", () => $ef98fa099ffbdef1$export$95fa4b7a60ebef6);
$parcel$export(module.exports, "default", () => $ef98fa099ffbdef1$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $eK5AI = parcelRequire("eK5AI");

var $5yd4l = parcelRequire("5yd4l");
// eslint-disable-next-line jira/react/no-class-components
class $ef98fa099ffbdef1$var$Reporter extends (0, $eJOHy.Component) {
    static{
        this.defaultProps = {
            performanceMarkKey: undefined
        };
    }
    componentDidMount() {
        this.props.onMounted();
    }
    render() {
        const { performanceMarkKey: performanceMarkKey } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, performanceMarkKey && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eK5AI.default), {
            metricKey: performanceMarkKey
        }), this.props.children);
    }
}
function $ef98fa099ffbdef1$export$95fa4b7a60ebef6(Wrapped) {
    return (props)=>{
        const { performanceMarkKey: performanceMarkKey, ...rest } = props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5yd4l.default).Consumer, null, ({ reportMount: reportMount })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($ef98fa099ffbdef1$var$Reporter, {
                onMounted: reportMount,
                performanceMarkKey: performanceMarkKey
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(Wrapped, rest)));
    };
}
const $ef98fa099ffbdef1$var$MountReporter = $ef98fa099ffbdef1$export$95fa4b7a60ebef6(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null));
var $ef98fa099ffbdef1$export$2e2bcd8739ae039 = $ef98fa099ffbdef1$var$MountReporter;

});

parcelRegister("bt4Z6", function(module, exports) {

$parcel$export(module.exports, "getStatus", () => $efad135e16b62051$export$b70265791d2079d4);

var $6SY0Q = parcelRequire("6SY0Q");
const $efad135e16b62051$export$b70265791d2079d4 = (state)=>{
    if ((0, $6SY0Q.isError)(state)) return 'error';
    if ((0, $6SY0Q.isLoading)(state)) return 'has-entities';
    const dataProvider = (0, $6SY0Q.getDataProvider)(state);
    const elementsCount = dataProvider ? dataProvider.getData().length : (0, $6SY0Q.getEntityIds)(state).length;
    return elementsCount === 0 && (0, $6SY0Q.getFilter)(state) === undefined && (0, $6SY0Q.getPage)(state) === 1 ? 'empty' : 'has-entities';
};

});

parcelRegister("6FHTv", function(module, exports) {

$parcel$export(module.exports, "default", () => $e0574a56fae741f0$export$2e2bcd8739ae039);

var $LFmXM = parcelRequire("LFmXM");

var $91zZ6 = parcelRequire("91zZ6");

var $6SY0Q = parcelRequire("6SY0Q");

var $bt4Z6 = parcelRequire("bt4Z6");

var $cXdYX = parcelRequire("cXdYX");
const $e0574a56fae741f0$var$mapStateToPropsFactory = ()=>{
    const onFilterFactory = (0, $LFmXM.default)((state)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
        (filter)=>(0, $6SY0Q.getOnReload)(state)({
                page: 1,
                filter: filter
            }));
    return (state)=>({
            FilterView: (0, $6SY0Q.getFilterView)(state),
            onFilter: onFilterFactory(state),
            hasEntities: (0, $bt4Z6.getStatus)(state) === 'has-entities'
        });
};
var // @ts-expect-error - TS2554 - Expected 3-4 arguments, but got 2. | TS2345 - Argument of type '<T>(props: Props<T>) => false | Element' is not assignable to parameter of type 'Component<DispatchProp<any>>'.
$e0574a56fae741f0$export$2e2bcd8739ae039 = (0, $91zZ6.connect)($e0574a56fae741f0$var$mapStateToPropsFactory, {})((0, $cXdYX.default));

});
parcelRegister("cXdYX", function(module, exports) {

$parcel$export(module.exports, "default", () => $bee0d7cc05606f81$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");
function $bee0d7cc05606f81$export$2e2bcd8739ae039(props) {
    const { hasEntities: hasEntities, FilterView: FilterView, onFilter: onFilter } = props;
    return hasEntities ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $bee0d7cc05606f81$var$wrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(FilterView, {
        onFilter: onFilter
    })) : null;
}
const $bee0d7cc05606f81$var$wrapperStyles = (0, $1DXK0.xcss)({
    marginBottom: 'space.200'
});

});


parcelRegister("jCVOe", function(module, exports) {

$parcel$export(module.exports, "default", () => $caf4a8d1960fcc3c$export$2e2bcd8739ae039);

var $gnQAk = parcelRequire("gnQAk");

var $91zZ6 = parcelRequire("91zZ6");

var $6SY0Q = parcelRequire("6SY0Q");

var $bt4Z6 = parcelRequire("bt4Z6");

var $lBd8e = parcelRequire("lBd8e");

var $dbkrW = parcelRequire("dbkrW");

var $bgiMi = parcelRequire("bgiMi");
const $caf4a8d1960fcc3c$var$mapStateToProps = (state)=>{
    const headerConfiguration = (0, $6SY0Q.getHeaderConfiguration)(state);
    // @ts-expect-error - TS2339 - Property 'View' does not exist on type 'HeaderConfiguration<TFilter>'.
    if (!headerConfiguration || headerConfiguration.View) throw new Error('Invalid state - Default Header view must not be mounted');
    return {
        Filter: $dbkrW.default,
        // @ts-expect-error - TS2339 - Property 'ActionsView' does not exist on type 'HeaderConfiguration<TFilter>'.
        Actions: headerConfiguration.ActionsView || (0, $lBd8e.default),
        hasEntities: (0, $bt4Z6.getStatus)(state) === 'has-entities',
        // @ts-expect-error - TS2339 - Property 'caption' does not exist on type 'HeaderConfiguration<TFilter>'.
        caption: headerConfiguration.caption || null
    };
};
var // @ts-expect-error - TS2345 - Argument of type 'ComponentType<Diff<Record<any, any> | (Record<any, any> & { children?: ReactNode; }), InjectIntlVoidProps>>' is not assignable to parameter of type 'Component<DispatchProp<any> & { Filter: ComponentClass<Omit<DispatchProp<any>, "dispatch">> & { WrappedComponent: Component<DispatchProp<any>>; }; Actions: any; hasEntities: boolean; caption: any; }>'.
$caf4a8d1960fcc3c$export$2e2bcd8739ae039 = (0, $gnQAk.connect)($caf4a8d1960fcc3c$var$mapStateToProps, null, null, (0, $91zZ6.storeOptions))((0, $bgiMi.default));

});
parcelRegister("lBd8e", function(module, exports) {

$parcel$export(module.exports, "default", () => $35248647e13a4408$export$2e2bcd8739ae039);

var $gnQAk = parcelRequire("gnQAk");

var $91zZ6 = parcelRequire("91zZ6");

var $4wOQJ = parcelRequire("4wOQJ");

var $6SY0Q = parcelRequire("6SY0Q");

var $byghB = parcelRequire("byghB");
const $35248647e13a4408$var$mapStateToProps = (state)=>{
    const headerConfiguration = (0, $6SY0Q.getHeaderConfiguration)(state);
    // @ts-expect-error - TS2339 - Property 'View' does not exist on type 'HeaderConfiguration<TFilter>'. | TS2339 - Property 'ActionsView' does not exist on type 'HeaderConfiguration<TFilter>'.
    if (headerConfiguration && !headerConfiguration.View && !headerConfiguration.ActionsView) {
        // @ts-expect-error - TS2339 - Property 'isAddAllowed' does not exist on type 'HeaderConfiguration<TFilter>'. | TS2339 - Property 'addButtonCaption' does not exist on type 'HeaderConfiguration<TFilter>'.
        const { isAddAllowed: isAddAllowed, addButtonCaption: addButtonCaption } = headerConfiguration;
        return {
            canAdd: isAddAllowed,
            caption: addButtonCaption
        };
    }
    return {};
};
const $35248647e13a4408$var$mapDispatchToProps = {
    onAdd: (0, $4wOQJ.initiate)
};
var $35248647e13a4408$export$2e2bcd8739ae039 = (0, $gnQAk.connect)($35248647e13a4408$var$mapStateToProps, $35248647e13a4408$var$mapDispatchToProps, null, (0, $91zZ6.storeOptions))((0, $byghB.default));

});
parcelRegister("byghB", function(module, exports) {

$parcel$export(module.exports, "default", () => $d0b84cb0461ed13a$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $goZPP = parcelRequire("goZPP");

var $lRq8t = parcelRequire("lRq8t");
function $d0b84cb0461ed13a$var$Add(props) {
    const { canAdd: canAdd, caption: caption, onAdd: onAdd } = props;
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return canAdd ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
        appearance: "primary",
        onClick: onAdd
    }, caption && formatMessage(caption)) : null;
}
$d0b84cb0461ed13a$var$Add.defaultProps = {
    canAdd: false
};
var $d0b84cb0461ed13a$export$2e2bcd8739ae039 = $d0b84cb0461ed13a$var$Add;

});


parcelRegister("dbkrW", function(module, exports) {

$parcel$export(module.exports, "default", () => $56b26b42f2c579c7$export$2e2bcd8739ae039);

var $LFmXM = parcelRequire("LFmXM");

var $91zZ6 = parcelRequire("91zZ6");

var $6SY0Q = parcelRequire("6SY0Q");

var $181ce = parcelRequire("181ce");
const $56b26b42f2c579c7$var$mapStateToPropsFactory = ()=>{
    const onFilterFactory = (0, $LFmXM.default)((state)=>(filter)=>(0, $6SY0Q.getOnReload)(state)({
                page: 1,
                filter: filter
            }));
    return (state)=>{
        const headerConfiguration = (0, $6SY0Q.getHeaderConfiguration)(state);
        // @ts-expect-error - TS2339 - Property 'FilterView' does not exist on type 'HeaderConfiguration<TFilter>'.
        if (!headerConfiguration || !headerConfiguration.FilterView) throw new Error('Invalid state - Filter wrapper must not be mounted');
        return {
            // @ts-expect-error - TS2339 - Property 'FilterView' does not exist on type 'HeaderConfiguration<TFilter>'.
            FilterView: headerConfiguration.FilterView,
            onFilter: onFilterFactory(state)
        };
    };
};
var // @ts-expect-error - TS2554 - Expected 3-4 arguments, but got 2. | TS2345 - Argument of type 'typeof Filter' is not assignable to parameter of type 'Component<DispatchProp<any>>'.
$56b26b42f2c579c7$export$2e2bcd8739ae039 = (0, $91zZ6.connect)($56b26b42f2c579c7$var$mapStateToPropsFactory, {})((0, $181ce.default));

});
parcelRegister("181ce", function(module, exports) {

$parcel$export(module.exports, "default", () => $ee176a642e448aa0$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");
function $ee176a642e448aa0$export$2e2bcd8739ae039(props) {
    const { FilterView: FilterView, onFilter: onFilter } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(FilterView, {
        onFilter: onFilter
    });
}

});


parcelRegister("bgiMi", function(module, exports) {

$parcel$export(module.exports, "default", () => $206ccb85f3340cfa$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $gfcvC = parcelRequire("gfcvC");

var $idGBm = parcelRequire("idGBm");
function $206ccb85f3340cfa$var$Default(props) {
    const { Filter: Filter, Actions: Actions, caption: caption, hasEntities: hasEntities, intl: { formatMessage: formatMessage } } = props;
    let searchBar = null;
    let actions = null;
    if (hasEntities) {
        searchBar = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(Filter, null);
        actions = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(Actions, null);
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gfcvC.default), {
        truncateTitle: true,
        actions: actions,
        bottomBar: searchBar
    }, caption ? formatMessage(caption) : '');
}
var $206ccb85f3340cfa$export$2e2bcd8739ae039 = (0, $idGBm.injectIntlV2)($206ccb85f3340cfa$var$Default);

});
parcelRegister("idGBm", function(module, exports) {

$parcel$export(module.exports, "injectIntlV2", () => $c35e98ccc24112a8$export$440265f0ca78e98e);
/* eslint-disable @typescript-eslint/consistent-type-assertions */ /* eslint-disable @typescript-eslint/no-explicit-any */ 
var $eJOHy = parcelRequire("eJOHy");

var $cjwij = parcelRequire("cjwij");

var $lRq8t = parcelRequire("lRq8t");
const $c35e98ccc24112a8$var$isDisplayableString = (mayBeString)=>typeof mayBeString === 'string' && mayBeString !== '';
function $c35e98ccc24112a8$var$getDisplayName(Component) {
    if ($c35e98ccc24112a8$var$isDisplayableString(Component.displayName)) // @ts-expect-error - TS2322 - Type 'string | undefined' is not assignable to type 'string'.
    return Component.displayName;
    if ($c35e98ccc24112a8$var$isDisplayableString(Component.name)) return Component.name;
    return 'Component';
}
const $c35e98ccc24112a8$export$440265f0ca78e98e = (WrappedComponent, options)=>{
    const { withRef: withRef = false } = options || {};
    const WithIntl = (props)=>{
        const intl = (0, $lRq8t.default)();
        const intlRef = (0, $eJOHy.useRef)(null);
        if (!intl) throw new Error('REACT_INTL_FACADE: React Intl Could not find required `intl` object');
        if (!intlRef.current) intlRef.current = {
            // @ts-expect-error We force v5 messages type on v2 type
            messages: intl.messages,
            locale: intl.locale,
            formats: intl.formats,
            formatDate: intl.formatDate,
            formatMessage: intl.formatMessage,
            formatNumber: intl.formatNumber,
            formatPlural: intl.formatPlural,
            formatTime: intl.formatTime
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(WrappedComponent, {
            ...props,
            intl: intlRef.current,
            ref: withRef ? props.forwardedRef : null
        });
    };
    // Changed this display name to be capital letter to prevent snapshots from failing, here is the original: https://github.com/formatjs/formatjs/blob/main/packages/react-intl/src/components/injectIntl.tsx#L98
    WithIntl.displayName = `InjectIntl(${$c35e98ccc24112a8$var$getDisplayName(WrappedComponent)})`;
    WithIntl.WrappedComponent = WrappedComponent;
    if (withRef) return (0, (/*@__PURE__*/$parcel$interopDefault($cjwij)))(/*#__PURE__*/ (0, $eJOHy.forwardRef)((props, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(WithIntl, {
            ...props,
            forwardedRef: ref
        })), WrappedComponent);
    return (0, (/*@__PURE__*/$parcel$interopDefault($cjwij)))(WithIntl, WrappedComponent);
};

});



parcelRegister("1YsZU", function(module, exports) {

$parcel$export(module.exports, "default", () => $862a891411120bc1$export$2e2bcd8739ae039);

var $LFmXM = parcelRequire("LFmXM");

var $91zZ6 = parcelRequire("91zZ6");

var $4wOQJ = parcelRequire("4wOQJ");

var $6SY0Q = parcelRequire("6SY0Q");

var $bt4Z6 = parcelRequire("bt4Z6");

var $cadFR = parcelRequire("cadFR");
const $862a891411120bc1$var$mapStateToPropsFactory = ()=>{
    const onFilterFactory = (0, $LFmXM.default)((state)=>(filter)=>(0, $6SY0Q.getOnReload)(state)({
                page: 1,
                filter: filter
            }));
    return (state)=>{
        const headerConfiguration = (0, $6SY0Q.getHeaderConfiguration)(state);
        // @ts-expect-error - TS2339 - Property 'View' does not exist on type 'HeaderConfiguration<TFilter>'.
        if (!headerConfiguration || !headerConfiguration.View) throw new Error('Invalid state - Header wrapper must not be mounted');
        return {
            // @ts-expect-error - TS2339 - Property 'View' does not exist on type 'HeaderConfiguration<TFilter>'.
            HeaderView: headerConfiguration.View,
            hasEntities: (0, $bt4Z6.getStatus)(state) === 'has-entities',
            onFilter: onFilterFactory(state)
        };
    };
};
const $862a891411120bc1$var$mapDispatchToProps = {
    onAdd: (0, $4wOQJ.initiate)
};
var // @ts-expect-error - TS2554 - Expected 3-4 arguments, but got 2. | TS2345 - Argument of type 'typeof Wrapper' is not assignable to parameter of type 'Component<DispatchProp<any>>'.
$862a891411120bc1$export$2e2bcd8739ae039 = (0, $91zZ6.connect)($862a891411120bc1$var$mapStateToPropsFactory, $862a891411120bc1$var$mapDispatchToProps)((0, $cadFR.default));

});
parcelRegister("cadFR", function(module, exports) {

$parcel$export(module.exports, "default", () => $b0b6660764944ecf$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");
function $b0b6660764944ecf$export$2e2bcd8739ae039(props) {
    const { HeaderView: HeaderView, hasEntities: hasEntities, onAdd: onAdd, onFilter: onFilter } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(HeaderView, {
        hasEntities: hasEntities,
        onAdd: onAdd,
        onFilter: onFilter
    });
}

});


parcelRegister("lzizg", function(module, exports) {

$parcel$export(module.exports, "default", () => $7006066677abaaa5$export$2e2bcd8739ae039);

var $LFmXM = parcelRequire("LFmXM");

var $gnQAk = parcelRequire("gnQAk");

var $91zZ6 = parcelRequire("91zZ6");

var $6SY0Q = parcelRequire("6SY0Q");

var $6rNj9 = parcelRequire("6rNj9");
const $7006066677abaaa5$var$mapStateToPropsFactory = ()=>{
    const onPageChangeFactory = (0, $LFmXM.default)(// @ts-expect-error - TS7006 - Parameter 'event' implicitly has an 'any' type. | TS7006 - Parameter 'page' implicitly has an 'any' type.
    (state)=>(event, page)=>(0, $6SY0Q.getOnReload)(state)({
                page: page
            }));
    return (state)=>({
            currentPage: (0, $6SY0Q.getPage)(state),
            totalPages: (0, $6SY0Q.getTotalPages)(state),
            onPageChange: onPageChangeFactory(state)
        });
};
var $7006066677abaaa5$export$2e2bcd8739ae039 = (0, $gnQAk.connect)($7006066677abaaa5$var$mapStateToPropsFactory, {}, null, (0, $91zZ6.storeOptions))((0, $6rNj9.default));

});
parcelRegister("6rNj9", function(module, exports) {

$parcel$export(module.exports, "default", () => $c9bf74b4e5ee6e93$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $tGEEK = parcelRequire("tGEEK");

var $b3eVo = parcelRequire("b3eVo");

var $2sLVw = parcelRequire("2sLVw");

var $idGBm = parcelRequire("idGBm");

var $gCeeo = parcelRequire("gCeeo");

var $6XJko = parcelRequire("6XJko");

var $7NPCc = parcelRequire("7NPCc");
function $c9bf74b4e5ee6e93$var$Paginator(props) {
    const { currentPage: currentPage, totalPages: totalPages, intl: { formatMessage: formatMessage } } = props;
    const onPageChange = (data, event, analyticsEvent)=>{
        props.onPageChange(data, event);
        if (analyticsEvent) (0, $gCeeo.fireUIAnalytics)(analyticsEvent, 'pagination');
    };
    const content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $b3eVo.default), {
        selectedIndex: currentPage - 1,
        onChange: onPageChange,
        pages: (0, (/*@__PURE__*/$parcel$interopDefault($tGEEK)))(1, totalPages + 1),
        previousLabel: formatMessage((0, $7NPCc.default).previousButton),
        nextLabel: formatMessage((0, $7NPCc.default).nextButton)
    });
    if (totalPages > 1) return (0, $6XJko.isVisualRefreshEnabled)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2sLVw.default), {
        alignItems: "center",
        justifyContent: "center",
        xcss: $c9bf74b4e5ee6e93$var$styles.paginationContainer,
        testId: "global-pages.directories.directory-base.content.paginator.container"
    }, content) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($c9bf74b4e5ee6e93$var$Container, {
        "data-test-id": "global-pages.directories.directory-base.content.paginator.container"
    }, content);
    return null;
}
var $c9bf74b4e5ee6e93$export$2e2bcd8739ae039 = (0, $idGBm.injectIntlV2)($c9bf74b4e5ee6e93$var$Paginator);
const $c9bf74b4e5ee6e93$var$styles = {
    paginationContainer: "_n3td1ejb _18u0xmi2"
}; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $c9bf74b4e5ee6e93$var$Container = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_n3td1ejb _18u0xmi2",
            __cmplp.className
        ])
    });
});

});
parcelRegister("b3eVo", function(module, exports) {

$parcel$export(module.exports, "default", () => $2e9938bbbd4852c0$export$2e2bcd8739ae039);
/* pagination.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $jrFnt = parcelRequire("jrFnt");

var $3Vuhz = parcelRequire("3Vuhz");

var $7O2l7 = parcelRequire("7O2l7");

var $a2JSB = parcelRequire("a2JSB");

var $1kTzc = parcelRequire("1kTzc");

var $8IeH1 = parcelRequire("8IeH1");
var $6djmC = parcelRequire("6djmC");

var $2xCo3 = parcelRequire("2xCo3");

var $6CP4r = parcelRequire("6CP4r");

var $3IiVn = parcelRequire("3IiVn");

var $1CN10 = parcelRequire("1CN10");

var $1hfAD = parcelRequire("1hfAD");
const $2e9938bbbd4852c0$var$styles = {
    paginationMenu: "_ca0qze3t _u5f3ze3t _n3tdze3t _19bvze3t _19pkze3t _2hwxze3t _otyrze3t _18u0ze3t",
    paginationMenuItem: "_1pfhze3t _ect41gqc",
    navigatorIconWrapper: "_18zr12x7"
};
const $2e9938bbbd4852c0$var$analyticsAttributes = {
    componentName: 'pagination',
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local"
};
function $2e9938bbbd4852c0$var$NavigatorIcon({ chevronDirection: chevronDirection }) {
    const Chevron = chevronDirection === 'left' ? (0, (/*@__PURE__*/$parcel$interopDefault($a2JSB))) : (0, (/*@__PURE__*/$parcel$interopDefault($1kTzc)));
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
        as: "span",
        xcss: $2e9938bbbd4852c0$var$styles.navigatorIconWrapper,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)(Chevron, {
            label: "",
            LEGACY_margin: `0 ${"var(--ds-space-negative-075, -6px)"}`,
            color: "currentColor",
            size: "small"
        })
    });
}
function $2e9938bbbd4852c0$var$InnerPagination({ components: components = (0, $1CN10.emptyObject), defaultSelectedIndex: defaultSelectedIndex = 0, selectedIndex: selectedIndex, label: label = 'pagination', pageLabel: pageLabel = 'page', previousLabel: previousLabel = 'previous', nextLabel: nextLabel = 'next', style: style = (0, $1CN10.emptyObject), max: max = 7, onChange: onChange = (0, $3Vuhz.default), pages: pages, getPageLabel: getPageLabel, renderEllipsis: renderEllipsis = (0, $3IiVn.default), analyticsContext: analyticsContext, testId: testId, isDisabled: isDisabled }, ref) {
    const [selectedIndexValue, setSelectedIndexValue] = (0, $7O2l7.default)(selectedIndex, ()=>defaultSelectedIndex || 0);
    const onChangeWithAnalytics = (0, $jrFnt.usePlatformLeafEventHandler)({
        fn: (value, analyticsEvent)=>{
            const { event: event, selectedPageIndex: selectedPageIndex } = value;
            if (selectedIndex === undefined) setSelectedIndexValue(selectedPageIndex);
            if (onChange) onChange(event, pages[selectedPageIndex], analyticsEvent);
        },
        action: 'changed',
        actionSubject: 'pageNumber',
        analyticsData: analyticsContext,
        ...$2e9938bbbd4852c0$var$analyticsAttributes
    });
    const transform = (page, currPageIndex, testId)=>{
        const selectedPage = pages[selectedIndexValue];
        const pageIndexLabel = `${pageLabel} ${getPageLabel ? getPageLabel(page, currPageIndex) : page}`;
        const isCurrentPage = page === selectedPage;
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6djmC.default), {
            as: "li",
            xcss: $2e9938bbbd4852c0$var$styles.paginationMenuItem,
            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6CP4r.default), {
                component: components.Page,
                onClick: (event)=>onChangeWithAnalytics({
                        event: event,
                        selectedPageIndex: currPageIndex
                    }),
                "aria-current": isCurrentPage ? 'page' : undefined,
                "aria-label": pageIndexLabel,
                isSelected: isCurrentPage,
                isDisabled: isDisabled,
                page: page,
                testId: testId && `${testId}--${isCurrentPage ? 'current-' : ''}page-${currPageIndex}`,
                children: getPageLabel ? getPageLabel(page, currPageIndex) : page
            })
        }, `page-${getPageLabel ? getPageLabel(page, currPageIndex) : currPageIndex}`);
    };
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
        testId: testId,
        style: style,
        ref: ref,
        "aria-label": label,
        as: "nav",
        children: /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $6djmC.default), {
            space: "space.0",
            alignBlock: "center",
            children: [
                /*#__PURE__*/ (0, $gt9Am.jsx)((0, $2xCo3.default), {
                    component: components.Previous,
                    onClick: (event)=>onChangeWithAnalytics({
                            event: event,
                            selectedPageIndex: selectedIndexValue - 1
                        }),
                    isDisabled: isDisabled || selectedIndexValue === 0,
                    iconBefore: /*#__PURE__*/ (0, $gt9Am.jsx)($2e9938bbbd4852c0$var$NavigatorIcon, {
                        chevronDirection: "left"
                    }),
                    "aria-label": previousLabel,
                    testId: testId && `${testId}--left-navigator`
                }, "left-navigator"),
                /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6djmC.default), {
                    space: "space.0",
                    alignBlock: "baseline",
                    as: "ul",
                    xcss: $2e9938bbbd4852c0$var$styles.paginationMenu,
                    children: (0, $1hfAD.default)(pages, selectedIndexValue, {
                        max: max,
                        ellipsis: renderEllipsis,
                        transform: transform
                    }, testId)
                }),
                /*#__PURE__*/ (0, $gt9Am.jsx)((0, $2xCo3.default), {
                    component: components.Next,
                    onClick: (event)=>onChangeWithAnalytics({
                            event: event,
                            selectedPageIndex: selectedIndexValue + 1
                        }),
                    isDisabled: isDisabled || selectedIndexValue === pages.length - 1,
                    iconBefore: /*#__PURE__*/ (0, $gt9Am.jsx)($2e9938bbbd4852c0$var$NavigatorIcon, {
                        chevronDirection: "right"
                    }),
                    "aria-label": nextLabel,
                    testId: testId && `${testId}--right-navigator`
                }, "right-navigator")
            ]
        })
    }));
}
/**
 * __Pagination__
 *
 * Pagination allows you to divide large amounts of content into smaller chunks across multiple pages.
 *
 * - [Examples](https://atlassian.design/components/pagination/examples)
 * - [Code](https://atlassian.design/components/pagination/code)
 * - [Usage](https://atlassian.design/components/pagination/usage)
 */ const $2e9938bbbd4852c0$var$Pagination = /*#__PURE__*/ (0, $eJOHy.memo)(/*#__PURE__*/ (0, $eJOHy.forwardRef)($2e9938bbbd4852c0$var$InnerPagination));
var $2e9938bbbd4852c0$export$2e2bcd8739ae039 = $2e9938bbbd4852c0$var$Pagination;

});
parcelRegister("a2JSB", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::8e8ea817ec2fe685ddbf301b825d4978>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $74fdae0df2a41f03$var$_react = $74fdae0df2a41f03$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $74fdae0df2a41f03$var$_chevronLeft = $74fdae0df2a41f03$var$_interopRequireDefault((parcelRequire("8PCRQ")));

var $74fdae0df2a41f03$var$_chevronLeftLarge = $74fdae0df2a41f03$var$_interopRequireDefault((parcelRequire("k9ooi")));
function $74fdae0df2a41f03$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for ChevronLeftIcon.
 * This component is ChevronLeftIcon, with `UNSAFE_fallbackIcon` set to "ChevronLeftLargeIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Do not use 16px chevrons within buttons, icon buttons, or dropdowns to maintain visual cohesion with ADS which uses 12px chevrons.
Known uses: Navigate back, show previous page of pagination results
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $74fdae0df2a41f03$var$ChevronLeftIcon = (props)=>/*#__PURE__*/ $74fdae0df2a41f03$var$_react.default.createElement($74fdae0df2a41f03$var$_chevronLeft.default, Object.assign({
        name: "ChevronLeftIcon",
        LEGACY_fallbackIcon: $74fdae0df2a41f03$var$_chevronLeftLarge.default
    }, props));
$74fdae0df2a41f03$var$ChevronLeftIcon.displayName = 'ChevronLeftIconMigration';
var $74fdae0df2a41f03$var$_default = module.exports.default = $74fdae0df2a41f03$var$ChevronLeftIcon;

});
parcelRegister("8PCRQ", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::8ee9ad5072a30451ff7ca2ddc0961d03>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $66e13c6de5d90262$var$_react = $66e13c6de5d90262$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $66e13c6de5d90262$var$_baseNew = $66e13c6de5d90262$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $66e13c6de5d90262$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ChevronLeft".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Do not use 16px chevrons within buttons, icon buttons, or dropdowns to maintain visual cohesion with ADS which uses 12px chevrons.
Known uses: Navigate back, show previous page of pagination results
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $66e13c6de5d90262$var$ChevronLeftIcon = (props)=>/*#__PURE__*/ $66e13c6de5d90262$var$_react.default.createElement($66e13c6de5d90262$var$_baseNew.default, Object.assign({
        name: "ChevronLeftIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="m9.97 1.47-6 6a.75.75 0 0 0-.052 1.004l.052.056 6 6 1.06-1.06L5.56 8l5.47-5.47z"/>`
    }, props));
$66e13c6de5d90262$var$ChevronLeftIcon.displayName = 'ChevronLeftIcon';
var $66e13c6de5d90262$var$_default = module.exports.default = $66e13c6de5d90262$var$ChevronLeftIcon;

});

parcelRegister("k9ooi", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $eab7917427604e36$var$_react = $eab7917427604e36$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $fL0In = parcelRequire("fL0In");
function $eab7917427604e36$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $eab7917427604e36$var$ChevronLeftLargeIcon = (props)=>/*#__PURE__*/ $eab7917427604e36$var$_react.default.createElement($fL0In.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m9.005 10.995 4.593-4.593a.99.99 0 1 1 1.4 1.4l-3.9 3.9 3.9 3.9a.99.99 0 0 1-1.4 1.4L9.005 12.41a1 1 0 0 1 0-1.414"/></svg>`
    }, props));
$eab7917427604e36$var$ChevronLeftLargeIcon.displayName = 'ChevronLeftLargeIcon';
var $eab7917427604e36$var$_default = module.exports.default = $eab7917427604e36$var$ChevronLeftLargeIcon;

});


parcelRegister("1kTzc", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::ffb3eee7b92db2782a45444d8dbb123a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0f92c313e495a986$var$_react = $0f92c313e495a986$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $0f92c313e495a986$var$_chevronRight = $0f92c313e495a986$var$_interopRequireDefault((parcelRequire("cQxBL")));

var $0f92c313e495a986$var$_chevronRightLarge = $0f92c313e495a986$var$_interopRequireDefault((parcelRequire("czcci")));
function $0f92c313e495a986$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for ChevronRightIcon.
 * This component is ChevronRightIcon, with `UNSAFE_fallbackIcon` set to "ChevronRightLargeIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Do not use 16px chevrons within buttons, icon buttons, or dropdowns to maintain visual cohesion with ADS which uses 12px chevrons.
Known uses: Next page of pagination results, collapsed tree item, expand tree item
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $0f92c313e495a986$var$ChevronRightIcon = (props)=>/*#__PURE__*/ $0f92c313e495a986$var$_react.default.createElement($0f92c313e495a986$var$_chevronRight.default, Object.assign({
        name: "ChevronRightIcon",
        LEGACY_fallbackIcon: $0f92c313e495a986$var$_chevronRightLarge.default
    }, props));
$0f92c313e495a986$var$ChevronRightIcon.displayName = 'ChevronRightIconMigration';
var $0f92c313e495a986$var$_default = module.exports.default = $0f92c313e495a986$var$ChevronRightIcon;

});
parcelRegister("czcci", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9262370c29d80ea9$var$_react = $9262370c29d80ea9$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $fL0In = parcelRequire("fL0In");
function $9262370c29d80ea9$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $9262370c29d80ea9$var$ChevronRightLargeIcon = (props)=>/*#__PURE__*/ $9262370c29d80ea9$var$_react.default.createElement($fL0In.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M14.995 10.995a1 1 0 0 1 0 1.414l-4.593 4.593a.99.99 0 0 1-1.4-1.4l3.9-3.9-3.9-3.9a.99.99 0 0 1 1.4-1.4z"/></svg>`
    }, props));
$9262370c29d80ea9$var$ChevronRightLargeIcon.displayName = 'ChevronRightLargeIcon';
var $9262370c29d80ea9$var$_default = module.exports.default = $9262370c29d80ea9$var$ChevronRightLargeIcon;

});


parcelRegister("2xCo3", function(module, exports) {

$parcel$export(module.exports, "default", () => $390a465a7b875c7d$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $goZPP = parcelRequire("goZPP");
function $390a465a7b875c7d$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $goZPP.default), {
        "aria-label": props['aria-label'],
        isDisabled: props.isDisabled,
        iconBefore: props.iconBefore,
        testId: props.testId,
        onClick: props.onClick,
        component: props.component,
        appearance: "subtle"
    });
}

});

parcelRegister("6CP4r", function(module, exports) {

$parcel$export(module.exports, "default", () => $a7a0738c73e50f62$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $goZPP = parcelRequire("goZPP");
function $a7a0738c73e50f62$export$2e2bcd8739ae039(props) {
    // eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $goZPP.default), {
        ...props,
        appearance: "subtle"
    });
}

});

parcelRegister("3IiVn", function(module, exports) {

$parcel$export(module.exports, "default", () => $eee95bde3b212432$export$2e2bcd8739ae039);
/* render-ellipsis.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $8IeH1 = parcelRequire("8IeH1");
var $3cMgR = parcelRequire("3cMgR");

var $6fs4r = parcelRequire("6fs4r");
const $eee95bde3b212432$var$styles = {
    container: "_1e0c1txw _kqswh2mm"
};
function $eee95bde3b212432$export$2e2bcd8739ae039({ key: key, testId: testId, from: from, to: to }) {
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
        as: "li",
        testId: testId,
        xcss: $eee95bde3b212432$var$styles.container,
        paddingInline: "space.100",
        children: /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $3cMgR.default), {
            testId: testId && `${testId}-text`,
            children: [
                /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $6fs4r.default), {
                    children: [
                        "Skipped pages from ",
                        from,
                        " to ",
                        to
                    ]
                }),
                "\u2026"
            ]
        })
    }, key);
}

});

parcelRegister("1CN10", function(module, exports) {

$parcel$export(module.exports, "emptyObject", () => $1b85b3c8ab534085$export$3f860eba1218f8d3);
const $1b85b3c8ab534085$export$3f860eba1218f8d3 = {};

});

parcelRegister("1hfAD", function(module, exports) {

$parcel$export(module.exports, "default", () => $916df7f6e7c50105$export$2e2bcd8739ae039);

var $LFmXM = parcelRequire("LFmXM");
// TODO: comma needed after generic declaration below, or the .tsx file thinks
// it is a JSX element. Tidy up in a future refactor.
const $916df7f6e7c50105$var$collapseRange = (pages, current, { max: max, ellipsis: ellipsis, transform: transform }, testId)=>{
    const total = pages.length;
    // only need ellipsis if we have more pages than we can display
    const needEllipsis = total > max;
    // show start ellipsis if the current page is further away than max - 4 from the first page
    const hasStartEllipsis = needEllipsis && max - 4 < current;
    // show end ellipsis if the current page is further than total - max + 3 from the last page
    const hasEndEllipsis = needEllipsis && current < total - max + 3;
    const getPageComponents = (0, $LFmXM.default)((startIndex = 0, lastIndex = total)=>{
        return pages.slice(startIndex, lastIndex).map((page, index)=>transform(page, startIndex + index, testId));
    });
    if (!needEllipsis) return getPageComponents(0, total);
    if (hasStartEllipsis && !hasEndEllipsis) {
        const pageCount = max - 2;
        return [
            ...getPageComponents(0, 1),
            ellipsis({
                key: 'ellipsis-1',
                testId: testId && `${testId}-ellipsis`,
                from: 2,
                to: total - pageCount
            }),
            ...getPageComponents(total - pageCount)
        ];
    }
    if (!hasStartEllipsis && hasEndEllipsis) {
        const pageCount = max - 2;
        return [
            ...getPageComponents(0, pageCount),
            ellipsis({
                key: 'ellipsis-1',
                testId: testId && `${testId}-ellipsis`,
                from: pageCount + 1,
                to: total - 1
            }),
            ...getPageComponents(total - 1)
        ];
    }
    // we have both start and end ellipsis
    const pageCount = max - 4;
    return [
        ...getPageComponents(0, 1),
        ellipsis({
            key: 'ellipsis-1',
            testId: testId && `${testId}-ellipsis`,
            from: 2,
            to: current - Math.floor(pageCount / 2)
        }),
        ...getPageComponents(current - Math.floor(pageCount / 2), current + pageCount - 1),
        ellipsis({
            key: 'ellipsis-2',
            testId: testId && `${testId}-ellipsis`,
            from: current + 3,
            to: total - 1
        }),
        ...getPageComponents(total - 1)
    ];
};
var $916df7f6e7c50105$export$2e2bcd8739ae039 = $916df7f6e7c50105$var$collapseRange;

});


parcelRegister("7NPCc", function(module, exports) {

$parcel$export(module.exports, "default", () => $07ec01bbb9ef28ec$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $07ec01bbb9ef28ec$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    previousButton: {
        "id": "directory-base.content.paginator.previous-button",
        "defaultMessage": "Previous page"
    },
    nextButton: {
        "id": "directory-base.content.paginator.next-button",
        "defaultMessage": "Next page"
    }
});

});



parcelRegister("5FTzj", function(module, exports) {

$parcel$export(module.exports, "default", () => $a468657d4ef5c51d$export$2e2bcd8739ae039);

var $ahm5r = parcelRequire("ahm5r");

var $LFmXM = parcelRequire("LFmXM");

var $91zZ6 = parcelRequire("91zZ6");

var $5cBQu = parcelRequire("5cBQu");

var $6SY0Q = parcelRequire("6SY0Q");

var $4fI4K = parcelRequire("4fI4K");

var $hd1Pz = parcelRequire("hd1Pz");

var $96vM9 = parcelRequire("96vM9");
const $a468657d4ef5c51d$var$getSpotlightForCellSelectorMemoized = ()=>(0, $ahm5r.createSelector)((state)=>(0, $6SY0Q.getSpotlightForCell)(state), (res)=>res);
const $a468657d4ef5c51d$var$mapStateToPropsFactory = ()=>{
    const getSpotlightForCellSelectorInstance = $a468657d4ef5c51d$var$getSpotlightForCellSelectorMemoized();
    const onSortFactory = (0, $LFmXM.default)(// @ts-expect-error - TS7006 - Parameter 'sort' implicitly has an 'any' type.
    (state)=>(sort)=>(0, $6SY0Q.getOnReload)(state)({
                page: 1,
                ...sort
            }));
    return (state)=>{
        // @ts-expect-error - TS2339 - Property 'View' does not exist on type 'EmptyFilterResultConfiguration'.
        const EmptyView = (0, $6SY0Q.getEmptyFilterResultConfiguration)(state).View || (0, $hd1Pz.default);
        const TableMaskView = (0, $6SY0Q.getTableMaskView)(state);
        const filter = (0, $6SY0Q.getFilter)(state);
        const filterQuery = filter ? filter.query : '';
        return {
            tableConfiguration: (0, $6SY0Q.getTableConfiguration)(state),
            tableLabel: (0, $6SY0Q.getTableLabel)(state),
            resultsAnnouncerMessage: (0, $6SY0Q.getResultsAnnouncerMessage)(state),
            EmptyView: EmptyView,
            TableMaskView: TableMaskView,
            dataProvider: (0, $6SY0Q.getDataProvider)(state),
            entityIds: (0, $6SY0Q.getEntityIds)(state),
            totalItems: (0, $6SY0Q.getTotalItems)(state),
            operationInitializationStatusPerEntity: (0, $6SY0Q.getOperationInitializationStatusPerEntity)(state),
            isLoading: (0, $6SY0Q.isLoading)(state),
            sortField: (0, $6SY0Q.getSortField)(state),
            sortDirection: (0, $6SY0Q.getSortDirection)(state),
            onSort: onSortFactory(state),
            mountMetricKey: (0, $4fI4K.getTableMountedMetricKey)(state),
            getSpotlightForCell: getSpotlightForCellSelectorInstance(state),
            firstColumnHeadingAlignment: (0, $6SY0Q.getFirstColumnHeadingAlignment)(state),
            lastColumnHeadingAlignment: (0, $6SY0Q.getLastColumnHeadingAlignment)(state),
            filterQuery: filterQuery
        };
    };
};
const $a468657d4ef5c51d$var$mapDispatchToProps = {
    onOperationRequested: (0, $5cBQu.initiate)
};
var // @ts-expect-error - TS2554 - Expected 3-4 arguments, but got 2.
$a468657d4ef5c51d$export$2e2bcd8739ae039 = (0, $91zZ6.connect)($a468657d4ef5c51d$var$mapStateToPropsFactory, $a468657d4ef5c51d$var$mapDispatchToProps)((0, $96vM9.default));

});
parcelRegister("4fI4K", function(module, exports) {

$parcel$export(module.exports, "getTableMountedMetricKey", () => $9e43c8fdf7968ae6$export$b6c1493984bb04f9);
const $9e43c8fdf7968ae6$export$b6c1493984bb04f9 = (state)=>state.app.props.metrics.tableMounted;

});

parcelRegister("hd1Pz", function(module, exports) {

$parcel$export(module.exports, "default", () => $ccf583b38e8b01a8$export$2e2bcd8739ae039);

var $gnQAk = parcelRequire("gnQAk");

var $91zZ6 = parcelRequire("91zZ6");

var $6SY0Q = parcelRequire("6SY0Q");

var $46lOx = parcelRequire("46lOx");
const $ccf583b38e8b01a8$var$mapStateToProps = (state)=>{
    const configuration = (0, $6SY0Q.getEmptyFilterResultConfiguration)(state);
    // @ts-expect-error - TS2339 - Property 'message' does not exist on type 'EmptyFilterResultConfiguration'.
    if (!configuration.message) throw new Error('Invalid state - Default empty view should not be mounted');
    return {
        // @ts-expect-error - TS2339 - Property 'message' does not exist on type 'EmptyFilterResultConfiguration'.
        message: configuration.message
    };
};
var $ccf583b38e8b01a8$export$2e2bcd8739ae039 = (0, $gnQAk.connect)($ccf583b38e8b01a8$var$mapStateToProps, null, null, (0, $91zZ6.storeOptions))((0, $46lOx.default));

});
parcelRegister("46lOx", function(module, exports) {

$parcel$export(module.exports, "default", () => $cdf52a671bcf0851$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $6MnLl = parcelRequire("6MnLl");

var $6YFG2 = parcelRequire("6YFG2");

var $hj82Y = parcelRequire("hj82Y");

var $6XJko = parcelRequire("6XJko");

var $87ztG = parcelRequire("87ztG");
function $cdf52a671bcf0851$var$DefaultEmptyView(props) {
    const { message: message } = props;
    const { intl: { formatMessage: formatMessage } } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
        "data-test-id": "global-pages.directories.directory-base.content.table.default-empty-view.empty-state"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6MnLl.default), {
        imageUrl: (0, $6XJko.isVisualRefreshEnabled)() ? (0, (/*@__PURE__*/$parcel$interopDefault($hj82Y))) : (0, (/*@__PURE__*/$parcel$interopDefault($87ztG))),
        header: formatMessage(message),
        width: "narrow",
        headingLevel: 2
    }));
}
var $cdf52a671bcf0851$export$2e2bcd8739ae039 = (0, $6YFG2.default)($cdf52a671bcf0851$var$DefaultEmptyView);

});
parcelRegister("hj82Y", function(module, exports) {
module.exports = new URL("search-no-results.1d478205.svg", import.meta.url).toString();

});

parcelRegister("87ztG", function(module, exports) {
module.exports = new URL("generic-no-results.fb302821.svg", import.meta.url).toString();

});



parcelRegister("96vM9", function(module, exports) {

$parcel$export(module.exports, "default", () => $58d4afddfb7fcf61$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
var $awdRS = parcelRequire("awdRS");

var $12DRg = parcelRequire("12DRg");

var $aXKmr = parcelRequire("aXKmr");

var $lOOiG = parcelRequire("lOOiG");

var $guChT = parcelRequire("guChT");

var $8IeH1 = parcelRequire("8IeH1");
var $2sLVw = parcelRequire("2sLVw");
var $3cMgR = parcelRequire("3cMgR");

var $8nw3F = parcelRequire("8nw3F");


var $idGBm = parcelRequire("idGBm");

var $gCeeo = parcelRequire("gCeeo");

var $6XJko = parcelRequire("6XJko");

var $7jTnu = parcelRequire("7jTnu");

var $eS6Sp = parcelRequire("eS6Sp");

var $8TMMM = parcelRequire("8TMMM");
class $58d4afddfb7fcf61$var$Table extends (0, $eJOHy.Component) {
    static{
        this.defaultProps = {
            isLoading: false,
            entityIds: [],
            totalItems: 0,
            sortDirection: (0, $a535a1c1a5d4d33f$export$1dee026a19752d6b),
            mountMetricKey: undefined,
            getSpotlightForCell: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
            TableMaskView: undefined,
            firstColumnHeadingAlignment: 'left',
            lastColumnHeadingAlignment: 'left',
            filterQuery: '',
            tableLabel: undefined,
            resultsAnnouncerMessage: (0, $8TMMM.default).filterResultsAnnouncement,
            onSort: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
            onOperationRequested: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg)))
        };
    }
    componentDidUpdate(prevProps) {
        if (prevProps.sortDirection !== this.props.sortDirection || prevProps.sortField !== this.props.sortField) this.state.hasSortingChanged = true;
        if (!prevProps.isLoading && this.props.isLoading) this.state.shouldAnnounceResults = !this.state.hasSortingChanged;
        else if (prevProps.isLoading && !this.props.isLoading) this.state.hasSortingChanged = false;
        if (this.state.returnFocusTo && (0, $7jTnu.fg)('blu-7774_fix_focus_bug_table_header_in_directories')) {
            // Find the index of the sort field that we should put focus on, then go through all the headers and find the one that matches the sort field index
            const sortFieldIndex = this.props.tableConfiguration.findIndex((config)=>config.sortField === this.state.returnFocusTo);
            if (sortFieldIndex >= 0) {
                const allHeaders = globalThis.document.querySelectorAll('thead th');
                if (sortFieldIndex < allHeaders.length) {
                    const targetHeader = allHeaders[sortFieldIndex];
                    const sortButton = targetHeader.querySelector('button[aria-roledescription="Sort button"]');
                    if (sortButton instanceof HTMLElement) sortButton.focus();
                }
            }
        }
    }
    render() {
        const { tableConfiguration: tableConfiguration, entityIds: entityIds, totalItems: totalItems, EmptyView: EmptyView, isLoading: isLoading, operationInitializationStatusPerEntity: operationInitializationStatusPerEntity, sortField: sortField, sortDirection: sortDirection, mountMetricKey: mountMetricKey, getSpotlightForCell: getSpotlightForCell, TableMaskView: TableMaskView, dataProvider: dataProvider, firstColumnHeadingAlignment: firstColumnHeadingAlignment, lastColumnHeadingAlignment: lastColumnHeadingAlignment, intl: { formatMessage: formatMessage }, tableLabel: tableLabel, resultsAnnouncerMessage: resultsAnnouncerMessage } = this.props;
        const headCells = tableConfiguration.map(({ title: title, width: width, sortField: cellSortField, dataTestId: dataTestId, isIconOnlyHeader: isIconOnlyHeader, ascendingSortTooltip: ascendingSortTooltip, descendingSortTooltip: descendingSortTooltip })=>{
            let content = '';
            const wrapperProps = dataTestId ? {
                'data-test-id': dataTestId
            } : {};
            if (dataTestId) // @ts-expect-error - TS2322 - Type 'Element' is not assignable to type 'string'.
            content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($58d4afddfb7fcf61$var$NonBreakingCell, wrapperProps);
            if (typeof title === 'function') {
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                const HeaderCell = title; // @ts-expect-error - TS2322 - Type 'Element' is not assignable to type 'string'.
                content = (()=>{
                    if (!(0, $6XJko.isVisualRefreshEnabled)()) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($58d4afddfb7fcf61$var$HeaderWrapper, wrapperProps, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(HeaderCell, null));
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8IeH1.default), {
                        xcss: $58d4afddfb7fcf61$var$styles.headerWrapper,
                        testId: dataTestId
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(HeaderCell, null));
                })();
            } else if (typeof title !== 'undefined') {
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
                const message = title; // @ts-expect-error - TS2322 - Type 'Element' is not assignable to type 'string'.
                content = (0, $6XJko.isVisualRefreshEnabled)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2sLVw.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3cMgR.default), {
                    testId: dataTestId,
                    color: "color.text.subtle",
                    maxLines: 1,
                    weight: "bold",
                    size: "small"
                }, formatMessage(message))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($58d4afddfb7fcf61$var$NonBreakingCell, wrapperProps, formatMessage(message));
            }
            return {
                key: cellSortField || (0, $aXKmr.v1)(),
                isSortable: !!cellSortField,
                content: content,
                width: width,
                isIconOnlyHeader: (0, $6XJko.isVisualRefreshEnabled)() ? !!isIconOnlyHeader : undefined,
                ascendingSortTooltip: ascendingSortTooltip && (0, $6XJko.isVisualRefreshEnabled)() ? formatMessage(ascendingSortTooltip) : undefined,
                descendingSortTooltip: descendingSortTooltip && (0, $6XJko.isVisualRefreshEnabled)() ? formatMessage(descendingSortTooltip) : undefined
            };
        });
        const head = {
            cells: headCells
        };
        const ids = dataProvider ? dataProvider.getData().map((entity)=>dataProvider.idSelector(entity)) : entityIds;
        const tableAriaLabel = tableLabel ? formatMessage(tableLabel) : undefined;
        const rowCells = ids.map((entityId, rowIndex)=>{
            // the page is already sorted (by the API), so fake key,
            // so that DynamicTable won't destroy it
            const key = sortDirection === 'DESC' ? -(rowIndex + 1) : rowIndex + 1;
            const entity = dataProvider ? dataProvider.getData()[rowIndex] : undefined;
            const cells = tableConfiguration.map(({ Cell: Cell }, colIndex)=>{
                const content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(Cell, {
                    id: entityId,
                    entity: entity,
                    isOperationInProgress: !!operationInitializationStatusPerEntity[entityId],
                    onOperationRequested: (operation, operationParams)=>this.props.onOperationRequested({
                            id: entityId,
                            childEntityId: operationParams && operationParams.childEntityId,
                            operation: operation
                        })
                });
                const getVisuallyRefreshedContent = (visuallyRefreshedContent)=>{
                    return visuallyRefreshedContent;
                };
                const cellMatch = getSpotlightForCell(entityId, colIndex);
                if (cellMatch && cellMatch.spotlightId) {
                    const onboardingContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $guChT.default), {
                        name: cellMatch.spotlightId
                    }, getVisuallyRefreshedContent(content));
                    return {
                        content: onboardingContent,
                        key: key
                    };
                }
                return {
                    content: getVisuallyRefreshedContent(content),
                    key: key
                };
            });
            return {
                cells: cells
            };
        });
        return(// Note: the data-test-id attribute is used by Pollinator checks in Jalapeno so avoid changing if possible
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($58d4afddfb7fcf61$var$Container, {
            "data-test-id": "global-pages.directories.directory-base.content.table.container",
            firstColumnHeadingAlignment: firstColumnHeadingAlignment,
            lastColumnHeadingAlignment: lastColumnHeadingAlignment,
            visualRefreshEnabled: (0, $6XJko.isVisualRefreshEnabled)(),
            visuallyRefreshedHeight: (0, $6XJko.isVisualRefreshEnabled)()
        }, !isLoading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eS6Sp.default), {
            performanceMarkKey: mountMetricKey
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nw3F.AnnouncerV2), {
            message: formatMessage(resultsAnnouncerMessage || (0, $8TMMM.default).filterResultsAnnouncement, {
                itemCount: totalItems
            }),
            shouldAnnounce: !isLoading && this.state.shouldAnnounceResults
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lOOiG.default), {
            isFixedSize: true,
            isLoading: isLoading,
            head: head,
            rows: rowCells,
            onSort: this.onSort,
            sortKey: sortField,
            sortOrder: sortDirection,
            emptyView: isLoading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($58d4afddfb7fcf61$var$EmptyLoadingView, null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(EmptyView, null),
            label: tableAriaLabel
        }), TableMaskView && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(TableMaskView, null)));
    }
    constructor(...args){
        super(...args), this.state = {
            hasSortingChanged: false,
            shouldAnnounceResults: false,
            returnFocusTo: null
        }, /**
   * We very much wish that `attrs` is an object of this type {| key: string, sortOrder: string |}
   * but unfortunately @atlaskit/dynamic-table types do not give any guarantee of that
   * so we should be handling mixed here.
   */ this.onSort = (attrs, analyticsEvent)=>{
            // @ts-expect-error - TS2339 - Property 'key' does not exist on type 'unknown'. | TS2339 - Property 'sortOrder' does not exist on type 'unknown'.
            const { key: key, sortOrder: sortOrder } = attrs;
            const { onSort: onSort } = this.props;
            if (analyticsEvent) (0, $gCeeo.fireUIAnalytics)(analyticsEvent, 'tableHeader', {
                key: key
            });
            onSort({
                sortField: key,
                sortDirection: sortOrder
            });
            if ((0, $7jTnu.fg)('blu-7774_fix_focus_bug_table_header_in_directories')) this.setState({
                returnFocusTo: key
            });
        };
    }
}
var // @ts-expect-error - Argument of type 'typeof Table' is not assignable to parameter of type 'ComponentType<WithIntlProvided<Props<unknown, string, unknown, unknown>>> & typeof Table'.
$58d4afddfb7fcf61$export$2e2bcd8739ae039 = (0, $idGBm.injectIntlV2)($58d4afddfb7fcf61$var$Table);
const $58d4afddfb7fcf61$var$TABLE_ROW_HEIGHT = '40px'; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $58d4afddfb7fcf61$var$NonBreakingCell = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_o5721q9c",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $58d4afddfb7fcf61$var$Container = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { firstColumnHeadingAlignment: firstColumnHeadingAlignment, visuallyRefreshedHeight: visuallyRefreshedHeight, visualRefreshEnabled: visualRefreshEnabled, lastColumnHeadingAlignment: lastColumnHeadingAlignment, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1bgnkvw": (0, $awdRS.default)(__cmplp.firstColumnHeadingAlignment),
            "--_xer3jx": (0, $awdRS.default)(__cmplp.visuallyRefreshedHeight ? '16px' : '14px'),
            "--_w6gjp2": (0, $awdRS.default)(__cmplp.visualRefreshEnabled ? '16px' : '14px'),
            "--_jlq5ur": (0, $awdRS.default)(__cmplp.lastColumnHeadingAlignment)
        },
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_kqswh2mm _2ws7jp4b _p4liidpf _6autidpf _7dd61ux8 _13jcr73l _496i159m _9yen1pfg _10wbnkob _jwot4jg8",
            __cmplp.visualRefreshEnabled && "_19ibi2wt _y4woe4h9 _oaa6nqa1 _10okmuej _cnoh1vhk _1o7fzgxb _1m2zqbzx _1cuj1ylp _4lbnglyw _1ttwzgxb _qassi2wt _1g00i2wt",
            __cmplp.className
        ])
    });
});
const $58d4afddfb7fcf61$var$styles = {
    headerWrapper: "_19bvu2gc _u5f31b66 _ca0q1b66 _n3td1b66",
    headerWrapperOld: "_18zr1b66 _1rjcu2gc _4cvr1h6o _1bah1h6o _1bsbzwfg"
}; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $58d4afddfb7fcf61$var$EmptyLoadingView = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_4t3i1w81",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $58d4afddfb7fcf61$var$HeaderWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1o8l",
            __cmplp.className
        ])
    });
});

});
parcelRegister("lOOiG", function(module, exports) {

$parcel$export(module.exports, "default", () => $976d89647138dbc1$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $jrFnt = parcelRequire("jrFnt");

var $3Vuhz = parcelRequire("3Vuhz");


var $aXVGO = parcelRequire("aXVGO");

var $khVsD = parcelRequire("khVsD");

var $1NCSA = parcelRequire("1NCSA");

var $bEPjZ = parcelRequire("bEPjZ");

var $04ZiM = parcelRequire("04ZiM");

var $foLeX = parcelRequire("foLeX");

var $goxGh = parcelRequire("goxGh");

var $5hPH6 = parcelRequire("5hPH6");

var $iXYwm = parcelRequire("iXYwm");
function $976d89647138dbc1$var$toggleSortOrder(currentSortOrder) {
    switch(currentSortOrder){
        case 0, $861def5c205d1816$export$b6abcf7fa1d94f65:
            return 0, $861def5c205d1816$export$1dee026a19752d6b;
        case 0, $861def5c205d1816$export$1dee026a19752d6b:
            return 0, $861def5c205d1816$export$b6abcf7fa1d94f65;
        default:
            return currentSortOrder;
    }
}
const $976d89647138dbc1$var$DynamicTable = ({ caption: caption, head: head, highlightedRowIndex: highlightedRowIndex, rows: rows, sortKey: sortKey, sortOrder: sortOrder, loadingLabel: loadingLabel, onPageRowsUpdate: onPageRowsUpdate, testId: testId, totalRows: passedDownTotalRows, label: label, isLoading: isLoading = false, isFixedSize: isFixedSize = false, rowsPerPage: rowsPerPage = Infinity, onSetPage: onSetPage = (0, $3Vuhz.default), onSort: providedOnSort = (0, $3Vuhz.default), page: page = 1, emptyView: emptyView, isRankable: isRankable = false, isRankingDisabled: isRankingDisabled = false, onRankStart: onRankStart = (0, $3Vuhz.default), onRankEnd: providedOnRankEnd = (0, $3Vuhz.default), loadingSpinnerSize: loadingSpinnerSize, paginationi18n: paginationi18n = {
    prev: 'Previous Page',
    next: 'Next Page',
    label: 'Pagination',
    pageLabel: 'Page'
} })=>{
    const [isRanking, setIsRanking] = (0, $eJOHy.useState)(false);
    const tableBodyRef = (0, $eJOHy.useRef)(null);
    const onSort = (0, $jrFnt.usePlatformLeafEventHandler)({
        fn: providedOnSort,
        action: 'sorted',
        componentName: 'dynamicTable',
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local"
    });
    const onRankEnd = (0, $jrFnt.usePlatformLeafEventHandler)({
        fn: providedOnRankEnd,
        action: 'ranked',
        componentName: 'dynamicTable',
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local"
    });
    (0, $eJOHy.useEffect)(()=>{
        (0, $aXVGO.validateSortKey)(sortKey, head);
        (0, $aXVGO.assertIsSortable)(head);
    }, [
        sortKey,
        head
    ]);
    const onSortHandler = (item)=>()=>{
            const { key: key } = item;
            if (!key) return;
            if (onSort && isRankable && key === sortKey && sortOrder === (0, $861def5c205d1816$export$b6abcf7fa1d94f65)) {
                onSort({
                    key: null,
                    sortOrder: null,
                    item: item
                });
                return;
            }
            const sortOrderFormatted = key !== sortKey ? (0, $861def5c205d1816$export$1dee026a19752d6b) : $976d89647138dbc1$var$toggleSortOrder(sortOrder);
            if (onSort) onSort({
                key: key,
                item: item,
                sortOrder: sortOrderFormatted
            });
        };
    const onSetPageHandler = (page, event)=>{
        onSetPage(page, event);
    };
    const onRankStartHandler = (params)=>{
        setIsRanking(true);
        onRankStart(params);
    };
    const onRankEndHandler = (params)=>{
        setIsRanking(false);
        onRankEnd(params);
    };
    const getSpinnerSize = ()=>{
        if (loadingSpinnerSize) return loadingSpinnerSize;
        return (0, $aXVGO.getPageRows)(rows || [], page, rowsPerPage).length > 2 ? (0, $861def5c205d1816$export$7b93a10c0fefe3e3) : (0, $861def5c205d1816$export$71dd4c8ecd45e95f);
    };
    const renderEmptyBody = ()=>{
        if (isLoading) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $1NCSA.EmptyViewWithFixedHeight), {
            testId: testId
        });
        return emptyView && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $1NCSA.EmptyViewContainer), {
            testId: testId,
            children: emptyView
        });
    };
    const rowsLength = rows && rows.length;
    let totalPages;
    // set a flag to denote the dynamic table might get only one page of data
    // for paginated data
    let isTotalPagesControlledExternally = false;
    if (passedDownTotalRows && Number.isInteger(passedDownTotalRows) && rowsPerPage && rowsLength && rowsLength <= passedDownTotalRows) {
        /**
     * If total number of rows / records have been passed down as prop
     * Then table is being fed paginated data from server or other sources
     * In this case, we want to respect information passed down by server or external source
     * Rather than relying on our computation based on number of rows
     */ totalPages = Math.ceil(passedDownTotalRows / rowsPerPage);
        isTotalPagesControlledExternally = true;
    } else totalPages = rowsLength && rowsPerPage ? Math.ceil(rowsLength / rowsPerPage) : 0;
    totalPages = totalPages < 1 ? 1 : totalPages;
    const getPageNumber = page > totalPages ? totalPages : page; // page! required, because typescript can't yet see defaultProps to know that this won't be undefined
    const rowsExist = !!rowsLength;
    const spinnerSize = getSpinnerSize();
    const emptyBody = renderEmptyBody();
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $gt9Am.Fragment), {
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $goxGh.default), {
                isLoading: isLoading && rowsExist,
                spinnerSize: spinnerSize,
                targetRef: ()=>tableBodyRef.current,
                testId: testId,
                loadingLabel: loadingLabel,
                children: /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $khVsD.Table), {
                    isFixedSize: isFixedSize,
                    "aria-label": label,
                    hasDataRow: rowsExist,
                    testId: testId,
                    isLoading: isLoading,
                    children: [
                        !!caption && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $khVsD.Caption), {
                            children: caption
                        }),
                        head && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $iXYwm.default), {
                            head: head,
                            onSort: onSortHandler,
                            sortKey: sortKey,
                            sortOrder: sortOrder,
                            isRanking: isRanking,
                            isRankable: isRankable,
                            testId: testId
                        }),
                        rowsExist && /*#__PURE__*/ (0, $gt9Am.jsx)($976d89647138dbc1$var$TableBody, {
                            ref: tableBodyRef,
                            highlightedRowIndex: highlightedRowIndex,
                            rows: rows,
                            head: head,
                            sortKey: sortKey,
                            sortOrder: sortOrder,
                            rowsPerPage: rowsPerPage,
                            page: getPageNumber,
                            isFixedSize: isFixedSize || false,
                            onPageRowsUpdate: onPageRowsUpdate,
                            isTotalPagesControlledExternally: isTotalPagesControlledExternally,
                            testId: testId,
                            isRankable: isRankable,
                            isRanking: isRanking,
                            onRankStart: onRankStartHandler,
                            onRankEnd: onRankEndHandler,
                            isRankingDisabled: isRankingDisabled || isLoading || false
                        })
                    ]
                })
            }),
            totalPages <= 1 ? null : // only show pagination if there's MORE than 1 page
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $khVsD.PaginationWrapper), {
                testId: testId,
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5hPH6.default), {
                    value: getPageNumber,
                    onChange: onSetPageHandler,
                    total: totalPages,
                    i18n: paginationi18n,
                    isDisabled: isLoading,
                    testId: testId
                })
            }),
            !rowsExist && emptyBody && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $foLeX.default), {
                isLoading: isLoading,
                spinnerSize: (0, $861def5c205d1816$export$7b93a10c0fefe3e3),
                testId: testId,
                loadingLabel: loadingLabel,
                children: emptyBody
            })
        ]
    });
};

const $976d89647138dbc1$var$RankableTableBody = /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("itCCG")));
const $976d89647138dbc1$var$TableBody = /*#__PURE__*/ (0, $eJOHy.forwardRef)(function TableBody({ isRankable: isRankable = false, isRanking: isRanking, onRankStart: onRankStart, onRankEnd: onRankEnd, isRankingDisabled: isRankingDisabled, ...bodyProps }, ref) {
    const canRank = isRankable && !bodyProps.sortKey;
    /**
   * React 16 does not support SSR for lazy components,
   * so we avoid rendering the `Suspense` on the server.
   */ const [canRenderRankable, setCanRenderRankable] = (0, $eJOHy.useState)(false);
    (0, $eJOHy.useEffect)(()=>{
        if (canRank) setCanRenderRankable(true);
    }, [
        canRank
    ]);
    const nonRankableBody = /*#__PURE__*/ (0, $gt9Am.jsx)((0, $bEPjZ.default), {
        ref: ref,
        ...bodyProps
    });
    return canRank && canRenderRankable ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $04ZiM.ErrorBoundary), {
        fallback: nonRankableBody,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $eJOHy.Suspense), {
            fallback: nonRankableBody,
            children: /*#__PURE__*/ (0, $gt9Am.jsx)($976d89647138dbc1$var$RankableTableBody, {
                ref: ref,
                ...bodyProps,
                isRanking: isRanking,
                onRankStart: onRankStart,
                onRankEnd: onRankEnd,
                isRankingDisabled: isRankingDisabled
            })
        })
    }) : nonRankableBody;
});
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$976d89647138dbc1$export$2e2bcd8739ae039 = $976d89647138dbc1$var$DynamicTable;

});
const $861def5c205d1816$export$1dee026a19752d6b = 'ASC';
const $861def5c205d1816$export$b6abcf7fa1d94f65 = 'DESC';
const $861def5c205d1816$export$71dd4c8ecd45e95f = 'small';
const $861def5c205d1816$export$7b93a10c0fefe3e3 = 'large';
const $861def5c205d1816$export$3843c586a90b9cbf = 0.22;

parcelRegister("aXVGO", function(module, exports) {

$parcel$export(module.exports, "getPageRows", () => $d0bfac7c95a14ce3$export$3987dc24b734dcab);
$parcel$export(module.exports, "assertIsSortable", () => $d0bfac7c95a14ce3$export$5eb35a4771ec4090);
$parcel$export(module.exports, "validateSortKey", () => $d0bfac7c95a14ce3$export$9133f5a8bfe8a200);
$parcel$export(module.exports, "inlineStylesIfRanking", () => $d0bfac7c95a14ce3$export$a601f1775e10043f);
$parcel$export(module.exports, "reorderRows", () => $d0bfac7c95a14ce3$export$c476bbe5da59992d);
const $d0bfac7c95a14ce3$export$3987dc24b734dcab = (allRows, pageNumber, rowsPerPage)=>{
    if (!pageNumber || !rowsPerPage || !allRows.length) return [];
    return allRows.slice((pageNumber - 1) * rowsPerPage, pageNumber * rowsPerPage);
};
const $d0bfac7c95a14ce3$export$5eb35a4771ec4090 = (head)=>{
    if (!head || !head.cells) return;
    head.cells.forEach((cell)=>{
        if (cell.isSortable && !cell.key) try {
            throw Error("isSortable can't be set to true, if the 'key' prop is missing.");
        } catch (e) {
            // eslint-disable-next-line no-console
            console.error(e);
        }
    });
};
const $d0bfac7c95a14ce3$export$9133f5a8bfe8a200 = (sortKey, head)=>{
    if (!sortKey) return;
    const headHasKey = head && head.cells.map((cell)=>cell.key).includes(sortKey);
    if (!headHasKey) try {
        throw Error(`Cell with ${sortKey} key not found in head.`);
    } catch (e) {
        // eslint-disable-next-line no-console
        console.error(e);
    }
};
const $d0bfac7c95a14ce3$export$a601f1775e10043f = (isRanking, width, height)=>{
    if (!isRanking) return {};
    if (height) return {
        width: width,
        height: height
    };
    return {
        width: width
    };
};
const $d0bfac7c95a14ce3$export$92bcb1ed38b134a1 = (index, page, rowsPerPage)=>{
    const itemOnPreviousPages = rowsPerPage && isFinite(rowsPerPage) ? (page - 1) * rowsPerPage : 0;
    return index + itemOnPreviousPages;
};
const $d0bfac7c95a14ce3$export$c476bbe5da59992d = (rankEnd, rows, page = 1, rowsPerPage)=>{
    const { destination: destination, sourceIndex: sourceIndex } = rankEnd;
    if (!destination) return rows;
    const fromIndex = $d0bfac7c95a14ce3$export$92bcb1ed38b134a1(sourceIndex, page, rowsPerPage);
    const toIndex = $d0bfac7c95a14ce3$export$92bcb1ed38b134a1(destination.index, page, rowsPerPage);
    const reordered = rows.slice();
    const [removed] = reordered.splice(fromIndex, 1);
    reordered.splice(toIndex, 0, removed);
    return reordered;
};

});

parcelRegister("khVsD", function(module, exports) {

$parcel$export(module.exports, "Table", () => $fd7ebbab92fbe669$export$54ec01a60f47d33d);
$parcel$export(module.exports, "Caption", () => $fd7ebbab92fbe669$export$32fbfacc5d962e0c);
$parcel$export(module.exports, "PaginationWrapper", () => $fd7ebbab92fbe669$export$3e5e12dc01f20a43);
/* dynamic-table.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @repo/internal/react/require-jsdoc */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

const $fd7ebbab92fbe669$var$fixedSizeTableStyles = null;
const $fd7ebbab92fbe669$var$tableStyles = null;
const $fd7ebbab92fbe669$var$bodyBorder = null;
const $fd7ebbab92fbe669$export$54ec01a60f47d33d = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ isFixedSize: isFixedSize, hasDataRow: hasDataRow, children: children, testId: testId, isLoading: isLoading, ...rest }, ref)=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)("table", {
        inert: isLoading ? '' : undefined,
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            '--local-dynamic-table-hover-bg': `var(--ds-background-neutral-subtle-hovered, ${(0, $7bb4c1736002a04a$export$e655ef011c4aa1a2)})`,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            '--local-dynamic-table-highlighted-bg': `var(--ds-background-selected, ${(0, $7bb4c1736002a04a$export$226de0355ed012f8)})`,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            '--local-dynamic-table-hover-highlighted-bg': `var(--ds-background-selected-hovered, ${(0, $7bb4c1736002a04a$export$8c13c2ee36917869)})`,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            '--local-dynamic-table-row-focus-outline': `var(--ds-border-focused, ${(0, $7bb4c1736002a04a$export$ecfc1dff386a3e7a)})`
        },
        ref: ref,
        ...rest,
        "data-testid": testId && `${testId}--table`,
        className: (0, $hcewu.default)([
            "_1bsb1osq _yq5h18uv _btyzidpf _ect41gqc",
            isFixedSize && "_1kqm1n9t",
            hasDataRow && "_179r1on0"
        ]),
        children: children
    });
});
const $fd7ebbab92fbe669$var$captionStyles = null;
const $fd7ebbab92fbe669$export$32fbfacc5d962e0c = ({ children: children })=>/*#__PURE__*/ (0, $gt9Am.jsx)("caption", {
        className: (0, $hcewu.default)([
            "_11c8lodh _6rthu2gc _1pfh1ejb _m6k41e03"
        ]),
        children: children
    });
const $fd7ebbab92fbe669$var$paginationWrapperStyles = null;
const $fd7ebbab92fbe669$export$3e5e12dc01f20a43 = ({ children: children, testId: testId })=>/*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        "data-testid": testId && `${testId}--pagination--container`,
        className: (0, $hcewu.default)([
            "_1e0c1txw _1bah1h6o"
        ]),
        children: children
    });

});
var $7bb4c1736002a04a$exports = {};

$parcel$export($7bb4c1736002a04a$exports, "R50", () => $7bb4c1736002a04a$export$4b84fd0e2c617bd);
$parcel$export($7bb4c1736002a04a$exports, "R75", () => $7bb4c1736002a04a$export$b34b069eff244586);
$parcel$export($7bb4c1736002a04a$exports, "R100", () => $7bb4c1736002a04a$export$be802dd0d8b57f35);
$parcel$export($7bb4c1736002a04a$exports, "R200", () => $7bb4c1736002a04a$export$60847d42f9da92a6);
$parcel$export($7bb4c1736002a04a$exports, "R300", () => $7bb4c1736002a04a$export$4a7404f376229999);
$parcel$export($7bb4c1736002a04a$exports, "R400", () => $7bb4c1736002a04a$export$2010d0fb4295b346);
$parcel$export($7bb4c1736002a04a$exports, "R500", () => $7bb4c1736002a04a$export$2837b5a1a71d5c02);
$parcel$export($7bb4c1736002a04a$exports, "Y50", () => $7bb4c1736002a04a$export$8d9596b529bbb9cf);
$parcel$export($7bb4c1736002a04a$exports, "Y75", () => $7bb4c1736002a04a$export$41060a744ab0b7ae);
$parcel$export($7bb4c1736002a04a$exports, "Y100", () => $7bb4c1736002a04a$export$1cc05bbbf340e559);
$parcel$export($7bb4c1736002a04a$exports, "Y200", () => $7bb4c1736002a04a$export$5aae31392d72caaa);
$parcel$export($7bb4c1736002a04a$exports, "Y300", () => $7bb4c1736002a04a$export$c6930421db9fa514);
$parcel$export($7bb4c1736002a04a$exports, "Y400", () => $7bb4c1736002a04a$export$59619663aa6500fb);
$parcel$export($7bb4c1736002a04a$exports, "Y500", () => $7bb4c1736002a04a$export$874739ea9e379ab6);
$parcel$export($7bb4c1736002a04a$exports, "G50", () => $7bb4c1736002a04a$export$8a6341c32b6a3ee6);
$parcel$export($7bb4c1736002a04a$exports, "G75", () => $7bb4c1736002a04a$export$69a3bf21b9686c2b);
$parcel$export($7bb4c1736002a04a$exports, "G100", () => $7bb4c1736002a04a$export$afbce1382ec95f73);
$parcel$export($7bb4c1736002a04a$exports, "G200", () => $7bb4c1736002a04a$export$747d86715d4175de);
$parcel$export($7bb4c1736002a04a$exports, "G300", () => $7bb4c1736002a04a$export$940e1f69e873f202);
$parcel$export($7bb4c1736002a04a$exports, "G400", () => $7bb4c1736002a04a$export$a49394138f7b8e85);
$parcel$export($7bb4c1736002a04a$exports, "G500", () => $7bb4c1736002a04a$export$6fa04827ac68a4fb);
$parcel$export($7bb4c1736002a04a$exports, "B50", () => $7bb4c1736002a04a$export$226de0355ed012f8);
$parcel$export($7bb4c1736002a04a$exports, "B75", () => $7bb4c1736002a04a$export$8c13c2ee36917869);
$parcel$export($7bb4c1736002a04a$exports, "B100", () => $7bb4c1736002a04a$export$ecfc1dff386a3e7a);
$parcel$export($7bb4c1736002a04a$exports, "B200", () => $7bb4c1736002a04a$export$215b7063051591f1);
$parcel$export($7bb4c1736002a04a$exports, "B300", () => $7bb4c1736002a04a$export$e62e8919cca44969);
$parcel$export($7bb4c1736002a04a$exports, "B400", () => $7bb4c1736002a04a$export$b3de0ae08da2ce64);
$parcel$export($7bb4c1736002a04a$exports, "B500", () => $7bb4c1736002a04a$export$a6ee3d71bc067634);
$parcel$export($7bb4c1736002a04a$exports, "B600", () => $7bb4c1736002a04a$export$67f15409e87642a1);
$parcel$export($7bb4c1736002a04a$exports, "B700", () => $7bb4c1736002a04a$export$f0539dbc42dbb067);
$parcel$export($7bb4c1736002a04a$exports, "P50", () => $7bb4c1736002a04a$export$363e4475840015bb);
$parcel$export($7bb4c1736002a04a$exports, "P75", () => $7bb4c1736002a04a$export$4b0a4417ed59760f);
$parcel$export($7bb4c1736002a04a$exports, "P100", () => $7bb4c1736002a04a$export$6011520a64d9a187);
$parcel$export($7bb4c1736002a04a$exports, "P200", () => $7bb4c1736002a04a$export$a7175d4e9206bc80);
$parcel$export($7bb4c1736002a04a$exports, "P300", () => $7bb4c1736002a04a$export$b48405b95304b5a1);
$parcel$export($7bb4c1736002a04a$exports, "P400", () => $7bb4c1736002a04a$export$c71e4279dd54a18d);
$parcel$export($7bb4c1736002a04a$exports, "P500", () => $7bb4c1736002a04a$export$147899de772240ec);
$parcel$export($7bb4c1736002a04a$exports, "T50", () => $7bb4c1736002a04a$export$2cf711fe14c66f06);
$parcel$export($7bb4c1736002a04a$exports, "T75", () => $7bb4c1736002a04a$export$7a8f4d33f6f9772c);
$parcel$export($7bb4c1736002a04a$exports, "T100", () => $7bb4c1736002a04a$export$776c9c497ef08533);
$parcel$export($7bb4c1736002a04a$exports, "T200", () => $7bb4c1736002a04a$export$69cb3ca10c1e330e);
$parcel$export($7bb4c1736002a04a$exports, "T300", () => $7bb4c1736002a04a$export$9dc1ef0f3f48059b);
$parcel$export($7bb4c1736002a04a$exports, "T400", () => $7bb4c1736002a04a$export$7c835c78b6fcdef8);
$parcel$export($7bb4c1736002a04a$exports, "T500", () => $7bb4c1736002a04a$export$6036577f95c3877e);
$parcel$export($7bb4c1736002a04a$exports, "N0", () => $7bb4c1736002a04a$export$29a4f05edc054374);
$parcel$export($7bb4c1736002a04a$exports, "N10", () => $7bb4c1736002a04a$export$e655ef011c4aa1a2);
$parcel$export($7bb4c1736002a04a$exports, "N20", () => $7bb4c1736002a04a$export$9fdfb749e33cdf97);
$parcel$export($7bb4c1736002a04a$exports, "N30", () => $7bb4c1736002a04a$export$3e51e8f1440314ba);
$parcel$export($7bb4c1736002a04a$exports, "N40", () => $7bb4c1736002a04a$export$1ce2d1575d444ceb);
$parcel$export($7bb4c1736002a04a$exports, "N50", () => $7bb4c1736002a04a$export$8754fc7e6d8b3000);
$parcel$export($7bb4c1736002a04a$exports, "N60", () => $7bb4c1736002a04a$export$c2e91cbeada39b8b);
$parcel$export($7bb4c1736002a04a$exports, "N70", () => $7bb4c1736002a04a$export$5f71e19f3a7ad9de);
$parcel$export($7bb4c1736002a04a$exports, "N80", () => $7bb4c1736002a04a$export$eaa8c8a70ac22806);
$parcel$export($7bb4c1736002a04a$exports, "N90", () => $7bb4c1736002a04a$export$7c87d337fb91a97d);
$parcel$export($7bb4c1736002a04a$exports, "N100", () => $7bb4c1736002a04a$export$d6447c357493214f);
$parcel$export($7bb4c1736002a04a$exports, "N200", () => $7bb4c1736002a04a$export$f563ee71e9ee74cd);
$parcel$export($7bb4c1736002a04a$exports, "N300", () => $7bb4c1736002a04a$export$e2ef2124cf4024b1);
$parcel$export($7bb4c1736002a04a$exports, "N400", () => $7bb4c1736002a04a$export$eece5f492e429f08);
$parcel$export($7bb4c1736002a04a$exports, "N500", () => $7bb4c1736002a04a$export$c39c0fe0f26207ae);
$parcel$export($7bb4c1736002a04a$exports, "N600", () => $7bb4c1736002a04a$export$7090862dc3038a9f);
$parcel$export($7bb4c1736002a04a$exports, "N700", () => $7bb4c1736002a04a$export$ad0bacf983b7ddaa);
$parcel$export($7bb4c1736002a04a$exports, "N800", () => $7bb4c1736002a04a$export$7d61b15e0da132af);
$parcel$export($7bb4c1736002a04a$exports, "N900", () => $7bb4c1736002a04a$export$fbda843f0a27fe96);
$parcel$export($7bb4c1736002a04a$exports, "N10A", () => $7bb4c1736002a04a$export$791e57b27ca738ef);
$parcel$export($7bb4c1736002a04a$exports, "N20A", () => $7bb4c1736002a04a$export$8d43898f60b96a82);
$parcel$export($7bb4c1736002a04a$exports, "N30A", () => $7bb4c1736002a04a$export$920c0d5c49070351);
$parcel$export($7bb4c1736002a04a$exports, "N40A", () => $7bb4c1736002a04a$export$46987b49aab6d1a8);
$parcel$export($7bb4c1736002a04a$exports, "N50A", () => $7bb4c1736002a04a$export$7d3359664e8bb0e5);
$parcel$export($7bb4c1736002a04a$exports, "N60A", () => $7bb4c1736002a04a$export$d2d3bedfb276cac0);
$parcel$export($7bb4c1736002a04a$exports, "N70A", () => $7bb4c1736002a04a$export$6e5e7499ff054f6d);
$parcel$export($7bb4c1736002a04a$exports, "N80A", () => $7bb4c1736002a04a$export$59264b346c877fa7);
$parcel$export($7bb4c1736002a04a$exports, "N90A", () => $7bb4c1736002a04a$export$d092757d7c64925c);
$parcel$export($7bb4c1736002a04a$exports, "N100A", () => $7bb4c1736002a04a$export$486ab785e4bac3c6);
$parcel$export($7bb4c1736002a04a$exports, "N200A", () => $7bb4c1736002a04a$export$fba592bbc6419fea);
$parcel$export($7bb4c1736002a04a$exports, "N300A", () => $7bb4c1736002a04a$export$13609db0e6812ab8);
$parcel$export($7bb4c1736002a04a$exports, "N400A", () => $7bb4c1736002a04a$export$fbae4efaa892d883);
$parcel$export($7bb4c1736002a04a$exports, "N500A", () => $7bb4c1736002a04a$export$f13946d26f440ce6);
$parcel$export($7bb4c1736002a04a$exports, "N600A", () => $7bb4c1736002a04a$export$19f58225ac52a306);
$parcel$export($7bb4c1736002a04a$exports, "N700A", () => $7bb4c1736002a04a$export$6384f09da70e7b62);
$parcel$export($7bb4c1736002a04a$exports, "N800A", () => $7bb4c1736002a04a$export$d0dccc730683edc2);
$parcel$export($7bb4c1736002a04a$exports, "DN900", () => $7bb4c1736002a04a$export$2f6319cf7d736c2a);
$parcel$export($7bb4c1736002a04a$exports, "DN800", () => $7bb4c1736002a04a$export$95126bc8884d6634);
$parcel$export($7bb4c1736002a04a$exports, "DN700", () => $7bb4c1736002a04a$export$8338d8c35d44ff1);
$parcel$export($7bb4c1736002a04a$exports, "DN600", () => $7bb4c1736002a04a$export$5368d76ae4fbbda7);
$parcel$export($7bb4c1736002a04a$exports, "DN500", () => $7bb4c1736002a04a$export$9f0a771d16ec8d36);
$parcel$export($7bb4c1736002a04a$exports, "DN400", () => $7bb4c1736002a04a$export$abcf8c38338b4aa5);
$parcel$export($7bb4c1736002a04a$exports, "DN300", () => $7bb4c1736002a04a$export$97e81faa16a182c7);
$parcel$export($7bb4c1736002a04a$exports, "DN200", () => $7bb4c1736002a04a$export$bfe21c59123ecf33);
$parcel$export($7bb4c1736002a04a$exports, "DN100", () => $7bb4c1736002a04a$export$ee82aa2ea6a1558);
$parcel$export($7bb4c1736002a04a$exports, "DN90", () => $7bb4c1736002a04a$export$682927c6ed76be02);
$parcel$export($7bb4c1736002a04a$exports, "DN80", () => $7bb4c1736002a04a$export$91fd9994c5be9757);
$parcel$export($7bb4c1736002a04a$exports, "DN70", () => $7bb4c1736002a04a$export$d281fbfe3cff2df6);
$parcel$export($7bb4c1736002a04a$exports, "DN60", () => $7bb4c1736002a04a$export$3902c91d8b98a753);
$parcel$export($7bb4c1736002a04a$exports, "DN50", () => $7bb4c1736002a04a$export$8e8133c1ba5845b5);
$parcel$export($7bb4c1736002a04a$exports, "DN40", () => $7bb4c1736002a04a$export$33ff357f6620b39);
$parcel$export($7bb4c1736002a04a$exports, "DN30", () => $7bb4c1736002a04a$export$633847cf062b69e0);
$parcel$export($7bb4c1736002a04a$exports, "DN20", () => $7bb4c1736002a04a$export$9776a6e503bdbf76);
$parcel$export($7bb4c1736002a04a$exports, "DN10", () => $7bb4c1736002a04a$export$6c813d5160dff5db);
$parcel$export($7bb4c1736002a04a$exports, "DN0", () => $7bb4c1736002a04a$export$3d4f271a500072a);
$parcel$export($7bb4c1736002a04a$exports, "DN800A", () => $7bb4c1736002a04a$export$fe151285c22759ec);
$parcel$export($7bb4c1736002a04a$exports, "DN700A", () => $7bb4c1736002a04a$export$a101c6190d0da34);
$parcel$export($7bb4c1736002a04a$exports, "DN600A", () => $7bb4c1736002a04a$export$4b16f52932fda51);
$parcel$export($7bb4c1736002a04a$exports, "DN500A", () => $7bb4c1736002a04a$export$a74bcd7b9845b0d8);
$parcel$export($7bb4c1736002a04a$exports, "DN400A", () => $7bb4c1736002a04a$export$9209c179316d1751);
$parcel$export($7bb4c1736002a04a$exports, "DN300A", () => $7bb4c1736002a04a$export$88f55133f636c8dd);
$parcel$export($7bb4c1736002a04a$exports, "DN200A", () => $7bb4c1736002a04a$export$51126f85d1009512);
$parcel$export($7bb4c1736002a04a$exports, "DN100A", () => $7bb4c1736002a04a$export$a069b547bd23af78);
$parcel$export($7bb4c1736002a04a$exports, "DN90A", () => $7bb4c1736002a04a$export$40cce05af3b2600a);
$parcel$export($7bb4c1736002a04a$exports, "DN80A", () => $7bb4c1736002a04a$export$b78942185925a0d);
$parcel$export($7bb4c1736002a04a$exports, "DN70A", () => $7bb4c1736002a04a$export$e058fb44b8eaafca);
$parcel$export($7bb4c1736002a04a$exports, "DN60A", () => $7bb4c1736002a04a$export$92b0b8de26920c18);
$parcel$export($7bb4c1736002a04a$exports, "DN50A", () => $7bb4c1736002a04a$export$67564f7459d3fc9e);
$parcel$export($7bb4c1736002a04a$exports, "DN40A", () => $7bb4c1736002a04a$export$77868e1ca884ffa3);
$parcel$export($7bb4c1736002a04a$exports, "DN30A", () => $7bb4c1736002a04a$export$2afd71d7d3ea2cd5);
$parcel$export($7bb4c1736002a04a$exports, "DN20A", () => $7bb4c1736002a04a$export$f2a0acaab9972c70);
$parcel$export($7bb4c1736002a04a$exports, "DN10A", () => $7bb4c1736002a04a$export$9ab70e67d6475361);
$parcel$export($7bb4c1736002a04a$exports, "T30", () => $7bb4c1736002a04a$export$d2adc5dedf09fced);
$parcel$export($7bb4c1736002a04a$exports, "L50", () => $7bb4c1736002a04a$export$f51762073d2bb381);
$parcel$export($7bb4c1736002a04a$exports, "L75", () => $7bb4c1736002a04a$export$95e26d54def96891);
// Reds
const $7bb4c1736002a04a$export$4b84fd0e2c617bd = '#FFEBE6';
const $7bb4c1736002a04a$export$b34b069eff244586 = '#FFBDAD';
const $7bb4c1736002a04a$export$be802dd0d8b57f35 = '#FF8F73';
const $7bb4c1736002a04a$export$60847d42f9da92a6 = '#FF7452';
const $7bb4c1736002a04a$export$4a7404f376229999 = '#FF5630';
const $7bb4c1736002a04a$export$2010d0fb4295b346 = '#DE350B';
const $7bb4c1736002a04a$export$2837b5a1a71d5c02 = '#BF2600';
const $7bb4c1736002a04a$export$8d9596b529bbb9cf = '#FFFAE6';
const $7bb4c1736002a04a$export$41060a744ab0b7ae = '#FFF0B3';
const $7bb4c1736002a04a$export$1cc05bbbf340e559 = '#FFE380';
const $7bb4c1736002a04a$export$5aae31392d72caaa = '#FFC400';
const $7bb4c1736002a04a$export$c6930421db9fa514 = '#FFAB00';
const $7bb4c1736002a04a$export$59619663aa6500fb = '#FF991F';
const $7bb4c1736002a04a$export$874739ea9e379ab6 = '#FF8B00';
const $7bb4c1736002a04a$export$8a6341c32b6a3ee6 = '#E3FCEF';
const $7bb4c1736002a04a$export$69a3bf21b9686c2b = '#ABF5D1';
const $7bb4c1736002a04a$export$afbce1382ec95f73 = '#79F2C0';
const $7bb4c1736002a04a$export$747d86715d4175de = '#57D9A3';
const $7bb4c1736002a04a$export$940e1f69e873f202 = '#36B37E';
const $7bb4c1736002a04a$export$a49394138f7b8e85 = '#00875A';
const $7bb4c1736002a04a$export$6fa04827ac68a4fb = '#006644';
const $7bb4c1736002a04a$export$226de0355ed012f8 = '#DEEBFF';
const $7bb4c1736002a04a$export$8c13c2ee36917869 = '#B3D4FF';
const $7bb4c1736002a04a$export$ecfc1dff386a3e7a = '#4C9AFF';
const $7bb4c1736002a04a$export$215b7063051591f1 = '#2684FF';
const $7bb4c1736002a04a$export$e62e8919cca44969 = '#0065FF';
const $7bb4c1736002a04a$export$b3de0ae08da2ce64 = '#0052CC';
const $7bb4c1736002a04a$export$a6ee3d71bc067634 = '#0747A6';
const $7bb4c1736002a04a$export$67f15409e87642a1 = '#669DF1';
const $7bb4c1736002a04a$export$f0539dbc42dbb067 = '#8FB8F6';
const $7bb4c1736002a04a$export$363e4475840015bb = '#EAE6FF';
const $7bb4c1736002a04a$export$4b0a4417ed59760f = '#C0B6F2';
const $7bb4c1736002a04a$export$6011520a64d9a187 = '#998DD9';
const $7bb4c1736002a04a$export$a7175d4e9206bc80 = '#8777D9';
const $7bb4c1736002a04a$export$b48405b95304b5a1 = '#6554C0';
const $7bb4c1736002a04a$export$c71e4279dd54a18d = '#5243AA';
const $7bb4c1736002a04a$export$147899de772240ec = '#403294';
const $7bb4c1736002a04a$export$2cf711fe14c66f06 = '#E6FCFF';
const $7bb4c1736002a04a$export$7a8f4d33f6f9772c = '#B3F5FF';
const $7bb4c1736002a04a$export$776c9c497ef08533 = '#79E2F2';
const $7bb4c1736002a04a$export$69cb3ca10c1e330e = '#00C7E6';
const $7bb4c1736002a04a$export$9dc1ef0f3f48059b = '#00B8D9';
const $7bb4c1736002a04a$export$7c835c78b6fcdef8 = '#00A3BF';
const $7bb4c1736002a04a$export$6036577f95c3877e = '#008DA6';
const $7bb4c1736002a04a$export$29a4f05edc054374 = '#FFFFFF';
const $7bb4c1736002a04a$export$e655ef011c4aa1a2 = '#FAFBFC';
const $7bb4c1736002a04a$export$9fdfb749e33cdf97 = '#F4F5F7';
const $7bb4c1736002a04a$export$3e51e8f1440314ba = '#EBECF0';
const $7bb4c1736002a04a$export$1ce2d1575d444ceb = '#DFE1E6';
const $7bb4c1736002a04a$export$8754fc7e6d8b3000 = '#C1C7D0';
const $7bb4c1736002a04a$export$c2e91cbeada39b8b = '#B3BAC5';
const $7bb4c1736002a04a$export$5f71e19f3a7ad9de = '#A5ADBA';
const $7bb4c1736002a04a$export$eaa8c8a70ac22806 = '#97A0AF';
const $7bb4c1736002a04a$export$7c87d337fb91a97d = '#8993A4';
const $7bb4c1736002a04a$export$d6447c357493214f = '#7A869A';
const $7bb4c1736002a04a$export$f563ee71e9ee74cd = '#6B778C';
const $7bb4c1736002a04a$export$e2ef2124cf4024b1 = '#5E6C84';
const $7bb4c1736002a04a$export$eece5f492e429f08 = '#505F79';
const $7bb4c1736002a04a$export$c39c0fe0f26207ae = '#42526E';
const $7bb4c1736002a04a$export$7090862dc3038a9f = '#344563';
const $7bb4c1736002a04a$export$ad0bacf983b7ddaa = '#253858';
const $7bb4c1736002a04a$export$7d61b15e0da132af = '#172B4D';
const $7bb4c1736002a04a$export$fbda843f0a27fe96 = '#091E42';
const $7bb4c1736002a04a$export$791e57b27ca738ef = 'rgba(9, 30, 66, 0.02)';
const $7bb4c1736002a04a$export$8d43898f60b96a82 = 'rgba(9, 30, 66, 0.04)';
const $7bb4c1736002a04a$export$920c0d5c49070351 = 'rgba(9, 30, 66, 0.08)';
const $7bb4c1736002a04a$export$46987b49aab6d1a8 = 'rgba(9, 30, 66, 0.13)';
const $7bb4c1736002a04a$export$7d3359664e8bb0e5 = 'rgba(9, 30, 66, 0.25)';
const $7bb4c1736002a04a$export$d2d3bedfb276cac0 = 'rgba(9, 30, 66, 0.31)';
const $7bb4c1736002a04a$export$6e5e7499ff054f6d = 'rgba(9, 30, 66, 0.36)';
const $7bb4c1736002a04a$export$59264b346c877fa7 = 'rgba(9, 30, 66, 0.42)';
const $7bb4c1736002a04a$export$d092757d7c64925c = 'rgba(9, 30, 66, 0.48)';
const $7bb4c1736002a04a$export$486ab785e4bac3c6 = 'rgba(9, 30, 66, 0.54)';
const $7bb4c1736002a04a$export$fba592bbc6419fea = 'rgba(9, 30, 66, 0.60)';
const $7bb4c1736002a04a$export$13609db0e6812ab8 = 'rgba(9, 30, 66, 0.66)';
const $7bb4c1736002a04a$export$fbae4efaa892d883 = 'rgba(9, 30, 66, 0.71)';
const $7bb4c1736002a04a$export$f13946d26f440ce6 = 'rgba(9, 30, 66, 0.77)';
const $7bb4c1736002a04a$export$19f58225ac52a306 = 'rgba(9, 30, 66, 0.82)';
const $7bb4c1736002a04a$export$6384f09da70e7b62 = 'rgba(9, 30, 66, 0.89)';
const $7bb4c1736002a04a$export$d0dccc730683edc2 = 'rgba(9, 30, 66, 0.95)';
const $7bb4c1736002a04a$export$2f6319cf7d736c2a = '#E6EDFA';
const $7bb4c1736002a04a$export$95126bc8884d6634 = '#DCE5F5';
const $7bb4c1736002a04a$export$8338d8c35d44ff1 = '#CED9EB';
const $7bb4c1736002a04a$export$5368d76ae4fbbda7 = '#B8C7E0';
const $7bb4c1736002a04a$export$9f0a771d16ec8d36 = '#ABBBD6';
const $7bb4c1736002a04a$export$abcf8c38338b4aa5 = '#9FB0CC';
const $7bb4c1736002a04a$export$97e81faa16a182c7 = '#8C9CB8';
const $7bb4c1736002a04a$export$bfe21c59123ecf33 = '#7988A3';
const $7bb4c1736002a04a$export$ee82aa2ea6a1558 = '#67758F';
const $7bb4c1736002a04a$export$682927c6ed76be02 = '#56637A';
const $7bb4c1736002a04a$export$91fd9994c5be9757 = '#455166';
const $7bb4c1736002a04a$export$d281fbfe3cff2df6 = '#3B475C';
const $7bb4c1736002a04a$export$3902c91d8b98a753 = '#313D52';
const $7bb4c1736002a04a$export$8e8133c1ba5845b5 = '#283447';
const $7bb4c1736002a04a$export$33ff357f6620b39 = '#202B3D';
const $7bb4c1736002a04a$export$633847cf062b69e0 = '#1B2638';
const $7bb4c1736002a04a$export$9776a6e503bdbf76 = '#121A29';
const $7bb4c1736002a04a$export$6c813d5160dff5db = '#0E1624';
const $7bb4c1736002a04a$export$3d4f271a500072a = '#0D1424';
const $7bb4c1736002a04a$export$fe151285c22759ec = 'rgba(13, 20, 36, 0.06)';
const $7bb4c1736002a04a$export$a101c6190d0da34 = 'rgba(13, 20, 36, 0.14)';
const $7bb4c1736002a04a$export$4b16f52932fda51 = 'rgba(13, 20, 36, 0.18)';
const $7bb4c1736002a04a$export$a74bcd7b9845b0d8 = 'rgba(13, 20, 36, 0.29)';
const $7bb4c1736002a04a$export$9209c179316d1751 = 'rgba(13, 20, 36, 0.36)';
const $7bb4c1736002a04a$export$88f55133f636c8dd = 'rgba(13, 20, 36, 0.40)';
const $7bb4c1736002a04a$export$51126f85d1009512 = 'rgba(13, 20, 36, 0.47)';
const $7bb4c1736002a04a$export$a069b547bd23af78 = 'rgba(13, 20, 36, 0.53)';
const $7bb4c1736002a04a$export$40cce05af3b2600a = 'rgba(13, 20, 36, 0.63)';
const $7bb4c1736002a04a$export$b78942185925a0d = 'rgba(13, 20, 36, 0.73)';
const $7bb4c1736002a04a$export$e058fb44b8eaafca = 'rgba(13, 20, 36, 0.78)';
const $7bb4c1736002a04a$export$92b0b8de26920c18 = 'rgba(13, 20, 36, 0.81)';
const $7bb4c1736002a04a$export$67564f7459d3fc9e = 'rgba(13, 20, 36, 0.85)';
const $7bb4c1736002a04a$export$77868e1ca884ffa3 = 'rgba(13, 20, 36, 0.89)';
const $7bb4c1736002a04a$export$2afd71d7d3ea2cd5 = 'rgba(13, 20, 36, 0.92)';
const $7bb4c1736002a04a$export$f2a0acaab9972c70 = 'rgba(13, 20, 36, 0.95)';
const $7bb4c1736002a04a$export$9ab70e67d6475361 = 'rgba(13, 20, 36, 0.97)';
const $7bb4c1736002a04a$export$d2adc5dedf09fced = '#292A2E';
const $7bb4c1736002a04a$export$f51762073d2bb381 = '#94C748';
const $7bb4c1736002a04a$export$95e26d54def96891 = '#B3DF72';


parcelRegister("1NCSA", function(module, exports) {

$parcel$export(module.exports, "EmptyViewWithFixedHeight", () => $b2a7a5f88e6f100c$export$8f45b9407d4090d7);
$parcel$export(module.exports, "EmptyViewContainer", () => $b2a7a5f88e6f100c$export$381ea436de119582);
/* empty-body.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @repo/internal/react/require-jsdoc */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
const $b2a7a5f88e6f100c$var$fixedHeightStyles = null;
const $b2a7a5f88e6f100c$export$8f45b9407d4090d7 = ({ children: children, testId: testId })=>/*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        "data-testid": testId && `${testId}--empty-view-with-fixed-height`,
        className: (0, $hcewu.default)([
            "_4t3i1jdh"
        ]),
        children: children
    });
const $b2a7a5f88e6f100c$var$emptyViewContainerStyles = null;
const $b2a7a5f88e6f100c$export$381ea436de119582 = (props)=>{
    const { children: children, testId: testId } = props;
    return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        "data-testid": testId && `${testId}--empty-view-container`,
        className: (0, $hcewu.default)([
            "_19pk1wug _2hwx1wug _otyr1wug _18u01wug _ca0q19bv _u5f319bv _n3td19bv _19bv19bv _1bsb1ssb _y3gn1h6o"
        ]),
        children: children
    });
};

});

parcelRegister("bEPjZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $2c021f4be43795a4$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $jNhOC = parcelRequire("jNhOC");

var $lW0bH = parcelRequire("lW0bH");
class $2c021f4be43795a4$var$BodyComponent extends (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Component {
    render() {
        const { pageRows: pageRows, head: head, isFixedSize: isFixedSize, highlightedRowIndex: highlightedRowIndex, testId: testId, forwardedRef: forwardedRef } = this.props;
        return /*#__PURE__*/ (0, $gt9Am.jsx)("tbody", {
            "data-testid": testId && `${testId}--body`,
            ref: forwardedRef,
            children: pageRows.map((row, rowIndex)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $lW0bH.default), {
                    head: head,
                    isFixedSize: isFixedSize,
                    row: row,
                    isHighlighted: row.isHighlighted || !!highlightedRowIndex && (typeof highlightedRowIndex === 'number' ? highlightedRowIndex === rowIndex : highlightedRowIndex.indexOf(rowIndex) > -1),
                    testId: testId
                }, row.key || rowIndex))
        });
    }
}
const $2c021f4be43795a4$var$Body = (0, $jNhOC.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).forwardRef((props, ref)=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)($2c021f4be43795a4$var$BodyComponent, {
        ...props,
        forwardedRef: ref
    });
}));
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$2c021f4be43795a4$export$2e2bcd8739ae039 = $2c021f4be43795a4$var$Body;

});
parcelRegister("jNhOC", function(module, exports) {

$parcel$export(module.exports, "default", () => $835026024c70c744$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");


var $aXVGO = parcelRequire("aXVGO");
const $835026024c70c744$var$getSortingCellValue = (cells, head, sortKey)=>{
    for(let i = 0; i < cells.length; i++){
        if (head.cells[i] && head.cells[i]?.key === sortKey) return cells[i]?.key;
    }
    return undefined;
};
// sort all rows based on sort key and order
const $835026024c70c744$var$getSortedRows = (head, rows, sortKey, sortOrder)=>{
    if (!sortKey || !head) return rows;
    if (!rows) return [];
    const modifier = sortOrder === (0, $861def5c205d1816$export$1dee026a19752d6b) ? 1 : -1;
    // Re-initialising an I18n Collator on every sort is performance intensive, thus constructed outside
    const collator = new Intl.Collator(undefined, {
        numeric: true,
        sensitivity: 'accent'
    });
    // Get copy of rows to avoid sorting prop in place
    const sortableRows = Array.from(rows);
    // Reorder rows in table based on sorting cell value
    // Algorithm will sort numerics or strings, but not both
    return sortableRows.sort((a, b)=>{
        const valA = $835026024c70c744$var$getSortingCellValue(a.cells, head, sortKey);
        const valB = $835026024c70c744$var$getSortingCellValue(b.cells, head, sortKey);
        if (valA === undefined || valB === undefined) return modifier;
        if (typeof valA !== typeof valB) {
            // numbers are always grouped higher in the sort
            if (typeof valA === 'number') return -1;
            if (typeof valB === 'number') return 1;
            // strings are grouped next
            if (typeof valA === 'string') return -1;
            if (typeof valB === 'string') return 1;
        }
        if (typeof valA === 'string' && typeof valB === 'string') return modifier * collator.compare(valA, valB);
        if (!valA && valA !== 0 || valA < valB) return -modifier;
        if (!valB && valB !== 0 || valA > valB) return modifier;
        if (valA === valB) return 0;
        return 1;
    });
};
function $835026024c70c744$export$2e2bcd8739ae039(WrappedComponent) {
    class WithSortedPageRows extends (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Component {
        static getDerivedStateFromProps(props, state) {
            const { rows: rows, head: head, sortKey: sortKey, sortOrder: sortOrder, page: page, rowsPerPage: rowsPerPage, isTotalPagesControlledExternally: isTotalPagesControlledExternally } = props;
            (0, $aXVGO.validateSortKey)(sortKey, head);
            let sortedRows;
            let pageRows;
            if (isTotalPagesControlledExternally) {
                sortedRows = rows;
                pageRows = rows;
            } else {
                sortedRows = $835026024c70c744$var$getSortedRows(head, rows, sortKey, sortOrder) || [];
                pageRows = (0, $aXVGO.getPageRows)(sortedRows, page, rowsPerPage);
            }
            return {
                ...state,
                pageRows: pageRows
            };
        }
        componentDidMount() {
            this.props.onPageRowsUpdate && this.props.onPageRowsUpdate(this.state.pageRows);
        }
        componentDidUpdate(_prevProps, prevState) {
            if (this.props.onPageRowsUpdate && this.state.pageRows !== prevState.pageRows) this.props.onPageRowsUpdate(this.state.pageRows);
        }
        render() {
            const { rows: rows, head: head, sortKey: sortKey, sortOrder: sortOrder, rowsPerPage: rowsPerPage, page: page, forwardedRef: forwardedRef, ...restProps } = this.props;
            return /*#__PURE__*/ (0, $gt9Am.jsx)(WrappedComponent, {
                //@ts-expect-error TODO Fix legit TypeScript 3.9.6 improved inference error
                pageRows: this.state.pageRows,
                head: head,
                ...restProps,
                ref: forwardedRef
            });
        }
        constructor(...args){
            super(...args), this.state = {
                pageRows: []
            };
        }
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).forwardRef((props, ref)=>{
        return /*#__PURE__*/ (0, $gt9Am.jsx)(WithSortedPageRows, {
            ...props,
            forwardedRef: ref
        });
    });
}

});

parcelRegister("lW0bH", function(module, exports) {

$parcel$export(module.exports, "default", () => $c4bfc9d23dedd74e$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $5ljLr = parcelRequire("5ljLr");

var $268TF = parcelRequire("268TF");
const $c4bfc9d23dedd74e$var$Row = ({ row: row, head: head, testId: testId, isFixedSize: isFixedSize, isHighlighted: isHighlighted })=>{
    const { cells: cells, ...restRowProps } = row;
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $268TF.TableBodyRow), {
        ...restRowProps,
        isHighlighted: isHighlighted,
        ...isHighlighted ? {
            'data-ts--dynamic-table--table-row--highlighted': true
        } : null,
        testId: row.testId || testId && `${testId}--row-${restRowProps.key}`,
        children: cells.map((cell, cellIndex)=>{
            const { content: content, testId: cellTestId, ...restCellProps } = cell;
            const { shouldTruncate: shouldTruncate, width: width } = (head || {
                cells: []
            }).cells[cellIndex] || {};
            return /*#__PURE__*/ (0, $eJOHy.createElement)((0, $5ljLr.TableBodyCell), {
                "data-testid": cellTestId || testId && `${testId}--cell-${cellIndex}`,
                ...restCellProps,
                isFixedSize: isFixedSize,
                key: cellIndex,
                shouldTruncate: shouldTruncate,
                width: width
            }, content);
        })
    });
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$c4bfc9d23dedd74e$export$2e2bcd8739ae039 = $c4bfc9d23dedd74e$var$Row;

});
parcelRegister("5ljLr", function(module, exports) {

$parcel$export(module.exports, "TableBodyCell", () => $6d87de66ba7880ae$export$948e91fcef170792);
/* table-cell.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $1eoPo = parcelRequire("1eoPo");
const $6d87de66ba7880ae$var$fixedSizeTruncateStyles = null;
const $6d87de66ba7880ae$var$overflowTruncateStyles = null;
const $6d87de66ba7880ae$var$truncationWidthStyles = null;
const $6d87de66ba7880ae$var$cellStyles = null;
const $6d87de66ba7880ae$export$948e91fcef170792 = ({ width: width, isFixedSize: isFixedSize, shouldTruncate: shouldTruncate, innerRef: innerRef, ...props })=>/*#__PURE__*/ (0, $gt9Am.jsx)("td", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        style: (0, $1eoPo.getTruncationStyleVars)({
            width: width
        }),
        // HOC withDimensions complains about the types but it is working fine
        // @ts-ignore
        ref: innerRef,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $hcewu.default)([
            "_1bsb8a2a",
            isFixedSize && shouldTruncate && "_1bto1l2s _o5721q9c",
            isFixedSize && "_1reo15vq _18m915vq",
            "_19itglyw _85i51b66 _1q511b66 _y4tiu2gc _bozgu2gc _y3gn1e5h _1s37ze3t _uupyze3t",
            props.className
        ]),
        ...props
    });

});
parcelRegister("1eoPo", function(module, exports) {

$parcel$export(module.exports, "getTruncationStyleVars", () => $91687adffdb20f71$export$5e6497a652ae30b5);
const $91687adffdb20f71$var$CSS_VAR_WIDTH = '--local-dynamic-table-width';
const $91687adffdb20f71$export$5e6497a652ae30b5 = ({ width: width })=>typeof width !== 'undefined' ? {
        [$91687adffdb20f71$var$CSS_VAR_WIDTH]: `${width}%`
    } : undefined;

});


parcelRegister("268TF", function(module, exports) {

$parcel$export(module.exports, "TableBodyRow", () => $a53c59e604030c6d$export$45f39d9c38b886d5);
/* table-row.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
const $a53c59e604030c6d$var$rowStyles = null;
const $a53c59e604030c6d$var$rowBackgroundStyles = null;
const $a53c59e604030c6d$var$rowHighlightedBackgroundStyles = null;
const $a53c59e604030c6d$export$45f39d9c38b886d5 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ isHighlighted: isHighlighted, children: children, style: style, testId: testId, className: className, ...rest }, ref)=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)("tr", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: style,
        /**
   * We rely on this `className` for the `RankableTableBodyRow` to apply extra styles.
   * With Compiled it needs to be statically analyzable. It does not get applied via spread props.
   */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $hcewu.default)([
            "_bfhk1w7a _1ygbi9un _1ah312gs",
            isHighlighted ? "_bfhktkjs _irr31ae3" : "_irr3s8ts",
            className
        ]),
        ...rest,
        ref: ref,
        "data-testid": testId,
        children: children
    });
});

});



parcelRegister("04ZiM", function(module, exports) {

$parcel$export(module.exports, "ErrorBoundary", () => $fd6eb2a47216dc9b$export$e926676385687eaf);

var $eJOHy = parcelRequire("eJOHy");
class $fd6eb2a47216dc9b$export$e926676385687eaf extends (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Component {
    constructor(props){
        super(props);
        this.state = {
            hasError: false
        };
    }
    static getDerivedStateFromError() {
        // Update state so the next render will show the fallback UI.
        return {
            hasError: true
        };
    }
    render() {
        if (this.state.hasError) // You can render any custom fallback UI
        return this.props.fallback;
        return this.props.children;
    }
}

});

parcelRegister("foLeX", function(module, exports) {

$parcel$export(module.exports, "default", () => $7869f2e695a66a65$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $7ep4S = parcelRequire("7ep4S");


var $CEHHO = parcelRequire("CEHHO");
class $7869f2e695a66a65$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Component {
    static{
        this.defaultProps = {
            isLoading: true,
            spinnerSize: (0, $861def5c205d1816$export$7b93a10c0fefe3e3),
            contentsOpacity: (0, $861def5c205d1816$export$3843c586a90b9cbf),
            loadingLabel: 'Loading table'
        };
    }
    render() {
        const { children: children, isLoading: isLoading, spinnerSize: spinnerSize, contentsOpacity: contentsOpacity, testId: testId, loadingLabel: loadingLabel } = this.props;
        return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $CEHHO.Container), {
            testId: testId,
            children: [
                !isLoading ? children : /*#__PURE__*/ (0, $gt9Am.jsx)((0, $CEHHO.ContentsContainer), {
                    contentsOpacity: contentsOpacity,
                    testId: testId,
                    children: children
                }),
                isLoading && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $CEHHO.SpinnerContainer), {
                    testId: testId,
                    children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $7ep4S.default), {
                        size: spinnerSize,
                        testId: testId && `${testId}--loadingSpinner`,
                        label: loadingLabel
                    })
                })
            ]
        });
    }
}

});
parcelRegister("CEHHO", function(module, exports) {

$parcel$export(module.exports, "Container", () => $dfc2e003c707e1fb$export$42a852a2b6b56249);
$parcel$export(module.exports, "ContentsContainer", () => $dfc2e003c707e1fb$export$67c29eae8ae2137a);
$parcel$export(module.exports, "SpinnerContainer", () => $dfc2e003c707e1fb$export$a5e06607a5ac6158);
/* loading-container.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @repo/internal/react/require-jsdoc */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
const $dfc2e003c707e1fb$export$c335a80381ec61f5 = '--contents-opacity';
const $dfc2e003c707e1fb$var$containerStyles = null;
const $dfc2e003c707e1fb$export$42a852a2b6b56249 = ({ children: children, testId: testId })=>/*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        "data-testid": testId && `${testId}--container`,
        className: (0, $hcewu.default)([
            "_kqswh2mm"
        ]),
        children: children
    });
const $dfc2e003c707e1fb$var$contentsContainerStyles = null;
const $dfc2e003c707e1fb$export$67c29eae8ae2137a = ({ children: children, contentsOpacity: contentsOpacity, testId: testId })=>/*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        style: {
            [$dfc2e003c707e1fb$export$c335a80381ec61f5]: contentsOpacity
        },
        "data-testid": testId && `${testId}--contents--container`,
        className: (0, $hcewu.default)([
            "_tzy4saf5 _lcxvglyw"
        ]),
        children: children
    });
const $dfc2e003c707e1fb$var$spinnerContainerStyles = null;
const $dfc2e003c707e1fb$export$a5e06607a5ac6158 = ({ children: children, testId: testId })=>/*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        "data-testid": testId && `${testId}--spinner--container`,
        className: (0, $hcewu.default)([
            "_1r04idpf _1e0c1txw _kqswstnw _4cvr1h6o _1bah1h6o"
        ]),
        children: children
    });

});


parcelRegister("goxGh", function(module, exports) {

$parcel$export(module.exports, "default", () => $313fee558443ede2$export$2e2bcd8739ae039);
/* eslint-disable @repo/internal/dom-events/no-unsafe-event-listeners */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $7ep4S = parcelRequire("7ep4S");


var $3rtaW = parcelRequire("3rtaW");
class $313fee558443ede2$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Component {
    static{
        this.defaultProps = {
            isLoading: true,
            spinnerSize: (0, $861def5c205d1816$export$7b93a10c0fefe3e3),
            contentsOpacity: `var(--ds-opacity-loading, ${`${0, $861def5c205d1816$export$3843c586a90b9cbf}`})`,
            loadingLabel: 'Loading table'
        };
    }
    attachListeners() {
        window.addEventListener('scroll', this.handleScroll);
        window.addEventListener('resize', this.handleResize);
    }
    detachListeners() {
        window.removeEventListener('scroll', this.handleScroll);
        window.removeEventListener('resize', this.handleResize);
    }
    updateSpinnerPosition() {
        const viewportHeight = window.innerHeight;
        const targetNode = this.getTargetNode();
        const spinnerNode = this.spinnerRef?.current;
        if (!targetNode || typeof targetNode.getBoundingClientRect !== 'function' || !spinnerNode) return;
        const targetRect = targetNode.getBoundingClientRect();
        const spinnerRect = spinnerNode.getBoundingClientRect();
        const spinnerHeight = spinnerRect.height;
        const isInViewport = this.isVerticallyVisible(targetRect, viewportHeight);
        const { top: top, bottom: bottom, height: height } = targetRect;
        if (isInViewport) {
            // The spinner may follow the element only if there is enough space:
            // Let's say the element can fit at least three spinners (vertically)
            const canFollow = height >= spinnerHeight * 3;
            if (canFollow && !this.isFullyVerticallyVisible(targetRect, viewportHeight)) {
                if (top >= 0) {
                    // Only the head of the element is visible
                    const viewportSpaceTakenByElement = viewportHeight - top;
                    const diff = viewportSpaceTakenByElement / 2 + top - spinnerHeight / 2;
                    const y = viewportSpaceTakenByElement < spinnerHeight * 3 ? top + spinnerHeight : diff;
                    this.translateSpinner(spinnerNode, y, true);
                } else if (top < 0 && bottom > viewportHeight) {
                    // The element takes all viewport, nor its head nor tail are visible
                    const y = viewportHeight / 2 - spinnerHeight / 2;
                    this.translateSpinner(spinnerNode, y, true);
                } else {
                    // Only the tail of the element is visible
                    const diff = bottom / 2 - spinnerHeight / 2;
                    const y = diff < spinnerHeight ? diff - (spinnerHeight - diff) : diff;
                    this.translateSpinner(spinnerNode, y, true);
                }
                return;
            }
        } else {
            // If both the element and the spinner are off screen - quit
            if (!this.isVerticallyVisible(spinnerRect, viewportHeight)) return;
        }
        // Three options here:
        // 1) the element is fully visible
        // 2) the element is too small for the spinner to follow
        // 3) the spinner might still be visible while the element isn't
        const containerNode = this.containerRef?.current;
        if (containerNode && typeof containerNode.getBoundingClientRect === 'function') {
            const thisTop = containerNode.getBoundingClientRect().top;
            const y = (top - thisTop) / 2;
            this.translateSpinner(spinnerNode, y, false);
        }
    }
    render() {
        const { children: children, isLoading: isLoading, spinnerSize: spinnerSize, testId: testId, loadingLabel: loadingLabel } = this.props;
        return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $3rtaW.Container), {
            testId: testId && `${testId}--loading--container--advanced`,
            ref: this.containerRef,
            children: [
                children,
                isLoading && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3rtaW.SpinnerBackdrop), {
                    testId: testId,
                    children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3rtaW.SpinnerContainer), {
                        ref: this.spinnerRef,
                        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $7ep4S.default), {
                            size: spinnerSize,
                            testId: testId && `${testId}--loadingSpinner`,
                            label: loadingLabel
                        })
                    })
                })
            ]
        });
    }
    constructor(...args){
        super(...args), this.spinnerRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createRef(), this.containerRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createRef(), this.componentDidMount = ()=>{
            if (this.props.isLoading && this.hasTargetNode()) {
                this.attachListeners();
                this.updateTargetAppearance();
                this.updateSpinnerPosition();
            }
        }, this.UNSAFE_componentWillReceiveProps = (nextProps)=>{
            if (!nextProps.isLoading || !this.hasTargetNode(nextProps)) this.detachListeners();
            else if (!this.props.isLoading) this.attachListeners();
        }, this.componentDidUpdate = ()=>{
            if (this.hasTargetNode()) {
                this.updateTargetAppearance();
                if (this.props.isLoading) this.updateSpinnerPosition();
            }
        }, this.componentWillUnmount = ()=>{
            this.detachListeners();
        }, this.getTargetNode = (nextProps = this.props)=>{
            const { targetRef: targetRef } = nextProps;
            const target = targetRef?.();
            return target || this.containerRef.current;
        }, this.hasTargetNode = (nextProps)=>!!this.getTargetNode(nextProps), this.isVerticallyVisible = (elementRect, viewportHeight)=>{
            const { top: top, bottom: bottom } = elementRect;
            if (bottom <= 0) return false;
            return top < viewportHeight;
        }, this.isFullyVerticallyVisible = (elementRect, viewportHeight)=>{
            const { top: top, bottom: bottom } = elementRect;
            return top >= 0 && bottom <= viewportHeight;
        }, this.handleResize = ()=>{
            this.updateSpinnerPosition();
        }, this.handleScroll = ()=>{
            this.updateSpinnerPosition();
        }, this.translateSpinner = (spinnerNode, transformY, isFixed)=>{
            spinnerNode.style.position = isFixed ? 'fixed' : '';
            spinnerNode.style.transform = transformY !== 0 ? `translate3d(0, ${transformY}px, 0)` : '';
        }, this.updateTargetAppearance = ()=>{
            const targetNode = this.getTargetNode();
            const { isLoading: isLoading, contentsOpacity: contentsOpacity } = this.props;
            if (targetNode && targetNode.style && typeof targetNode.style === 'object') {
                targetNode.style.pointerEvents = isLoading ? 'none' : '';
                targetNode.style.opacity = isLoading ? contentsOpacity.toString() : '';
            }
        };
    }
}

});
parcelRegister("3rtaW", function(module, exports) {

$parcel$export(module.exports, "Container", () => $dcd16b6cedc99af6$export$42a852a2b6b56249);
$parcel$export(module.exports, "SpinnerBackdrop", () => $dcd16b6cedc99af6$export$aa207050321b0c53);
$parcel$export(module.exports, "SpinnerContainer", () => $dcd16b6cedc99af6$export$a5e06607a5ac6158);
/* loading-container-advanced.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @repo/internal/react/require-jsdoc */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
const $dcd16b6cedc99af6$var$containerStyles = null;
const $dcd16b6cedc99af6$export$42a852a2b6b56249 = /*#__PURE__*/ (0, $eJOHy.forwardRef)((props, ref)=>{
    const { children: children, testId: testId, ...rest } = props;
    return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        ...rest,
        "data-testid": testId,
        ref: ref,
        className: (0, $hcewu.default)([
            "_kqswh2mm _6rth1ejb"
        ]),
        children: children
    });
});
const $dcd16b6cedc99af6$var$spinnerBackdropStyles = null;
const $dcd16b6cedc99af6$export$aa207050321b0c53 = ({ children: children, testId: testId })=>/*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        "data-testid": testId && `${testId}--spinner-backdrop`,
        className: (0, $hcewu.default)([
            "_1r04idpf _1e0c1txw _kqswstnw _4cvr1h6o _1bah1h6o _lcxvglyw"
        ]),
        children: children
    });
const $dcd16b6cedc99af6$var$spinnerContainerStyles = null;
const $dcd16b6cedc99af6$export$a5e06607a5ac6158 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ children: children }, ref)=>/*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        ref: ref,
        className: (0, $hcewu.default)([
            "_kqswh2mm _152tidpf"
        ]),
        children: children
    }));

});


parcelRegister("5hPH6", function(module, exports) {

$parcel$export(module.exports, "default", () => $d482c3e387def2e8$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $b3eVo = parcelRequire("b3eVo");
class $d482c3e387def2e8$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Component {
    render() {
        const { total: total, value: value = 1, i18n: i18n, testId: testId, isDisabled: isDisabled } = this.props;
        const pages = [
            ...Array(total)
        ].map((_, index)=>index + 1);
        // Pagination accepts array now thus selectedIndex starts with 0
        // So, we are substracting value by one thus not breaking dynamic table
        const selectedIndex = value - 1;
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $b3eVo.default), {
            selectedIndex: selectedIndex,
            isDisabled: isDisabled,
            label: i18n?.label,
            nextLabel: i18n?.next,
            previousLabel: i18n?.prev,
            pageLabel: i18n?.pageLabel,
            onChange: this.onChange,
            pages: pages,
            testId: testId && `${testId}--pagination`
        });
    }
    constructor(...args){
        super(...args), this.onChange = (_event, newValue, analyticsEvent)=>{
            this.props.onChange(newValue, analyticsEvent);
        };
    }
}

});

parcelRegister("iXYwm", function(module, exports) {

$parcel$export(module.exports, "default", () => $eab3a1b41c933c64$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $eGOwo = parcelRequire("eGOwo");

var $aXVGO = parcelRequire("aXVGO");

var $6d05d = parcelRequire("6d05d");

var $2YodG = parcelRequire("2YodG");

var $bve5l = parcelRequire("bve5l");

var $dYUdf = parcelRequire("dYUdf");

var $fw2VE = parcelRequire("fw2VE");
class $eab3a1b41c933c64$var$TableHead extends (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Component {
    constructor(props){
        super(props);
        this.state = {
            activeSortButtonId: null
        };
    }
    UNSAFE_componentWillMount() {
        (0, $aXVGO.validateSortKey)(this.props.sortKey, this.props.head);
    }
    UNSAFE_componentWillReceiveProps(nextProps) {
        if (this.props.sortKey !== nextProps.sortKey || this.props.head !== nextProps.head) (0, $aXVGO.validateSortKey)(nextProps.sortKey, nextProps.head);
    }
    render() {
        const { head: head, sortKey: sortKey, sortOrder: sortOrder, isFixedSize: isFixedSize, onSort: onSort, isRanking: isRanking, isRankable: isRankable, testId: testId } = this.props;
        const { activeSortButtonId: activeSortButtonId } = this.state;
        if (!head) return null;
        const HeadCellComponentOld = isRankable ? (0, $bve5l.default) : (0, $fw2VE.default);
        const HeadCellComponent = isRankable ? (0, $2YodG.default) : (0, $dYUdf.default);
        // TODO: Remove `rest` props and use only what is explicitly in the API.
        // Some tests use this to pass in onClick and other stuff within the `head`
        // variable here, but considering it's not in the API, it should probably
        // be removed.
        const { cells: cells, ...rest } = head;
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6d05d.Head), {
            ...rest,
            isRanking: isRanking,
            testId: testId && `${testId}--head`,
            children: /*#__PURE__*/ (0, $gt9Am.jsx)("tr", {
                children: cells.map((cell, index)=>{
                    const { ascendingSortTooltip: ascendingSortTooltip, buttonAriaRoleDescription: buttonAriaRoleDescription, colSpan: colSpan, content: content, descendingSortTooltip: descendingSortTooltip, isIconOnlyHeader: isIconOnlyHeader, isSortable: isSortable, key: key, shouldTruncate: shouldTruncate, testId: cellTestId, width: width, // TODO: Remove `rest` props and use only what is explicitly in
                    // the API.
                    ...restCellProps } = cell;
                    const headCellId = `head-cell-${index}`;
                    const handleClick = ()=>{
                        this.setState({
                            activeSortButtonId: headCellId
                        });
                        if (isSortable) onSort(cell)();
                    };
                    return (0, $eGOwo.fg)('platform-component-visual-refresh') ? /*#__PURE__*/ (0, $gt9Am.jsx)(HeadCellComponent, {
                        colSpan: colSpan,
                        content: content,
                        isFixedSize: isFixedSize,
                        isIconOnlyHeader: isIconOnlyHeader,
                        isSortable: !!isSortable,
                        isRanking: isRanking,
                        headCellId: headCellId,
                        activeSortButtonId: activeSortButtonId,
                        onClick: handleClick,
                        testId: cellTestId || testId,
                        shouldTruncate: shouldTruncate,
                        sortOrder: key === sortKey ? sortOrder : undefined,
                        width: width,
                        ascendingSortTooltip: ascendingSortTooltip,
                        descendingSortTooltip: descendingSortTooltip,
                        buttonAriaRoleDescription: buttonAriaRoleDescription,
                        ...restCellProps
                    }, key || index) : /*#__PURE__*/ (0, $gt9Am.jsx)(HeadCellComponentOld, {
                        colSpan: colSpan,
                        content: content,
                        isFixedSize: isFixedSize,
                        isSortable: !!isSortable,
                        isRanking: isRanking,
                        onClick: isSortable ? onSort(cell) : undefined,
                        testId: cellTestId || testId,
                        shouldTruncate: shouldTruncate,
                        sortOrder: key === sortKey ? sortOrder : undefined,
                        width: width,
                        ...restCellProps
                    }, key || index);
                })
            })
        });
    }
}
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$eab3a1b41c933c64$export$2e2bcd8739ae039 = $eab3a1b41c933c64$var$TableHead;

});
parcelRegister("6d05d", function(module, exports) {

$parcel$export(module.exports, "Head", () => $8e34007a1dac0529$export$e93312b7773dfcac);
$parcel$export(module.exports, "HeadCell", () => $8e34007a1dac0529$export$4e8024263ace498b);
/* table-head.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @repo/internal/react/require-jsdoc */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $eGOwo = parcelRequire("eGOwo");



var $1eoPo = parcelRequire("1eoPo");
const $8e34007a1dac0529$var$CSS_VAR_TEXT_COLOR = '--local-dynamic-table-text-color';
const $8e34007a1dac0529$var$rankingStyles = null;
const $8e34007a1dac0529$var$headStyles = null;
const $8e34007a1dac0529$var$overflowTruncateStyles = null;
const $8e34007a1dac0529$var$truncationWidthStyles = null;
const $8e34007a1dac0529$var$fixedSizeTruncateStyles = null;
const $8e34007a1dac0529$var$cellStyles = null;
const $8e34007a1dac0529$export$e93312b7773dfcac = ({ isRanking: isRanking, testId: testId, ...props })=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)("thead", {
        "data-testid": testId,
        ...props,
        className: (0, $hcewu.default)([
            "_179rglyw",
            isRanking && "_1e0c1ule"
        ])
    });
};
const $8e34007a1dac0529$var$headCellBaseStyles = null;
const $8e34007a1dac0529$var$headCellBaseStylesOld = null;
const $8e34007a1dac0529$var$onClickStyles = null;
const $8e34007a1dac0529$var$baseStyles = null;
const $8e34007a1dac0529$var$ascendingStyles = null;
const $8e34007a1dac0529$var$descendingStyles = null;
const $8e34007a1dac0529$export$4e8024263ace498b = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ width: width, children: children, isSortable: isSortable, sortOrder: sortOrder, isFixedSize: isFixedSize, shouldTruncate: shouldTruncate, onClick: onClick, style: style, testId: testId, ...rest }, ref)=>{
    const mergedStyles = {
        ...style,
        ...width && (0, $1eoPo.getTruncationStyleVars)({
            width: width
        }),
        [$8e34007a1dac0529$var$CSS_VAR_TEXT_COLOR]: `var(--ds-text-subtlest, ${(0, $7bb4c1736002a04a$export$e2ef2124cf4024b1)})`
    };
    const isASC = sortOrder === (0, $861def5c205d1816$export$1dee026a19752d6b);
    const isDESC = sortOrder === (0, $861def5c205d1816$export$b6abcf7fa1d94f65);
    const getFormattedSortOrder = ()=>{
        if (isASC) return 'ascending';
        else if (isDESC) return 'descending';
    };
    // If there is no content in the cell, it should be rendered as an empty `td`, not a `th`.
    // https://dequeuniversity.com/rules/axe/4.7/empty-table-header
    const Component = children ? 'th' : 'td';
    const isVisuallyRefreshed = (0, $eGOwo.fg)('platform-component-visual-refresh');
    return /*#__PURE__*/ (0, $gt9Am.jsx)(Component, {
        "aria-sort": getFormattedSortOrder(),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: mergedStyles,
        onClick: !isVisuallyRefreshed ? onClick : undefined,
        ref: ref,
        "data-testid": testId,
        ...rest,
        className: (0, $hcewu.default)([
            "_izbqglyw _h7alglyw _85i51b66 _1q511b66 _y4tiu2gc _bozgu2gc _y3gn1e5h _1s37ze3t _uupyze3t",
            isVisuallyRefreshed ? "_11c8dcr7 _179r1on0 _mqm2glyw _kqswh2mm _syaz34id _k48pmoej _y3gn1e5h _s7n4nkob _1ygbvd8c" : "_11c8dcr7 _179r1on0 _mqm2glyw _t51zglyw _191wglyw _vchhusvi _kqswh2mm _syaz34id _k48pmoej _y3gn1e5h _s7n4jp4b _1ygbvd8c",
            !isVisuallyRefreshed && onClick && "_irr3yw9d _d0altlke",
            "_1bsb8a2a",
            isFixedSize && shouldTruncate && "_1bto1l2s _o5721q9c",
            isFixedSize && "_1reo15vq _18m915vq",
            !isVisuallyRefreshed && isSortable && "_173zglyw _pw6dglyw _1xgk3acm _1wfn3acm _y9yonqa1 _997wnqa1 _sklb1l7b _1j091l7b _19w61ule _1w611ule _1hvvidpf _n56nidpf _wyc4idpf _1d4oidpf _no7mstnw _qh32stnw _4b5mb3bt _hn3bb3bt _14gsx0bf _cigmx0bf _c77kvia6 _qzvtu2gc _f473via6 _1fpyidpf _a04fh2mm _xv14glyw _58ej1kw7 _1ay31kw7 _mdbq1kw7 _10pp1kw7 _1yw3ze3t _n2fdze3t _8607ze3t _szhwze3t _1g2wwc43 _ze9fwc43 _1lcgnqa1 _at5qnqa1 _o4d71l7b _npl51l7b _1rp11onz _1iornqa1 _oi051l7b _1ehx1onz _19t8nqa1 _1bog1l7b",
            !isVisuallyRefreshed && isASC && "_c77k1thn _142s94yt",
            !isVisuallyRefreshed && isDESC && "_f4731thn _17x894yt"
        ]),
        children: children
    });
});

});

parcelRegister("2YodG", function(module, exports) {

$parcel$export(module.exports, "default", () => $e8fde9bd86f03325$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $fTTHR = parcelRequire("fTTHR");

var $aXVGO = parcelRequire("aXVGO");

var $dYUdf = parcelRequire("dYUdf");
class $e8fde9bd86f03325$var$RankableTableHeadCellComponent extends (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Component {
    render() {
        const { isRanking: isRanking, refHeight: refHeight, refWidth: refWidth, ...restProps } = this.props;
        const inlineStyles = (0, $aXVGO.inlineStylesIfRanking)(isRanking, refWidth);
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $dYUdf.default), {
            inlineStyles: inlineStyles,
            ...restProps
        });
    }
}
const $e8fde9bd86f03325$var$RankableTableHeadCell = (0, $fTTHR.default)($e8fde9bd86f03325$var$RankableTableHeadCellComponent);
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$e8fde9bd86f03325$export$2e2bcd8739ae039 = $e8fde9bd86f03325$var$RankableTableHeadCell;

});
parcelRegister("fTTHR", function(module, exports) {

$parcel$export(module.exports, "default", () => $173dc77e0c07b527$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");
function $173dc77e0c07b527$export$2e2bcd8739ae039(WrappedComponent) {
    return class WithDimensions extends (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Component {
        UNSAFE_componentWillReceiveProps(nextProps) {
            const wasRanking = this.props.isRanking;
            const willRanking = nextProps.isRanking;
            if (willRanking && !wasRanking) this.updateDimensions();
        }
        render() {
            const { refWidth: refWidth, refHeight: refHeight } = this.state;
            return /*#__PURE__*/ (0, $gt9Am.jsx)(WrappedComponent, {
                //@ts-expect-error TODO Fix legit TypeScript 3.9.6 improved inference error
                refWidth: refWidth,
                //@ts-expect-error TODO Fix legit TypeScript 3.9.6 improved inference error
                refHeight: refHeight,
                innerRef: this.innerRef,
                ...this.props
            });
        }
        constructor(...args){
            super(...args), this.state = {
                refWidth: 0,
                refHeight: 0
            }, this.innerRef = (ref)=>{
                if (ref && !this.props.isRanking) this.ref = ref;
            }, this.updateDimensions = ()=>{
                if (!this.ref) return;
                const clientRect = this.ref.getBoundingClientRect();
                const { width: width } = clientRect;
                const { height: height } = clientRect;
                if (width !== this.state.refWidth || height !== this.state.refHeight) this.setState({
                    refWidth: width,
                    refHeight: height
                });
            };
        }
    };
}

});

parcelRegister("dYUdf", function(module, exports) {

$parcel$export(module.exports, "default", () => $f5386cb5a0fc1b36$export$2e2bcd8739ae039);
/* table-head-cell.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $8Gywp = parcelRequire("8Gywp");

var $aDbql = parcelRequire("aDbql");

var $8IeH1 = parcelRequire("8IeH1");
var $2sLVw = parcelRequire("2sLVw");
var $46R8N = parcelRequire("46R8N");

var $k71qx = parcelRequire("k71qx");


var $6d05d = parcelRequire("6d05d");
const $f5386cb5a0fc1b36$var$styles = {
    buttonWrapper: "_1e0c1txw _bfhk18uv _4cvr1h6o _ca0qze3t _u5f3ze3t _n3tdze3t _19bvze3t _d0altlke",
    sortIconHiddenWrapper: "_1e0c1txw _tzy4idpf _bfhk18uv _ca0q1b66 _u5f31b66 _n3td1b66 _19bv1b66 _1h7hkb7n",
    sortIconVisibleWrapper: "_1e0c1txw _tzy4kb7n _bfhk18uv _ca0q1b66 _u5f31b66 _n3td1b66 _19bv1b66",
    hideIconHeaderWrapper: "_tzy4idpf _18u010v4",
    visibleHeaderWrapper: "_tzy4kb7n _u5f31b66"
};
const $f5386cb5a0fc1b36$var$headCellStyles = {
    headCellContainer: "_1e0c1txw _4cvr1h6o",
    text: "_11c81o8v _syaz1gjq _k48pmoej"
};
const $f5386cb5a0fc1b36$var$TableHeadCell = ({ content: content, inlineStyles: inlineStyles, testId: testId, isRanking: isRanking, innerRef: innerRef, isSortable: isSortable, sortOrder: sortOrder, onClick: onClick, headCellId: headCellId, activeSortButtonId: activeSortButtonId, ascendingSortTooltip: ascendingSortTooltip = 'Sort ascending', descendingSortTooltip: descendingSortTooltip = 'Sort descending', buttonAriaRoleDescription: buttonAriaRoleDescription = 'Sort button', isIconOnlyHeader: isIconOnlyHeader, ...rest })=>{
    const [isHovered, setIsHovered] = (0, $eJOHy.useState)(false);
    const [isFocused, setIsFocused] = (0, $eJOHy.useState)(false);
    const isActive = headCellId === activeSortButtonId || sortOrder !== undefined;
    const isSortIconVisible = isHovered || isActive || isFocused;
    const isVisibleIconOnlyHeader = isSortIconVisible && isIconOnlyHeader;
    const shouldRenderSortIcon = !isIconOnlyHeader || isSortIconVisible || isIconOnlyHeader && !isFocused;
    const handleFocus = (0, $eJOHy.useCallback)(()=>{
        setIsFocused?.(true);
    }, [
        setIsFocused
    ]);
    const handleBlur = (0, $eJOHy.useCallback)(()=>{
        setIsFocused?.(false);
    }, [
        setIsFocused
    ]);
    const handleMouseEnter = (0, $eJOHy.useCallback)(()=>{
        setIsHovered(true);
    }, [
        setIsHovered
    ]);
    const handleMouseLeave = (0, $eJOHy.useCallback)(()=>{
        setIsHovered(false);
    }, [
        setIsHovered
    ]);
    const visuallyRefreshedButton = /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
        xcss: $f5386cb5a0fc1b36$var$headCellStyles.headCellContainer,
        onMouseEnter: handleMouseEnter,
        onMouseLeave: handleMouseLeave,
        onFocus: handleFocus,
        onBlur: handleBlur,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $k71qx.default), {
            content: sortOrder === (0, $861def5c205d1816$export$1dee026a19752d6b) ? ascendingSortTooltip : descendingSortTooltip,
            children: /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $46R8N.default), {
                onClick: onClick,
                xcss: $f5386cb5a0fc1b36$var$styles.buttonWrapper,
                "aria-roledescription": buttonAriaRoleDescription,
                children: [
                    /*#__PURE__*/ (0, $gt9Am.jsx)((0, $2sLVw.default), {
                        xcss: isVisibleIconOnlyHeader ? $f5386cb5a0fc1b36$var$styles.hideIconHeaderWrapper : $f5386cb5a0fc1b36$var$styles.visibleHeaderWrapper,
                        children: /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
                            className: (0, $hcewu.default)([
                                $f5386cb5a0fc1b36$var$headCellStyles.text
                            ]),
                            children: content
                        })
                    }),
                    shouldRenderSortIcon && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $2sLVw.default), {
                        xcss: isSortIconVisible ? $f5386cb5a0fc1b36$var$styles.sortIconVisibleWrapper : $f5386cb5a0fc1b36$var$styles.sortIconHiddenWrapper,
                        children: sortOrder === (0, $861def5c205d1816$export$1dee026a19752d6b) ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($aDbql))), {
                            label: "",
                            color: "var(--ds-text-subtle, #44546F)",
                            testId: testId && `${testId}--up--icon`
                        }) : /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($8Gywp))), {
                            label: "",
                            color: "var(--ds-text-subtle, #44546F)",
                            testId: testId && `${testId}--down--icon`
                        })
                    })
                ]
            })
        })
    });
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6d05d.HeadCell), {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: inlineStyles,
        testId: testId && `${testId}--head--cell`,
        ref: typeof innerRef !== 'string' ? innerRef : null,
        ...rest,
        isSortable: isSortable,
        sortOrder: sortOrder,
        children: isSortable ? visuallyRefreshedButton : content
    });
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$f5386cb5a0fc1b36$export$2e2bcd8739ae039 = $f5386cb5a0fc1b36$var$TableHeadCell;

});
parcelRegister("8Gywp", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::fcfd9fc2877ad309c8a5d6e5d6ea9482>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $652d0645e24346a6$var$_react = $652d0645e24346a6$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $652d0645e24346a6$var$_baseNew = $652d0645e24346a6$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $652d0645e24346a6$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ArrowDown".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Know uses: sorting table headers or Bitbucket code difference.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $652d0645e24346a6$var$ArrowDownIcon = (props)=>/*#__PURE__*/ $652d0645e24346a6$var$_react.default.createElement($652d0645e24346a6$var$_baseNew.default, Object.assign({
        name: "ArrowDownIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8.75 1v11.44l3.72-3.72 1.06 1.06-5 5a.75.75 0 0 1-1.06 0l-5-5 1.06-1.06 3.72 3.72V1z" clip-rule="evenodd"/>`
    }, props));
$652d0645e24346a6$var$ArrowDownIcon.displayName = 'ArrowDownIcon';
var $652d0645e24346a6$var$_default = module.exports.default = $652d0645e24346a6$var$ArrowDownIcon;

});

parcelRegister("aDbql", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::be13ec6c7b346b13ffda97746cc85c67>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7bd6687a611ada9e$var$_react = $7bd6687a611ada9e$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $7bd6687a611ada9e$var$_baseNew = $7bd6687a611ada9e$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $7bd6687a611ada9e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ArrowUp".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: back to top.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $7bd6687a611ada9e$var$ArrowUpIcon = (props)=>/*#__PURE__*/ $7bd6687a611ada9e$var$_react.default.createElement($7bd6687a611ada9e$var$_baseNew.default, Object.assign({
        name: "ArrowUpIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8.75 15V3.56l3.72 3.72 1.06-1.06-5-5a.75.75 0 0 0-1.06 0l-5 5 1.06 1.06 3.72-3.72V15z" clip-rule="evenodd"/>`
    }, props));
$7bd6687a611ada9e$var$ArrowUpIcon.displayName = 'ArrowUpIcon';
var $7bd6687a611ada9e$var$_default = module.exports.default = $7bd6687a611ada9e$var$ArrowUpIcon;

});



parcelRegister("bve5l", function(module, exports) {

$parcel$export(module.exports, "default", () => $f96b5064e4cfa0d2$export$2e2bcd8739ae039);
// Delete this file when cleaning up platform-component-visual-refresh FG

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $fTTHR = parcelRequire("fTTHR");

var $aXVGO = parcelRequire("aXVGO");

var $fw2VE = parcelRequire("fw2VE");
class $f96b5064e4cfa0d2$var$RankableTableHeadCellComponentOld extends (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Component {
    render() {
        const { isRanking: isRanking, refHeight: refHeight, refWidth: refWidth, ...restProps } = this.props;
        const inlineStyles = (0, $aXVGO.inlineStylesIfRanking)(isRanking, refWidth);
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $fw2VE.default), {
            inlineStyles: inlineStyles,
            ...restProps
        });
    }
}
const $f96b5064e4cfa0d2$var$RankableTableHeadCellOld = (0, $fTTHR.default)($f96b5064e4cfa0d2$var$RankableTableHeadCellComponentOld);
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$f96b5064e4cfa0d2$export$2e2bcd8739ae039 = $f96b5064e4cfa0d2$var$RankableTableHeadCellOld;

});
parcelRegister("fw2VE", function(module, exports) {

$parcel$export(module.exports, "default", () => $ba69cb38cd2149ae$export$2e2bcd8739ae039);
// Delete this file when cleaning up platform-component-visual-refresh FG

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $6d05d = parcelRequire("6d05d");
const $ba69cb38cd2149ae$var$TableHeadCellOld = ({ content: content, inlineStyles: inlineStyles, testId: testId, isRanking: isRanking, innerRef: innerRef, isSortable: isSortable, onClick: onClick, ...rest })=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6d05d.HeadCell), {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: inlineStyles,
        testId: testId && `${testId}--head--cell`,
        ref: typeof innerRef !== 'string' ? innerRef : null,
        ...rest,
        onClick: onClick,
        isSortable: isSortable,
        children: isSortable ? /*#__PURE__*/ (0, $gt9Am.jsx)("button", {
            type: "button",
            "aria-roledescription": "Sort button",
            children: content
        }) : content
    });
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$ba69cb38cd2149ae$export$2e2bcd8739ae039 = $ba69cb38cd2149ae$var$TableHeadCellOld;

});



parcelRegister("itCCG", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = Promise.all([
    $ewTvA("76n7a"),
    $ewTvA("l253H"),
    $ewTvA("4aw4p")
]).then(()=>parcelRequire('l7wPr'));

});


parcelRegister("8TMMM", function(module, exports) {

$parcel$export(module.exports, "default", () => $a1b6dcf21e6f1de9$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $a1b6dcf21e6f1de9$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    filterResultAnnounce: {
        "id": "directory-base.content.table.filter-result-announce",
        "defaultMessage": "{itemCount, plural, one {One item was found after filtering.} other {{itemCount} items were found after filtering.}}"
    },
    filterResultsAnnouncement: {
        "id": "directory-base.content.table.filter-results-announcement",
        "defaultMessage": "{itemCount, plural, =0 {No results were found that match your search} one {{itemCount} result found} other {{itemCount} results found}}"
    }
});

});



parcelRegister("bj0qr", function(module, exports) {

$parcel$export(module.exports, "default", () => $017eecc563c11f26$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $12DRg = parcelRequire("12DRg");

var $54CI2 = parcelRequire("54CI2");

var $6zXPf = parcelRequire("6zXPf");
const $017eecc563c11f26$var$styles = {
    pageContainerNav3: "_7opz1wug",
    pageContainerNav3inner: "_1ul94na8"
};
function $017eecc563c11f26$export$2e2bcd8739ae039(props) {
    const { Header: Header, Table: Table, Paginator: Paginator, Empty: Empty, Error: Error, status: status, onAdd: onAdd, onRetry: onRetry, isOnboardingEnabled: isOnboardingEnabled, renderOnboardingSpotlight: renderOnboardingSpotlight, availableSpotlightTargets: availableSpotlightTargets } = props;
    let main = null;
    let spotlight = null;
    let expectOverflow = false;
    switch(status){
        case 'has-entities':
            expectOverflow = true;
            main = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(Table, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(Paginator, null));
            spotlight = isOnboardingEnabled && renderOnboardingSpotlight && renderOnboardingSpotlight(availableSpotlightTargets);
            break;
        case 'empty':
            main = Empty ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(Empty, {
                onAdd: onAdd
            }) : null;
            break;
        case 'error':
            main = Error ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(Error, {
                onRetry: onRetry
            }) : null;
            break;
        default:
            break;
    }
    if ((0, $6zXPf.getWillShowNav4)()) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $54CI2.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, spotlight, Header ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(Header, null) : null, main));
    if (expectOverflow) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $54CI2.default), null, spotlight, Header ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(Header, null) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
        className: (0, $hcewu.default)([
            $017eecc563c11f26$var$styles.pageContainerNav3
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
        className: (0, $hcewu.default)([
            $017eecc563c11f26$var$styles.pageContainerNav3inner
        ])
    }, main)));
    return expectOverflow ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $54CI2.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
        className: (0, $hcewu.default)([
            $017eecc563c11f26$var$styles.pageContainerNav3
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
        className: (0, $hcewu.default)([
            $017eecc563c11f26$var$styles.pageContainerNav3inner
        ])
    }, spotlight, Header ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(Header, null) : null, main))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $54CI2.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, spotlight, Header ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(Header, null) : null, main));
}
$017eecc563c11f26$export$2e2bcd8739ae039.defaultProps = {
    isOnboardingEnabled: false,
    renderOnboardingSpotlight: ()=>null,
    availableSpotlightTargets: [],
    onAdd: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
    onRetry: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg)))
};

});


parcelRegister("54lJh", function(module, exports) {

$parcel$export(module.exports, "default", () => $7c677f42b9a16635$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/restricted/react-component-props

var $91zZ6 = parcelRequire("91zZ6");

var $6SY0Q = parcelRequire("6SY0Q");

var $ePZvy = parcelRequire("ePZvy");

var $7EfkR = parcelRequire("7EfkR");

var $dZ0bL = parcelRequire("dZ0bL");
const $7c677f42b9a16635$var$mapStateToProps = (state)=>({
        isCreateModalShown: (0, $6SY0Q.isCreateOpen)(state),
        CreateModal: $ePZvy.default,
        operations: (0, $6SY0Q.getOperations)(state),
        OperationModal: $7EfkR.default
    });
var // @ts-expect-error - TS2554 - Expected 3-4 arguments, but got 2. | TS2345 - Argument of type 'typeof Modals' is not assignable to parameter of type 'Component<DispatchProp<any>>'.
$7c677f42b9a16635$export$2e2bcd8739ae039 = (0, $91zZ6.connect)($7c677f42b9a16635$var$mapStateToProps, {})((0, $dZ0bL.default));

});
parcelRegister("ePZvy", function(module, exports) {

$parcel$export(module.exports, "default", () => $e85a5d5d8af0cf08$export$2e2bcd8739ae039);

var $gnQAk = parcelRequire("gnQAk");

var $91zZ6 = parcelRequire("91zZ6");

var $4wOQJ = parcelRequire("4wOQJ");

var $6SY0Q = parcelRequire("6SY0Q");

var $5kAHG = parcelRequire("5kAHG");
const $e85a5d5d8af0cf08$var$mapStateToProps = (state)=>{
    const CreateModal = (0, $6SY0Q.getCreateModal)(state);
    if (!CreateModal) throw new Error('Invalid state - no Create Modal provided');
    return {
        CreateModal: CreateModal
    };
};
const $e85a5d5d8af0cf08$var$mapDispatchToProps = {
    onCreated: (0, $4wOQJ.entityCreated),
    onCreateFailed: (0, $4wOQJ.entityCreateFailed),
    onCancel: (0, $4wOQJ.cancelled)
};
var $e85a5d5d8af0cf08$export$2e2bcd8739ae039 = (0, $gnQAk.connect)($e85a5d5d8af0cf08$var$mapStateToProps, $e85a5d5d8af0cf08$var$mapDispatchToProps, null, (0, $91zZ6.storeOptions))((0, $5kAHG.default));

});
parcelRegister("5kAHG", function(module, exports) {

$parcel$export(module.exports, "default", () => $b78add7cdc0c3965$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");
function $b78add7cdc0c3965$export$2e2bcd8739ae039(props) {
    const { CreateModal: CreateModal, onCreated: onCreated, onCreateFailed: onCreateFailed, onCancel: onCancel } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(CreateModal, {
        onCreated: onCreated,
        onCreateFailed: onCreateFailed,
        onCancel: onCancel
    });
}

});


parcelRegister("7EfkR", function(module, exports) {

$parcel$export(module.exports, "default", () => $6ea54fa0c184bfea$export$2e2bcd8739ae039);

var $LFmXM = parcelRequire("LFmXM");

var $91zZ6 = parcelRequire("91zZ6");

var $5cBQu = parcelRequire("5cBQu");

var $6SY0Q = parcelRequire("6SY0Q");

var $aeXGs = parcelRequire("aeXGs");
const $6ea54fa0c184bfea$var$mapStateToPropsFactory = ()=>{
    const onDataRetrievedFactory = (0, $LFmXM.default)((state, id)=>// @ts-expect-error - TS7031 - Binding element 'patch' implicitly has an 'any' type.
        ({ patch: patch })=>(0, $6SY0Q.getOnPatch)(state)({
                id: id,
                patch: patch
            }));
    return (state, ownProps)=>{
        const { id: id, operation: operation } = ownProps;
        return {
            OperationModal: (0, $6SY0Q.getOperationModal)(state, operation),
            onDataRetrieved: onDataRetrievedFactory(state, id)
        };
    };
};
const $6ea54fa0c184bfea$var$mapDispatchToProps = (dispatch, ownProps)=>{
    const { id: id, operation: operation, childEntityId: childEntityId, isInitializing: isInitializing } = ownProps;
    return {
        entityId: id,
        isInitializing: isInitializing,
        onDialogShown: ()=>dispatch((0, $5cBQu.dialogShown)({
                id: id,
                operation: operation,
                childEntityId: childEntityId
            })),
        onDataRetrieveFailed: ()=>dispatch((0, $5cBQu.entityDataRetrieveFailed)({
                id: id,
                operation: operation
            })),
        // @ts-expect-error - TS2525 - Initializer provides no value for this binding element and the binding element has no default value.
        onUpdated: ({ patch: patch } = {})=>dispatch((0, $5cBQu.entityUpdated)({
                id: id,
                operation: operation,
                patch: patch
            })),
        onUpdateFailed: ()=>dispatch((0, $5cBQu.entityUpdateFailed)({
                id: id,
                operation: operation
            })),
        onCancel: ()=>dispatch((0, $5cBQu.cancelled)({
                id: id,
                operation: operation
            }))
    };
};
var // @ts-expect-error - TS2554 - Expected 3-4 arguments, but got 2. | TS2345 - Argument of type 'typeof Operation' is not assignable to parameter of type 'Component<DispatchProp<any>>'.
$6ea54fa0c184bfea$export$2e2bcd8739ae039 = (0, $91zZ6.connect)($6ea54fa0c184bfea$var$mapStateToPropsFactory, $6ea54fa0c184bfea$var$mapDispatchToProps)((0, $aeXGs.default));

});
parcelRegister("aeXGs", function(module, exports) {

$parcel$export(module.exports, "default", () => $0fff5b41a33d1817$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");
function $0fff5b41a33d1817$export$2e2bcd8739ae039(props) {
    const { OperationModal: OperationModal, ...modalProps } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(OperationModal, modalProps);
}

});


parcelRegister("dZ0bL", function(module, exports) {

$parcel$export(module.exports, "default", () => $b3018c586c391011$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");
function $b3018c586c391011$export$2e2bcd8739ae039(props) {
    const { isCreateModalShown: isCreateModalShown, CreateModal: CreateModal, operations: operations, OperationModal: OperationModal } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", null, isCreateModalShown && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(CreateModal, null), operations.map(({ id: id, operation: operation, childEntityId: childEntityId, isInitializing: isInitializing })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(OperationModal, {
            key: id,
            id: id,
            operation: operation,
            childEntityId: childEntityId,
            isInitializing: isInitializing
        })));
}

});


parcelRegister("dIYLk", function(module, exports) {

$parcel$export(module.exports, "default", () => $4d4b3dfd6658db1e$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");
function $4d4b3dfd6658db1e$export$2e2bcd8739ae039(props) {
    const { Content: Content, Modals: Modals } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(Content, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(Modals, null));
}

});



parcelRegister("iYaR3", function(module, exports) {

$parcel$export(module.exports, "getIds", () => $a7cceca13c7f04d1$export$24b60fe7179439bc);
$parcel$export(module.exports, "getTotal", () => $a7cceca13c7f04d1$export$94860ac4a286a8d9);
$parcel$export(module.exports, "isLoading", () => $a7cceca13c7f04d1$export$20bb0d907fbbe433);
$parcel$export(module.exports, "isError", () => $a7cceca13c7f04d1$export$e6127cc7fe7395c3);
$parcel$export(module.exports, "getName", () => $a7cceca13c7f04d1$export$7d9f7e9c1c02b41e);
$parcel$export(module.exports, "getDescription", () => $a7cceca13c7f04d1$export$67580b1c13935958);
$parcel$export(module.exports, "getOwner", () => $a7cceca13c7f04d1$export$5f4ed0d56c2c0edf);
$parcel$export(module.exports, "getViewUrl", () => $a7cceca13c7f04d1$export$bdccd6a672e4a607);
$parcel$export(module.exports, "getShares", () => $a7cceca13c7f04d1$export$3b3cfad4475f6525);
$parcel$export(module.exports, "getEdits", () => $a7cceca13c7f04d1$export$ade2933f0cc600b);
$parcel$export(module.exports, "getFilter", () => $a7cceca13c7f04d1$export$61ec8404f465cd36);
$parcel$export(module.exports, "getIsWritable", () => $a7cceca13c7f04d1$export$8e04de5241998cf7);
$parcel$export(module.exports, "manageSubscriptionsUrl", () => $a7cceca13c7f04d1$export$e68f39a61961e36b);
$parcel$export(module.exports, "getChangeFavorite", () => $a7cceca13c7f04d1$export$85b24bd43a2bd6cf);
$parcel$export(module.exports, "isFavorite", () => $a7cceca13c7f04d1$export$70b3463aa7e3e514);
$parcel$export(module.exports, "isPending", () => $a7cceca13c7f04d1$export$872dec21e9a69476);
$parcel$export(module.exports, "getPopularity", () => $a7cceca13c7f04d1$export$34145270e160ba15);

var $b5RwB = parcelRequire("b5RwB");

var $7MYNw = parcelRequire("7MYNw");
const $a7cceca13c7f04d1$export$dd1bc94b04021eeb = (state)=>state.filters.order.length === 0;
const $a7cceca13c7f04d1$export$24b60fe7179439bc = (state)=>state.filters.order;
const $a7cceca13c7f04d1$export$94860ac4a286a8d9 = (state)=>state.filters.total;
const $a7cceca13c7f04d1$export$20bb0d907fbbe433 = (state)=>state.filters.isLoading;
const $a7cceca13c7f04d1$export$e6127cc7fe7395c3 = (state)=>state.filters.isError;
const $a7cceca13c7f04d1$export$7d9f7e9c1c02b41e = (state, id)=>state.filters.page[id]?.name;
const $a7cceca13c7f04d1$export$67580b1c13935958 = (state, id)=>state.filters.page[id]?.description;
const $a7cceca13c7f04d1$export$5f4ed0d56c2c0edf = (state, id)=>state.filters.page[id]?.owner;
const $a7cceca13c7f04d1$export$bdccd6a672e4a607 = (state, id)=>state.filters.page[id]?.viewUrl;
const $a7cceca13c7f04d1$export$3b3cfad4475f6525 = (state, id)=>state.filters.page[id]?.shares;
const $a7cceca13c7f04d1$export$ade2933f0cc600b = (state, id)=>state.filters.page[id]?.edits;
const $a7cceca13c7f04d1$export$61ec8404f465cd36 = (state, id)=>state.filters.page[id];
const $a7cceca13c7f04d1$export$8e04de5241998cf7 = (state, id)=>state.filters.page[id]?.isWritable || false;
const $a7cceca13c7f04d1$export$9b4c238bf352f0c9 = (actionType)=>(state, filterId)=>{
        const xsrfToken = (0, $7MYNw.getXsrfToken)(state);
        const parsed = (0, (/*@__PURE__*/$parcel$interopDefault($b5RwB))).stringify({
            atl_token: xsrfToken,
            returnUrl: 'ManageFilters.jspa',
            filterId: filterId
        });
        return `/${actionType}!default.jspa?${parsed}`;
    };
const $a7cceca13c7f04d1$export$e68f39a61961e36b = $a7cceca13c7f04d1$export$9b4c238bf352f0c9('ViewSubscriptions');
const $a7cceca13c7f04d1$var$getFavoriteChangeContext = (state)=>state.app.props.favoriteChangeContext;
const $a7cceca13c7f04d1$export$85b24bd43a2bd6cf = (state)=>{
    // TODO EM-312: remove `| void` checks (e.g. `context &&`) from this and other directory pages when old provider is removed
    const context = $a7cceca13c7f04d1$var$getFavoriteChangeContext(state);
    return context && context.changeFavorite;
};
const $a7cceca13c7f04d1$var$getChangedFilter = (state, id)=>{
    const context = $a7cceca13c7f04d1$var$getFavoriteChangeContext(state);
    // @ts-expect-error - TS2532 - Object is possibly 'undefined'.
    return context && context.items.filters[id];
};
const $a7cceca13c7f04d1$var$getIsFavoriteFromState = (state, id)=>state.page[id]?.isFavourite;
const $a7cceca13c7f04d1$var$getPopularityFromState = (state, id)=>state.page[id]?.popularity;
const $a7cceca13c7f04d1$export$70b3463aa7e3e514 = (state, id)=>{
    const itemChanged = $a7cceca13c7f04d1$var$getChangedFilter(state, id);
    return itemChanged ? itemChanged.value : $a7cceca13c7f04d1$var$getIsFavoriteFromState(state.filters, id);
};
const $a7cceca13c7f04d1$export$872dec21e9a69476 = (state, id)=>{
    const item = $a7cceca13c7f04d1$var$getChangedFilter(state, id);
    return !!(item && item.pending);
};
const $a7cceca13c7f04d1$export$34145270e160ba15 = (state, id)=>{
    const popularityInState = $a7cceca13c7f04d1$var$getPopularityFromState(state.filters, id);
    const isFavoriteInState = $a7cceca13c7f04d1$var$getIsFavoriteFromState(state.filters, id);
    const item = $a7cceca13c7f04d1$var$getChangedFilter(state, id);
    if (!item) return popularityInState;
    if (item.value && !isFavoriteInState && popularityInState) return popularityInState + 1;
    if (!item.value && isFavoriteInState && popularityInState) return popularityInState - 1;
    return popularityInState;
};

});

parcelRegister("hBxux", function(module, exports) {

$parcel$export(module.exports, "default", () => $32dce03aba9f6dc0$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $6MnLl = parcelRequire("6MnLl");

var $7jTnu = parcelRequire("7jTnu");

var $kDaaB = parcelRequire("kDaaB");

var $idGBm = parcelRequire("idGBm");

var $hRdnZ = parcelRequire("hRdnZ");

var $3eRIv = parcelRequire("3eRIv");
function $32dce03aba9f6dc0$var$Empty({ intl: { formatMessage: formatMessage } }) {
    // https://ecosystem.atlassian.net/browse/AK-4581
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const description = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kDaaB.default), {
        ...(0, $3eRIv.default).description,
        values: {
            viewAllIssues: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("b", null, formatMessage((0, $7jTnu.fg)('jira-issue-terminology-update-m4') ? (0, $3eRIv.default).viewAllIssuesIssueTerminologyRefreshM4 : (0, $3eRIv.default).viewAllIssues)),
            saveFilterAs: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("b", null, formatMessage((0, $3eRIv.default).saveFilterAs))
        }
    }) // eslint-disable-next-line @typescript-eslint/no-explicit-any
    ;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6MnLl.default), {
        imageUrl: (0, (/*@__PURE__*/$parcel$interopDefault($hRdnZ))),
        header: formatMessage((0, $3eRIv.default).header),
        description: description,
        headingLevel: 2
    });
}
var $32dce03aba9f6dc0$export$2e2bcd8739ae039 = (0, $idGBm.injectIntlV2)($32dce03aba9f6dc0$var$Empty);

});
parcelRegister("hRdnZ", function(module, exports) {
module.exports = new URL("empty.368985dc.svg", import.meta.url).toString();

});

parcelRegister("3eRIv", function(module, exports) {

$parcel$export(module.exports, "default", () => $a2653e04ac26b25f$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $a2653e04ac26b25f$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    header: {
        "id": "directories.filters-v2.main.content.empty.header",
        "defaultMessage": "You don't have any filters"
    },
    description: {
        "id": "directories.filters-v2.main.content.empty.description",
        "defaultMessage": "You can create a filter by searching. Select {viewAllIssues} option from the Filters top bar item and enter your search criteria. Then, select {saveFilterAs} to create a filter"
    },
    viewAllIssues: {
        "id": "directories.filters-v2.main.content.empty.view-all-issues",
        "defaultMessage": "View all issues"
    },
    saveFilterAs: {
        "id": "directories.filters-v2.main.content.empty.save-filter-as",
        "defaultMessage": "Save filter"
    },
    viewAllIssuesIssueTerminologyRefreshM4: {
        "id": "directories.filters-v2.main.content.empty.view-all-issues-issue-terminology-refresh-m4",
        "defaultMessage": "View all work items"
    }
});

});


parcelRegister("e6mG7", function(module, exports) {

$parcel$export(module.exports, "default", () => $ad603320ecab4a11$export$2e2bcd8739ae039);

var $gnQAk = parcelRequire("gnQAk");

var $iYaR3 = parcelRequire("iYaR3");

var $g3FS5 = parcelRequire("g3FS5");
const $ad603320ecab4a11$var$mapStateToProps = (state)=>({
        isLoading: (0, $iYaR3.isLoading)(state)
    });
var $ad603320ecab4a11$export$2e2bcd8739ae039 = (0, $gnQAk.connect)($ad603320ecab4a11$var$mapStateToProps, {})((0, $g3FS5.default));

});
parcelRegister("g3FS5", function(module, exports) {

$parcel$export(module.exports, "default", () => $95ca55cfa0136f1a$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $1sChl = parcelRequire("1sChl");

var $lRq8t = parcelRequire("lRq8t");

var $5pCr6 = parcelRequire("5pCr6");
function $95ca55cfa0136f1a$var$Error(props) {
    const { isLoading: isLoading, onRetry: onRetry } = props;
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1sChl.default), {
        header: formatMessage((0, $5pCr6.default).header),
        description: formatMessage((0, $5pCr6.default).description),
        isLoading: isLoading,
        onRetry: onRetry,
        headingLevel: 2
    });
}
$95ca55cfa0136f1a$var$Error.defaultProps = {
    isLoading: false
};
var $95ca55cfa0136f1a$export$2e2bcd8739ae039 = $95ca55cfa0136f1a$var$Error;

});
parcelRegister("1sChl", function(module, exports) {

$parcel$export(module.exports, "default", () => $6bf0f4be8561750a$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $goZPP = parcelRequire("goZPP");

var $6MnLl = parcelRequire("6MnLl");

var $idGBm = parcelRequire("idGBm");

var $jiDI0 = parcelRequire("jiDI0");

var $bxoX3 = parcelRequire("bxoX3");

var $iAkRR = parcelRequire("iAkRR");
function $6bf0f4be8561750a$export$edf27be85e5f6da0(props) {
    const { header: header, description: description, size: size, onRetry: onRetry, isLoading: isLoading, intl: { formatMessage: formatMessage }, errorImage: errorImage, isSubtle: isSubtle, imageWidth: imageWidth, maxImageHeight: maxImageHeight, retryMessage: retryMessage, renderErrorImage: renderErrorImage, headingLevel: headingLevel } = props;
    const buttonAppearance = isSubtle ? 'default' : 'primary';
    const defaultImageUrl = isSubtle ? (0, (/*@__PURE__*/$parcel$interopDefault($jiDI0))) : (0, (/*@__PURE__*/$parcel$interopDefault($bxoX3)));
    const fallbackImage = errorImage || defaultImageUrl;
    let imageUrl;
    if (renderErrorImage) imageUrl = undefined;
    else imageUrl = fallbackImage;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6MnLl.default), {
        testId: "common-components-error-state.empty-state",
        width: size,
        imageWidth: imageWidth,
        imageUrl: imageUrl,
        header: header,
        description: description,
        isLoading: isLoading,
        maxImageHeight: maxImageHeight,
        primaryAction: !onRetry ? null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
            appearance: buttonAppearance,
            isDisabled: isLoading,
            onClick: onRetry
        }, formatMessage(retryMessage)),
        renderImage: renderErrorImage,
        headingLevel: headingLevel
    });
}
$6bf0f4be8561750a$export$edf27be85e5f6da0.defaultProps = {
    header: '',
    size: 'wide',
    isLoading: false,
    isSubtle: false,
    retryMessage: (0, $iAkRR.default).retry
};
var $6bf0f4be8561750a$export$2e2bcd8739ae039 = (0, $idGBm.injectIntlV2)($6bf0f4be8561750a$export$edf27be85e5f6da0);

});
parcelRegister("jiDI0", function(module, exports) {
module.exports = new URL("error-subtle.580d9941.svg", import.meta.url).toString();

});

parcelRegister("bxoX3", function(module, exports) {
module.exports = new URL("error.4fa1b24b.svg", import.meta.url).toString();

});

parcelRegister("iAkRR", function(module, exports) {

$parcel$export(module.exports, "default", () => $cf64bf54453c0d07$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $cf64bf54453c0d07$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    retry: {
        "id": "common.components.error-state.retry-action",
        "defaultMessage": "Try again"
    }
});

});


parcelRegister("5pCr6", function(module, exports) {

$parcel$export(module.exports, "default", () => $2172222b909d4703$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $2172222b909d4703$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    header: {
        "id": "directories.filters-v2.main.content.error.header",
        "defaultMessage": "We couldn't load your filters"
    },
    description: {
        "id": "directories.filters-v2.main.content.error.description",
        "defaultMessage": "Give it another try. If you run into more trouble, contact your admin for help."
    }
});

});



parcelRegister("iFREh", function(module, exports) {

$parcel$export(module.exports, "default", () => $91201d6e6669f482$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $LFmXM = parcelRequire("LFmXM");

var $l5htz = parcelRequire("l5htz");

var $19N3W = parcelRequire("19N3W");

var $jubdf = parcelRequire("jubdf");

var $k3q7u = parcelRequire("k3q7u");

var $gnQAk = parcelRequire("gnQAk");

var $fucyK = parcelRequire("fucyK");

var $jIOdj = parcelRequire("jIOdj");

var $7MYNw = parcelRequire("7MYNw");

var $kycze = parcelRequire("kycze");

var $w2wEp = parcelRequire("w2wEp");

var $5U7bK = parcelRequire("5U7bK");
const $91201d6e6669f482$var$SearchWithAnalytics = (0, $l5htz.default)({
    onChange: 'search'
})((0, $19N3W.default));
const $91201d6e6669f482$var$OwnerPickerWithAnalytics = (0, $l5htz.default)({
    onChange: 'owner'
})((0, $fucyK.default));
const $91201d6e6669f482$var$ProjectTypePickerWithAnalytics = (0, $l5htz.default)({
    onChange: 'project'
})((0, $k3q7u.default));
const $91201d6e6669f482$var$GroupPickerWithAnalytics = (0, $l5htz.default)({
    onChange: 'group'
})((0, $jubdf.default));
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $91201d6e6669f482$var$renderFilterSearch = (state)=>(props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($91201d6e6669f482$var$SearchWithAnalytics, {
            ...props,
            value: (0, $kycze.getSearchQuery)(state),
            isAlwaysExpanded: true,
            placeholderAlwaysVisible: true,
            shouldFitContainerWidth: true
        });
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $91201d6e6669f482$var$renderOwnerPicker = (state)=>(props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($91201d6e6669f482$var$OwnerPickerWithAnalytics, {
            ...props,
            selectedUser: (0, $kycze.getSelectedOwner)(state),
            suggestedAccountId: (0, $7MYNw.getAtlassianAccountId)(state),
            isCompact: true,
            shouldFitContainer: true,
            noPortal: true
        });
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $91201d6e6669f482$var$renderProjectPicker = (state)=>(props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($91201d6e6669f482$var$ProjectTypePickerWithAnalytics, {
            ...props,
            selectedProject: (0, $kycze.getSelectedProject)(state),
            isCompact: true,
            width: "100%",
            noPortal: true
        });
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $91201d6e6669f482$var$renderGroupPicker = (state)=>(props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($91201d6e6669f482$var$GroupPickerWithAnalytics, {
            ...props,
            selectedGroup: (0, $kycze.getSelectedGroup)(state),
            isCompact: true,
            width: "100%",
            noPortal: true
        });
// @ts-expect-error - TS7006 - Parameter 'state' implicitly has an 'any' type.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $91201d6e6669f482$var$renderClear = (state)=>(props)=>(0, $kycze.isFilterApplied)(state) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $w2wEp.default), props);
const $91201d6e6669f482$var$mapStateToPropsFactory = ()=>{
    const renderFilterSearchFactory = (0, $LFmXM.default)($91201d6e6669f482$var$renderFilterSearch);
    const renderOwnerPickerFactory = (0, $LFmXM.default)($91201d6e6669f482$var$renderOwnerPicker);
    const renderProjectPickerFactory = (0, $LFmXM.default)($91201d6e6669f482$var$renderProjectPicker);
    const renderGroupPickerFactory = (0, $LFmXM.default)($91201d6e6669f482$var$renderGroupPicker);
    const renderClearFactory = (0, $LFmXM.default)($91201d6e6669f482$var$renderClear);
    return (state, ownProps)=>({
            renderFilterSearch: renderFilterSearchFactory(state),
            renderOwnerPicker: renderOwnerPickerFactory(state),
            renderProjectPicker: renderProjectPickerFactory(state),
            renderGroupPicker: renderGroupPickerFactory(state),
            renderClear: renderClearFactory(state),
            initialFilter: (0, $jIOdj.initialQuery).filter,
            value: (0, $kycze.getFilter)(state),
            onChange: ownProps.onFilter
        });
};
var $91201d6e6669f482$export$2e2bcd8739ae039 = (0, $gnQAk.connect)($91201d6e6669f482$var$mapStateToPropsFactory, {})((0, $5U7bK.default));

});
parcelRegister("l5htz", function(module, exports) {

$parcel$export(module.exports, "default", () => $647ecf3cf7b12c9d$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $iM63C = parcelRequire("iM63C");
/**
 * Adds analytics events to the given callbacks without altering the original behavior
 * Callback is expected to have analyticsEvent as a last argument
 * @example
 * ```tsx
 *  // will fire "select" event when onSelect is called
 *  fileWithUIAnalytics({ onSelect: 'select' })
 *
 *  // will fire "select" event with extra attributes
 *  fileWithUIAnalytics({ onSelect: (value) => ({ name: 'select', value: value}) }
 *  ```
 */ const $647ecf3cf7b12c9d$var$fireWithUIAnalytics = (ConnectedProps)=>{
    // sort the keys so we can set the deps of useMemo
    const providedKeys = Object.keys(ConnectedProps).sort();
    /**
	 * We implement a custom caching mechanism rather than memoizeOne. We got
	 * more ops/sec this way and we only need to bust the changing props cache
	 * instead of destroying all references on a single prop change.
	 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const cachedMappedProps = {}; /*    the actual prop value */ 
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const cachedConnectedProps = {}; /* the connected prop value (the callback) */ 
    const getStateFromMappedProps = (mapped)=>{
        providedKeys.forEach((key, index)=>{
            // firstly check the cache if the prop has changed before creating
            // any new connected props
            const prop = mapped[index];
            if (key in cachedMappedProps && cachedMappedProps[key] === prop) return;
            cachedMappedProps[key] = prop;
            // @ts-expect-error - TS7019 - Rest parameter 'attrs' implicitly has an 'any[]' type.
            cachedConnectedProps[key] = (...attrs)=>{
                // assume that analytics event is always the last one (it should be by convention)
                const analyticsEvent = attrs[attrs.length - 1].clone();
                const connectedProp = ConnectedProps[key];
                // example: { onSelect: 'select' }
                if (typeof ConnectedProps[key] === 'string') analyticsEvent.update({
                    name: connectedProp,
                    analyticsType: (0, $iM63C.UI_EVENT_TYPE)
                }).fire();
                else if (typeof connectedProp === 'function') {
                    const update = connectedProp(...attrs);
                    analyticsEvent.update({
                        ...update,
                        analyticsType: (0, $iM63C.UI_EVENT_TYPE)
                    }).fire();
                }
                if (typeof prop === 'function') prop(...attrs);
            };
        });
        return cachedConnectedProps;
    };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return (WrappedComponent)=>// eslint-disable-next-line jira/react/no-class-components, @typescript-eslint/no-explicit-any,@typescript-eslint/consistent-type-assertions
        class WithAnalytics extends (0, $eJOHy.Component) {
            static{
                // Note: This seems to render weirdly in the chrome debugger. May need to change the string formatting to work around it
                this.displayName = `WithAnalytics(${WrappedComponent.displayName || WrappedComponent.name || 'UnnamedComponent'}`;
            }
            render() {
                const newMappedProps = getStateFromMappedProps(providedKeys.map((key)=>this.props[key]));
                // @ts-expect-error TS2322: Type {} is not assignable to type
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(WrappedComponent, {
                    ...this.props,
                    ...newMappedProps
                });
            }
        }; // eslint-disable-line @typescript-eslint/no-explicit-any
};
var $647ecf3cf7b12c9d$export$2e2bcd8739ae039 = $647ecf3cf7b12c9d$var$fireWithUIAnalytics;

});

parcelRegister("19N3W", function(module, exports) {

$parcel$export(module.exports, "default", () => $97c15cb42d30fa30$export$2e2bcd8739ae039);

var $aBFKZ = parcelRequire("aBFKZ");

var $jVH7m = parcelRequire("jVH7m");
var $97c15cb42d30fa30$export$2e2bcd8739ae039 = (0, $aBFKZ.default)('filterSearch', {
    onChange: 'changed'
})((0, $jVH7m.default));

});
parcelRegister("jVH7m", function(module, exports) {

$parcel$export(module.exports, "default", () => $bd5c5e55d3f97b9c$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/restricted/react

var $eJOHy = parcelRequire("eJOHy");

var $3s8bj = parcelRequire("3s8bj");

var $dqc6Z = parcelRequire("dqc6Z");

var $6XJko = parcelRequire("6XJko");
const $bd5c5e55d3f97b9c$export$4c4c11a6ab1f5b09 = 1000;
const $bd5c5e55d3f97b9c$var$debouncedSearch = (0, (/*@__PURE__*/$parcel$interopDefault($3s8bj)))((value, callback)=>callback(value), $bd5c5e55d3f97b9c$export$4c4c11a6ab1f5b09);
// eslint-disable-next-line jira/react/no-class-components
class $bd5c5e55d3f97b9c$var$Filter extends (0, $eJOHy.PureComponent) {
    static{
        this.defaultProps = {
            value: '',
            placeholder: '',
            describedById: '',
            hasAutoFocus: false,
            isCompact: true,
            increasedWidth: false,
            placeholderAlwaysVisible: false
        };
    }
    getSearchValue(value) {
        const searchValue = value === this.prevSearchValue ? this.prevQueryValue : value;
        if (value !== this.prevSearchValue) {
            this.prevSearchValue = value;
            this.prevQueryValue = value;
        }
        return searchValue;
    }
    render() {
        const searchValue = this.getSearchValue(this.props.value);
        const { hasAutoFocus: autoFocus, ariaLabelText: ariaLabelText, ...props } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dqc6Z.SearchField), {
            ...props,
            autoFocus: autoFocus,
            value: searchValue,
            onChange: this.handleOnChange,
            onEnter: this.handleNewValue,
            ariaLabelText: ariaLabelText,
            showIconBeforeInput: (0, $6XJko.isVisualRefreshEnabled)()
        });
    }
    constructor(...args){
        super(...args), this.prevQueryValue = this.props.value, this.prevSearchValue = this.props.value, this.handleNewValue = (newValue)=>{
            $bd5c5e55d3f97b9c$var$debouncedSearch.cancel();
            if (newValue !== this.props.value) this.props.onChange(newValue);
        }, this.handleOnChange = (newValue)=>{
            this.prevQueryValue = newValue;
            newValue === '' ? this.handleNewValue(newValue) : $bd5c5e55d3f97b9c$var$debouncedSearch(newValue, this.handleNewValue);
        };
    }
}
var $bd5c5e55d3f97b9c$export$2e2bcd8739ae039 = $bd5c5e55d3f97b9c$var$Filter;

});
parcelRegister("dqc6Z", function(module, exports) {

$parcel$export(module.exports, "SearchField", () => $84caf67c6542222b$export$b94867ecbd698f21);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
var $awdRS = parcelRequire("awdRS");

var $6S4l2 = parcelRequire("6S4l2");

var $ftN6c = parcelRequire("ftN6c");

var $sY9BV = parcelRequire("sY9BV");

var $k71qx = parcelRequire("k71qx");

var $lmgo6 = parcelRequire("lmgo6");
var $1DXK0 = parcelRequire("1DXK0");

var $lRq8t = parcelRequire("lRq8t");

var $6XJko = parcelRequire("6XJko");

var $jd93d = parcelRequire("jd93d");

var $7jTnu = parcelRequire("7jTnu");

var $1uv7v = parcelRequire("1uv7v");

var $kUoGK = parcelRequire("kUoGK");

var $1302Y = parcelRequire("1302Y");

var $7CY7m = parcelRequire("7CY7m");

var $4jrRd = parcelRequire("4jrRd");

var $ixnXK = parcelRequire("ixnXK");
function $84caf67c6542222b$export$41946885a418e1(object) {
    return 'ref' in object && 'data-test-id' in object;
}
// This class prevents filled in input field causing confirmation dialog
// when user wants to navigate away. This functionality is coming from Jira monolith.
const $84caf67c6542222b$var$className = 'ajs-dirty-warning-exempt';
const $84caf67c6542222b$var$SearchFieldContainer = ({ shouldFitContainerWidth: shouldFitContainerWidth, reducedHeight: reducedHeight, children: children })=>{
    const { isSoftwareFullTheming: isSoftwareFullTheming } = (0, $kUoGK.useSoftwareProjectTheming)();
    return (0, $1302Y.getIsSoftwareThemingM2Enabled)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lmgo6.default), {
        xcss: [
            shouldFitContainerWidth && $84caf67c6542222b$var$fitContainerStyles,
            (0, $6XJko.isVisualRefreshEnabled)() && reducedHeight && $84caf67c6542222b$var$reducedHeightStyles,
            isSoftwareFullTheming && $84caf67c6542222b$var$themedBgStyles
        ]
    }, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($84caf67c6542222b$var$Container, {
        shouldFitContainerWidth: shouldFitContainerWidth,
        ...(0, $6XJko.isVisualRefreshEnabled)() ? {
            reducedHeight: reducedHeight
        } : {}
    }, children);
};
const $84caf67c6542222b$var$STABLE_EMPTY_OBJECT = {};
const $84caf67c6542222b$var$SearchFieldUnmemoized = ({ onEnter: onEnter, onChange: onChange, onFocus: onFocus, onBlur: onBlur, placeholder: placeholder = '', inputRef: inputRef, value: externalValue, autoFocus: autoFocus = false, isCompact: isCompact = false, isDisabled: isDisabled = false, shouldFitContainerWidth: shouldFitContainerWidth = false, isAutocompleteDisabled: isAutocompleteDisabled = false, placeholderAlwaysVisible: placeholderAlwaysVisible = false, searchIconVisible: searchIconVisible = true, isAlwaysExpanded: isAlwaysExpanded = false, increasedWidth: increasedWidth = false, reducedHeight: reducedHeight = false, maxLength: maxLength, describedById: describedById = '', ariaLabelText: ariaLabelText, id: id, renderCustomSearchField: renderCustomSearchField, searchIconPrimaryColor: searchIconPrimaryColor, testId: testId, inputProps: inputProps = $84caf67c6542222b$var$STABLE_EMPTY_OBJECT, isResponsive: isResponsive = false, showIconBeforeInput: showIconBeforeInput = false, renderTooltipContent: renderTooltipContent = null })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const [isFocused, setIsFocused] = (0, $eJOHy.useState)(false);
    const [value, setValue] = (0, $eJOHy.useState)(externalValue || '');
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const textInput = (0, $eJOHy.useRef)(null);
    const previousValueRef = (0, $eJOHy.useRef)();
    if (!(0, $7jTnu.fg)('jif-jam-search-filter-edit')) {
        const previousValue = previousValueRef.current;
        if (externalValue !== previousValue && externalValue !== value) // @ts-expect-error - TS2345 - Argument of type 'string | undefined' is not assignable to parameter of type 'SetStateAction<string>'.
        setValue(externalValue);
        previousValueRef.current = externalValue;
    } // If clear filters gets clicked
    (0, $eJOHy.useEffect)(()=>{
        if (externalValue === '' && (0, $7jTnu.fg)('jif-jam-search-filter-edit')) setValue('');
    }, [
        externalValue
    ]);
    const handleOnFocus = (0, $eJOHy.useCallback)((event)=>{
        setIsFocused(true);
        onFocus && onFocus(event);
    }, [
        onFocus
    ]);
    const handleOnBlur = (0, $eJOHy.useCallback)((event)=>{
        onBlur && onBlur(event);
        setIsFocused(false);
    }, [
        onBlur
    ]);
    const handleOnChange = (0, $eJOHy.useCallback)(({ currentTarget: currentTarget })=>{
        const { value: val } = currentTarget;
        const analyticsEvent = createAnalyticsEvent({
            action: 'changed'
        });
        setValue(val);
        onChange(val, analyticsEvent);
    }, [
        createAnalyticsEvent,
        onChange
    ]);
    const handleKeyDown = (0, $eJOHy.useCallback)((event)=>{
        const analyticsEvent = createAnalyticsEvent({
            action: 'changed'
        });
        if (event.key === 'Escape') {
            setValue('');
            onChange('', analyticsEvent);
        }
        if (onEnter && event.keyCode === (0, (/*@__PURE__*/$parcel$interopDefault($6S4l2)))('enter')) {
            event.preventDefault();
            onEnter(event.currentTarget && event.currentTarget.value);
        }
    }, [
        createAnalyticsEvent,
        onChange,
        onEnter
    ]);
    const handleOnClear = (0, $eJOHy.useCallback)(()=>{
        if (value !== '') {
            const analyticsEvent = createAnalyticsEvent({
                action: 'changed'
            });
            setValue('');
            onChange('', analyticsEvent);
        }
        if (inputRef && inputRef.current !== null) inputRef.current.blur();
        if (textInput.current !== null) // @ts-expect-error - TS2571 - Object is of type 'unknown'.
        textInput.current.blur();
    }, [
        createAnalyticsEvent,
        inputRef,
        onChange,
        value
    ]);
    const isExpanded = isFocused || value !== '' || isAlwaysExpanded;
    const textFieldProps = (0, $7jTnu.fg)('filter_refinement_search_field_tooltip') ? // condition is because of fg
    // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $eJOHy.useMemo)(()=>{
        return {
            ...inputProps,
            'aria-label': ariaLabelText || placeholder || formatMessage((0, $7CY7m.messages).search),
            'aria-describedby': describedById,
            type: 'text',
            'data-test-id': 'searchfield',
            testId: testId ?? 'searchfield',
            name: 'search',
            className: $84caf67c6542222b$var$className,
            placeholder: placeholder,
            onFocus: handleOnFocus,
            onBlur: handleOnBlur,
            width: '120px',
            onChange: handleOnChange,
            onKeyDown: handleKeyDown,
            ref: inputRef || textInput,
            isCompact: isCompact,
            autoFocus: autoFocus,
            autoComplete: isAutocompleteDisabled ? 'off' : 'on',
            value: value,
            maxLength: maxLength,
            isDisabled: isDisabled
        };
    }, [
        ariaLabelText,
        autoFocus,
        describedById,
        formatMessage,
        handleKeyDown,
        handleOnBlur,
        handleOnChange,
        handleOnFocus,
        inputProps,
        inputRef,
        isAutocompleteDisabled,
        isCompact,
        isDisabled,
        maxLength,
        placeholder,
        testId,
        value
    ]) : {
        ...inputProps,
        'aria-label': ariaLabelText || placeholder || formatMessage((0, $7CY7m.messages).search),
        'aria-describedby': describedById,
        type: 'text',
        'data-test-id': 'searchfield',
        testId: testId ?? 'searchfield',
        name: 'search',
        className: $84caf67c6542222b$var$className,
        placeholder: placeholder,
        onFocus: handleOnFocus,
        onBlur: handleOnBlur,
        width: '120px',
        onChange: handleOnChange,
        onKeyDown: handleKeyDown,
        ref: inputRef || textInput,
        isCompact: isCompact,
        autoFocus: autoFocus,
        autoComplete: isAutocompleteDisabled ? 'off' : 'on',
        value: value,
        maxLength: maxLength,
        isDisabled: isDisabled
    };
    const searchIconDynamic = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ixnXK.SearchFieldIconDynamic), {
        onClear: handleOnClear,
        hasValue: value !== '',
        clearIconLabel: formatMessage((0, $7CY7m.messages).clear),
        searchIconVisible: searchIconVisible,
        primaryColor: (0, $6XJko.isVisualRefreshEnabled)() ? undefined : searchIconPrimaryColor,
        onlyIconSpacing: isResponsive && !isExpanded,
        ...(0, $7jTnu.fg)('jira_jif_jam_clear_text_icon') ? {
            inCustomSearchField: renderCustomSearchField !== undefined
        } : {}
    });
    const searchIcon = showIconBeforeInput ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ixnXK.SearchFieldIcon), {
        searchIconVisible: searchIconVisible,
        onlyIconSpacing: isResponsive && !isExpanded
    }) : undefined;
    const clearIcon = showIconBeforeInput && value !== '' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4jrRd.ClearFieldIcon), {
        onClear: handleOnClear,
        clearIconLabel: formatMessage((0, $7CY7m.messages).clear)
    }) : undefined;
    if ($84caf67c6542222b$export$41946885a418e1(textFieldProps) && (0, $7jTnu.fg)('filter_refinement_search_field_tooltip')) {
        const { onFocus: onFocusTextField, ref: textFieldRef, 'aria-describedby': textfieldAriaDescription, onBlur: onBlurTextField, ...restTextFieldProps } = textFieldProps; // condition is just because of fg
        // eslint-disable-next-line react-hooks/react-compiler
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const showTooltip = (0, $eJOHy.useMemo)(()=>{
            return renderTooltipContent !== null && renderTooltipContent !== undefined && value === '';
        }, [
            renderTooltipContent,
            value
        ]); // condition is because of fg - remove disabled eslint rule once fg is removed
        // eslint-disable-next-line react-hooks/react-compiler
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const useShowTooltip = (0, $eJOHy.useCallback)(()=>showTooltip, [
            showTooltip
        ]);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($84caf67c6542222b$var$SearchFieldContainer, {
            shouldFitContainerWidth: shouldFitContainerWidth,
            reducedHeight: reducedHeight
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($84caf67c6542222b$var$InputWrapper, {
            isExpanded: isExpanded,
            shouldFitContainerWidth: shouldFitContainerWidth,
            maxWidth: increasedWidth ? 328 : 184,
            placeholderAlwaysVisible: placeholderAlwaysVisible,
            isResponsive: isResponsive
        }, renderCustomSearchField !== undefined ? renderCustomSearchField({
            textFieldProps: textFieldProps,
            searchIcon: searchIconDynamic
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $k71qx.default), {
            content: renderTooltipContent,
            canAppear: useShowTooltip,
            position: "bottom-start",
            hideTooltipOnClick: true,
            ignoreTooltipPointerEvents: true
        }, ({ onFocus: onFocusTooltip, ref: tooltipRef, 'aria-describedby': tooltipAriaDescription, onBlur: onBlurTooltip, ...tooltipProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $sY9BV.default), {
                ...tooltipProps,
                ...restTextFieldProps,
                elemBeforeInput: searchIcon,
                elemAfterInput: !showIconBeforeInput ? searchIconDynamic : clearIcon,
                ...id !== undefined ? {
                    id: id
                } : {},
                // eslint-disable-next-line react-hooks/rules-of-hooks
                onFocus: (0, $eJOHy.useCallback)((event)=>{
                    onFocusTextField && onFocusTextField(event);
                    onFocusTooltip(event);
                }, [
                    onFocusTooltip
                ]),
                // eslint-disable-next-line react-hooks/rules-of-hooks
                onBlur: (0, $eJOHy.useCallback)((event)=>{
                    onBlurTextField && onBlurTextField(event);
                    onBlurTooltip(event);
                }, [
                    onBlurTooltip
                ]),
                ref: (0, $jd93d.mergeRefs)(textFieldRef, tooltipRef),
                "aria-describedby": tooltipAriaDescription || textfieldAriaDescription
            }))));
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($84caf67c6542222b$var$SearchFieldContainer, {
        shouldFitContainerWidth: shouldFitContainerWidth,
        reducedHeight: reducedHeight
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($84caf67c6542222b$var$InputWrapper, {
        isExpanded: isExpanded,
        shouldFitContainerWidth: shouldFitContainerWidth,
        maxWidth: increasedWidth ? 328 : 184,
        placeholderAlwaysVisible: placeholderAlwaysVisible,
        isResponsive: isResponsive
    }, renderCustomSearchField !== undefined ? renderCustomSearchField({
        textFieldProps: textFieldProps,
        searchIcon: searchIconDynamic
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $sY9BV.default), {
        ...textFieldProps,
        elemBeforeInput: searchIcon,
        elemAfterInput: !showIconBeforeInput ? searchIconDynamic : clearIcon,
        ...id !== undefined ? {
            id: id
        } : {}
    })));
};
$84caf67c6542222b$var$SearchFieldUnmemoized.displayName = 'Search';
$84caf67c6542222b$var$SearchFieldUnmemoized.whyDidYouRender = true;
const $84caf67c6542222b$export$b94867ecbd698f21 = /*#__PURE__*/ (0, $eJOHy.memo)($84caf67c6542222b$var$SearchFieldUnmemoized);
$84caf67c6542222b$export$b94867ecbd698f21.displayName = 'Search';
const $84caf67c6542222b$var$fitContainerStyles = (0, $1DXK0.xcss)({
    width: '100%'
});
const $84caf67c6542222b$var$reducedHeightStyles = (0, $1DXK0.xcss)({
    height: '32px'
});
const $84caf67c6542222b$var$themedBgStyles = (0, $1DXK0.xcss)({
    // @ts-expect-error - Apply the dominant colour behind the search input for image background themes
    backgroundColor: (0, $1uv7v.Tokens).COLOR_ELEVATION_SURFACE /* eslint-disable-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values */ ,
    borderRadius: "var(--ds-border-radius, 4px)"
}); // Delete when cleaning up getIsSoftwareThemingM2Enabled
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $84caf67c6542222b$var$Container = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { shouldFitContainerWidth: shouldFitContainerWidth, reducedHeight: reducedHeight, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1txw",
            __cmplp.shouldFitContainerWidth && "_1bsb1osq",
            __cmplp.reducedHeight && "_4t3izwfg",
            __cmplp.className
        ])
    });
});
const $84caf67c6542222b$var$InputWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { placeholderAlwaysVisible: placeholderAlwaysVisible, isResponsive: isResponsive, maxWidth: maxWidth, isExpanded: isExpanded, shouldFitContainerWidth: shouldFitContainerWidth, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1et2rhb": (0, $awdRS.default)(__cmplp.maxWidth, "px"),
            "--_47juog": (0, $awdRS.default)(__cmplp.isExpanded ? `${__cmplp.maxWidth}px` : '30px'),
            "--_5cv8rq": (0, $awdRS.default)(__cmplp.isExpanded ? 'auto' : '32px'),
            "--_jy5l88": (0, $awdRS.default)(__cmplp.isExpanded ? `${"var(--ds-space-050, 4px)"} ${"var(--ds-space-075, 6px)"}` : "var(--ds-space-0, 0px)"),
            "--_1skyi4s": (0, $awdRS.default)(__cmplp.isExpanded ? 'auto' : 0),
            "--_1qenfck": (0, $awdRS.default)(__cmplp.isExpanded ? 1 : 0),
            "--_1b7586u": (0, $awdRS.default)(__cmplp.isExpanded ? `${__cmplp.maxWidth}px` : '120px'),
            "--_1b72lxu": (0, $awdRS.default)(__cmplp.shouldFitContainerWidth ? '100%' : `${__cmplp.isExpanded ? __cmplp.maxWidth : 120}px`)
        },
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_v564zpk5 _1e0c1txw _166qglyw _101ad2bq _i2ybkb7n",
            __cmplp.placeholderAlwaysVisible ? "_lav0kb7n" : "_lav0idpf",
            __cmplp.isResponsive ? "_1bsb1ayu _1s4pflvl _1kneabdv _odci1sf5 _ffa416hp _5xde1wic _1hr27bcq" : "_1bsb1di6",
            __cmplp.className
        ])
    });
});

});
parcelRegister("7CY7m", function(module, exports) {

$parcel$export(module.exports, "messages", () => $1790c56385a948ce$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $1790c56385a948ce$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    clear: {
        "id": "searchfield.clear",
        "defaultMessage": "Clear"
    },
    search: {
        "id": "searchfield.search",
        "defaultMessage": "Search"
    }
});

});

parcelRegister("4jrRd", function(module, exports) {

$parcel$export(module.exports, "ClearFieldIcon", () => $047d370cc11f69d8$export$84038b503874befa);

var $eJOHy = parcelRequire("eJOHy");

var $Ay1uj = parcelRequire("Ay1uj");

var $6zhpo = parcelRequire("6zhpo");

var $a03qM = parcelRequire("a03qM");

var $8nu6j = parcelRequire("8nu6j");
var $6efFi = parcelRequire("6efFi");
var $bQP4O = parcelRequire("bQP4O");
var $1DXK0 = parcelRequire("1DXK0");

var $7jTnu = parcelRequire("7jTnu");
const $047d370cc11f69d8$export$84038b503874befa = ({ onClear: onClear, clearIconLabel: clearIconLabel })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: [
            (0, $7jTnu.fg)('jira_jif_jam_clear_text_icon') ? $047d370cc11f69d8$var$wrapperStylesClearIcon : $047d370cc11f69d8$var$wrapperStylesCloseIcon
        ]
    }, (0, $7jTnu.fg)('jira_jif_jam_clear_text_icon') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bQP4O.default), {
        xcss: $047d370cc11f69d8$var$iconWrapperStyles,
        onClick: onClear,
        // Clear button should not be focusable
        // see https://hello.atlassian.net/wiki/spaces/A11YKB/pages/3031993460/Clear+options+on+an+input+field
        tabIndex: -1,
        "aria-label": clearIconLabel,
        testId: "searchfield.ui.clearfield-icon.clear-button"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($a03qM))), {
        label: ""
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $Ay1uj.default), {
        appearance: "subtle",
        testId: "searchfield.ui.clearfield-icon.clear-button",
        onClick: onClear,
        label: clearIconLabel,
        spacing: "compact",
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($6zhpo)))
    }));
const $047d370cc11f69d8$var$wrapperStylesCloseIcon = (0, $1DXK0.xcss)({
    display: 'flex',
    marginRight: 'space.025',
    [(0, $6efFi.media).above.md]: {
        marginRight: 'space.050'
    }
});
const $047d370cc11f69d8$var$wrapperStylesClearIcon = (0, $1DXK0.xcss)({
    display: 'flex',
    marginRight: 'space.050',
    [(0, $6efFi.media).above.md]: {
        marginRight: 'space.075'
    }
});
const $047d370cc11f69d8$var$iconWrapperStyles = (0, $1DXK0.xcss)({
    display: 'flex',
    cursor: 'pointer',
    paddingInlineStart: 'space.0',
    paddingInlineEnd: 'space.0',
    paddingBlockStart: 'space.0',
    paddingBlockEnd: 'space.0',
    borderRadius: 'border.radius.circle',
    color: 'color.text.subtlest',
    ':hover': {
        color: 'color.text.accent.gray'
    }
});

});

parcelRegister("ixnXK", function(module, exports) {

$parcel$export(module.exports, "SearchFieldIconDynamic", () => $fd1be89cde4ae981$export$9eef03e91cdeba14);
$parcel$export(module.exports, "SearchFieldIcon", () => $fd1be89cde4ae981$export$8a82bff895521bd9);

var $eJOHy = parcelRequire("eJOHy");

var $goZPP = parcelRequire("goZPP");

var $6J9k6 = parcelRequire("6J9k6");

var $i0iAU = parcelRequire("i0iAU");

var $dt3aG = parcelRequire("dt3aG");

var $8nu6j = parcelRequire("8nu6j");
var $6efFi = parcelRequire("6efFi");
var $bQP4O = parcelRequire("bQP4O");
var $1DXK0 = parcelRequire("1DXK0");

var $a03qM = parcelRequire("a03qM");

var $7jTnu = parcelRequire("7jTnu");
const $fd1be89cde4ae981$export$9eef03e91cdeba14 = ({ onClear: onClear, hasValue: hasValue, searchIconVisible: searchIconVisible, clearIconLabel: clearIconLabel, primaryColor: primaryColor, onlyIconSpacing: onlyIconSpacing = false, inCustomSearchField: inCustomSearchField = false })=>{
    const akSearchIcon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($i0iAU))), {
        LEGACY_size: "small",
        label: "",
        LEGACY_primaryColor: primaryColor,
        color: "currentColor"
    });
    const searchIcon = searchIconVisible ? akSearchIcon : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: [
            $fd1be89cde4ae981$var$wrapperStyles,
            onlyIconSpacing && $fd1be89cde4ae981$var$spacingStyles,
            inCustomSearchField && (0, $7jTnu.fg)('jira_jif_jam_clear_text_icon') && $fd1be89cde4ae981$var$minimalSpacingStyles
        ]
    }, // eslint-disable-next-line no-nested-ternary
    hasValue ? (0, $7jTnu.fg)('jira_jif_jam_clear_text_icon') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bQP4O.default), {
        xcss: $fd1be89cde4ae981$var$iconWrapperStyles,
        onClick: onClear,
        // Clear button should not be focusable
        // see https://hello.atlassian.net/wiki/spaces/A11YKB/pages/3031993460/Clear+options+on+an+input+field
        tabIndex: -1,
        testId: "searchfield.ui.searchfield-icon.clear-button",
        "aria-label": clearIconLabel
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($a03qM))), {
        label: ""
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
        appearance: "subtle",
        spacing: "none",
        // eslint-disable-next-line jira/integration/enforce-data-testid-usage
        "data-test-id": "searchfield.ui.searchfield-icon.clear-button",
        testId: "searchfield.ui.searchfield-icon.clear-button",
        onClick: onClear,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6J9k6))), {
            LEGACY_size: "small",
            label: clearIconLabel,
            LEGACY_primaryColor: primaryColor,
            color: "currentColor"
        })
    }) : searchIcon);
};
const $fd1be89cde4ae981$export$8a82bff895521bd9 = ({ searchIconVisible: searchIconVisible, onlyIconSpacing: onlyIconSpacing = false })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: [
            $fd1be89cde4ae981$var$wrapperStylesBefore,
            onlyIconSpacing && $fd1be89cde4ae981$var$spacingStylesBefore
        ]
    }, searchIconVisible ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dt3aG))), {
        spacing: "none",
        label: "",
        color: "var(--ds-icon, #44546F)"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null));
const $fd1be89cde4ae981$var$wrapperStyles = (0, $1DXK0.xcss)({
    color: 'color.text.accent.gray',
    marginTop: 'space.0',
    // the wider marginRight is applicable for when the search/clear icon is after the input
    marginRight: 'space.100',
    marginBottom: 'space.0',
    marginLeft: 'space.0',
    height: '16px',
    display: 'flex',
    alignItems: 'center'
});
// if this icon is used in a custom search field, we won't assume any spacing since we don't know where their searchIcon is used
// i.e. before or after the input
// it will be up to the consumers to add spacing where needed
const $fd1be89cde4ae981$var$minimalSpacingStyles = (0, $1DXK0.xcss)({
    marginRight: 'space.0'
});
const $fd1be89cde4ae981$var$spacingStyles = (0, $1DXK0.xcss)({
    marginRight: 'space.075',
    [(0, $6efFi.media).above.md]: {
        marginRight: 'space.100'
    }
});
const $fd1be89cde4ae981$var$wrapperStylesBefore = (0, $1DXK0.xcss)({
    display: 'flex',
    marginRight: 'space.0',
    marginLeft: 'space.075',
    [(0, $6efFi.media).above.md]: {
        marginLeft: 'space.100'
    }
});
const $fd1be89cde4ae981$var$spacingStylesBefore = (0, $1DXK0.xcss)({
    marginLeft: 'space.075',
    [(0, $6efFi.media).above.md]: {
        marginLeft: 'space.100'
    }
});
const $fd1be89cde4ae981$var$iconWrapperStyles = (0, $1DXK0.xcss)({
    display: 'flex',
    cursor: 'pointer',
    paddingInlineStart: 'space.0',
    paddingInlineEnd: 'space.0',
    paddingBlockStart: 'space.0',
    paddingBlockEnd: 'space.0',
    borderRadius: 'border.radius.circle',
    color: 'color.text.subtlest',
    ':hover': {
        color: 'color.text.accent.gray'
    }
});

});




parcelRegister("jubdf", function(module, exports) {

$parcel$export(module.exports, "default", () => $8003c333d6bcdf2a$export$2e2bcd8739ae039);

var $aBFKZ = parcelRequire("aBFKZ");

var $1Ejia = parcelRequire("1Ejia");
var $8003c333d6bcdf2a$export$2e2bcd8739ae039 = (0, $aBFKZ.default)('GroupPicker', {
    onChange: 'changed'
})((0, $1Ejia.default));

});
parcelRegister("1Ejia", function(module, exports) {

$parcel$export(module.exports, "default", () => $517a0c57c4b325d5$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $aXKmr = parcelRequire("aXKmr");

var $lG2jM = parcelRequire("lG2jM");

var $2sHLK = parcelRequire("2sHLK");

var $idGBm = parcelRequire("idGBm");

var $l01aN = parcelRequire("l01aN");

var $403OI = parcelRequire("403OI");
class $517a0c57c4b325d5$export$471c4c2b52766e8d extends (0, $eJOHy.Component) {
    static{
        this.defaultProps = {
            isRequired: false,
            isDisabled: false,
            isClearable: true,
            isCompact: false,
            fetchOnce: false,
            width: 200
        };
    }
    constructor(props){
        super(props), this.state = {
            options: [],
            selectedGroup: this.props.selectedGroup,
            prevSelectedGroup: this.props.selectedGroup
        }, this.onSelected = (selectedOption)=>{
            this.setState({
                selectedGroup: selectedOption
            });
            this.props.onChange(selectedOption);
        }, /* eslint-disable jira/react-arrow-function-property-naming */ this.formatOptionDataTransformer = (group)=>({
                // @ts-expect-error - TS2769 - No overload matches this call.
                avatar: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($lG2jM))), {
                    LEGACY_size: "small"
                }),
                label: group.name
            }), /* eslint-disable jira/react-arrow-function-property-naming */ this.fetchAllGroups = (searchQuery)=>(0, $l01aN.getAllGroups)(searchQuery), /* eslint-disable jira/react-arrow-function-property-naming */ this.fetchUserGroups = (searchQuery)=>this.props.withMember ? (0, $l01aN.getUserGroups)(this.props.withMember, searchQuery) : Promise.resolve();
        this.groupPickerId = `group-picker.label.id-${(0, $aXKmr.v4)()}`;
    }
    static getDerivedStateFromProps(props, state) {
        const currentGroup = props.selectedGroup && props.selectedGroup.value;
        const prevGroup = state.prevSelectedGroup && state.prevSelectedGroup.value;
        if (currentGroup !== prevGroup) return {
            ...state,
            selectedGroup: props.selectedGroup,
            prevSelectedGroup: props.selectedGroup
        };
        return null;
    }
    componentDidMount() {
        const { fetchOnce: fetchOnce } = this.props;
        if (fetchOnce === true) {
            const getOptions = this.getFetchOptionsFunction();
            getOptions('').then((groups)=>this.setState({
                    // @ts-expect-error - TS2322 - Type 'void | Group[]' is not assignable to type 'Group[]'.
                    options: groups
                }));
        }
    }
    getFetchOptionsFunction() {
        return this.props.withMember ? this.fetchUserGroups : this.fetchAllGroups;
    }
    render() {
        const { intl: { formatMessage: formatMessage }, placeholder: placeholder = this.props.placeholder || formatMessage((0, $403OI.default).placeholder), onChange: onChange, fetchOnce: fetchOnce, ...props } = this.props;
        const { selectedGroup: selectedGroup } = this.state;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2sHLK.PickerWithAvatar), {
            "aria-label": !this.props.label ? formatMessage((0, $403OI.default).labelText) : undefined,
            inputId: this.groupPickerId,
            ...props,
            errorMessage: formatMessage((0, $403OI.default).error),
            placeholder: placeholder,
            onSelected: this.onSelected,
            // @ts-expect-error - TS2769 - No overload matches this call.
            options: fetchOnce === true ? this.state.options : this.getFetchOptionsFunction(),
            formatOptionDataTransformer: this.formatOptionDataTransformer,
            value: selectedGroup && selectedGroup.name ? selectedGroup : null
        });
    }
}
var $517a0c57c4b325d5$export$2e2bcd8739ae039 = (0, $idGBm.injectIntlV2)($517a0c57c4b325d5$export$471c4c2b52766e8d);

});
parcelRegister("lG2jM", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::68ed51f9e1612abe38768085b9e3fc4c>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $fc7f518425e4bcf9$var$_react = $fc7f518425e4bcf9$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $fc7f518425e4bcf9$var$_peopleGroup = $fc7f518425e4bcf9$var$_interopRequireDefault((parcelRequire("hxN6p")));

var $fc7f518425e4bcf9$var$_peopleGroup2 = $fc7f518425e4bcf9$var$_interopRequireDefault((parcelRequire("hh8BY")));
function $fc7f518425e4bcf9$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for PeopleGroupIcon.
 * This component is PeopleGroupIcon, with `UNSAFE_fallbackIcon` set to "PeopleGroupIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Known uses: representing a group or collection of people or users.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $fc7f518425e4bcf9$var$PeopleGroupIcon = (props)=>/*#__PURE__*/ $fc7f518425e4bcf9$var$_react.default.createElement($fc7f518425e4bcf9$var$_peopleGroup.default, Object.assign({
        name: "PeopleGroupIcon",
        LEGACY_fallbackIcon: $fc7f518425e4bcf9$var$_peopleGroup2.default
    }, props));
$fc7f518425e4bcf9$var$PeopleGroupIcon.displayName = 'PeopleGroupIconMigration';
var $fc7f518425e4bcf9$var$_default = module.exports.default = $fc7f518425e4bcf9$var$PeopleGroupIcon;

});
parcelRegister("hh8BY", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c93ab4407be6cde9$var$_react = $c93ab4407be6cde9$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $fL0In = parcelRequire("fL0In");
function $c93ab4407be6cde9$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $c93ab4407be6cde9$var$PeopleGroupIcon = (props)=>/*#__PURE__*/ $c93ab4407be6cde9$var$_react.default.createElement($fL0In.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path d="M8.13 10H4a2 2 0 0 0-2 2v3.73c0 1.31 1.87 2.05 4 2.23V15a3 3 0 0 1 3-3h.35a4 4 0 0 1-1.23-2m7.75 0H20c1.11 0 2 .89 2 2v3.73c0 1.31-1.87 2.05-4 2.23V15a3 3 0 0 0-3-3h-.35a4 4 0 0 0 1.23-2M9.97 5.55a3 3 0 1 0-1.96 3.27 4 4 0 0 1 1.96-3.27M16 8.83a3 3 0 1 0-1.96-3.28A4 4 0 0 1 16 8.83"/><path d="M7 15c0-1.105.887-2 2-2h6c1.105 0 2 .885 2 2v3.73c0 3.027-10 3.027-10 0z"/><circle cx="12" cy="9" r="3"/></g></svg>`
    }, props));
$c93ab4407be6cde9$var$PeopleGroupIcon.displayName = 'PeopleGroupIcon';
var $c93ab4407be6cde9$var$_default = module.exports.default = $c93ab4407be6cde9$var$PeopleGroupIcon;

});


parcelRegister("2sHLK", function(module, exports) {

$parcel$export(module.exports, "PickerWithAvatar", () => $3183b99370c8c0ed$export$e6b8a87858f7afd1);
$parcel$export(module.exports, "PickerWithAvatarAndAnalytics", () => $3183b99370c8c0ed$export$3d409af828769e2e);
/**
 * This is the base for Picker that can be used to create any type of component:
 * 1) with a list of predefined options
 * 2) that dynamically fetches its options from external resource.
 */ 
var $aBFKZ = parcelRequire("aBFKZ");

var $fJTOm = parcelRequire("fJTOm");

var $87K62 = parcelRequire("87K62");
const $3183b99370c8c0ed$export$e6b8a87858f7afd1 = (0, $87K62.default);
const $3183b99370c8c0ed$export$3d409af828769e2e = (0, $aBFKZ.default)('picker', {
    onSelected: 'changed',
    onMultiSelected: 'multi-changed'
})((0, $87K62.default));
const $3183b99370c8c0ed$export$d8d9f25d80d89b16 = (0, $aBFKZ.default)('picker', {
    onSelected: 'changed',
    onMultiSelected: 'multi-changed'
})((0, $fJTOm.default));

});
parcelRegister("fJTOm", function(module, exports) {

$parcel$export(module.exports, "getOptionBaseStyles", () => $69685483963d086b$export$cef6e25059b681a);
$parcel$export(module.exports, "Picker", () => $69685483963d086b$export$ba25329847403e11);
$parcel$export(module.exports, "default", () => $69685483963d086b$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $3s8bj = parcelRequire("3s8bj");

var $12DRg = parcelRequire("12DRg");

var $goZPP = parcelRequire("goZPP");

var $8IeH1 = parcelRequire("8IeH1");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $3DNvO = parcelRequire("3DNvO");
var $6UCkD = parcelRequire("6UCkD");
var $6XEne = parcelRequire("6XEne");
var $kVcjU = parcelRequire("kVcjU");
var $c4OV1 = parcelRequire("c4OV1");

var $k71qx = parcelRequire("k71qx");

var $fceQU = parcelRequire("fceQU");

var $7jTnu = parcelRequire("7jTnu");

var $8uyZr = parcelRequire("8uyZr");

var $lxUP5 = parcelRequire("lxUP5");

var $dPMMf = parcelRequire("dPMMf");

var $6joHJ = parcelRequire("6joHJ");

var $6YFG2 = parcelRequire("6YFG2");

var $bJscI = parcelRequire("bJscI");

var $6rlhA = parcelRequire("6rlhA");
const $69685483963d086b$export$3a3072dd741f354b = 500;
const $69685483963d086b$export$cef6e25059b681a = (optionState)=>({
        ...optionState.isDisabled ? {
            cursor: 'not-allowed',
            color: "var(--ds-text-subtlest, #626F86)",
            '&, :active': {
                backgroundColor: 'transparent'
            }
        } : {
            cursor: 'pointer'
        },
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis'
    });
class $69685483963d086b$export$ba25329847403e11 extends (0, $eJOHy.Component) {
    static{
        this.defaultProps = {
            isRequired: false,
            isDisabled: false,
            isClearable: false,
            isCompact: false,
            isCreatable: false,
            isMulti: false,
            noPortal: false,
            isCheckbox: false,
            label: undefined,
            defaultValue: undefined,
            width: 'auto',
            onSelected: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
            onMultiSelected: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg)))
        };
    }
    static getDerivedStateFromProps(props) {
        if (props.menuIsOpen !== undefined) return {
            menuIsOpen: props.menuIsOpen
        };
        return null;
    }
    constructor(props){
        super(props), this.state = {
            validationState: 'default',
            showErrorMessage: false,
            menuWasOpen: false,
            menuIsOpen: false,
            initialFocusHandled: false
        }, this.onSelected = (selection, action, analyticsEvent)=>{
            this.setState(()=>({
                    menuIsOpen: false
                }));
            const { isMulti: isMulti } = this.props;
            if (Array.isArray(selection)) {
                if (isMulti) // @ts-expect-error - TS2554 - Expected 1 arguments, but got 2.
                this.props.onMultiSelected(selection, analyticsEvent);
                else // When the selection is cleared in single select mode, selection is an array.
                this.props.onSelected(undefined, analyticsEvent);
            } else // @ts-expect-error - TS2339 - Property 'value' does not exist on type 'SelectOption'.
            selection && selection.value ? this.props.onSelected(selection, analyticsEvent) : this.props.onSelected(undefined, analyticsEvent);
        }, this.onMenuOpen = ()=>{
            this.setState(()=>({
                    menuIsOpen: true,
                    menuWasOpen: true
                }));
        }, this.onMenuClose = ()=>{
            this.setState(()=>({
                    menuIsOpen: false
                }));
        }, this.onBlur = (event)=>{
            this.hideErrorMessage();
            const { onBlur: onBlur } = this.props;
            if (onBlur && typeof onBlur === 'function') onBlur(event);
        }, this.onFocus = (event)=>{
            this.showErrorMessage();
            const { onFocus: onFocus } = this.props;
            if (onFocus && typeof onFocus === 'function') onFocus(event);
        }, this.setErrorState = ()=>{
            this.setState({
                showErrorMessage: true,
                validationState: 'error'
            });
        }, this.showErrorMessage = ()=>this.setState({
                showErrorMessage: true
            }), this.hideErrorMessage = ()=>this.setState({
                showErrorMessage: false
            }) // eslint-disable-next-line @typescript-eslint/no-explicit-any
        , this.loadOptions = (filter, callback)=>{
            this.setState({
                validationState: 'default'
            });
            this.debouncedLoadOptions(filter, callback);
        }, this.renderOption = (props)=>{
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            const propsData = props.data;
            const disableReason = props.isDisabled && propsData && propsData.disableReason || null;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $k71qx.default), {
                position: "right",
                content: disableReason
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6XEne.components).Option // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            , props));
        } // Will remove this renderMenuList when clean up FG since it's no longer needed
        , this.renderMenuList = (menuListProps)=>{
            const { isClearable: isClearable, intl: { formatMessage: formatMessage } } = this.props;
            return(// @ts-expect-error - TS2740 - Type '{ children: (Element | ReactNode)[]; hasValue: boolean; clearValue: () => void; }' is missing the following properties from type 'CommonProps<OptionTypeBase, boolean, GroupTypeBase<OptionTypeBase>>': cx, getStyles, getValue, isMulti, and 6 more.
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6XEne.components).MenuList, menuListProps, isClearable && menuListProps.hasValue && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($69685483963d086b$var$ClearButtonWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
                appearance: "link",
                shouldFitContainer: true,
                onClick: menuListProps.clearValue
            }, formatMessage((0, $6rlhA.default).clearSelected))), menuListProps.children));
        }, this.renderValueContainer = (props)=>{
            const { onValueContainerClick: onValueContainerClick } = props.selectProps;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($69685483963d086b$var$StyledValueContainer, {
                "data-testid": "common-components-picker.base.react-dnd-and-select-focus-bug-fix",
                onClick: onValueContainerClick
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6XEne.components).ValueContainer, props));
        }; // This is initialized in constructor because when it is a class property then flow gets confused about the generic type in callback.
        // That is a known bug: https://github.com/facebook/flow/issues/6978
        this.debouncedLoadOptions = (0, (/*@__PURE__*/$parcel$interopDefault($3s8bj)))(// eslint-disable-next-line @typescript-eslint/no-explicit-any
        (filter, callback)=>{
            // @ts-expect-error - TS2349 - This expression is not callable.
            this.props.options(filter).then(callback, ()=>{
                callback([]);
                this.setErrorState();
            });
        }, $69685483963d086b$export$3a3072dd741f354b); // @ts-expect-error - Property 'selectRef' does not exist on type 'Picker<SelectOption>'
        this.selectRef = /*#__PURE__*/ (0, $eJOHy.createRef)();
    }
    getSelectComponent(isAsync) {
        if (this.props.isCreatable) return isAsync ? (0, $3DNvO.default) : (0, $kVcjU.default);
        if (isAsync) return 0, $8uyZr.AsyncSelectWithAnalytics;
        return this.props.isCheckbox ? (0, $6UCkD.default) : (0, $c4OV1.default);
    }
    getComponentOverrides() {
        const { menuWasOpen: menuWasOpen } = this.state;
        const Option = {
            Option: this.renderOption
        }; // Remove MenuList when clean up FG since we no longer need to override to add `Clear Selected` button
        const MenuList = (0, $7jTnu.fg)('jfp-a11y-team_update_legacy_select_clear_fuction') ? {} : {
            MenuList: this.renderMenuList
        };
        const LoadingIndicator = menuWasOpen ? {} : {
            LoadingIndicator: null
        };
        return {
            ...this.props.components,
            ...Option,
            ...MenuList,
            ...LoadingIndicator
        };
    }
    render() {
        const { showErrorMessage: showErrorMessage, validationState: validationState, menuIsOpen: menuIsOpen } = this.state;
        const { intl: { formatMessage: formatMessage } } = this.props;
        const { label: label, listItemCustomStyles: listItemCustomStyles, placeholder: placeholder = formatMessage((0, $6rlhA.default).defaultPlaceholder), defaultValue: defaultValue, isRequired: isRequired, isDisabled: isDisabled, isCompact: isCompact, isClearableWithCrossIcon: isClearableWithCrossIcon, errorMessage: errorMessage, options: options, width: width, minWidth: minWidth, noPortal: noPortal, isCheckbox: isCheckbox, hasDraggableParentComponent: hasDraggableParentComponent } = this.props;
        const isAsync = typeof options === 'function';
        const SelectComponent = this.getSelectComponent(isAsync);
        const isErrorMessageOpened = showErrorMessage && validationState === 'error'; // Fixing eslint violation as part of another fix.
        const body = (0, $7jTnu.fg)('blu-8182-dashboards-project-picker-a11y-fix') ? (0, $fceQU.getDocument)()?.body : // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        document.body;
        let selectParams = {
            placeholder: placeholder,
            isDisabled: isDisabled,
            isClearable: isClearableWithCrossIcon || false,
            defaultValue: defaultValue,
            defaultOptions: true,
            autoFocus: !!this.props.autoFocus,
            loadOptions: isAsync && this.loadOptions,
            options: !isAsync && options,
            onChange: this.onSelected,
            noOptionsMessage: ()=>this.props.noOptionsMessage ?? formatMessage((0, $6rlhA.default).noOptions),
            loadingMessage: ()=>formatMessage((0, $6rlhA.default).loading),
            validationState: this.state.validationState,
            onBlur: this.onBlur,
            onFocus: this.onFocus,
            menuPortalTarget: noPortal ? null : body,
            spacing: isCompact ? 'compact' : 'default',
            styles: {
                ...this.props.styles,
                // without properly set zIndex value dropdown with options is cut inside modal dialogs
                // @ts-expect-error - TS7006 - Parameter 'base' implicitly has an 'any' type.
                menuPortal: (base)=>({
                        ...base,
                        zIndex: (0, $dPMMf.layers).modal
                    }),
                // @ts-expect-error - TS7006 - Parameter 'base' implicitly has an 'any' type.
                container: (base)=>({
                        ...base,
                        width: width,
                        minWidth: minWidth
                    }),
                // @ts-expect-error - TS7006 - Parameter 'base' implicitly has an 'any' type. | TS7006 - Parameter 'optionState' implicitly has an 'any' type.
                option: (base, optionState)=>({
                        ...base,
                        ...$69685483963d086b$export$cef6e25059b681a(optionState),
                        ...listItemCustomStyles
                    }),
                // @ts-expect-error - TS7006 - Parameter 'base' implicitly has an 'any' type. | TS7006 - Parameter 'optionState' implicitly has an 'any' type.
                menu: (base)=>{
                    if ((0, $7jTnu.fg)('blu-8182-dashboards-project-picker-a11y-fix')) return {
                        ...base,
                        width: 'max-content',
                        // This makes the menu fit the widest content
                        minWidth: '100%'
                    };
                    return base;
                }
            }
        };
        if (!isCheckbox) selectParams = {
            ...selectParams,
            menuIsOpen: // @ts-expect-error - TS2322 - Type '{ menuIsOpen: boolean; onMenuOpen: () => void; onMenuClose: () => void; components: { LoadingIndicator?: undefined; MenuList: (menuListProps: MenuListProps) => JSX.Element; Option: (props: CommonProps<...> & ... 1 more ... & { ...; }) => JSX.Element; } | { ...; }; ... 16 more ...; styles: { ...; }; }' is not assignable to type '{ placeholder: string; isDisabled: boolean | undefined; isClearable: boolean; defaultValue: SelectOption | undefined; defaultOptions: boolean; autoFocus: boolean; loadOptions: false | ((filter: string, callback: (arg1: SelectOption[]) => Record<...>) => void); ... 9 more ...; styles: { ...; }; }'.
            menuIsOpen,
            onMenuOpen: this.onMenuOpen,
            onMenuClose: this.onMenuClose,
            components: this.getComponentOverrides()
        };
         // When "hasDraggableParentComponent" is true, this means <Select /> is nested inside <Draggable /> from react-beautiful-dnd
        // This relationship prevents the dropdown menu from opening because of bugs in the default focus state and clicking in a particular area of <Select />
        // Context: https://hello.atlassian.net/wiki/spaces/~989411314/pages/2861097485/Investigation+Notes+for+atlaskit+select+react-beautiful-dnd#Temporary-Solution
        if (hasDraggableParentComponent) {
            const { initialFocusHandled: initialFocusHandled } = this.state;
            const handleClick = ()=>{
                if (initialFocusHandled) // As <Select /> is already focused, calling this.selectRef.current.focus() again no longer triggers its own handlers (i.e. onMenuOpen, onMenuClose)
                // We have to manually handle the open and close states of the dropdown menu based on a user's click from this point onwards to prevent the bug
                this.setState((state)=>({
                        menuIsOpen: !state.menuIsOpen
                    }));
                else if (!menuIsOpen) {
                    // Trigger focus state when ValueContainer is clicked for the first time
                    // The focused state will then invoke <Select /> instance's own handlers (e.g. onMenuOpen, onMenuClose)
                    // to manage the state of the dropdown menu
                    // @ts-expect-error - Property 'selectRef' does not exist on type 'Picker<SelectOption>'
                    this.selectRef.current.focus();
                    this.setState(()=>({
                            initialFocusHandled: true
                        }));
                }
            };
            selectParams = {
                ...selectParams,
                // @ts-expect-error - Object literal may only specify known properties, and 'ref' does not exist in type '{ placeholder: string; isDisabled: boolean | undefined; isClearable: boolean; defaultValue: SelectOption | undefined; defaultOptions: boolean; autoFocus: boolean; loadOptions: false | ((filter: string, callback: (arg1: SelectOption[]) => Record<...>) => void); ... 9 more ...; styles: { ...; }; }'
                // + Property 'selectRef' does not exist on type 'Picker<SelectOption>'
                ref: this.selectRef,
                components: {
                    ...this.getComponentOverrides,
                    ValueContainer: this.renderValueContainer
                },
                onValueContainerClick: handleClick,
                openMenuOnFocus: true
            };
        }
        const { isClearable: isClearable } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, label && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lxUP5.FieldLabel), {
            htmlFor: this.props.inputId,
            label: label,
            isRequired: isRequired
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6joHJ.JiraInlineDialog), {
            content: errorMessage,
            isOpen: isErrorMessageOpened,
            messageId: `common-components-picker.base.jira-inline-dialog.pickerErrorMessage.${this.props.inputId ?? 'unnamedInputId'}`,
            messageType: "transactional",
            placement: "right"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(SelectComponent, {
            inputId: this.props.inputId,
            ...this.props,
            ...selectParams,
            ...(0, $7jTnu.fg)('jfp-a11y-team_update_legacy_select_clear_fuction') ? {
                isClearable: isClearable
            } : {},
            options: isAsync ? undefined : this.props.options
        })));
    }
}
// @ts-expect-error This is required because of the ratcheted conversion from intlV2 to intl
const $69685483963d086b$var$PickerWithIntl = (0, $6YFG2.default)($69685483963d086b$export$ba25329847403e11);
const $69685483963d086b$var$DefaultPicker = (props)=>{
    // this function exists only to "preserve" generic on the Picker that is lost at injectIntl
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($69685483963d086b$var$PickerWithIntl, props);
};
$69685483963d086b$var$DefaultPicker.defaultProps = $69685483963d086b$export$ba25329847403e11.defaultProps;
var $69685483963d086b$export$2e2bcd8739ae039 = $69685483963d086b$var$DefaultPicker;
const $69685483963d086b$var$NewStyledValueContainer = (props)=>// eslint-disable-next-line @atlassian/a11y/interactive-element-not-keyboard-focusable
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8IeH1.default), {
        xcss: $69685483963d086b$var$styles.valueContainer,
        onClick: props.onClick,
        testId: props['data-testid']
    }, props.children);
const $69685483963d086b$var$styles = {
    clearButtonWrapper: "_n7zl7r9e",
    valueContainer: "_16jlkb7n"
};
const $69685483963d086b$var$OldClearButtonWrapper = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $69685483963d086b$var$clearButtonWrapperStyles
    }, children);
const $69685483963d086b$var$NewClearButtonWrapper = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8IeH1.default), {
        xcss: $69685483963d086b$var$styles.clearButtonWrapper
    }, children);
const $69685483963d086b$var$ClearButtonWrapper = (0, $bJscI.componentWithFG)('blu-8182-dashboards-project-picker-a11y-fix', $69685483963d086b$var$NewClearButtonWrapper, $69685483963d086b$var$OldClearButtonWrapper);
const $69685483963d086b$var$clearButtonWrapperStyles = (0, $1DXK0.xcss)({
    borderBottom: `${"var(--ds-border-width, 1px)"} solid ${"var(--ds-border, #091E4224)"}`
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $69685483963d086b$var$OldStyledValueContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_16jlkb7n",
            __cmplp.className
        ])
    });
});
const $69685483963d086b$var$StyledValueContainer = (0, $bJscI.componentWithFG)('blu-8182-dashboards-project-picker-a11y-fix', $69685483963d086b$var$NewStyledValueContainer, $69685483963d086b$var$OldStyledValueContainer);

});
parcelRegister("3DNvO", function(module, exports) {

$parcel$export(module.exports, "default", () => $35aa8c3d4d43b8a4$export$2e2bcd8739ae039);

var $7pkFT = parcelRequire("7pkFT");

var $dDv66 = parcelRequire("dDv66");
const $35aa8c3d4d43b8a4$var$AsyncCreatableSelect = (0, $dDv66.default)((0, $7pkFT.default));
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$35aa8c3d4d43b8a4$export$2e2bcd8739ae039 = $35aa8c3d4d43b8a4$var$AsyncCreatableSelect;

});
parcelRegister("7pkFT", function(module, exports) {

$parcel$export(module.exports, "default", () => $69fba18f5363b86b$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $5tlgh = parcelRequire("5tlgh");

var $iSKoM = parcelRequire("iSKoM");

var $9gNEN = parcelRequire("9gNEN");

var $gVVTN = parcelRequire("gVVTN");
const $69fba18f5363b86b$var$AsyncCreatableSelect = /*#__PURE__*/ (0, $eJOHy.forwardRef)((props, ref)=>{
    const stateManagerProps = (0, $iSKoM.default)(props);
    const creatableProps = (0, $gVVTN.default)(stateManagerProps);
    const selectProps = (0, $9gNEN.default)(creatableProps);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5tlgh.default), {
        ref: ref,
        ...selectProps
    });
});
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$69fba18f5363b86b$export$2e2bcd8739ae039 = $69fba18f5363b86b$var$AsyncCreatableSelect;

});
parcelRegister("9gNEN", function(module, exports) {

$parcel$export(module.exports, "default", () => $59d3993c69e6bf3a$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $20dEN = parcelRequire("20dEN");

var $gNnQq = parcelRequire("gNnQq");
const $59d3993c69e6bf3a$var$compareOption = (inputValue = '', option, accessors)=>{
    const candidate = String(inputValue).toLowerCase();
    const optionValue = String(accessors.getOptionValue(option)).toLowerCase();
    const optionLabel = String(accessors.getOptionLabel(option)).toLowerCase();
    return optionValue === candidate || optionLabel === candidate;
};
const $59d3993c69e6bf3a$var$builtins = {
    formatCreateLabel: (inputValue)=>`Create "${inputValue}"`,
    isValidNewOption: (inputValue, selectValue, selectOptions, accessors)=>!(!inputValue || selectValue.some((option)=>$59d3993c69e6bf3a$var$compareOption(inputValue, option, accessors)) || selectOptions.some((option)=>$59d3993c69e6bf3a$var$compareOption(inputValue, option, accessors))),
    getNewOptionData: (inputValue, optionLabel)=>({
            label: optionLabel,
            value: inputValue,
            __isNew__: true
        })
};
function $59d3993c69e6bf3a$export$2e2bcd8739ae039({ allowCreateWhileLoading: allowCreateWhileLoading = false, createOptionPosition: createOptionPosition = 'last', formatCreateLabel: formatCreateLabel = $59d3993c69e6bf3a$var$builtins.formatCreateLabel, isValidNewOption: isValidNewOption = $59d3993c69e6bf3a$var$builtins.isValidNewOption, getNewOptionData: //@ts-ignore
getNewOptionData = $59d3993c69e6bf3a$var$builtins.getNewOptionData, onCreateOption: onCreateOption, options: propsOptions = [], onChange: propsOnChange, ...restSelectProps }) {
    const { getOptionValue: getOptionValue = (0, $20dEN.getOptionValue), getOptionLabel: getOptionLabel = (0, $20dEN.getOptionLabel), inputValue: inputValue, isLoading: isLoading, isMulti: isMulti, value: value, name: name } = restSelectProps;
    const newOption = (0, $eJOHy.useMemo)(()=>isValidNewOption(inputValue, (0, $gNnQq.cleanValue)(value), propsOptions, {
            getOptionValue: getOptionValue,
            getOptionLabel: getOptionLabel
        }) ? getNewOptionData(inputValue, formatCreateLabel(inputValue)) : undefined, [
        formatCreateLabel,
        getNewOptionData,
        getOptionLabel,
        getOptionValue,
        inputValue,
        isValidNewOption,
        propsOptions,
        value
    ]);
    const options = (0, $eJOHy.useMemo)(()=>(allowCreateWhileLoading || !isLoading) && newOption ? createOptionPosition === 'first' ? [
            newOption,
            ...propsOptions
        ] : [
            ...propsOptions,
            newOption
        ] : propsOptions, [
        allowCreateWhileLoading,
        createOptionPosition,
        isLoading,
        newOption,
        propsOptions
    ]);
    const onChange = (0, $eJOHy.useCallback)((newValue, actionMeta)=>{
        if (actionMeta.action !== 'select-option') return propsOnChange(newValue, actionMeta);
        const valueArray = Array.isArray(newValue) ? newValue : [
            newValue
        ];
        if (valueArray[valueArray.length - 1] === newOption) {
            if (onCreateOption) onCreateOption(inputValue);
            else {
                const newOptionData = getNewOptionData(inputValue, inputValue);
                const newActionMeta = {
                    action: 'create-option',
                    name: name,
                    option: newOptionData
                };
                propsOnChange((0, $gNnQq.valueTernary)(isMulti, [
                    ...(0, $gNnQq.cleanValue)(value),
                    newOptionData
                ], newOptionData), newActionMeta);
            }
            return;
        }
        propsOnChange(newValue, actionMeta);
    }, [
        getNewOptionData,
        inputValue,
        isMulti,
        name,
        newOption,
        onCreateOption,
        propsOnChange,
        value
    ]);
    return {
        ...restSelectProps,
        options: options,
        onChange: onChange
    };
}

});



parcelRegister("6UCkD", function(module, exports) {

$parcel$export(module.exports, "default", () => $3bb5dff77a1a2ff0$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $jzkyh = parcelRequire("jzkyh");

var $c4OV1 = parcelRequire("c4OV1");
const $3bb5dff77a1a2ff0$var$CheckboxSelectInternal = ({ components: components, ...props })=>{
    const mergedComponents = (0, $eJOHy.useMemo)(()=>({
            ...components,
            Option: (0, $jzkyh.CheckboxOption)
        }), [
        components
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $c4OV1.default), {
        closeMenuOnSelect: false,
        hideSelectedOptions: false,
        isMulti: true,
        ...props,
        components: mergedComponents
    });
};
const $3bb5dff77a1a2ff0$var$CheckboxSelect = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).memo($3bb5dff77a1a2ff0$var$CheckboxSelectInternal);
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$3bb5dff77a1a2ff0$export$2e2bcd8739ae039 = $3bb5dff77a1a2ff0$var$CheckboxSelect;

});
parcelRegister("jzkyh", function(module, exports) {

$parcel$export(module.exports, "CheckboxOption", () => $c59673c02b42adcb$export$d40cc97ecda916f9);
$parcel$export(module.exports, "RadioOption", () => $c59673c02b42adcb$export$82ab7168879267a7);
/* input-options.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $dwm7g = parcelRequire("dwm7g");

var $279SN = parcelRequire("279SN");

var $2Swhg = parcelRequire("2Swhg");

var $eGOwo = parcelRequire("eGOwo");
const $c59673c02b42adcb$var$optionStyles = {
    default: "_1e0c1txw _4cvr1h6o _1bsb1osq _uiztglyw _18ql1j7p _vchhusvi _85i51b66 _1q511b66 _bozgpxbi _y4tiutpp _bfhk18uv _16qs1kw7 _syaz1kw7 _1di61dty",
    focused: "_bfhk166n _16qsn8hf _112ej1ic",
    disabled: "_syaz15gi"
};
// the primary color represents the outer or background element
const $c59673c02b42adcb$var$getPrimaryColor = ({ isActive: isActive, isDisabled: isDisabled, isFocused: isFocused, isSelected: isSelected })=>{
    if (isDisabled) return "var(--ds-background-disabled, #091E4208)";
    else if (isSelected && isActive) return "var(--ds-background-selected-bold-pressed, #09326C)";
    else if (isActive) return "var(--ds-background-selected-pressed, #85B8FF)";
    else if (isFocused && isSelected) return "var(--ds-background-selected-bold-hovered, #0055CC)";
    else if (isFocused) return "var(--ds-surface, #FFFFFF)";
    else if (isSelected) return "var(--ds-background-selected-bold, #0C66E4)";
    return "var(--ds-background-neutral, #091E420F)";
};
// the secondary color represents the radio dot or checkmark
const $c59673c02b42adcb$var$getSecondaryColor = ({ isDisabled: isDisabled, isSelected: isSelected })=>{
    if (isDisabled && isSelected) return "var(--ds-text-disabled, #091E424F)";
    else if (!isSelected) return 'transparent';
    return "var(--ds-surface, #FFFFFF)";
};
const $c59673c02b42adcb$var$iconStyles = {
    inherit: "_1u9j1r31 _1gqp1r31",
    default: "_1u9j1elr _1gqp1elr"
};
const $c59673c02b42adcb$var$baseIconStyles = null;
const $c59673c02b42adcb$var$baseOptionStyles = null;
const $c59673c02b42adcb$var$ControlOption = (props)=>{
    const [isActive, setIsActive] = (0, $eJOHy.useState)(false);
    const onMouseDown = (0, $eJOHy.useCallback)(()=>setIsActive(true), []);
    const onMouseUp = (0, $eJOHy.useCallback)(()=>setIsActive(false), []);
    const { Icon: Icon, children: children, innerProps: innerProps, innerRef: innerRef, cx: cx, className: className, isDisabled: isDisabled, isSelected: isSelected, isFocused: isFocused } = props;
    const classNames = (0, $eJOHy.useMemo)(()=>cx({
            option: true,
            'option--is-disabled': isDisabled,
            'option--is-focused': isFocused,
            'option--is-selected': isSelected
        }, className), [
        cx,
        isDisabled,
        isFocused,
        isSelected,
        className
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsxs)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $hcewu.default)([
            $c59673c02b42adcb$var$optionStyles.default,
            isFocused && $c59673c02b42adcb$var$optionStyles.focused,
            isDisabled && $c59673c02b42adcb$var$optionStyles.disabled,
            classNames
        ]),
        ref: innerRef,
        onMouseDown: onMouseDown,
        onMouseUp: onMouseUp,
        onMouseLeave: onMouseUp,
        ...innerProps,
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                className: (0, $hcewu.default)([
                    "_1e0c1txw _4cvr1h6o _1o9zidpf _y4ti1b66 _16cu892t _1xci892t _59qxe4h9 _8y3xe4h9",
                    isSelected || isActive || isDisabled ? $c59673c02b42adcb$var$iconStyles.inherit : $c59673c02b42adcb$var$iconStyles.default
                ]),
                children: !!Icon ? /*#__PURE__*/ (0, $gt9Am.jsx)(Icon, {
                    label: "",
                    primaryColor: $c59673c02b42adcb$var$getPrimaryColor({
                        isDisabled: isDisabled,
                        isSelected: isSelected,
                        isFocused: isFocused,
                        isActive: isActive
                    }),
                    secondaryColor: $c59673c02b42adcb$var$getSecondaryColor({
                        isDisabled: isDisabled,
                        isSelected: isSelected
                    }),
                    isFacadeDisabled: true
                }) : null
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                className: (0, $hcewu.default)([
                    "_16jlkb7n _1reo15vq _1bto1l2s _o5721q9c"
                ]),
                children: children
            })
        ]
    });
};
const $c59673c02b42adcb$var$NewCheckboxIcon = (props)=>// eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    /*#__PURE__*/ (0, $gt9Am.jsx)((0, $2Swhg.default), {
        ...props,
        children: /*#__PURE__*/ (0, $gt9Am.jsxs)("g", {
            fillRule: "evenodd",
            children: [
                /*#__PURE__*/ (0, $gt9Am.jsx)("rect", {
                    x: "5.5",
                    y: "5.5",
                    width: "13",
                    height: "13",
                    rx: "1.5",
                    fill: "currentColor"
                }),
                /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M16.3262 9.48011L15.1738 8.51984L10.75 13.8284L8.82616 11.5198L7.67383 12.4801L10.1738 15.4801C10.3163 15.6511 10.5274 15.75 10.75 15.75C10.9726 15.75 11.1837 15.6511 11.3262 15.4801L16.3262 9.48011Z",
                    fill: "inherit"
                })
            ]
        })
    });
const $c59673c02b42adcb$var$NewRadioIcon = (props)=>// eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    /*#__PURE__*/ (0, $gt9Am.jsx)((0, $2Swhg.default), {
        ...props,
        children: /*#__PURE__*/ (0, $gt9Am.jsxs)("g", {
            fillRule: "evenodd",
            children: [
                /*#__PURE__*/ (0, $gt9Am.jsx)("circle", {
                    cx: "12",
                    cy: "12",
                    r: "6.75",
                    fill: "currentColor",
                    strokeWidth: "1.5"
                }),
                /*#__PURE__*/ (0, $gt9Am.jsx)("circle", {
                    cx: "12",
                    cy: "12",
                    r: "3",
                    fill: "inherit"
                })
            ]
        })
    });
const $c59673c02b42adcb$export$d40cc97ecda916f9 = (props)=>/*#__PURE__*/ (0, $gt9Am.jsx)($c59673c02b42adcb$var$ControlOption, {
        Icon: // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
        (0, $eGOwo.fg)('platform-visual-refresh-icons') ? $c59673c02b42adcb$var$NewCheckboxIcon : // eslint-disable-next-line @atlaskit/design-system/no-legacy-icons
        (0, (/*@__PURE__*/$parcel$interopDefault($dwm7g))),
        ...props
    });
const $c59673c02b42adcb$export$82ab7168879267a7 = (props)=>// TODO https://product-fabric.atlassian.net/browse/DSP-20769
    /*#__PURE__*/ (0, $gt9Am.jsx)($c59673c02b42adcb$var$ControlOption, {
        Icon: // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
        (0, $eGOwo.fg)('platform-visual-refresh-icons') ? $c59673c02b42adcb$var$NewRadioIcon : // eslint-disable-next-line @atlaskit/design-system/no-legacy-icons
        (0, (/*@__PURE__*/$parcel$interopDefault($279SN))),
        ...props
    });

});
parcelRegister("dwm7g", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9d7f6b5a4b54b43d$var$_react = $9d7f6b5a4b54b43d$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $fL0In = parcelRequire("fL0In");
function $9d7f6b5a4b54b43d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $9d7f6b5a4b54b43d$var$CheckboxIcon = (props)=>/*#__PURE__*/ $9d7f6b5a4b54b43d$var$_react.default.createElement($fL0In.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><rect width="12" height="12" x="6" y="6" fill="currentcolor" rx="2"/><path fill="inherit" d="M9.707 11.293a1 1 0 1 0-1.414 1.414l2 2a1 1 0 0 0 1.414 0l4-4a1 1 0 1 0-1.414-1.414L11 12.586z"/></g></svg>`
    }, props));
$9d7f6b5a4b54b43d$var$CheckboxIcon.displayName = 'CheckboxIcon';
var $9d7f6b5a4b54b43d$var$_default = module.exports.default = $9d7f6b5a4b54b43d$var$CheckboxIcon;

});

parcelRegister("279SN", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $18a3e6b70b5fecb4$var$_react = $18a3e6b70b5fecb4$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $fL0In = parcelRequire("fL0In");
function $18a3e6b70b5fecb4$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $18a3e6b70b5fecb4$var$RadioIcon = (props)=>/*#__PURE__*/ $18a3e6b70b5fecb4$var$_react.default.createElement($fL0In.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><circle cx="12" cy="12" r="6" fill="currentcolor"/><circle cx="12" cy="12" r="2" fill="inherit"/></g></svg>`
    }, props));
$18a3e6b70b5fecb4$var$RadioIcon.displayName = 'RadioIcon';
var $18a3e6b70b5fecb4$var$_default = module.exports.default = $18a3e6b70b5fecb4$var$RadioIcon;

});



parcelRegister("kVcjU", function(module, exports) {

$parcel$export(module.exports, "default", () => $a77c87292d58cd15$export$2e2bcd8739ae039);

var $dSBuj = parcelRequire("dSBuj");

var $dDv66 = parcelRequire("dDv66");
const $a77c87292d58cd15$var$CreatableSelect = (0, $dDv66.default)((0, $dSBuj.default));
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$a77c87292d58cd15$export$2e2bcd8739ae039 = $a77c87292d58cd15$var$CreatableSelect;

});
parcelRegister("dSBuj", function(module, exports) {

$parcel$export(module.exports, "default", () => $bfa75c11ff37aa8b$export$2e2bcd8739ae039);
$parcel$export(module.exports, "useCreatable", () => (parcelRequire("9gNEN")).default);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $5tlgh = parcelRequire("5tlgh");

var $9gNEN = parcelRequire("9gNEN");

var $gVVTN = parcelRequire("gVVTN");
const $bfa75c11ff37aa8b$var$CreatableSelect = /*#__PURE__*/ (0, $eJOHy.forwardRef)((props, ref)=>{
    const creatableProps = (0, $gVVTN.default)(props);
    const selectProps = (0, $9gNEN.default)(creatableProps);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5tlgh.default), {
        ref: ref,
        ...selectProps
    });
});
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$bfa75c11ff37aa8b$export$2e2bcd8739ae039 = $bfa75c11ff37aa8b$var$CreatableSelect;

});


parcelRegister("8uyZr", function(module, exports) {

$parcel$export(module.exports, "AsyncSelectWithAnalytics", () => $e03cabeb319fc25e$export$ee664e5add893f9);

var $gWITR = parcelRequire("gWITR");

var $aBFKZ = parcelRequire("aBFKZ");
const $e03cabeb319fc25e$export$ee664e5add893f9 = (0, $aBFKZ.default)('select', {
    onChange: 'changed'
})((0, $gWITR.default));

});
parcelRegister("gWITR", function(module, exports) {

$parcel$export(module.exports, "default", () => $c00970193ac2e0bb$export$2e2bcd8739ae039);

var $g6uAx = parcelRequire("g6uAx");

var $dDv66 = parcelRequire("dDv66");
const $c00970193ac2e0bb$var$AsyncSelect = (0, $dDv66.default)((0, $g6uAx.default));
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$c00970193ac2e0bb$export$2e2bcd8739ae039 = $c00970193ac2e0bb$var$AsyncSelect;

});


parcelRegister("lxUP5", function(module, exports) {

$parcel$export(module.exports, "FieldLabel", () => $02d61fcf6733b580$export$1acdcf5a973a8414);
/* main.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $806LH = parcelRequire("806LH");
const $02d61fcf6733b580$export$1acdcf5a973a8414 = ({ label: label, htmlFor: htmlFor, isRequired: isRequired = false })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($02d61fcf6733b580$var$Label, {
        htmlFor: htmlFor
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $806LH.default), {
        size: "xxsmall",
        as: "h2"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
        className: (0, $hcewu.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _syaz131l _1e0c1ule _ca0qv47k _u5f3idpf _n3td1b66 _19bvidpf _ect41gqc"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("span", null, label), isRequired ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("span", {
        role: "presentation",
        className: (0, $hcewu.default)([
            "_syaz1tmw _19bvv77o _ect41gqc"
        ])
    }, "*") : null)));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $02d61fcf6733b580$var$Label = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "label", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1ule",
            __cmplp.className
        ])
    });
});
const $02d61fcf6733b580$var$labelStyle = null;
const $02d61fcf6733b580$var$requiredIndicatorStyle = null;

});

parcelRegister("6joHJ", function(module, exports) {

$parcel$export(module.exports, "JiraInlineDialog", () => $765bdfac52a4c302$export$7ab52478615504b3);

var $eJOHy = parcelRequire("eJOHy");

var $cwZBT = parcelRequire("cwZBT");

var $SyPNn = parcelRequire("SyPNn");

var $fYeTG = parcelRequire("fYeTG");

var $1kIuW = parcelRequire("1kIuW");
const $765bdfac52a4c302$export$7ab52478615504b3 = (props)=>{
    if ((0, $SyPNn.shouldBeChoreographed)(props)) {
        if ((0, $fYeTG.isMobileAndInViewPanelIterationExperiment)()) return null;
        const { messageType: messageType, ...rest } = props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1kIuW.ChoreographerInlineDialog), rest);
    }
    const { messageType: messageType, messageId: messageId, onMessageDisposition: onMessageDisposition, ...rest } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cwZBT.default), rest);
};

});
parcelRegister("1kIuW", function(module, exports) {

$parcel$export(module.exports, "ChoreographerInlineDialog", () => $7432b934335413bd$export$44a404f218b0e66e);

var $cwZBT = parcelRequire("cwZBT");

var $gL5G0 = parcelRequire("gL5G0");
const $7432b934335413bd$export$44a404f218b0e66e = (0, $gL5G0.withChoreographedToggle)((0, $cwZBT.default), 'isOpen', 'content');

});


parcelRegister("6rlhA", function(module, exports) {

$parcel$export(module.exports, "default", () => $742c5e69dae6a49f$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $742c5e69dae6a49f$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    noOptions: {
        "id": "common.components.picker.base.no-options",
        "defaultMessage": "No results"
    },
    loading: {
        "id": "common.components.picker.base.loading",
        "defaultMessage": "Searching..."
    },
    defaultPlaceholder: {
        "id": "common.components.picker.base.default-placeholder",
        "defaultMessage": "Select..."
    },
    clearSelected: {
        "id": "common.components.picker.base.clear-selected",
        "defaultMessage": "Clear selected"
    }
});

});


parcelRegister("87K62", function(module, exports) {

$parcel$export(module.exports, "default", () => $33a231bde2dbcecf$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $5DgXR = parcelRequire("5DgXR");

var $2sLVw = parcelRequire("2sLVw");

var $fJTOm = parcelRequire("fJTOm");
class $33a231bde2dbcecf$export$2e2bcd8739ae039 extends (0, $eJOHy.Component) {
    static{
        this.defaultProps = {
            showFocusedAvatar: false
        };
    }
    render() {
        const { formatOptionDataTransformer: formatOptionDataTransformer, showFocusedAvatar: showFocusedAvatar, ...props } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fJTOm.default), {
            ...props,
            onBlur: this.onBlur,
            onFocus: this.onFocus,
            formatOptionLabel: this.renderOption
        });
    }
    constructor(...args){
        super(...args), this.state = {
            canShowAvatar: true
        }, this.onBlur = (event)=>{
            this.setState(()=>({
                    canShowAvatar: true
                }));
            this.props.onBlur && this.props.onBlur(event);
        }, this.onFocus = (event)=>{
            if (!this.props.showFocusedAvatar) this.setState(()=>({
                    canShowAvatar: false
                }));
            this.props.onFocus && this.props.onFocus(event);
        }, this.renderOption = (option, { context: context // eslint-disable-next-line @typescript-eslint/no-explicit-any
         })=>{
            const { avatar: avatar, label: label } = this.props.formatOptionDataTransformer(option);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($33a231bde2dbcecf$var$OptionWrapper, null, typeof avatar !== 'undefined' && (context !== 'value' || this.state.canShowAvatar) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2sLVw.default), null, typeof avatar === 'string' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5DgXR.default), {
                src: avatar,
                size: "xsmall"
            }) : avatar) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($33a231bde2dbcecf$var$LabelWrapper, null, label));
        };
    }
}
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $33a231bde2dbcecf$var$OptionWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_zulpu2gc _1e0c1txw _4cvr1h6o",
            __cmplp.className
        ])
    });
});
const $33a231bde2dbcecf$var$LabelWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1reo15vq _18m915vq _o5721q9c _1bto1l2s",
            __cmplp.className
        ])
    });
});

});


parcelRegister("l01aN", function(module, exports) {

$parcel$export(module.exports, "getAllGroups", () => $7a95b05e333f0285$export$c243565349cba18c);
$parcel$export(module.exports, "getUserGroups", () => $7a95b05e333f0285$export$bda937ecc753b1f3);

var $8B2Am = parcelRequire("8B2Am");

var $1fygZ = parcelRequire("1fygZ");
const $7a95b05e333f0285$export$c243565349cba18c = (searchQuery, maxResults)=>(0, $8B2Am.getAllGroups)(searchQuery, maxResults).then((0, $1fygZ.transformAllGroups));
const $7a95b05e333f0285$export$bda937ecc753b1f3 = (accountId, searchQuery)=>{
    if (!accountId) return Promise.resolve([]);
    return (0, $8B2Am.getUserGroups)(accountId).then((response)=>{
        const filteredGroups = (0, $1fygZ.filterUserGroups)(response, searchQuery);
        return (0, $1fygZ.transformUserGroups)(filteredGroups);
    });
};

});
parcelRegister("8B2Am", function(module, exports) {

$parcel$export(module.exports, "getAllGroups", () => $6d1f3f29001b39a3$export$c243565349cba18c);
$parcel$export(module.exports, "getUserGroups", () => $6d1f3f29001b39a3$export$bda937ecc753b1f3);

var $1Ozm9 = parcelRequire("1Ozm9");
// Get all groups (including ones user is not a member of)
const $6d1f3f29001b39a3$var$MAX_GROUPS = 5;
const $6d1f3f29001b39a3$export$dc22b2cc8b5a1431 = ()=>'/rest/api/2/groups/picker';
const $6d1f3f29001b39a3$var$getAllGroupsUrl = (query, maxResults = $6d1f3f29001b39a3$var$MAX_GROUPS)=>`${$6d1f3f29001b39a3$export$dc22b2cc8b5a1431()}?maxResults=${maxResults}&query=${encodeURIComponent(query)}`;
const $6d1f3f29001b39a3$export$c243565349cba18c = (query = '', maxResults = $6d1f3f29001b39a3$var$MAX_GROUPS)=>(0, $1Ozm9.default)($6d1f3f29001b39a3$var$getAllGroupsUrl(query, maxResults));
const $6d1f3f29001b39a3$export$a1f49428f96f52c7 = ()=>'/rest/api/3/user/groups';
const $6d1f3f29001b39a3$var$getUserGroupsUrl = (accountId)=>`${$6d1f3f29001b39a3$export$a1f49428f96f52c7()}?accountId=${accountId}`;
const $6d1f3f29001b39a3$export$bda937ecc753b1f3 = (accountId)=>(0, $1Ozm9.default)($6d1f3f29001b39a3$var$getUserGroupsUrl(accountId));

});

parcelRegister("1fygZ", function(module, exports) {

$parcel$export(module.exports, "transformAllGroups", () => $ff9b793dc903753d$export$b53a6053f3a37f82);
$parcel$export(module.exports, "filterUserGroups", () => $ff9b793dc903753d$export$3803c0f966c39ffc);
$parcel$export(module.exports, "transformUserGroups", () => $ff9b793dc903753d$export$3e297671f207b321);
const $ff9b793dc903753d$export$b53a6053f3a37f82 = (response)=>response && response.groups && response.groups.map(({ name: name, groupId: groupId })=>({
            name: name,
            label: name,
            value: name,
            groupId: groupId
        }));
const $ff9b793dc903753d$export$3803c0f966c39ffc = (groupsRest, searchQuery)=>{
    if (!searchQuery) return groupsRest;
    return groupsRest.filter((group)=>group.name.includes(searchQuery || '')); // `|| ''` check is just for Flow
};
const $ff9b793dc903753d$export$3e297671f207b321 = (groupsRest)=>groupsRest.map(({ name: name, groupId: groupId })=>({
            name: name,
            label: name,
            value: name,
            groupId: groupId
        }));

});


parcelRegister("403OI", function(module, exports) {

$parcel$export(module.exports, "default", () => $f3e7a132e0991919$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $f3e7a132e0991919$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    error: {
        "id": "group-picker.error",
        "defaultMessage": "We couldn't retrieve groups"
    },
    placeholder: {
        "id": "group-picker.placeholder",
        "defaultMessage": "Group"
    },
    labelText: {
        "id": "group-picker.label-text",
        "defaultMessage": "Group"
    }
});

});



parcelRegister("k3q7u", function(module, exports) {

$parcel$export(module.exports, "default", () => $993004d92fc3087c$export$2e2bcd8739ae039);

var $aBFKZ = parcelRequire("aBFKZ");

var $2uf1V = parcelRequire("2uf1V");
var $993004d92fc3087c$export$2e2bcd8739ae039 = (0, $aBFKZ.default)('ProjectPicker', {
    onChange: 'changed'
})((0, $2uf1V.default));

});
parcelRegister("2uf1V", function(module, exports) {

$parcel$export(module.exports, "default", () => $649631acf9dc7036$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/restricted/react-component-props

var $eJOHy = parcelRequire("eJOHy");

var $aXKmr = parcelRequire("aXKmr");

var $2sHLK = parcelRequire("2sHLK");

var $idGBm = parcelRequire("idGBm");

var $7RIAd = parcelRequire("7RIAd");

var $559oH = parcelRequire("559oH");
class $649631acf9dc7036$export$a4519235a2ef9605 extends (0, $eJOHy.Component) {
    static{
        this.defaultProps = {
            isRequired: false,
            isDisabled: false,
            isClearable: true,
            isCompact: false,
            detailed: false,
            width: '200px',
            requireBrowsePermission: false,
            requireEditPermission: false,
            label: undefined,
            inputId: undefined,
            projectType: undefined
        };
    }
    constructor(props){
        super(props), this.state = {
            selectedProject: this.props.selectedProject,
            projects: [],
            prevSelectedProject: this.props.selectedProject
        }, this.onSelected = (selectedOption)=>{
            this.setState({
                selectedProject: selectedOption
            });
            this.props.onChange(selectedOption);
        }, /* eslint-disable jira/react-arrow-function-property-naming */ this.formatOptionDataTransformer = (project)=>{
            const { avatarUrl: avatarUrl, name: name } = project;
            const avatar = this.props.renderAvatar ? this.props.renderAvatar(avatarUrl) : avatarUrl;
            return {
                avatar: avatar,
                label: name
            };
        }, /* eslint-disable jira/react-arrow-function-property-naming */ this.fetchOptions = async (filter)=>{
            const projects = await (0, $7RIAd.requestProjects)(filter, {
                detailed: this.props.detailed,
                requireBrowsePermission: this.props.requireBrowsePermission,
                requireEditPermission: this.props.requireEditPermission,
                projectType: this.props.projectType
            });
            this.setState({
                projects: projects
            });
            return projects;
        };
        this.projectPickerId = `project-picker.label.id-${(0, $aXKmr.v4)()}`;
    }
    static getDerivedStateFromProps(props, state) {
        const currentProjectId = props.selectedProject && props.selectedProject.value;
        const prevProjectId = state.prevSelectedProject && state.prevSelectedProject.value;
        if (currentProjectId !== prevProjectId) return {
            ...state,
            selectedProject: props.selectedProject,
            prevSelectedProject: props.selectedProject
        };
        return null;
    }
    componentDidMount() {
        const { selectedProject: selectedProject } = this.state;
        if (selectedProject && !selectedProject.name) this.fetchProject(selectedProject);
    }
    componentDidUpdate() {
        const { selectedProject: selectedProject } = this.state;
        if (selectedProject && !selectedProject.name) this.fetchProject(selectedProject);
    }
    fetchProject(selectedProject) {
        const projectValue = selectedProject.value;
        // @ts-expect-error - TS7006 - Parameter 'newProject' implicitly has an 'any' type.
        const updateSelectedProject = (newProject)=>{
            const currentProject = this.state.selectedProject;
            const currentProjectValue = currentProject && currentProject.value;
            // Update the state only in case the project wasn't changed
            if (currentProjectValue === projectValue) {
                this.setState({
                    selectedProject: newProject
                });
                this.props.onChange(newProject);
            }
        };
        return (0, $7RIAd.requestProject)(projectValue).then((project)=>updateSelectedProject(project)).catch(()=>updateSelectedProject(undefined));
    }
    render() {
        const { intl: { formatMessage: formatMessage }, selectedProject: selectedProject, onChange: onChange, ...props } = this.props;
        const { selectedProject: project, projects: projects } = this.state;
        // the selected option needs to have same object reference to be correctly announced by screen readers
        const selectedOptionWithObjectReference = projects?.find((projectInList)=>projectInList.value === project?.value);
        const selectedOption = selectedOptionWithObjectReference || (project && project.name ? project : null);
        return(// @ts-expect-error - TS2769 - No overload matches this call.
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2sHLK.PickerWithAvatar), {
            "aria-label": !this.props.label ? formatMessage((0, $559oH.default).labelText) : undefined,
            ...props,
            inputId: !this.props.inputId ? this.projectPickerId : this.props.inputId,
            errorMessage: formatMessage((0, $559oH.default).error),
            placeholder: this.props.placeholder || formatMessage((0, $559oH.default).placeholder),
            onSelected: this.onSelected,
            options: this.fetchOptions,
            formatOptionDataTransformer: this.formatOptionDataTransformer,
            value: selectedOption,
            showFocusedAvatar: true
        }));
    }
}
var $649631acf9dc7036$export$2e2bcd8739ae039 = (0, $idGBm.injectIntlV2)($649631acf9dc7036$export$a4519235a2ef9605);

});
parcelRegister("7RIAd", function(module, exports) {

$parcel$export(module.exports, "requestProjects", () => $335c617be9654301$export$fd47004f2da106d6);
$parcel$export(module.exports, "requestProject", () => $335c617be9654301$export$5fc96122a11240fa);

var $ki1Cz = parcelRequire("ki1Cz");

var $lN5GE = parcelRequire("lN5GE");
const $335c617be9654301$export$fd47004f2da106d6 = (filter, { detailed: detailed, requireBrowsePermission: requireBrowsePermission, requireEditPermission: requireEditPermission, maxResults: maxResults, projectType: projectType })=>(0, $ki1Cz.getProjects)(filter, detailed, requireBrowsePermission, requireEditPermission, maxResults, projectType).then((0, $lN5GE.transformProjects));
const $335c617be9654301$export$5fc96122a11240fa = (projectId)=>(0, $ki1Cz.getProject)(projectId).then((0, $lN5GE.transformProject));

});
parcelRegister("ki1Cz", function(module, exports) {

$parcel$export(module.exports, "getProjects", () => $48d0e50622956812$export$b00a271f69f3d728);
$parcel$export(module.exports, "getProject", () => $48d0e50622956812$export$637b60a42bb03f06);

var $1Ozm9 = parcelRequire("1Ozm9");
const $48d0e50622956812$var$MAX_PROJECTS = 5;
const $48d0e50622956812$var$VALID_PROJECT_TYPES = [
    'business',
    'service_desk',
    'software'
];
const $48d0e50622956812$export$897983d170945c20 = ()=>'/rest/api/2/project/search';
const $48d0e50622956812$export$40e632ede9793c84 = ()=>'/rest/api/2/project';
const $48d0e50622956812$export$3675f59ca23820db = (filter, detailed, requireBrowsePermission, requireEditPermission, maxResults = $48d0e50622956812$var$MAX_PROJECTS, projectType = '')=>{
    const urlSearchParams = new URLSearchParams();
    urlSearchParams.set('orderBy', 'NAME');
    urlSearchParams.set('startAt', '0');
    urlSearchParams.set('query', filter);
    urlSearchParams.set('maxResults', maxResults.toString());
    if (detailed) urlSearchParams.set('expand', 'lead,issueTypes');
    const actions = [];
    if (requireBrowsePermission) actions.push('browse');
    if (requireEditPermission) actions.push('edit');
    if (actions.length > 0) urlSearchParams.set('action', actions.join(','));
    if ($48d0e50622956812$var$VALID_PROJECT_TYPES.includes(projectType)) urlSearchParams.set('typeKey', projectType);
    const urlParams = `?${urlSearchParams.toString()}`;
    return `${$48d0e50622956812$export$897983d170945c20()}${urlParams}`;
};
const $48d0e50622956812$export$42f2db4bad372151 = (projectId)=>`${$48d0e50622956812$export$40e632ede9793c84()}/${encodeURIComponent(projectId)}`;
const $48d0e50622956812$export$b00a271f69f3d728 = (filter = '', detailed = false, requireBrowsePermission = false, requireEditPermission = false, maxResults = $48d0e50622956812$var$MAX_PROJECTS, projectType = '')=>(0, $1Ozm9.default)($48d0e50622956812$export$3675f59ca23820db(filter, detailed, requireBrowsePermission, requireEditPermission, maxResults, projectType));
const $48d0e50622956812$export$637b60a42bb03f06 = (projectId = '')=>(0, $1Ozm9.default)($48d0e50622956812$export$42f2db4bad372151(projectId));

});

parcelRegister("lN5GE", function(module, exports) {

$parcel$export(module.exports, "transformProject", () => $a026cc7331d138a2$export$e179869ce707f546);
$parcel$export(module.exports, "transformProjects", () => $a026cc7331d138a2$export$227473965d2e27db);
const $a026cc7331d138a2$var$transformLead = (leadResponse)=>leadResponse && {
        key: leadResponse.key,
        name: leadResponse.name,
        displayName: leadResponse.displayName,
        avatarUrl: leadResponse.avatarUrls['24x24']
    };
const $a026cc7331d138a2$var$transformIssueTypes = (types)=>types.map((t)=>({
            id: t.id,
            name: t.name,
            description: t.description,
            iconUrl: t.iconUrl,
            subtask: t.subtask
        }));
const $a026cc7331d138a2$var$transformDetails = (restResponse)=>({
        id: restResponse.id,
        key: restResponse.key,
        lead: $a026cc7331d138a2$var$transformLead(restResponse.lead),
        issueTypes: restResponse.issueTypes ? $a026cc7331d138a2$var$transformIssueTypes(restResponse.issueTypes) : [],
        projectTypeKey: restResponse.projectTypeKey,
        simplified: restResponse.simplified
    });
const $a026cc7331d138a2$export$e179869ce707f546 = (restResponse)=>restResponse && {
        value: restResponse.id,
        name: restResponse.name,
        label: restResponse.name,
        avatarUrl: restResponse.avatarUrls['24x24'],
        details: $a026cc7331d138a2$var$transformDetails(restResponse)
    };
const $a026cc7331d138a2$export$227473965d2e27db = (restResponse)=>restResponse && restResponse.values && restResponse.values.map($a026cc7331d138a2$export$e179869ce707f546);

});


parcelRegister("559oH", function(module, exports) {

$parcel$export(module.exports, "default", () => $333fdb33476e624f$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $333fdb33476e624f$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    error: {
        "id": "project-picker.error",
        "defaultMessage": "We couldn't retrieve projects"
    },
    placeholder: {
        "id": "project-picker.placeholder",
        "defaultMessage": "Project"
    },
    labelText: {
        "id": "project-picker.label-text",
        "defaultMessage": "Project"
    },
    errorProjectTermRefresh: {
        "id": "project-picker.error-project-term-refresh",
        "defaultMessage": "We couldn't retrieve spaces"
    },
    placeholderProjectTermRefresh: {
        "id": "project-picker.placeholder-project-term-refresh",
        "defaultMessage": "Space"
    },
    labelTextProjectTermRefresh: {
        "id": "project-picker.label-text-project-term-refresh",
        "defaultMessage": "Space"
    }
});

});



parcelRegister("fucyK", function(module, exports) {

$parcel$export(module.exports, "default", () => $cace7a5a03fd5f19$export$2e2bcd8739ae039);

var $aBFKZ = parcelRequire("aBFKZ");

var $aPsSO = parcelRequire("aPsSO");
var $cace7a5a03fd5f19$export$2e2bcd8739ae039 = (0, $aBFKZ.default)('UserPicker', {
    onChange: 'changed'
})((0, $aPsSO.default));

});
parcelRegister("aPsSO", function(module, exports) {

$parcel$export(module.exports, "default", () => $8995af3cbc8e38f3$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $aXKmr = parcelRequire("aXKmr");

var $2sHLK = parcelRequire("2sHLK");

var $eSnSE = parcelRequire("eSnSE");

var $idGBm = parcelRequire("idGBm");

var $2e8aC = parcelRequire("2e8aC");

var $d5dE5 = parcelRequire("d5dE5");
class $8995af3cbc8e38f3$export$83e0c73b09b3a9cd extends (0, $eJOHy.Component) {
    static{
        this.defaultProps = {
            isRequired: false,
            isDisabled: false,
            isClearable: true,
            isClearableWithCrossIcon: false,
            isCompact: false,
            shouldFitContainer: false,
            width: '200px'
        };
    }
    constructor(props){
        super(props), this.state = {
            selectedUser: this.props.selectedUser,
            prevSelectedUser: this.props.selectedUser
        }, this.onSelected = (selectedUser)=>{
            this.setState({
                selectedUser: selectedUser
            });
            this.props.onChange(selectedUser);
        }, /* eslint-disable jira/react-arrow-function-property-naming */ this.formatOptionDataTransformer = (user)=>({
                avatar: user.avatarUrl,
                label: user.displayName
            }), this.fetchOptions = (query)=>{
            const { suggestedAccountId: suggestedAccountId } = this.props;
            if (query) return (0, $2e8aC.requestUsers)(query);
            if (suggestedAccountId) return new Promise((resolve)=>{
                (0, $2e8aC.requestUser)(suggestedAccountId).then((user)=>resolve([
                        user
                    ])).catch(()=>resolve([]));
            });
            return Promise.resolve([]);
        };
        this.userPickerId = `group-picker.label.id-${(0, $aXKmr.v4)()}`;
    }
    static getDerivedStateFromProps(props, state) {
        const currentAccountId = props.selectedUser && props.selectedUser.accountId;
        const prevAccountId = state.prevSelectedUser && state.prevSelectedUser.accountId;
        if (currentAccountId !== prevAccountId) return {
            ...state,
            selectedUser: props.selectedUser,
            prevSelectedUser: props.selectedUser
        };
        return null;
    }
    componentDidMount() {
        this.ensureSelectedUserInfoPresent();
    }
    componentDidUpdate(prevProps) {
        this.ensureSelectedUserInfoPresent();
        if (prevProps.suggestedAccountId !== this.props.suggestedAccountId) // Good to know:
        // react-select caches resolved Promise value for an empty filter so
        // there is no way to change the suggestion other then replacing the component with a new one
        (0, $eSnSE.default).safeErrorWithoutCustomerData('user-picker.prop-update', "suggestedAccountId prop change won't be applied, you have to replace the component with a new one");
    }
    ensureSelectedUserInfoPresent() {
        const { selectedUser: selectedUser } = this.state;
        if (!selectedUser || selectedUser.displayName) return;
        const { accountId: accountId } = selectedUser;
        // @ts-expect-error - TS7006 - Parameter 'newUser' implicitly has an 'any' type.
        const updateSelectedUser = (newUser)=>{
            const currentUser = this.state.selectedUser;
            const currentAccountId = currentUser && currentUser.accountId;
            // Update the state only in case the user wasn't changed
            if (currentAccountId === accountId) this.setState({
                selectedUser: newUser
            });
        };
        (0, $2e8aC.requestUser)(accountId).then((user)=>updateSelectedUser(user)).catch(()=>updateSelectedUser(undefined));
    }
    render() {
        const { intl: { formatMessage: formatMessage }, suggestedAccountId: suggestedAccountId, selectedUser: selectedUser, placeholder: placeholder = this.props.placeholder || formatMessage((0, $d5dE5.default).placeholder), onChange: onChange, shouldFitContainer: shouldFitContainer, width: width, isClearableWithCrossIcon: isClearableWithCrossIcon, ...props } = this.props;
        const { selectedUser: user } = this.state;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2sHLK.PickerWithAvatar), {
            "aria-label": !this.props.label ? formatMessage((0, $d5dE5.default).labelText) : undefined,
            inputId: this.userPickerId,
            ...props,
            errorMessage: formatMessage((0, $d5dE5.default).error),
            placeholder: placeholder,
            onSelected: this.onSelected,
            options: this.fetchOptions,
            formatOptionDataTransformer: this.formatOptionDataTransformer,
            value: user && user.displayName ? user : null,
            width: shouldFitContainer ? undefined : width,
            isClearableWithCrossIcon: isClearableWithCrossIcon
        });
    }
}
var $8995af3cbc8e38f3$export$2e2bcd8739ae039 = (0, $idGBm.injectIntlV2)($8995af3cbc8e38f3$export$83e0c73b09b3a9cd);

});
parcelRegister("2e8aC", function(module, exports) {

$parcel$export(module.exports, "requestUser", () => $340ce2eca69238dd$export$949646a1c1731536);
$parcel$export(module.exports, "requestUsers", () => $340ce2eca69238dd$export$55b721778f931cc1);

var $37Xqw = parcelRequire("37Xqw");

var $1otmW = parcelRequire("1otmW");
const $340ce2eca69238dd$export$949646a1c1731536 = (accountId)=>(0, $37Xqw.getUser)(accountId).then((0, $1otmW.transformUser));
const $340ce2eca69238dd$export$55b721778f931cc1 = (query)=>(0, $37Xqw.getUsers)(query).then((0, $1otmW.transformUsers));

});
parcelRegister("37Xqw", function(module, exports) {

$parcel$export(module.exports, "getUser", () => $143cc0293437bb25$export$7cbf767827cd68ba);
$parcel$export(module.exports, "getUsers", () => $143cc0293437bb25$export$925a4945a6cd0f3e);

var $1Ozm9 = parcelRequire("1Ozm9");
const $143cc0293437bb25$export$e45b57f6c6c40475 = 5;
const $143cc0293437bb25$export$7eaa662f51e316ae = ()=>'/rest/api/2/user';
const $143cc0293437bb25$export$8df721f926f55c9a = (accountId = '')=>`${$143cc0293437bb25$export$7eaa662f51e316ae()}?accountId=${encodeURIComponent(accountId)}`;
const $143cc0293437bb25$export$715964ba85b11e2b = ()=>'/rest/api/2/user/picker';
const $143cc0293437bb25$export$977bdbd87001f83 = (query = '')=>`${$143cc0293437bb25$export$715964ba85b11e2b()}?showAvatar=true&maxResults=${$143cc0293437bb25$export$e45b57f6c6c40475}&query=${query}`;
const $143cc0293437bb25$export$7cbf767827cd68ba = (accountId = '')=>(0, $1Ozm9.default)($143cc0293437bb25$export$8df721f926f55c9a(accountId));
const $143cc0293437bb25$export$925a4945a6cd0f3e = (query = '')=>(0, $1Ozm9.default)($143cc0293437bb25$export$977bdbd87001f83(query));

});

parcelRegister("1otmW", function(module, exports) {

$parcel$export(module.exports, "transformUser", () => $19e9ef34e6aae24a$export$88dcd5c1adae8021);
$parcel$export(module.exports, "transformUsers", () => $19e9ef34e6aae24a$export$fb8c90bfc4beaa59);
const $19e9ef34e6aae24a$export$88dcd5c1adae8021 = ({ accountId: accountId, displayName: displayName, avatarUrls: avatarUrls })=>({
        accountId: accountId,
        value: accountId,
        displayName: displayName,
        label: displayName,
        avatarUrl: avatarUrls['24x24']
    });
const $19e9ef34e6aae24a$export$fb8c90bfc4beaa59 = (response)=>response.users.map(({ accountId: accountId, avatarUrl: avatarUrl, displayName: displayName })=>({
            accountId: accountId,
            value: accountId,
            displayName: displayName,
            label: displayName,
            avatarUrl: avatarUrl
        }));

});


parcelRegister("d5dE5", function(module, exports) {

$parcel$export(module.exports, "default", () => $61835bca22ccc32e$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $61835bca22ccc32e$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    error: {
        "id": "user-picker.error",
        "defaultMessage": "We couldn't retrieve users"
    },
    placeholder: {
        "id": "user-picker.placeholder",
        "defaultMessage": "User"
    },
    labelText: {
        "id": "user-picker.label-text",
        "defaultMessage": "User"
    }
});

});



parcelRegister("w2wEp", function(module, exports) {

$parcel$export(module.exports, "default", () => $46badcff0c61bd7c$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $eq3Hf = parcelRequire("eq3Hf");

var $5CSKW = parcelRequire("5CSKW");

var $l5htz = parcelRequire("l5htz");

var $idGBm = parcelRequire("idGBm");

var $91NFD = parcelRequire("91NFD");
function $46badcff0c61bd7c$export$47d037774b685574(props) {
    const { onClick: onClick, intl: { formatMessage: formatMessage } } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5CSKW.default), {
        appearance: "subtle",
        onClick: onClick,
        shouldFitContainer: true
    }, formatMessage((0, $91NFD.default).label));
}
var $46badcff0c61bd7c$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($eq3Hf)))((0, $l5htz.default)({
    onClick: 'clearFilters'
}), (0, $idGBm.injectIntlV2))($46badcff0c61bd7c$export$47d037774b685574);

});
parcelRegister("91NFD", function(module, exports) {

$parcel$export(module.exports, "default", () => $52867d9c556c6bab$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $52867d9c556c6bab$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    label: {
        "id": "directories.filters-v2.main.content.filter.clear.label",
        "defaultMessage": "Clear filters"
    }
});

});


parcelRegister("5U7bK", function(module, exports) {

$parcel$export(module.exports, "default", () => $a5301067805b7cb0$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $idGBm = parcelRequire("idGBm");

var $9QRvN = parcelRequire("9QRvN");

var $dJEUx = parcelRequire("dJEUx");

var $8aLWf = parcelRequire("8aLWf");
class $a5301067805b7cb0$export$ec91da630f36d5ea extends (0, $eJOHy.Component) {
    render() {
        const { renderFilterSearch: renderFilterSearch, renderOwnerPicker: renderOwnerPicker, renderProjectPicker: renderProjectPicker, renderGroupPicker: renderGroupPicker, renderClear: renderClear, intl: { formatMessage: formatMessage } } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9QRvN.FilterBar), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dJEUx.FilterItem), {
            expandOnSmall: true
        }, renderFilterSearch({
            onChange: this.onSearchChange,
            placeholder: formatMessage((0, $8aLWf.default).searchPlaceholder)
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dJEUx.FilterItem), null, renderOwnerPicker({
            onChange: this.onOwnerChange,
            placeholder: formatMessage((0, $8aLWf.default).ownerPlaceholder)
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dJEUx.FilterItem), null, renderProjectPicker({
            onChange: this.onProjectChange
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dJEUx.FilterItem), null, renderGroupPicker({
            onChange: this.onGroupChange
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dJEUx.FilterItem), {
            expandOnSmall: true
        }, renderClear({
            onClick: this.onClear
        })));
    }
    constructor(...args){
        super(...args), // @ts-expect-error - TS2322 - Type 'undefined' is not assignable to type 'string'.
        this.onSearchChange = (query, analyticsEvent)=>{
            this.props.onChange({
                ...this.props.value,
                query: query
            }, analyticsEvent);
        }, this.onOwnerChange = (owner, analyticsEvent)=>{
            this.props.onChange({
                ...this.props.value,
                owner: owner
            }, analyticsEvent);
        }, this.onProjectChange = (project, analyticsEvent)=>{
            this.props.onChange({
                ...this.props.value,
                project: project
            }, analyticsEvent);
        }, this.onGroupChange = (group, analyticsEvent)=>{
            this.props.onChange({
                ...this.props.value,
                group: group
            }, analyticsEvent);
        }, this.onClear = (analyticsEvent)=>{
            this.props.onChange({
                ...this.props.initialFilter
            }, analyticsEvent);
        };
    }
}
var $a5301067805b7cb0$export$2e2bcd8739ae039 = (0, $idGBm.injectIntlV2)($a5301067805b7cb0$export$ec91da630f36d5ea);

});
parcelRegister("9QRvN", function(module, exports) {

$parcel$export(module.exports, "FilterBar", () => $3ecd990baea72ae1$export$56a20ec2552ffba2);

var $eJOHy = parcelRequire("eJOHy");

var $6DCNy = parcelRequire("6DCNy");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $gMRLG = parcelRequire("gMRLG");

var $6XJko = parcelRequire("6XJko");

const $3ecd990baea72ae1$export$56a20ec2552ffba2 = ({ children: children })=>{
    const [containerWidth, setContainerWidth] = (0, $eJOHy.useState)(900);
    const handleWidth = (0, (/*@__PURE__*/$parcel$interopDefault($6DCNy)))(setContainerWidth, 50);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $3ecd990baea72ae1$var$relativeWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gMRLG.WidthObserver), {
        setWidth: handleWidth
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: [
            $3ecd990baea72ae1$var$filterBarSharedStyles,
            (0, $6XJko.isVisualRefreshEnabled)() && $3ecd990baea72ae1$var$filterBarSharedStylesVisualRefresh,
            containerWidth > (0, $5b4f651e2b94645c$export$9cc428d7e02a0e8b) && $3ecd990baea72ae1$var$filterBarLargeStyles,
            containerWidth <= (0, $5b4f651e2b94645c$export$9cc428d7e02a0e8b) && containerWidth > (0, $5b4f651e2b94645c$export$99041d531d62aef9) && $3ecd990baea72ae1$var$filterBarMidStyles,
            containerWidth <= (0, $5b4f651e2b94645c$export$99041d531d62aef9) && containerWidth > (0, $5b4f651e2b94645c$export$54280d191a58e9f6) && $3ecd990baea72ae1$var$filterBarSmallStyles
        ]
    }, children));
};
const $3ecd990baea72ae1$var$relativeWrapperStyles = (0, $1DXK0.xcss)({
    position: 'relative'
});
const $3ecd990baea72ae1$var$filterBarSharedStyles = (0, $1DXK0.xcss)({
    width: '100%',
    display: 'grid',
    columnGap: 'space.200',
    rowGap: 'space.100',
    alignItems: 'flex-end'
});
const $3ecd990baea72ae1$var$filterBarSharedStylesVisualRefresh = (0, $1DXK0.xcss)({
    columnGap: 'space.100'
});
const $3ecd990baea72ae1$var$filterBarSmallStyles = (0, $1DXK0.xcss)({
    gridTemplateColumns: 'repeat(2, 1fr)'
});
const $3ecd990baea72ae1$var$filterBarMidStyles = (0, $1DXK0.xcss)({
    gridTemplateColumns: 'repeat(3, 1fr)'
});
const $3ecd990baea72ae1$var$filterBarLargeStyles = (0, $1DXK0.xcss)({
    display: 'flex',
    flexWrap: 'wrap'
});

});
parcelRegister("gMRLG", function(module, exports) {

$parcel$export(module.exports, "WidthObserver", () => $fc07c79ce5b93db8$export$b2ad68b9bc407b80);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $ghv3t = parcelRequire("ghv3t");
const $fc07c79ce5b93db8$export$b2ad68b9bc407b80 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).memo((props)=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $ghv3t.WidthDetectorObserver), {
        setWidth: props.setWidth,
        offscreen: props.offscreen
    });
});
var $fc07c79ce5b93db8$export$2e2bcd8739ae039 = $fc07c79ce5b93db8$export$b2ad68b9bc407b80;

});
parcelRegister("ghv3t", function(module, exports) {

$parcel$export(module.exports, "WidthDetectorObserver", () => $8fd70c84fe96dcaa$export$ff983d2a2b6112ea);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $1DXAa = parcelRequire("1DXAa");
const $8fd70c84fe96dcaa$export$ff983d2a2b6112ea = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).memo(({ setWidth: setWidth, offscreen: offscreen })=>{
    const [inViewRef, inView, target] = (0, $1DXAa.useInView)({
        /* Optional options */ threshold: 0
    });
    const observer = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useRef(()=>{
        if (typeof window === 'undefined') return null;
        // https://github.com/DefinitelyTyped/DefinitelyTyped/pull/40909
        // @ts-ignore
        return new ResizeObserver((entries)=>{
            if (!Array.isArray(entries) || !entries.length) return;
            const { width: width } = entries[0].contentRect;
            setWidth(Math.round(width));
        });
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useEffect(()=>{
        const { current: currentObserver } = observer;
        const resizeObserver = currentObserver();
        if (resizeObserver === null) return;
        if (target) {
            if (inView || offscreen) resizeObserver.observe(target);
            else resizeObserver.unobserve(target);
        }
        return ()=>{
            resizeObserver.disconnect();
        };
    }, [
        target,
        inView,
        offscreen
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            display: 'block',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            width: '100%',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            position: 'absolute'
        },
        ref: inViewRef
    });
});

});
parcelRegister("1DXAa", function(module, exports) {

$parcel$export(module.exports, "useInView", () => $cca7bb4179e40d90$export$2f62ee6831462844);

var $eJOHy = parcelRequire("eJOHy");
function $cca7bb4179e40d90$export$2f62ee6831462844(options = {}) {
    const ref = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useRef();
    const observerInstance = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useRef();
    const [state, setState] = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useState({
        inView: false,
        entry: undefined,
        target: undefined
    });
    const { threshold: threshold, root: root, rootMargin: rootMargin } = options;
    const setRef = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useCallback((node)=>{
        observerInstance.current = new IntersectionObserver((entries)=>{
            if (entries && entries.length) {
                const intersection = entries[0];
                const { isIntersecting: isIntersecting, intersectionRatio: intersectionRatio } = intersection;
                if (intersectionRatio >= 0) {
                    // Note: `0` will be used here when an array of numbers is passed as the threshold, which doesn't feel right
                    const numericThreshold = typeof threshold === 'number' ? threshold : 0;
                    let inView = intersectionRatio >= numericThreshold;
                    if (isIntersecting !== undefined) inView = inView && isIntersecting;
                    setState({
                        inView: inView,
                        entry: intersection,
                        target: node
                    });
                }
            }
        }, {
            threshold: threshold,
            root: root,
            rootMargin: rootMargin
        });
        if (ref.current) observerInstance.current.unobserve(ref.current);
        if (node) observerInstance.current.observe(node);
        // Store a reference to the node
        ref.current = node;
    }, [
        threshold,
        root,
        rootMargin
    ]);
    /**
	 * Unsubscribe IntersectionObserver before unmounting a component.
	 */ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useEffect(()=>{
        return ()=>{
            if (observerInstance.current && ref.current) observerInstance.current.unobserve(ref.current);
        };
    }, []);
    return [
        setRef,
        state.inView,
        state.target,
        state.entry
    ];
}

});



const $5b4f651e2b94645c$export$54280d191a58e9f6 = 420;
const $5b4f651e2b94645c$export$99041d531d62aef9 = 640;
const $5b4f651e2b94645c$export$9cc428d7e02a0e8b = 850;
const $5b4f651e2b94645c$export$a4477e829bcd1e02 = 200;


parcelRegister("dJEUx", function(module, exports) {

$parcel$export(module.exports, "FilterItem", () => $57ae9b62bc01824b$export$3cf161fcd24b6b4f);

var $eJOHy = parcelRequire("eJOHy");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");
const $57ae9b62bc01824b$export$3cf161fcd24b6b4f = ({ expandOnSmall: expandOnSmall, children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: expandOnSmall ? [
            $57ae9b62bc01824b$var$filterItemContainerStyles,
            $57ae9b62bc01824b$var$filterItemContainerExpandedStyles
        ] : $57ae9b62bc01824b$var$filterItemContainerStyles
    }, children);
};
const $57ae9b62bc01824b$var$filterItemContainerStyles = (0, $1DXK0.xcss)({
    // 200px is the width commonly used for directory filters, so including it here helps
    // to ensure consistency with the existing design and gives us predictability for responsive behaviour
    minWidth: '200px'
});
const $57ae9b62bc01824b$var$filterItemContainerExpandedStyles = (0, $1DXK0.xcss)({
    gridColumn: '1 / -1'
});

});

parcelRegister("8aLWf", function(module, exports) {

$parcel$export(module.exports, "default", () => $a895492deac52a3d$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $a895492deac52a3d$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    ownerPlaceholder: {
        "id": "directories.filters-v2.main.content.filter.owner-placeholder",
        "defaultMessage": "Owner"
    },
    searchPlaceholder: {
        "id": "directories.filters-v2.main.content.filter.search-placeholder",
        "defaultMessage": "Search filters"
    },
    searchFilterAriaSearchDescription: {
        "id": "directories.filters-v2.main.content.filter.search-filter-aria-search-description",
        "defaultMessage": "The table will be filtered below as you type into the field"
    }
});

});



parcelRegister("7nCDL", function(module, exports) {

$parcel$export(module.exports, "operationModals", () => $60f7810812c80b5b$export$fee8081fa482dfbf);
$parcel$export(module.exports, "emptyFilterResultConfiguration", () => $60f7810812c80b5b$export$972f54d0cb76a888);
$parcel$export(module.exports, "getHeaderConfiguration", () => $60f7810812c80b5b$export$60b0ef02721854ed);
$parcel$export(module.exports, "getTableConfiguration", () => $60f7810812c80b5b$export$6847365bea1c5392);
$parcel$export(module.exports, "getTableLabel", () => $60f7810812c80b5b$export$b2d196af18e06ad6);
$parcel$export(module.exports, "getResultsAnnouncerMessage", () => $60f7810812c80b5b$export$64df75861e57fb7f);

var $ahm5r = parcelRequire("ahm5r");

var $20b6k = parcelRequire("20b6k");


var $6XJko = parcelRequire("6XJko");

var $bJscI = parcelRequire("bJscI");

var $3gN48 = parcelRequire("3gN48");

var $7MYNw = parcelRequire("7MYNw");

var $lHUhg = parcelRequire("lHUhg");

var $5ZuqW = parcelRequire("5ZuqW");

var $g2XH5 = parcelRequire("g2XH5");

var $ansmd = parcelRequire("ansmd");

var $5WDV3 = parcelRequire("5WDV3");

var $lq3kr = parcelRequire("lq3kr");

var $eJBDJ = parcelRequire("eJBDJ");

var $ELsnh = parcelRequire("ELsnh");

var $f0pMb = parcelRequire("f0pMb");

var $glN2F = parcelRequire("glN2F");

var $82d1f = parcelRequire("82d1f");

var $9CQfK = parcelRequire("9CQfK");

var $iFREh = parcelRequire("iFREh");

var $96S5E = parcelRequire("96S5E");

var $cAFyD = parcelRequire("cAFyD");
const $60f7810812c80b5b$export$fee8081fa482dfbf = {
    [(0, $85bfce414eef38c7$export$92f9e1ed9114d3a6)]: (0, $bJscI.componentWithFG)('nin-save-filter-dialog-entry-point', ()=>null, (0, $glN2F.default)),
    [(0, $85bfce414eef38c7$export$39d2a7fb21967424)]: (0, $f0pMb.default),
    [(0, $85bfce414eef38c7$export$250171a898bf7ef)]: (0, $bJscI.componentWithFG)('nin-save-filter-dialog-entry-point', ()=>null, (0, $9CQfK.default)),
    [(0, $85bfce414eef38c7$export$4bd2facc4a3e6aa1)]: (0, $82d1f.default)
};
const $60f7810812c80b5b$export$972f54d0cb76a888 = {
    message: (0, $96S5E.default).emptyFilterResultMessage
};
const $60f7810812c80b5b$export$60b0ef02721854ed = ()=>({
        ActionsView: $lHUhg.default,
        FilterView: $iFREh.default,
        caption: (0, $96S5E.default).headerCaption
    });
const $60f7810812c80b5b$export$6847365bea1c5392 = (0, $ahm5r.createSelector)((0, $7MYNw.getAtlassianAccountId), (atlassianAccountId)=>[
        atlassianAccountId !== undefined ? {
            title: (0, $20b6k.default),
            Cell: (0, $5WDV3.default),
            sortField: (0, $3gN48.FAVOURITED),
            width: (0, $6XJko.isVisualRefreshEnabled)() ? 3 : 3.1,
            isIconOnlyHeader: (0, $6XJko.isVisualRefreshEnabled)(),
            ascendingSortTooltip: (0, $6XJko.isVisualRefreshEnabled)() ? (0, $96S5E.default).starredToUnstarredOrder : undefined,
            descendingSortTooltip: (0, $6XJko.isVisualRefreshEnabled)() ? (0, $96S5E.default).unstarredToStarredOrder : undefined
        } : undefined,
        {
            title: (0, $96S5E.default).filter,
            Cell: (0, $ELsnh.default),
            sortField: (0, $3gN48.NAME),
            // eslint-disable-next-line no-nested-ternary
            width: atlassianAccountId ? (0, $6XJko.isVisualRefreshEnabled)() ? 23.6 : 22 : 25,
            ascendingSortTooltip: (0, $6XJko.isVisualRefreshEnabled)() ? (0, $96S5E.default).aToZOrder : undefined,
            descendingSortTooltip: (0, $6XJko.isVisualRefreshEnabled)() ? (0, $96S5E.default).zToAOrder : undefined
        },
        atlassianAccountId !== undefined ? {
            title: (0, $96S5E.default).owner,
            Cell: (0, $lq3kr.default),
            sortField: (0, $3gN48.OWNER),
            width: 20,
            ascendingSortTooltip: (0, $6XJko.isVisualRefreshEnabled)() ? (0, $96S5E.default).aToZOrder : undefined,
            descendingSortTooltip: (0, $6XJko.isVisualRefreshEnabled)() ? (0, $96S5E.default).zToAOrder : undefined
        } : undefined,
        {
            title: (0, $96S5E.default).viewers,
            Cell: (0, $5ZuqW.default),
            width: atlassianAccountId ? 20 : 30
        },
        {
            title: (0, $96S5E.default).editors,
            Cell: (0, $ansmd.default),
            width: atlassianAccountId ? 20 : 30
        },
        {
            title: (0, $96S5E.default).popularity,
            Cell: (0, $6XJko.isVisualRefreshEnabled)() ? (0, $cAFyD.default) : (0, $eJBDJ.default),
            sortField: (0, $3gN48.POPULARITY),
            // eslint-disable-next-line no-nested-ternary
            width: atlassianAccountId ? (0, $6XJko.isVisualRefreshEnabled)() ? 13.4 : 10 : 15,
            ascendingSortTooltip: (0, $6XJko.isVisualRefreshEnabled)() ? (0, $96S5E.default).lowestToHighestOrder : undefined,
            descendingSortTooltip: (0, $6XJko.isVisualRefreshEnabled)() ? (0, $96S5E.default).highestToLowestOrder : undefined,
            dataTestId: (0, $6XJko.isVisualRefreshEnabled)() ? 'filters-main.content.headerCell.actions.container' : undefined
        },
        atlassianAccountId !== undefined && !(0, $6XJko.isVisualRefreshEnabled)() ? {
            title: (0, $96S5E.default).actions,
            Cell: (0, $g2XH5.default),
            width: 3.4,
            dataTestId: 'filters-main.content.headerCell.actions.container'
        } : undefined
    ].filter(Boolean));
const $60f7810812c80b5b$export$b2d196af18e06ad6 = ()=>(0, $96S5E.default).tableAriaLabel;
const $60f7810812c80b5b$export$64df75861e57fb7f = ()=>(0, $96S5E.default).filterResultsAnnouncement;

});
parcelRegister("20b6k", function(module, exports) {

$parcel$export(module.exports, "default", () => $13fe72c3ec28f4da$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $1zDn7 = parcelRequire("1zDn7");

var $lRq8t = parcelRequire("lRq8t");

var $fxJiv = parcelRequire("fxJiv");
const $13fe72c3ec28f4da$var$StarTitleCell = ()=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1zDn7))), {
        LEGACY_size: "small",
        label: formatMessage((0, $fxJiv.messages).starred)
    });
};
var $13fe72c3ec28f4da$export$2e2bcd8739ae039 = $13fe72c3ec28f4da$var$StarTitleCell;

});
parcelRegister("1zDn7", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::423b9145cfca34a16d15e97e058708ca>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $125799c0d76ceff5$var$_react = $125799c0d76ceff5$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $125799c0d76ceff5$var$_starStarred = $125799c0d76ceff5$var$_interopRequireDefault((parcelRequire("gGgaG")));

var $125799c0d76ceff5$var$_starFilled = $125799c0d76ceff5$var$_interopRequireDefault((parcelRequire("91hUW")));
function $125799c0d76ceff5$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for StarStarredIcon.
 * This component is StarStarredIcon, with `UNSAFE_fallbackIcon` set to "StarFilledIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for starred or favourited objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $125799c0d76ceff5$var$StarStarredIcon = (props)=>/*#__PURE__*/ $125799c0d76ceff5$var$_react.default.createElement($125799c0d76ceff5$var$_starStarred.default, Object.assign({
        name: "StarStarredIcon",
        LEGACY_fallbackIcon: $125799c0d76ceff5$var$_starFilled.default
    }, props));
$125799c0d76ceff5$var$StarStarredIcon.displayName = 'StarStarredIconMigration';
var $125799c0d76ceff5$var$_default = module.exports.default = $125799c0d76ceff5$var$StarStarredIcon;

});
parcelRegister("gGgaG", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::230a74b5beecd6089e40fb6fd34c20ca>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c24d1cda47746043$var$_react = $c24d1cda47746043$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $c24d1cda47746043$var$_baseNew = $c24d1cda47746043$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $c24d1cda47746043$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "StarStarred".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for starred or favourited objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c24d1cda47746043$var$StarStarredIcon = (props)=>/*#__PURE__*/ $c24d1cda47746043$var$_react.default.createElement($c24d1cda47746043$var$_baseNew.default, Object.assign({
        name: "StarStarredIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 0a.75.75 0 0 1 .7.48l1.705 4.434 4.403.338a.75.75 0 0 1 .422 1.324l-3.38 2.818 1.25 4.662a.75.75 0 0 1-1.148.813L8 12.159l-3.95 2.71a.75.75 0 0 1-1.15-.813l1.251-4.662L.77 6.576a.75.75 0 0 1 .422-1.324l4.403-.338L7.3.48A.75.75 0 0 1 8 0m0 2.84L6.655 6.335l-3.506.27 2.7 2.25-.973 3.627L8 10.341l3.124 2.142-.973-3.627 2.7-2.25-3.506-.27z" clip-rule="evenodd"/><path fill="currentcolor" d="M6.655 6.336 8 2.84l1.345 3.497 3.506.27-2.7 2.25.973 3.627L8 10.341l-3.124 2.142.973-3.627-2.7-2.25z"/>`
    }, props));
$c24d1cda47746043$var$StarStarredIcon.displayName = 'StarStarredIcon';
var $c24d1cda47746043$var$_default = module.exports.default = $c24d1cda47746043$var$StarStarredIcon;

});

parcelRegister("91hUW", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $69121b14e227da1b$var$_react = $69121b14e227da1b$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $fL0In = parcelRequire("fL0In");
function $69121b14e227da1b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $69121b14e227da1b$var$StarFilledIcon = (props)=>/*#__PURE__*/ $69121b14e227da1b$var$_react.default.createElement($fL0In.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m12.072 17.284-3.905 2.053a1 1 0 0 1-1.451-1.054l.745-4.349-3.159-3.08a1 1 0 0 1 .554-1.705l4.366-.635 1.953-3.956a1 1 0 0 1 1.794 0l1.952 3.956 4.366.635a1 1 0 0 1 .555 1.705l-3.16 3.08.746 4.349a1 1 0 0 1-1.45 1.054z"/></svg>`
    }, props));
$69121b14e227da1b$var$StarFilledIcon.displayName = 'StarFilledIcon';
var $69121b14e227da1b$var$_default = module.exports.default = $69121b14e227da1b$var$StarFilledIcon;

});


parcelRegister("fxJiv", function(module, exports) {

$parcel$export(module.exports, "messages", () => $e5142eb9230ff6a4$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $e5142eb9230ff6a4$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    starred: {
        "id": "directories.common.components.star-title-cell.starred",
        "defaultMessage": "Starred"
    }
});

});


parcelRegister("lHUhg", function(module, exports) {

$parcel$export(module.exports, "default", () => $d446608208816728$export$2e2bcd8739ae039);

var $5A51c = parcelRequire("5A51c");

var $gnQAk = parcelRequire("gnQAk");
const $d446608208816728$var$mapStateToProps = (_state)=>({});
var $d446608208816728$export$2e2bcd8739ae039 = (0, $gnQAk.connect)($d446608208816728$var$mapStateToProps, {})((0, $5A51c.default));

});
parcelRegister("5A51c", function(module, exports) {

$parcel$export(module.exports, "default", () => $a92abd8264ecb739$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $eq3Hf = parcelRequire("eq3Hf");

var $goZPP = parcelRequire("goZPP");

var $l5htz = parcelRequire("l5htz");

var $6YFG2 = parcelRequire("6YFG2");

var $c9uTK = parcelRequire("c9uTK");

var $jDVmp = parcelRequire("jDVmp");
const $a92abd8264ecb739$export$6d3c345ce7c38fd9 = ({ onClick: onClick, intl: { formatMessage: formatMessage } })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
        href: `/issues/?jql=${encodeURIComponent('created >= -30d order by created DESC')}`,
        onClick: onClick,
        appearance: "primary",
        // @ts-expect-error - TS2322 - Type '{ children: string; href: string; onClick: (() => void) | undefined; appearance: "primary"; externalId: string; }' is not assignable to type 'IntrinsicAttributes & ButtonProps & RefAttributes<HTMLElement>'.
        externalId: "directory.filters-v2.create-button",
        component: (0, $c9uTK.Link)
    }, formatMessage((0, $jDVmp.default).createFilter));
var $a92abd8264ecb739$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($eq3Hf)))((0, $l5htz.default)({
    onClick: 'createFilter'
}), (0, $6YFG2.default))($a92abd8264ecb739$export$6d3c345ce7c38fd9);

});
parcelRegister("jDVmp", function(module, exports) {

$parcel$export(module.exports, "default", () => $d44f4ea114d6b392$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $d44f4ea114d6b392$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    createFilter: {
        "id": "create-filter-button.create-filter",
        "defaultMessage": "Create filter"
    }
});

});



parcelRegister("5ZuqW", function(module, exports) {

$parcel$export(module.exports, "default", () => $b7543eed32b1fb4d$export$2e2bcd8739ae039);

var $gnQAk = parcelRequire("gnQAk");

var $iYaR3 = parcelRequire("iYaR3");

var $h7xAk = parcelRequire("h7xAk");
const $b7543eed32b1fb4d$var$mapStateToProps = ()=>(state, ownProps)=>({
            shares: (0, $iYaR3.getShares)(state, ownProps.id)
        });
var $b7543eed32b1fb4d$export$2e2bcd8739ae039 = (0, $gnQAk.connect)($b7543eed32b1fb4d$var$mapStateToProps, {})((0, $h7xAk.default));

});
parcelRegister("h7xAk", function(module, exports) {

$parcel$export(module.exports, "default", () => $97bfaa398ef2befc$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $5DgXR = parcelRequire("5DgXR");

var $ifn8T = parcelRequire("ifn8T");

var $7icpf = parcelRequire("7icpf");

var $rZPcB = parcelRequire("rZPcB");

var $lG2jM = parcelRequire("lG2jM");

var $amvLf = parcelRequire("amvLf");

var $8IeH1 = parcelRequire("8IeH1");
var $2sLVw = parcelRequire("2sLVw");

var $idGBm = parcelRequire("idGBm");

var $epTsa = parcelRequire("epTsa");


var $6XJko = parcelRequire("6XJko");

var $2eNQW = parcelRequire("2eNQW");
const $97bfaa398ef2befc$var$assertUnreachable = (_x)=>{
    throw new Error("Didn't expect to get here");
};
class $97bfaa398ef2befc$export$3026e5a52c747d2c extends (0, $eJOHy.Component) {
    static{
        // go/jfe-eslint
        // eslint-disable-next-line react/sort-comp
        this.defaultProps = {
            shares: []
        };
    }
    static renderAvatar(text, avatarUrl, idx, appearance = 'square', hasMultipleProjectRoles) {
        const content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($97bfaa398ef2befc$var$AvatarContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5DgXR.default), {
            size: "small",
            src: avatarUrl,
            appearance: appearance
        })), (0, $6XJko.isVisualRefreshEnabled)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8IeH1.default), {
            xcss: hasMultipleProjectRoles ? $97bfaa398ef2befc$var$styles.textContainerMultipleRoles : $97bfaa398ef2befc$var$styles.textContainerSingleRole
        }, text) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($97bfaa398ef2befc$var$TextContainer, null, text));
        return (0, $6XJko.isVisualRefreshEnabled)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2sLVw.default), {
            key: idx,
            alignItems: "center",
            xcss: hasMultipleProjectRoles ? $97bfaa398ef2befc$var$styles.avatarContainerMultipleRoles : $97bfaa398ef2befc$var$styles.avatarContainerSingleRole
        }, content) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($97bfaa398ef2befc$var$Container, {
            key: idx
        }, content);
    }
    static renderIcon(text, IconComponent, idx = 1) {
        const content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($97bfaa398ef2befc$var$IconContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(IconComponent, {
            label: "",
            spacing: "spacious"
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($97bfaa398ef2befc$var$TextContainer, null, text));
        return (0, $6XJko.isVisualRefreshEnabled)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2sLVw.default), {
            key: idx,
            alignItems: "center",
            xcss: $97bfaa398ef2befc$var$styles.iconContainerWrapper
        }, content) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($97bfaa398ef2befc$var$Container, {
            key: idx
        }, content);
    }
    render() {
        const { shares: shares, intl: { formatMessage: formatMessage } } = this.props;
        const unknownProjectGalaxia = (0, $epTsa.expVal)('project-terminology-refresh', 'isEnabled', false) ? (0, $2eNQW.default).unknownProjectGalaxia : (0, $2eNQW.default).unknownProject;
        const content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, shares.length > 0 ? shares.map((share, idx)=>{
            switch(share.type){
                case 0, $f461f432d18e9f64$export$b0a0e62d9b1a8269:
                    return $97bfaa398ef2befc$export$3026e5a52c747d2c.renderIcon(formatMessage((0, $2eNQW.default).myOrganizationAccess), (0, (/*@__PURE__*/$parcel$interopDefault($rZPcB))), idx);
                case 0, $f461f432d18e9f64$export$86517eb0163ef745:
                    return $97bfaa398ef2befc$export$3026e5a52c747d2c.renderIcon(formatMessage((0, $2eNQW.default).publicAccess), (0, (/*@__PURE__*/$parcel$interopDefault($amvLf))), idx);
                case 0, $f461f432d18e9f64$export$b02d7412182d1bce:
                    return $97bfaa398ef2befc$export$3026e5a52c747d2c.renderIcon(share.group.name || '', (0, (/*@__PURE__*/$parcel$interopDefault($lG2jM))), idx);
                case 0, $f461f432d18e9f64$export$5ef95a67b8fd1ff6:
                    {
                        const roleName = share.role ? share.role.name : formatMessage((0, $2eNQW.default).allProjectRoles);
                        const text = `${share.project.name}, ${roleName}`;
                        return $97bfaa398ef2befc$export$3026e5a52c747d2c.renderAvatar(text, share.project.avatarUrl, idx, 'square', shares.length > 1);
                    }
                case 0, $f461f432d18e9f64$export$aea0835048e1c730:
                    return $97bfaa398ef2befc$export$3026e5a52c747d2c.renderAvatar(share.user.displayName, share.user.avatarUrl, idx, 'circle', false);
                case 0, $f461f432d18e9f64$export$487da0972e3459fe:
                    return $97bfaa398ef2befc$export$3026e5a52c747d2c.renderIcon(formatMessage(unknownProjectGalaxia), (0, (/*@__PURE__*/$parcel$interopDefault($ifn8T))), idx);
                default:
                    $97bfaa398ef2befc$var$assertUnreachable(share);
                    return null;
            }
        }) : $97bfaa398ef2befc$export$3026e5a52c747d2c.renderIcon(formatMessage((0, $2eNQW.default).privateAccess), (0, (/*@__PURE__*/$parcel$interopDefault($7icpf)))));
        return (0, $6XJko.isVisualRefreshEnabled)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2sLVw.default), {
            direction: "column"
        }, content) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($97bfaa398ef2befc$var$CellContainer, null, content);
    }
}
var $97bfaa398ef2befc$export$2e2bcd8739ae039 = (0, $idGBm.injectIntlV2)($97bfaa398ef2befc$export$3026e5a52c747d2c);
const $97bfaa398ef2befc$var$styles = {
    avatarContainerMultipleRoles: "_n3tdu2gc _4t3i1wug",
    avatarContainerSingleRole: "_n3tdze3t _4t3i1ylp",
    iconContainerWrapper: "_4t3i1ylp",
    textContainerMultipleRoles: "_1reo15vq _18m915vq _slp31hna _16jlkb7n",
    textContainerSingleRole: "_1reo15vq _18m915vq _slp31hna _16jlkb7n _1bto1l2s _o5721q9c"
}; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $97bfaa398ef2befc$var$Container = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1txw _4cvr1h6o _n3td1b66",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $97bfaa398ef2befc$var$AvatarContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_u5f3u2gc _vwz4kb7n _1o9zidpf",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $97bfaa398ef2befc$var$IconContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_ca0qv77o _u5f3utpp _n3tdv77o _19bvv77o _vwz4kb7n _1o9zidpf",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $97bfaa398ef2befc$var$TextContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1reo15vq _18m915vq _slp31hna _16jlkb7n",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $97bfaa398ef2befc$var$CellContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_ca0q12x7 _1e0c1txw _2lx21bp4",
            __cmplp.className
        ])
    });
});

});
parcelRegister("ifn8T", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::88ba20151931ba3bc3acff79a5d761b1>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d48b945619dca2dd$var$_react = $d48b945619dca2dd$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $d48b945619dca2dd$var$_folderClosed = $d48b945619dca2dd$var$_interopRequireDefault((parcelRequire("dCT0T")));

var $d48b945619dca2dd$var$_folder = $d48b945619dca2dd$var$_interopRequireDefault((parcelRequire("17hUm")));
function $d48b945619dca2dd$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for FolderClosedIcon.
 * This component is FolderClosedIcon, with `UNSAFE_fallbackIcon` set to "FolderIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for folders in Confluence.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $d48b945619dca2dd$var$FolderClosedIcon = (props)=>/*#__PURE__*/ $d48b945619dca2dd$var$_react.default.createElement($d48b945619dca2dd$var$_folderClosed.default, Object.assign({
        name: "FolderClosedIcon",
        LEGACY_fallbackIcon: $d48b945619dca2dd$var$_folder.default
    }, props));
$d48b945619dca2dd$var$FolderClosedIcon.displayName = 'FolderClosedIconMigration';
var $d48b945619dca2dd$var$_default = module.exports.default = $d48b945619dca2dd$var$FolderClosedIcon;

});
parcelRegister("dCT0T", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::329ffe53264930b81eb140b6c3cd31f4>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9eb97f7a872c0087$var$_react = $9eb97f7a872c0087$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $9eb97f7a872c0087$var$_baseNew = $9eb97f7a872c0087$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $9eb97f7a872c0087$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "FolderClosed".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for folders in Confluence.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $9eb97f7a872c0087$var$FolderClosedIcon = (props)=>/*#__PURE__*/ $9eb97f7a872c0087$var$_react.default.createElement($9eb97f7a872c0087$var$_baseNew.default, Object.assign({
        name: "FolderClosedIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M3 2.5a.5.5 0 0 0-.5.5v3h11V4.75a.5.5 0 0 0-.5-.5H7.69L5.94 2.5zm10.5 5h-11V13a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5zM1 3a2 2 0 0 1 2-2h3.56l1.75 1.75H13a2 2 0 0 1 2 2V13a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2z" clip-rule="evenodd"/>`
    }, props));
$9eb97f7a872c0087$var$FolderClosedIcon.displayName = 'FolderClosedIcon';
var $9eb97f7a872c0087$var$_default = module.exports.default = $9eb97f7a872c0087$var$FolderClosedIcon;

});

parcelRegister("17hUm", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0d04560c41581199$var$_react = $0d04560c41581199$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $fL0In = parcelRequire("fL0In");
function $0d04560c41581199$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $0d04560c41581199$var$FolderIcon = (props)=>/*#__PURE__*/ $0d04560c41581199$var$_react.default.createElement($fL0In.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="M20 19V8h-9.154l-.503-1.258-.455-1.136C9.778 5.33 9.291 5 9.003 5H3.997C4.002 5 4 19 4 19zM12.2 6h7.809C21.109 6 22 6.893 22 7.992v11.016c0 1.1-.898 1.992-1.991 1.992H3.991C2.891 21 2 20.107 2 19.008V5.006C2 3.898 2.896 3 3.997 3h5.006c1.103 0 2.327.826 2.742 1.862z"/></svg>`
    }, props));
$0d04560c41581199$var$FolderIcon.displayName = 'FolderIcon';
var $0d04560c41581199$var$_default = module.exports.default = $0d04560c41581199$var$FolderIcon;

});


parcelRegister("7icpf", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a40b994748e9c4ac5c744dc68bdbf45a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $54f3d671b23b5985$var$_react = $54f3d671b23b5985$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $54f3d671b23b5985$var$_lockLocked = $54f3d671b23b5985$var$_interopRequireDefault((parcelRequire("9QgTI")));

var $54f3d671b23b5985$var$_lock = $54f3d671b23b5985$var$_interopRequireDefault((parcelRequire("jFH1h")));
function $54f3d671b23b5985$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for LockLockedIcon.
 * This component is LockLockedIcon, with `UNSAFE_fallbackIcon` set to "LockIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: secure password in textfields, locked page in Confluence.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $54f3d671b23b5985$var$LockLockedIcon = (props)=>/*#__PURE__*/ $54f3d671b23b5985$var$_react.default.createElement($54f3d671b23b5985$var$_lockLocked.default, Object.assign({
        name: "LockLockedIcon",
        LEGACY_fallbackIcon: $54f3d671b23b5985$var$_lock.default
    }, props));
$54f3d671b23b5985$var$LockLockedIcon.displayName = 'LockLockedIconMigration';
var $54f3d671b23b5985$var$_default = module.exports.default = $54f3d671b23b5985$var$LockLockedIcon;

});
parcelRegister("9QgTI", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b170729cb10fdaa6c208ecbe5722b466>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $72a613e9f42e1e21$var$_react = $72a613e9f42e1e21$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $72a613e9f42e1e21$var$_baseNew = $72a613e9f42e1e21$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $72a613e9f42e1e21$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "LockLocked".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: secure password in textfields, locked page in Confluence.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $72a613e9f42e1e21$var$LockLockedIcon = (props)=>/*#__PURE__*/ $72a613e9f42e1e21$var$_react.default.createElement($72a613e9f42e1e21$var$_baseNew.default, Object.assign({
        name: "LockLockedIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 1.5A2.5 2.5 0 0 0 5.5 4v3h5V4A2.5 2.5 0 0 0 8 1.5M12 7V4a4 4 0 0 0-8 0v3a2 2 0 0 0-2 2v5a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2M4 8.5a.5.5 0 0 0-.5.5v5a.5.5 0 0 0 .5.5h8a.5.5 0 0 0 .5-.5V9a.5.5 0 0 0-.5-.5zM7.25 13v-3h1.5v3z" clip-rule="evenodd"/>`
    }, props));
$72a613e9f42e1e21$var$LockLockedIcon.displayName = 'LockLockedIcon';
var $72a613e9f42e1e21$var$_default = module.exports.default = $72a613e9f42e1e21$var$LockLockedIcon;

});

parcelRegister("jFH1h", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e523377710580c71$var$_react = $e523377710580c71$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $fL0In = parcelRequire("fL0In");
function $e523377710580c71$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $e523377710580c71$var$LockIcon = (props)=>/*#__PURE__*/ $e523377710580c71$var$_react.default.createElement($fL0In.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor"><path d="M16 11V9h-2V7.002A2 2 0 0 0 12 5c-1.102 0-2 .898-2 2.002V9H8v2H7v8h10v-8zm-2 0h-4V9h4zM8 9V7.002A4.004 4.004 0 0 1 12 3a4 4 0 0 1 4 4.002V9h.994A2.01 2.01 0 0 1 19 11.009v7.982c0 1.11-.897 2.009-2.006 2.009H7.006A2.01 2.01 0 0 1 5 18.991V11.01C5 9.899 5.897 9 7.006 9zm0 0h2v2H8zm6 0h2v2h-2z"/><circle cx="12" cy="15" r="2"/></g></svg>`
    }, props));
$e523377710580c71$var$LockIcon.displayName = 'LockIcon';
var $e523377710580c71$var$_default = module.exports.default = $e523377710580c71$var$LockIcon;

});


parcelRegister("rZPcB", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::7474181d8a0d516b6c121c7c5554f489>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $05427adb8338e2ba$var$_react = $05427adb8338e2ba$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $05427adb8338e2ba$var$_officeBuilding = $05427adb8338e2ba$var$_interopRequireDefault((parcelRequire("jPgjO")));

var $05427adb8338e2ba$var$_officeBuilding2 = $05427adb8338e2ba$var$_interopRequireDefault((parcelRequire("if7fN")));
function $05427adb8338e2ba$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for OfficeBuildingIcon.
 * This component is OfficeBuildingIcon, with `UNSAFE_fallbackIcon` set to "OfficeBuildingIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: office in Atlas, company.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $05427adb8338e2ba$var$OfficeBuildingIcon = (props)=>/*#__PURE__*/ $05427adb8338e2ba$var$_react.default.createElement($05427adb8338e2ba$var$_officeBuilding.default, Object.assign({
        name: "OfficeBuildingIcon",
        LEGACY_fallbackIcon: $05427adb8338e2ba$var$_officeBuilding2.default
    }, props));
$05427adb8338e2ba$var$OfficeBuildingIcon.displayName = 'OfficeBuildingIconMigration';
var $05427adb8338e2ba$var$_default = module.exports.default = $05427adb8338e2ba$var$OfficeBuildingIcon;

});
parcelRegister("jPgjO", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::61e479f96d30ea6369ef34d699ad08b2>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e6ef7042ada3add3$var$_react = $e6ef7042ada3add3$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $e6ef7042ada3add3$var$_baseNew = $e6ef7042ada3add3$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $e6ef7042ada3add3$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "OfficeBuilding".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: office in Atlas, company.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $e6ef7042ada3add3$var$OfficeBuildingIcon = (props)=>/*#__PURE__*/ $e6ef7042ada3add3$var$_react.default.createElement($e6ef7042ada3add3$var$_baseNew.default, Object.assign({
        name: "OfficeBuildingIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2 2a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v12.5h1V16H1v-1.5h1zm1.5 12.5h2v-3.75a.75.75 0 0 1 .75-.75h3.5a.75.75 0 0 1 .75.75v3.75h2V2a.5.5 0 0 0-.5-.5H4a.5.5 0 0 0-.5.5zm5.5 0v-3H7v3zm-2-10H5V3h2zm4 0H9V3h2zM5 6h2v1.5H5zm4 0h2v1.5H9z" clip-rule="evenodd"/>`
    }, props));
$e6ef7042ada3add3$var$OfficeBuildingIcon.displayName = 'OfficeBuildingIcon';
var $e6ef7042ada3add3$var$_default = module.exports.default = $e6ef7042ada3add3$var$OfficeBuildingIcon;

});

parcelRegister("if7fN", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d47f41275bf2da31$var$_react = $d47f41275bf2da31$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $fL0In = parcelRequire("fL0In");
function $d47f41275bf2da31$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $d47f41275bf2da31$var$OfficeBuildingIcon = (props)=>/*#__PURE__*/ $d47f41275bf2da31$var$_react.default.createElement($fL0In.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path fill-rule="nonzero" d="M8 6H5.009C3.902 6 3 6.962 3 8.15v10.7C3 20.04 3.9 21 5.009 21h5.487H8v-2.145c-1.616-.001-3-.003-3-.004 0 0 .005-10.708.009-10.708L8 8.144z"/><path d="M12 7h2v2h-2zm-6 3h2v2H6zm0 3h2v2H6zm6-3h2v2h-2zm0 3h2v2h-2zm2 3h2v3h-2zm2-9h2v2h-2zm0 3h2v2h-2zm0 3h2v2h-2z"/><path fill-rule="nonzero" d="M18.991 19C18.998 19 19 4.995 19 4.995c0 .006-7.991.005-7.991.005C11.002 5 11 19 11 19zM9 4.995C9 3.893 9.902 3 11.009 3h7.982C20.101 3 21 3.893 21 4.995v14.01A2.004 2.004 0 0 1 18.991 21H9z"/></g></svg>`
    }, props));
$d47f41275bf2da31$var$OfficeBuildingIcon.displayName = 'OfficeBuildingIcon';
var $d47f41275bf2da31$var$_default = module.exports.default = $d47f41275bf2da31$var$OfficeBuildingIcon;

});


parcelRegister("amvLf", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c6371335b92a848b5714db36f7f8e8cc>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $78b49887480e6b61$var$_react = $78b49887480e6b61$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $78b49887480e6b61$var$_globe = $78b49887480e6b61$var$_interopRequireDefault((parcelRequire("iBgxn")));

var $78b49887480e6b61$var$_world = $78b49887480e6b61$var$_interopRequireDefault((parcelRequire("d9Hm3")));
function $78b49887480e6b61$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for GlobeIcon.
 * This component is GlobeIcon, with `UNSAFE_fallbackIcon` set to "WorldIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: public link in Confluence share dialog, global rules in Automation.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $78b49887480e6b61$var$GlobeIcon = (props)=>/*#__PURE__*/ $78b49887480e6b61$var$_react.default.createElement($78b49887480e6b61$var$_globe.default, Object.assign({
        name: "GlobeIcon",
        LEGACY_fallbackIcon: $78b49887480e6b61$var$_world.default
    }, props));
$78b49887480e6b61$var$GlobeIcon.displayName = 'GlobeIconMigration';
var $78b49887480e6b61$var$_default = module.exports.default = $78b49887480e6b61$var$GlobeIcon;

});
parcelRegister("d9Hm3", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $993dbef3c65d6ca6$var$_react = $993dbef3c65d6ca6$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $fL0In = parcelRequire("fL0In");
function $993dbef3c65d6ca6$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $993dbef3c65d6ca6$var$WorldIcon = (props)=>/*#__PURE__*/ $993dbef3c65d6ca6$var$_react.default.createElement($fL0In.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18m-.9-1.863A7.19 7.19 0 0 1 4.8 12c0-.558.072-1.089.189-1.611L9.3 14.7v.9c0 .99.81 1.8 1.8 1.8zm6.21-2.286A1.79 1.79 0 0 0 15.6 15.6h-.9v-2.7c0-.495-.405-.9-.9-.9H8.4v-1.8h1.8c.495 0 .9-.405.9-.9V7.5h1.8c.99 0 1.8-.81 1.8-1.8v-.369c2.637 1.071 4.5 3.654 4.5 6.669 0 1.872-.72 3.573-1.89 4.851"/></svg>`
    }, props));
$993dbef3c65d6ca6$var$WorldIcon.displayName = 'WorldIcon';
var $993dbef3c65d6ca6$var$_default = module.exports.default = $993dbef3c65d6ca6$var$WorldIcon;

});


parcelRegister("2eNQW", function(module, exports) {

$parcel$export(module.exports, "default", () => $8fc8feed223880c1$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $8fc8feed223880c1$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    myOrganizationAccess: {
        "id": "directories.filters-v2.main.content.cells.access.my-organization-access",
        "defaultMessage": "My organization"
    },
    publicAccess: {
        "id": "directories.filters-v2.main.content.cells.access.public-access",
        "defaultMessage": "Public"
    },
    privateAccess: {
        "id": "directories.filters-v2.main.content.cells.access.private-access",
        "defaultMessage": "Private"
    },
    allProjectRoles: {
        "id": "directories.filters-v2.main.content.cells.access.all-project-roles",
        "defaultMessage": "All roles"
    },
    unknownProject: {
        "id": "directories.filters-v2.main.content.cells.access.unknown-project",
        "defaultMessage": "Unknown project"
    },
    unknownProjectGalaxia: {
        "id": "directories.filters-v2.main.content.cells.access.unknown-project-galaxia",
        "defaultMessage": "Unknown space"
    }
});

});



parcelRegister("g2XH5", function(module, exports) {

$parcel$export(module.exports, "default", () => $62a99b38228c8f8f$export$2e2bcd8739ae039);

var $LFmXM = parcelRequire("LFmXM");


var $gnQAk = parcelRequire("gnQAk");

var $dH9V1 = parcelRequire("dH9V1");

var $7MYNw = parcelRequire("7MYNw");

var $a7fcJ = parcelRequire("a7fcJ");

var $iYaR3 = parcelRequire("iYaR3");

var $g2Aua = parcelRequire("g2Aua");
const $62a99b38228c8f8f$var$mapStateToPropsFactory = ()=>{
    const onCopyFactory = (0, $LFmXM.default)((onOperationRequested)=>()=>// @ts-expect-error - TS2554 - Expected 2 arguments, but got 1.
            onOperationRequested((0, $85bfce414eef38c7$export$92f9e1ed9114d3a6)));
    const onEditFactory = (0, $LFmXM.default)((onOperationRequested)=>()=>// @ts-expect-error - TS2554 - Expected 2 arguments, but got 1.
            onOperationRequested((0, $85bfce414eef38c7$export$250171a898bf7ef)));
    const onChangeOwnerFactory = (0, $LFmXM.default)((onOperationRequested)=>()=>// @ts-expect-error - TS2554 - Expected 2 arguments, but got 1.
            onOperationRequested((0, $85bfce414eef38c7$export$39d2a7fb21967424)));
    const onDeleteFactory = (0, $LFmXM.default)((onOperationRequested)=>()=>// @ts-expect-error - TS2554 - Expected 2 arguments, but got 1.
            onOperationRequested((0, $85bfce414eef38c7$export$4bd2facc4a3e6aa1)));
    return (state, ownProps)=>({
            onCopy: onCopyFactory(ownProps.onOperationRequested),
            onEdit: onEditFactory(ownProps.onOperationRequested),
            onChangeOwner: onChangeOwnerFactory(ownProps.onOperationRequested),
            onDelete: onDeleteFactory(ownProps.onOperationRequested),
            manageSubscriptionsUrl: (0, $iYaR3.manageSubscriptionsUrl)(state, ownProps.id),
            name: (0, $iYaR3.getName)(state, ownProps.id),
            owner: (0, $iYaR3.getOwner)(state, ownProps.id),
            atlassianAccountId: (0, $7MYNw.getAtlassianAccountId)(state),
            showSpinner: ownProps.isOperationInProgress,
            isCopyFilterModalOpen: (0, $a7fcJ.isCopyFilterModalOpen)(state),
            isWritable: (0, $iYaR3.getIsWritable)(state, ownProps.id),
            isAdmin: (0, $7MYNw.getIsAdmin)(state),
            filterId: ownProps.id
        });
};
const $62a99b38228c8f8f$var$mapDispatchToProps = {
    onOpenCopyFilterModal: (0, $dH9V1.openCopyFilterModal)
};
var $62a99b38228c8f8f$export$2e2bcd8739ae039 = (0, $gnQAk.connect)($62a99b38228c8f8f$var$mapStateToPropsFactory, $62a99b38228c8f8f$var$mapDispatchToProps)((0, $g2Aua.default));

});
parcelRegister("a7fcJ", function(module, exports) {

$parcel$export(module.exports, "isCopyFilterModalOpen", () => $3d886112b86af646$export$d4543442696c05ca);
const $3d886112b86af646$export$d4543442696c05ca = (state)=>state.copyFilterModal.isCopyFilterModalOpen;

});

parcelRegister("g2Aua", function(module, exports) {

$parcel$export(module.exports, "default", () => $b9879cd5273d4736$export$2e2bcd8739ae039);
/* view-old.tsx generated by @compiled/babel-plugin v0.36.1 */ // delete this entire file when cleaning up isVisualRefreshEnabled() FG

var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $eq3Hf = parcelRequire("eq3Hf");

var $12DRg = parcelRequire("12DRg");

var $Ay1uj = parcelRequire("Ay1uj");

var $7rjYb = parcelRequire("7rjYb");
var $jYYbf = parcelRequire("jYYbf");
var $aLJ1L = parcelRequire("aLJ1L");

var $aMdh8 = parcelRequire("aMdh8");

var $l5htz = parcelRequire("l5htz");

var $aBFKZ = parcelRequire("aBFKZ");

var $6YFG2 = parcelRequire("6YFG2");

var $7jTnu = parcelRequire("7jTnu");

var $4aSRi = parcelRequire("4aSRi");

var $jd93d = parcelRequire("jd93d");

var $2FtDS = parcelRequire("2FtDS");

var $7kML2 = parcelRequire("7kML2");
const $b9879cd5273d4736$var$styles = {
    container: "_1e0c1txw _1bahesu3 _ca0q1b66 _u5f3v77o _n3tdze3t _19bvze3t",
    spinnerContainer: "_4t3i7vkz _1bsb1tcg"
};
const $b9879cd5273d4736$var$DropdownMenuWithAnalytics = (0, $aBFKZ.default)('dropdownMenu', {
    onOpenChange: 'open'
})((0, $7rjYb.default));
const $b9879cd5273d4736$var$DropdownItemWithAnalytics = (0, $aBFKZ.default)('dropdownItem', {
    onClick: 'clicked'
})((0, $jYYbf.default)); // eslint-disable-next-line jira/react/no-class-components
class $b9879cd5273d4736$var$ActionsOld extends (0, $eJOHy.Component) {
    static{
        this.defaultProps = {
            isWritable: false,
            defaultOpen: false,
            showSpinner: false,
            manageSubscriptionsUrl: '',
            name: undefined,
            owner: null,
            filterId: '',
            onCopy: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
            onChangeOwner: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
            onEdit: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
            onDelete: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
            setReturnFocusTo: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg)))
        };
    }
    componentDidUpdate(prevProps) {
        if (prevProps.isCopyFilterModalOpen && this.state.isCopyFilterModalOpen && !this.props.isCopyFilterModalOpen) this.setState({
            isCopyFilterModalOpen: false
        }, ()=>{
            if (this.triggerButtonRef && this.triggerButtonRef.current) this.triggerButtonRef.current.focus();
        });
    }
    delayedClose() {
        setTimeout(()=>this.setState(()=>({
                    isOpen: false
                })));
    }
    render() {
        const { showSpinner: showSpinner, intl: { formatMessage: formatMessage }, manageSubscriptionsUrl: manageSubscriptionsUrl, atlassianAccountId: atlassianAccountId, name: name, owner: owner, isWritable: isWritable, isAdmin: isAdmin, filterId: filterId } = this.props;
        const isOwner = owner && owner.accountId === atlassianAccountId;
        const { isOpen: isOpen } = this.state; // @ts-expect-error - TS7031 - Binding element 'triggerRef' implicitly has an 'any' type.
        const triggerFunction = ({ triggerRef: triggerRef, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $Ay1uj.default), {
                ...props,
                appearance: "subtle",
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($aMdh8))),
                ref: (0, $jd93d.mergeRefs)(triggerRef, this.triggerButtonRef),
                isLoading: showSpinner,
                label: name ? formatMessage((0, $2FtDS.default).tooltipWithName, {
                    name: name
                }) : formatMessage((0, $2FtDS.default).tooltip)
            });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
            className: (0, $hcewu.default)([
                $b9879cd5273d4736$var$styles.container
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($b9879cd5273d4736$var$DropdownMenuWithAnalytics // @ts-expect-error - Type '{ children: Element; position: string; isOpen: boolean; onOpenChange: ({ isOpen }: { isOpen: any; }) => void; trigger: ({ triggerRef, ...props }: { [x: string]: any; triggerRef: any; }) => Element; }' is not assignable to type 'IntrinsicAttributes & Omit<{ appearance?: "default" | "tall" | undefined; autoFocus?: boolean | undefined; children?: ReactNode; isLoading?: boolean | undefined; ... 11 more ...; label?: string | undefined; }, keyof WithAnalyticsEventsProps>'.
        , {
            position: "bottom right",
            isOpen: isOpen,
            onOpenChange: this.onOpenChange,
            trigger: triggerFunction,
            shouldRenderToParent: true
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aLJ1L.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($b9879cd5273d4736$var$DropdownItemWithAnalytics, {
            href: manageSubscriptionsUrl,
            onClick: this.onManageSubscriptionsClick
        }, formatMessage((0, $2FtDS.default).manageAction)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($b9879cd5273d4736$var$DropdownItemWithAnalytics, {
            onClick: this.onCopyFilterClick
        }, formatMessage((0, $2FtDS.default).copyAction)), (isWritable || isOwner === true) && ((0, $7jTnu.fg)('nin-save-filter-dialog-entry-point') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7kML2.UpdateFilterModal), {
            filterId: filterId,
            returnFocusRef: this.triggerButtonRef
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($b9879cd5273d4736$var$DropdownItemWithAnalytics, {
            onClick: this.onEditFilterClick
        }, formatMessage((0, $2FtDS.default).editFilter))), (isOwner === true || isAdmin === true) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($b9879cd5273d4736$var$DropdownItemWithAnalytics, {
            onClick: this.onChangeOwnerFilterClick
        }, formatMessage((0, $2FtDS.default).changeOwner)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($b9879cd5273d4736$var$DropdownItemWithAnalytics, {
            onClick: this.onDeleteFilterClick
        }, formatMessage((0, $2FtDS.default).deleteFilter))))));
    }
    constructor(...args){
        super(...args), this.state = {
            isOpen: this.props.defaultOpen,
            isCopyFilterModalOpen: false
        }, this.triggerButtonRef = /*#__PURE__*/ (0, $eJOHy.createRef)() // @ts-expect-error - TS7031 - Binding element 'isOpen' implicitly has an 'any' type.
        , this.onOpenChange = ({ isOpen: isOpen })=>{
            this.setState(()=>({
                    isOpen: isOpen
                }));
        } // eslint-disable-next-line @typescript-eslint/no-explicit-any
        , this.onCopyFilterClick = (e, analytics)=>{
            this.props.onCopyFilterClick(analytics);
            this.props.onCopy();
            this.props.onOpenCopyFilterModal();
            this.setState(()=>({
                    isCopyFilterModalOpen: true
                }));
        } // eslint-disable-next-line @typescript-eslint/no-explicit-any
        , this.onManageSubscriptionsClick = (e, analytics)=>{
            this.props.onManageSubscriptionsClick(analytics);
            this.delayedClose();
        } // eslint-disable-next-line @typescript-eslint/no-explicit-any
        , this.onEditFilterClick = (e, analytics)=>{
            this.props.onEditFilterClick(analytics);
            this.props.onEdit();
            this.triggerButtonRef.current && this.props.setReturnFocusTo(this.triggerButtonRef);
        } // eslint-disable-next-line @typescript-eslint/no-explicit-any
        , this.onChangeOwnerFilterClick = (e, analytics)=>{
            this.props.onChangeOwnerFilterClick(analytics);
            this.props.onChangeOwner();
            if ((0, $7jTnu.fg)('jfp_a11y_fix_filters_change_owner_modal_focus')) this.triggerButtonRef.current && this.props.setReturnFocusTo(this.triggerButtonRef);
        } // eslint-disable-next-line @typescript-eslint/no-explicit-any
        , this.onDeleteFilterClick = (e, analytics)=>{
            this.props.onDeleteFilterClick(analytics);
            this.props.onDelete();
            this.triggerButtonRef.current && this.props.setReturnFocusTo(this.triggerButtonRef);
        } /**
      * Close the menu with a minimal delay so the inner handlers are able to react on keypress properly.
      * In its current implementation if we close the menu right away it won't open the focused `href`.
      * Ideally we have to get right of this and few more methods when the bug linked below is fixed.
      * @see https://ecosystem.atlassian.net/browse/AK-4467
      */ ;
    }
}
const $b9879cd5273d4736$var$ActionsWithReturnToFocus = (props)=>{
    const { setReturnFocusTo: setReturnFocusTo } = (0, $4aSRi.useModalDialogActions)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($b9879cd5273d4736$var$ActionsOld, {
        ...props,
        setReturnFocusTo: setReturnFocusTo
    });
};
var $b9879cd5273d4736$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($eq3Hf)))((0, $6YFG2.default), (0, $l5htz.default)({
    onManageSubscriptionsClick: 'manageSubscriptions',
    onCopyFilterClick: 'copy',
    onChangeOwnerFilterClick: 'changeOwner',
    onEditFilterClick: 'edit',
    onDeleteFilterClick: 'delete'
}))($b9879cd5273d4736$var$ActionsWithReturnToFocus);

});
parcelRegister("4aSRi", function(module, exports) {

$parcel$export(module.exports, "useModalDialogActions", () => $0b2a666031d89d51$export$3cf2e4b6d3541465);
$parcel$export(module.exports, "useReturnFocusTo", () => $0b2a666031d89d51$export$217308a4ece853b2);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $iJq0l = parcelRequire("iJq0l");
var $GtRbT = parcelRequire("GtRbT");

var $gnlW1 = parcelRequire("gnlW1");

var $4CmBA = parcelRequire("4CmBA");

var $ik5fE = parcelRequire("ik5fE");
const $0b2a666031d89d51$var$Store = (0, $GtRbT.createStore)({
    name: 'JiraSoftwareModalDialog',
    initialState: $gnlW1.initialState,
    actions: $4CmBA.actions
});
const $0b2a666031d89d51$export$3cf2e4b6d3541465 = (0, $iJq0l.createActionsHook)($0b2a666031d89d51$var$Store);
const $0b2a666031d89d51$export$217308a4ece853b2 = (0, $iJq0l.createStateHook)($0b2a666031d89d51$var$Store, {
    selector: (0, $ik5fE.getReturnFocusTo)
});

});
parcelRegister("gnlW1", function(module, exports) {

$parcel$export(module.exports, "initialState", () => $155a858c98d12eaf$export$d4c72bab9d6cc13a);
const $155a858c98d12eaf$export$d4c72bab9d6cc13a = {
    returnFocusTo: null
};

});

parcelRegister("4CmBA", function(module, exports) {

$parcel$export(module.exports, "actions", () => $d6a92026239e37f0$export$e324594224ef24da);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $d6a92026239e37f0$export$b263d1e638b131c2 = (returnFocusTo)=>({ setState: setState })=>{
        setState({
            returnFocusTo: returnFocusTo
        });
    };
const $d6a92026239e37f0$export$e324594224ef24da = {
    setReturnFocusTo: $d6a92026239e37f0$export$b263d1e638b131c2
};

});

parcelRegister("ik5fE", function(module, exports) {

$parcel$export(module.exports, "getReturnFocusTo", () => $c992da1452d2469a$export$d5f8692765ccd209);
const $c992da1452d2469a$export$d5f8692765ccd209 = (state)=>state.returnFocusTo;

});


parcelRegister("2FtDS", function(module, exports) {

$parcel$export(module.exports, "default", () => $579f63be888b85b2$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $579f63be888b85b2$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    copyAction: {
        "id": "directories.filters-v2.main.content.cells.actions.copy-action",
        "defaultMessage": "Copy filter"
    },
    editFilter: {
        "id": "directories.filters-v2.main.content.cells.actions.edit-filter",
        "defaultMessage": "Edit"
    },
    changeOwner: {
        "id": "directories.filters-v2.main.content.cells.actions.change-owner",
        "defaultMessage": "Change owner"
    },
    deleteFilter: {
        "id": "directories.filters-v2.main.content.cells.actions.delete-filter",
        "defaultMessage": "Delete"
    },
    manageAction: {
        "id": "directories.filters-v2.main.content.cells.actions.manage-action",
        "defaultMessage": "Manage subscriptions"
    },
    tooltip: {
        "id": "directories.filters-v2.main.content.cells.actions.tooltip",
        "defaultMessage": "More"
    },
    tooltipWithName: {
        "id": "directories.filters-v2.main.content.cells.actions.tooltip-with-name",
        "defaultMessage": "More actions for {name}"
    },
    moreActionsTooltip: {
        "id": "directories.filters-v2.main.content.cells.actions.more-actions-tooltip",
        "defaultMessage": "More actions"
    }
});

});

parcelRegister("7kML2", function(module, exports) {

$parcel$export(module.exports, "UpdateFilterModal", () => $e590afe3bb62dd7b$export$bbd0622e137bea39);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $lRq8t = parcelRequire("lRq8t");

var $dMOn8 = parcelRequire("dMOn8");

var $4NoAT = parcelRequire("4NoAT");

var $kEUB1 = parcelRequire("kEUB1");

var $4ihOZ = parcelRequire("4ihOZ");

var $5cBQu = parcelRequire("5cBQu");


var $91zZ6 = parcelRequire("91zZ6");

var $gCeeo = parcelRequire("gCeeo");
var $ftN6c = parcelRequire("ftN6c");

var $d1S9l = parcelRequire("d1S9l");

var $2FtDS = parcelRequire("2FtDS");
const $e590afe3bb62dd7b$export$bbd0622e137bea39 = ({ filterId: filterId, returnFocusRef: returnFocusRef })=>{
    const cloudId = (0, $kEUB1.useCloudId)();
    const activationId = (0, $4ihOZ.useActivationId)();
    const dispatch = (0, $91zZ6.useDirectoryDispatch)();
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const entryPointProps = (0, $eJOHy.useMemo)(()=>({
            filterId: filterId,
            onDialogShown: ()=>{
                dispatch((0, $5cBQu.initiate)({
                    id: filterId,
                    operation: (0, $85bfce414eef38c7$export$250171a898bf7ef),
                    childEntityId: undefined
                }));
                dispatch((0, $5cBQu.dialogShown)({
                    id: filterId,
                    operation: (0, $85bfce414eef38c7$export$250171a898bf7ef),
                    childEntityId: undefined
                }));
            },
            onSuccess: ()=>dispatch((0, $5cBQu.entityUpdated)({
                    id: filterId,
                    operation: (0, $85bfce414eef38c7$export$250171a898bf7ef)
                })),
            onClose: ()=>{
                dispatch((0, $5cBQu.cancelled)({
                    id: filterId,
                    operation: (0, $85bfce414eef38c7$export$250171a898bf7ef)
                }));
                requestAnimationFrame(()=>{
                    returnFocusRef.current?.focus();
                });
            }
        }), [
        filterId,
        dispatch,
        returnFocusRef
    ]);
    const entryPointParams = (0, $eJOHy.useMemo)(()=>({
            filterAri: (0, $4NoAT.JiraFilterAri).create({
                activationId: activationId,
                siteId: cloudId,
                filterId: filterId
            }).toString()
        }), [
        filterId,
        cloudId,
        activationId
    ]);
    const onClick = (0, $eJOHy.useCallback)(()=>(0, $gCeeo.fireUIAnalytics)(createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'dropdownItem'
        }), 'editDropdownItem'), [
        createAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $d1S9l.ModalEntryPointDropdownItemTrigger), {
        modalProps: {
            width: 'medium',
            shouldScrollInViewport: true,
            shouldReturnFocus: false
        },
        entryPoint: (0, $dMOn8.updateFilterDialogEntryPoint),
        entryPointProps: entryPointProps,
        entryPointParams: entryPointParams,
        interactionName: "jiraSaveFilterDialog.UpdateFilterDetails",
        onClick: onClick,
        useInternalModal: true
    }, formatMessage((0, $2FtDS.default).editFilter));
};

});



parcelRegister("ansmd", function(module, exports) {

$parcel$export(module.exports, "default", () => $558453bf2c0b7c8e$export$2e2bcd8739ae039);

var $jdOqs = parcelRequire("jdOqs");

var $gnQAk = parcelRequire("gnQAk");

var $iYaR3 = parcelRequire("iYaR3");
const $558453bf2c0b7c8e$var$mapStateToProps = (state, ownProps)=>({
        shares: (0, $iYaR3.getEdits)(state, ownProps.id)
    });
var $558453bf2c0b7c8e$export$2e2bcd8739ae039 = (0, $gnQAk.connect)($558453bf2c0b7c8e$var$mapStateToProps, // We attempted to fix the below FixFlowMe but ran into issue with cross package dependencies which we do not want
// to introduce. We believe the unused fields in Props causes the below issue.
{})((0, $jdOqs.default));

});
parcelRegister("jdOqs", function(module, exports) {

$parcel$export(module.exports, "default", () => $ce93edf6e82d029b$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $5DgXR = parcelRequire("5DgXR");

var $7icpf = parcelRequire("7icpf");

var $rZPcB = parcelRequire("rZPcB");

var $lG2jM = parcelRequire("lG2jM");

var $amvLf = parcelRequire("amvLf");

var $idGBm = parcelRequire("idGBm");


var $5GvLH = parcelRequire("5GvLH");
const $ce93edf6e82d029b$var$assertUnreachable = (_x)=>{
    throw new Error("Didn't expect to get here");
};
class $ce93edf6e82d029b$export$3026e5a52c747d2c extends (0, $eJOHy.Component) {
    static{
        // go/jfe-eslint
        // eslint-disable-next-line react/sort-comp
        this.defaultProps = {
            shares: []
        };
    }
    static renderAvatar(text, avatarUrl, idx, appearance) {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($ce93edf6e82d029b$var$Container, {
            key: idx
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($ce93edf6e82d029b$var$AvatarContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5DgXR.default), {
            size: "small",
            src: avatarUrl,
            appearance: appearance
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($ce93edf6e82d029b$var$TextContainer, null, text));
    }
    static renderIcon(text, IconComponent, idx = 1) {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($ce93edf6e82d029b$var$Container, {
            key: idx
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($ce93edf6e82d029b$var$IconContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(IconComponent, {
            label: "",
            spacing: "spacious"
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($ce93edf6e82d029b$var$TextContainer, null, text));
    }
    render() {
        const { shares: shares, intl: { formatMessage: formatMessage } } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($ce93edf6e82d029b$var$CellContainer, null, shares.length > 0 ? shares.map((share, idx)=>{
            switch(share.type){
                case 0, $f461f432d18e9f64$export$b0a0e62d9b1a8269:
                    return $ce93edf6e82d029b$export$3026e5a52c747d2c.renderIcon(formatMessage((0, $5GvLH.default).myOrganizationAccess), (0, (/*@__PURE__*/$parcel$interopDefault($rZPcB))), idx);
                case 0, $f461f432d18e9f64$export$86517eb0163ef745:
                    return $ce93edf6e82d029b$export$3026e5a52c747d2c.renderIcon(formatMessage((0, $5GvLH.default).publicAccess), (0, (/*@__PURE__*/$parcel$interopDefault($amvLf))), idx);
                case 0, $f461f432d18e9f64$export$b02d7412182d1bce:
                    // @ts-expect-error - TS2345 - Type 'undefined' is not assignable to type 'string'
                    return $ce93edf6e82d029b$export$3026e5a52c747d2c.renderIcon(share.group.name, (0, (/*@__PURE__*/$parcel$interopDefault($lG2jM))), idx);
                case 0, $f461f432d18e9f64$export$aea0835048e1c730:
                    return $ce93edf6e82d029b$export$3026e5a52c747d2c.renderAvatar(share.user.displayName, share.user.avatarUrl, idx, 'circle');
                case 0, $f461f432d18e9f64$export$5ef95a67b8fd1ff6:
                    {
                        const roleName = share.role ? share.role.name : formatMessage((0, $5GvLH.default).allProjectRoles);
                        const text = `${share.project.name}, ${roleName}`;
                        return $ce93edf6e82d029b$export$3026e5a52c747d2c.renderAvatar(text, share.project.avatarUrl, idx, 'square');
                    }
                case 0, $f461f432d18e9f64$export$487da0972e3459fe:
                    return null;
                // hide from the list
                default:
                    $ce93edf6e82d029b$var$assertUnreachable(share);
                    return null;
            }
        }) : $ce93edf6e82d029b$export$3026e5a52c747d2c.renderIcon(formatMessage((0, $5GvLH.default).privateAccess), (0, (/*@__PURE__*/$parcel$interopDefault($7icpf)))));
    }
}
var $ce93edf6e82d029b$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = (0, $idGBm.injectIntlV2)($ce93edf6e82d029b$export$3026e5a52c747d2c);
const $ce93edf6e82d029b$var$Container = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1txw _4cvr1h6o _n3td1b66",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $ce93edf6e82d029b$var$AvatarContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_u5f3u2gc _vwz4kb7n _1o9zidpf",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $ce93edf6e82d029b$var$IconContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_ca0qv77o _u5f3utpp _n3tdv77o _19bvv77o _vwz4kb7n _1o9zidpf",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $ce93edf6e82d029b$var$TextContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1reo15vq _18m915vq _slp31hna _16jlkb7n",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $ce93edf6e82d029b$var$CellContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_ca0q12x7 _1e0c1txw _2lx21bp4",
            __cmplp.className
        ])
    });
});

});
parcelRegister("5GvLH", function(module, exports) {

$parcel$export(module.exports, "default", () => $7680afc0f5076786$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $7680afc0f5076786$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    myOrganizationAccess: {
        "id": "directories.common.components.access-cell.my-organization-access",
        "defaultMessage": "My organization"
    },
    publicAccess: {
        "id": "directories.common.components.access-cell.public-access",
        "defaultMessage": "Public"
    },
    privateAccess: {
        "id": "directories.common.components.access-cell.private-access",
        "defaultMessage": "Private"
    },
    allProjectRoles: {
        "id": "directories.common.components.access-cell.all-project-roles",
        "defaultMessage": "All roles"
    }
});

});



parcelRegister("5WDV3", function(module, exports) {

$parcel$export(module.exports, "default", () => $7aafb477751a0225$export$2e2bcd8739ae039);

var $eq3Hf = parcelRequire("eq3Hf");

var $12DRg = parcelRequire("12DRg");

var $LFmXM = parcelRequire("LFmXM");

var $BwaQq = parcelRequire("BwaQq");

var $k0CKR = parcelRequire("k0CKR");

var $gnQAk = parcelRequire("gnQAk");

var $iYaR3 = parcelRequire("iYaR3");
const $7aafb477751a0225$var$mapStateToPropsFactory = ()=>{
    const onClickFactory = (0, $LFmXM.default)((state, id)=>(analyticsEvent)=>{
            const changeFavorite = (0, $iYaR3.getChangeFavorite)(state);
            return changeFavorite ? changeFavorite({
                id: id,
                type: 'filters',
                value: !(0, $iYaR3.isFavorite)(state, id)
            }, analyticsEvent) : (0, (/*@__PURE__*/$parcel$interopDefault($12DRg)));
        });
    return (state, ownProps)=>({
            isFavorite: (0, $iYaR3.isFavorite)(state, ownProps.id),
            favoriteItemName: (0, $iYaR3.getName)(state, ownProps.id),
            id: ownProps.id,
            onClick: onClickFactory(state, ownProps.id),
            pending: (0, $iYaR3.isPending)(state, ownProps.id),
            isShownInList: true
        });
};
var $7aafb477751a0225$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($eq3Hf)))((0, $BwaQq.AnalyticsSubject)('filter'), // @ts-expect-error - TS2589 - Type instantiation is excessively deep and possibly infinite.
(0, $gnQAk.connect)($7aafb477751a0225$var$mapStateToPropsFactory, {}))((0, $k0CKR.FavoriteCellView));

});
parcelRegister("k0CKR", function(module, exports) {

$parcel$export(module.exports, "FavoriteCellView", () => $c36e74a942f9c7e3$export$7e4dcb8ef4c4afcd);
/* view.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $fVPN0 = parcelRequire("fVPN0");

var $6XJko = parcelRequire("6XJko");
const $c36e74a942f9c7e3$var$styles = {
    root: "_1e0c1txw _1bah1h6o _ca0q1b66 _u5f31b66 _n3td1b66 _19bv1b66"
};
function $c36e74a942f9c7e3$export$7e4dcb8ef4c4afcd(props) {
    return (0, $6XJko.isVisualRefreshEnabled)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $c36e74a942f9c7e3$var$rootStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fVPN0.default), props)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
        className: (0, $hcewu.default)([
            $c36e74a942f9c7e3$var$styles.root
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fVPN0.default), props));
}
$c36e74a942f9c7e3$export$7e4dcb8ef4c4afcd.defaultProps = {
    isFavorite: undefined
};
const $c36e74a942f9c7e3$var$rootStyles = (0, $1DXK0.xcss)({
    display: 'flex',
    justifyContent: 'center',
    paddingInline: 'space.050',
    paddingBlock: 'space.100',
    alignItems: 'center',
    height: '40px',
    width: '32px'
});

});
parcelRegister("fVPN0", function(module, exports) {

$parcel$export(module.exports, "FavoriteButtonWrapper", () => $c7558d16e1b4ddea$export$bb1478fee6cd5f0c);
$parcel$export(module.exports, "default", () => $c7558d16e1b4ddea$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $eq3Hf = parcelRequire("eq3Hf");

var $12DRg = parcelRequire("12DRg");

var $goZPP = parcelRequire("goZPP");

var $gGgaG = parcelRequire("gGgaG");

var $aaIe7 = parcelRequire("aaIe7");

var $2Cx9n = parcelRequire("2Cx9n");

var $91hUW = parcelRequire("91hUW");

var $dLR8J = parcelRequire("dLR8J");

var $k71qx = parcelRequire("k71qx");

var $l5htz = parcelRequire("l5htz");

var $f2JN3 = parcelRequire("f2JN3");

var $idGBm = parcelRequire("idGBm");

var $6XJko = parcelRequire("6XJko");

var $6urTU = parcelRequire("6urTU");
const $c7558d16e1b4ddea$var$SKELETON_TEST_ID = 'favouriting.favorite-button-stateless.skeleton';
const $c7558d16e1b4ddea$var$ICON_WRAPPER_TEST_ID_PREFIX = 'favouriting.favorite-button-stateless.icon-wrapper'; // eslint-disable-next-line jira/react/no-class-components
class $c7558d16e1b4ddea$export$f8ad2acf0ec4860f extends (0, $eJOHy.Component) {
    static{
        this.defaultProps = {
            isFavorite: undefined,
            favoriteItemName: undefined,
            isShownInList: false,
            isSmall: false,
            hideTooltip: false,
            onClick: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
            tooltipPosition: 'bottom',
            skipAnimation: false
        };
    }
    componentDidUpdate(prevProps) {
        if (!this.props.skipAnimation && (!prevProps.pending && this.props.pending || !prevProps.isFavorite && this.props.isFavorite)) {
            this.onAnimationStart();
            this.onSettingAnimationEnd();
        }
    }
    onAnimationStart() {
        this.setState({
            isAnimating: !this.state.isAnimating
        });
    }
    onSettingAnimationEnd() {
        setTimeout(()=>{
            this.setState({
                isAnimating: false
            });
        }, $c7558d16e1b4ddea$var$animationTime * 2);
    }
    render() {
        const { isFavorite: isFavorite, favoriteItemName: favoriteItemName, isShownInList: isShownInList, isSmall: isSmall, hideTooltip: hideTooltip, tooltipPosition: tooltipPosition, pending: pending, intl: { formatMessage: formatMessage } } = this.props;
        const { isAnimating: isAnimating } = this.state;
        if (isFavorite === undefined) // show skeleton as a space placeholder (to avoid layout recalculations in browser and visible "jump" when we got data)
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dLR8J.default), {
            name: "favourite-button"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($c7558d16e1b4ddea$export$db65185b5889c83, {
            "data-testid": $c7558d16e1b4ddea$var$SKELETON_TEST_ID,
            isSmall: isSmall
        }));
        const iconWrapperTestId = isShownInList ? `${$c7558d16e1b4ddea$var$ICON_WRAPPER_TEST_ID_PREFIX}-list` : $c7558d16e1b4ddea$var$ICON_WRAPPER_TEST_ID_PREFIX;
        const buttonContentOld = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($c7558d16e1b4ddea$var$FavIconWrapper, {
            isFavorite: isFavorite,
            isAnimating: isAnimating,
            "data-testid": iconWrapperTestId,
            isSmall: isSmall
        }, isFavorite ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gGgaG))), {
            LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($91hUW))),
            LEGACY_size: isSmall ? 'small' : undefined,
            color: "currentColor",
            label: formatMessage((0, $6urTU.default).removeFromStarred)
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($aaIe7))), {
            LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($2Cx9n))),
            LEGACY_size: isSmall ? 'small' : undefined,
            color: "currentColor",
            label: formatMessage((0, $6urTU.default).addToStarred)
        }));
        const renderIcon = ()=>{
            const label = isFavorite ? formatMessage((0, $6urTU.default).removeFromStarred) : formatMessage((0, $6urTU.default).addToStarred);
            const StarIconComponent = isFavorite ? (0, (/*@__PURE__*/$parcel$interopDefault($gGgaG))) : (0, (/*@__PURE__*/$parcel$interopDefault($aaIe7)));
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(StarIconComponent, {
                color: "currentColor",
                label: label,
                size: isSmall ? 'small' : 'medium'
            });
        };
        const buttonContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($c7558d16e1b4ddea$var$FavIconWrapper, {
            isFavorite: isFavorite,
            isAnimating: isAnimating,
            "data-testid": iconWrapperTestId,
            isSmall: isSmall
        }, renderIcon());
        const tooltipContent = isFavorite ? formatMessage((0, $6urTU.default).removeFromStarred) : formatMessage((0, $6urTU.default).addToStarred);
        const ariaLabel = favoriteItemName ? formatMessage((0, $6urTU.default).toggleStarredWithItemName, {
            itemName: favoriteItemName
        }) : formatMessage((0, $6urTU.default).toggleStarred);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($c7558d16e1b4ddea$export$bb1478fee6cd5f0c, {
            role: "presentation",
            onClick: this.onBtnClickWrapper,
            onKeyPress: this.onBtnClickWrapper,
            "data-is-favorite": isFavorite
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $k71qx.default), {
            content: !hideTooltip && tooltipContent,
            hideTooltipOnClick: true,
            position: tooltipPosition
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
            appearance: isShownInList ? 'subtle-link' : 'subtle',
            spacing: "none",
            "aria-label": ariaLabel,
            "aria-pressed": isFavorite,
            onClick: !pending ? this.onClick : (0, (/*@__PURE__*/$parcel$interopDefault($12DRg)))
        }, (0, $6XJko.isVisualRefreshEnabled)() ? buttonContent : buttonContentOld)));
    }
    constructor(...args){
        super(...args), this.state = {
            isAnimating: false
        }, this.onBtnClickWrapper = (e)=>{
            e.stopPropagation(); // should not let this event get outside of the component, to prevent issue when, for example, star button is clicked in an item or row, which goes somewhere else on onClick handler. Cannot put it in onBtnClick, otherwise hideTooltipOnClick in <Tooltip> will not work
            e.preventDefault(); // same for cases when btn is inside a link - not to go to that link (e.g. in Star Drawer)
        }, this.onClick = (_, analyticsEvent)=>{
            this.props.onClick(analyticsEvent);
        };
    }
}
var $c7558d16e1b4ddea$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($eq3Hf)))((0, $l5htz.default)({
    onClick: ()=>({
            name: 'star'
        })
}), (0, $idGBm.injectIntlV2))($c7558d16e1b4ddea$export$f8ad2acf0ec4860f);
const $c7558d16e1b4ddea$var$animationTime = 500; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $c7558d16e1b4ddea$export$bb1478fee6cd5f0c = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1o8l",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $c7558d16e1b4ddea$var$FavoriteIconWrapperBaseOld = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isSmall: isSmall, isAnimating: isAnimating, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1txw _4cvr1h6o _1bah1h6o",
            __cmplp.isSmall ? "_1bsb1tcg" : "_1bsbzwfg",
            __cmplp.isSmall ? "_4t3i1tcg" : "_4t3izwfg",
            __cmplp.isAnimating && "_11vn1twn _1px1fmmq _48hmq7pw _1uvf1e03",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $c7558d16e1b4ddea$var$FavoriteIconWrapperBaseNew = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isSmall: isSmall, isAnimating: isAnimating, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1txw _4cvr1h6o _1bah1h6o",
            __cmplp.isSmall ? "_1bsb1tcg" : "_1bsbzwfg",
            __cmplp.isSmall ? "_4t3i1tcg" : "_4t3izwfg",
            __cmplp.isAnimating && "_1px1fmmq _48hmq7pw _1uvf1e03",
            __cmplp.className
        ])
    });
});
const $c7558d16e1b4ddea$var$FavoriteIconWrapperBase = (0, $f2JN3.componentWithCondition)((0, $6XJko.isVisualRefreshEnabled), $c7558d16e1b4ddea$var$FavoriteIconWrapperBaseNew, $c7558d16e1b4ddea$var$FavoriteIconWrapperBaseOld); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $c7558d16e1b4ddea$var$FavIconWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = $c7558d16e1b4ddea$var$FavoriteIconWrapperBase, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "",
            __cmplp.isFavorite ? "_syaz1oqg" : "_syaz1oju",
            __cmplp.isFavorite ? "_30l31vop" : "_30l3wdcn",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $c7558d16e1b4ddea$export$db65185b5889c83 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isSmall: isSmall, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1txw",
            __cmplp.isSmall ? "_1bsb1tcg" : "_1bsbzwfg",
            __cmplp.isSmall ? "_4t3i1tcg" : "_4t3izwfg",
            __cmplp.className
        ])
    });
});

});
parcelRegister("2Cx9n", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1e88d859d9ad0102$var$_react = $1e88d859d9ad0102$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $fL0In = parcelRequire("fL0In");
function $1e88d859d9ad0102$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $1e88d859d9ad0102$var$StarIcon = (props)=>/*#__PURE__*/ $1e88d859d9ad0102$var$_react.default.createElement($fL0In.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="m12 16.373 3.98 2.193-.76-4.655 3.276-3.347-4.524-.69L12 5.687l-1.972 4.189-4.524.689L8.78 13.91l-.762 4.655zm0 2.283-3.016 1.662a2 2 0 0 1-2.939-2.075l.599-3.656-2.57-2.624a2 2 0 0 1 1.129-3.377l3.47-.528 1.518-3.224a2 2 0 0 1 3.618 0l1.519 3.224 3.47.528a2 2 0 0 1 1.127 3.377l-2.569 2.624.599 3.656a2 2 0 0 1-2.94 2.075z"/></svg>`
    }, props));
$1e88d859d9ad0102$var$StarIcon.displayName = 'StarIcon';
var $1e88d859d9ad0102$var$_default = module.exports.default = $1e88d859d9ad0102$var$StarIcon;

});

parcelRegister("6urTU", function(module, exports) {

$parcel$export(module.exports, "default", () => $708ae8e1a771b9ca$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $708ae8e1a771b9ca$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    addToStarred: {
        "id": "platform.ui.favouriting.favourite-button-stateless.add-to-starred",
        "defaultMessage": "Add to Starred"
    },
    removeFromStarred: {
        "id": "platform.ui.favouriting.favourite-button-stateless.remove-from-starred",
        "defaultMessage": "Remove from Starred"
    },
    toggleStarred: {
        "id": "platform.ui.favouriting.favourite-button-stateless.toggle-starred",
        "defaultMessage": "Star"
    },
    toggleStarredWithItemName: {
        "id": "platform.ui.favouriting.favourite-button-stateless.toggle-starred-with-item-name",
        "defaultMessage": "Star {itemName}"
    }
});

});




parcelRegister("lq3kr", function(module, exports) {

$parcel$export(module.exports, "default", () => $f0b99cf17767ce9d$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $rIjzv = parcelRequire("rIjzv");

var $gnQAk = parcelRequire("gnQAk");

var $iYaR3 = parcelRequire("iYaR3");
const $f0b99cf17767ce9d$var$mapStateToProps = (state, ownProps)=>({
        user: (0, $iYaR3.getOwner)(state, ownProps.id)
    });
const $f0b99cf17767ce9d$var$UserCell = (props)=>{
    const { user: user } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $rIjzv.default), {
        user: user
    });
};
$f0b99cf17767ce9d$var$UserCell.defaultProps = {
    onClick: null
};
var // @ts-expect-error - TS2345 - Argument of type '{ (props: UserCellProps): JSX.Element; defaultProps: { onClick: null; }; }' is not assignable to parameter of type 'Component<EntityCellProps & Props>'.
$f0b99cf17767ce9d$export$2e2bcd8739ae039 = (0, $gnQAk.connect)($f0b99cf17767ce9d$var$mapStateToProps, {})($f0b99cf17767ce9d$var$UserCell);

});
parcelRegister("rIjzv", function(module, exports) {

$parcel$export(module.exports, "default", () => $4786212b595d5412$export$2e2bcd8739ae039);

var $l5htz = parcelRequire("l5htz");

var $hJq8V = parcelRequire("hJq8V");
var $4786212b595d5412$export$2e2bcd8739ae039 = (0, $l5htz.default)({
    onClick: 'userProfile'
})((0, $hJq8V.default));

});
parcelRegister("hJq8V", function(module, exports) {

$parcel$export(module.exports, "default", () => $3a0cbec7d37711e3$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $3AXU8 = parcelRequire("3AXU8");

var $98kYt = parcelRequire("98kYt");
function $3a0cbec7d37711e3$export$2e2bcd8739ae039(props) {
    const { user: user, isDeleting: isDeleting } = props;
    if (!user) return null;
    const { accountId: accountId, displayName: displayName, avatarUrl: avatarUrl } = user;
    const content = /*#__PURE__*/ $eJOHy.createElement((0, $98kYt.default), {
        displayName: displayName,
        avatarUrl: avatarUrl,
        isDeleting: isDeleting
    });
    return /*#__PURE__*/ $eJOHy.createElement((0, $3AXU8.default), {
        accountId: accountId,
        prepopulatedData: {
            fullName: displayName
        }
    }, content);
}

});
parcelRegister("3AXU8", function(module, exports) {

$parcel$export(module.exports, "default", () => $1c1c7fb5d1ac654d$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");


const $1c1c7fb5d1ac654d$var$ConditionalProfileCard = (parcelRequire("gtXs1")).default;
function $1c1c7fb5d1ac654d$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($1c1c7fb5d1ac654d$var$ConditionalProfileCard, props);
}

});
parcelRegister("gtXs1", function(module, exports) {

module.exports = (parcelRequire("g81qY"))('empanada_profilecard_sync_trigger_import_final', function() {
    return parcelRequire('7xXvm');
}, function() {
    return parcelRequire('jQS3A');
});

});
parcelRegister("g81qY", function(module, exports) {
"use strict";
module.exports = function loadCond(cond, ifTrue, ifFalse, fallback) {
    let result = globalThis.__MCOND(cond);
    try {
        return result ? ifTrue() : ifFalse();
    } catch (err) {
        if (fallback) {
            console.error('Conditional dependency was not registered when executing. Falling back to synchronous bundle loading.');
            for (const url of fallback.urls)fallback.loader(url);
            return result ? ifTrue() : ifFalse();
        } else throw err;
    }
};

});



parcelRegister("98kYt", function(module, exports) {

$parcel$export(module.exports, "default", () => $b36214b33d25bdee$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $5DgXR = parcelRequire("5DgXR");

var $8nu6j = parcelRequire("8nu6j");
var $lmgo6 = parcelRequire("lmgo6");
var $3Wh6p = parcelRequire("3Wh6p");
var $1DXK0 = parcelRequire("1DXK0");

var $k71qx = parcelRequire("k71qx");

var $hdC3k = parcelRequire("hdC3k");

var $7jTnu = parcelRequire("7jTnu");

var $6XJko = parcelRequire("6XJko");

var $2wTQj = parcelRequire("2wTQj");
const $b36214b33d25bdee$var$styles = {
    avatarContainer: "_16jlidpf _1o9zidpf _i0dl1wug _u5f3u2gc _vwz4idpf",
    avatarContainerNew: "_4cvr1h6o",
    container: "_16jlkb7n _1o9zkb7n _i0dl1wug _ca0q12x7 _n3td12x7 _1e0c1txw",
    contentContainer: "_16jlkb7n _1o9zkb7n _i0dl1wug _1reo15vq _18m915vq _1e0c1txw _4cvr1h6o _1bsb1osq",
    contentContainerOld: "_16jlkb7n _1o9zkb7n _i0dl1wug _1e0c1txw _4cvr1h6o _1bsb1osq",
    accessibleContentContainer: "_16jlkb7n _1o9zkb7n _i0dl1wug _ca0qu2gc _n3tdu2gc _1e0c1txw _4cvr1h6o _1bsb1osq",
    link: "_1bsb1osq",
    textContainer: "_1reo15vq _18m915vq _slp31hna _o5721q9c _1bto1l2s"
};
function $b36214b33d25bdee$export$2e2bcd8739ae039(props) {
    const { avatarUrl: avatarUrl, displayName: displayName, href: href, appearance: appearance, isDeleting: isDeleting, onClick: onClick } = props;
    // To vertically align the avatar with the text and also change the height of the cell from 44px to 40px -  BLU-7380
    const applyVisualRefreshStyles = (0, $6XJko.isVisualRefreshEnabled)();
    const content = !href ? /*#__PURE__*/ $eJOHy.createElement((0, $lmgo6.default), {
        alignItems: applyVisualRefreshStyles ? 'center' : 'start',
        xcss: applyVisualRefreshStyles ? $b36214b33d25bdee$var$contentWrapperStyles : $b36214b33d25bdee$var$contentWrapperStylesOld
    }, /*#__PURE__*/ $eJOHy.createElement("div", {
        className: (0, $hcewu.default)([
            $b36214b33d25bdee$var$styles.avatarContainer,
            applyVisualRefreshStyles && $b36214b33d25bdee$var$styles.avatarContainerNew
        ])
    }, /*#__PURE__*/ $eJOHy.createElement((0, $5DgXR.default), {
        src: avatarUrl,
        size: "small",
        appearance: appearance
    })), /*#__PURE__*/ $eJOHy.createElement((0, $3Wh6p.default), {
        xcss: !applyVisualRefreshStyles ? $b36214b33d25bdee$var$inlineTextStyles : undefined
    }, isDeleting && (0, $7jTnu.fg)('hix-6302_project_delete_improvements') ? /*#__PURE__*/ $eJOHy.createElement((0, $2wTQj.default), null, displayName) : displayName)) : /*#__PURE__*/ $eJOHy.createElement($b36214b33d25bdee$var$Content, null, /*#__PURE__*/ $eJOHy.createElement("div", {
        className: (0, $hcewu.default)([
            $b36214b33d25bdee$var$styles.avatarContainer,
            applyVisualRefreshStyles && $b36214b33d25bdee$var$styles.avatarContainerNew
        ])
    }, /*#__PURE__*/ $eJOHy.createElement((0, $5DgXR.default), {
        src: avatarUrl,
        size: "small",
        appearance: appearance
    })), /*#__PURE__*/ $eJOHy.createElement("div", {
        className: (0, $hcewu.default)([
            $b36214b33d25bdee$var$styles.textContainer
        ])
    }, isDeleting && (0, $7jTnu.fg)('hix-6302_project_delete_improvements') ? /*#__PURE__*/ $eJOHy.createElement((0, $2wTQj.default), null, displayName, " ") : displayName));
    if (href) return /*#__PURE__*/ $eJOHy.createElement("div", {
        className: (0, $hcewu.default)([
            $b36214b33d25bdee$var$styles.container
        ])
    }, isDeleting && (0, $7jTnu.fg)('hix-6302_project_delete_improvements') ? content : /*#__PURE__*/ $eJOHy.createElement("div", {
        className: (0, $hcewu.default)([
            $b36214b33d25bdee$var$styles.link
        ])
    }, /*#__PURE__*/ $eJOHy.createElement((0, $8nu6j.default), {
        xcss: applyVisualRefreshStyles ? $b36214b33d25bdee$var$contentWrapperStyles : $b36214b33d25bdee$var$contentWrapperStylesOld
    }, /*#__PURE__*/ $eJOHy.createElement((0, $k71qx.default), {
        content: displayName,
        isScreenReaderAnnouncementDisabled: true,
        delay: 1000,
        position: "bottom-start"
    }, /*#__PURE__*/ $eJOHy.createElement((0, $hdC3k.default), {
        href: href,
        onClick: onClick
    }, content)))));
    return /*#__PURE__*/ $eJOHy.createElement("div", {
        className: (0, $hcewu.default)([
            (0, $6XJko.isVisualRefreshEnabled)() ? $b36214b33d25bdee$var$styles.contentContainer : $b36214b33d25bdee$var$styles.contentContainerOld
        ])
    }, content);
}
$b36214b33d25bdee$export$2e2bcd8739ae039.defaultProps = {
    avatarUrl: undefined,
    href: undefined,
    appearance: 'circle',
    onClick: undefined
};
const $b36214b33d25bdee$var$Content = (props)=>{
    return (0, $6XJko.isVisualRefreshEnabled)() ? /*#__PURE__*/ $eJOHy.createElement((0, $8nu6j.default), {
        xcss: $b36214b33d25bdee$var$accessibleContentContainerStyles
    }, props.children) : /*#__PURE__*/ $eJOHy.createElement("div", {
        className: (0, $hcewu.default)([
            $b36214b33d25bdee$var$styles.accessibleContentContainer
        ])
    }, props.children);
};
const $b36214b33d25bdee$var$contentWrapperStyles = (0, $1DXK0.xcss)({
    maxWidth: '100%',
    paddingBlock: 'space.075'
});
const $b36214b33d25bdee$var$contentWrapperStylesOld = (0, $1DXK0.xcss)({
    maxWidth: '100%',
    paddingBlock: 'space.100'
});
const $b36214b33d25bdee$var$inlineTextStyles = (0, $1DXK0.xcss)({
    paddingBlockStart: 'space.025'
});
const $b36214b33d25bdee$var$accessibleContentContainerStyles = (0, $1DXK0.xcss)({
    paddingTop: 'space.100',
    paddingBottom: 'space.100',
    display: 'flex',
    alignItems: 'center',
    flex: '1 1 auto',
    width: '100%',
    height: '40px'
});

});
parcelRegister("2wTQj", function(module, exports) {

$parcel$export(module.exports, "default", () => $1a72e7a385cd217c$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");
function $1a72e7a385cd217c$export$2e2bcd8739ae039({ children: children }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $1a72e7a385cd217c$var$disabledBoxStyles
    }, children);
}
const $1a72e7a385cd217c$var$disabledBoxStyles = (0, $1DXK0.xcss)({
    display: 'contents',
    color: 'color.text.disabled',
    ':hover': {
        cursor: 'default'
    }
});

});





parcelRegister("eJBDJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $e40bf08df64ea7bb$export$2e2bcd8739ae039);

var $gnQAk = parcelRequire("gnQAk");

var $iYaR3 = parcelRequire("iYaR3");

var $cjMdM = parcelRequire("cjMdM");
const $e40bf08df64ea7bb$var$mapStateToProps = ()=>(state, ownProps)=>({
            popularity: (0, $iYaR3.getPopularity)(state, ownProps.id)
        });
var $e40bf08df64ea7bb$export$2e2bcd8739ae039 = (0, $gnQAk.connect)($e40bf08df64ea7bb$var$mapStateToProps, {})((0, $cjMdM.default));

});
parcelRegister("cjMdM", function(module, exports) {

$parcel$export(module.exports, "default", () => $0ee18ec67be4c35a$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $3cMgR = parcelRequire("3cMgR");

var $6XJko = parcelRequire("6XJko");

var $lRq8t = parcelRequire("lRq8t");

var $hYVI0 = parcelRequire("hYVI0");
function $0ee18ec67be4c35a$var$Popularity(props) {
    const { popularity: popularity } = props;
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const content = formatMessage((0, $hYVI0.default).popularity, {
        popularity: popularity
    });
    return (0, $6XJko.isVisualRefreshEnabled)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3cMgR.default), {
        color: "color.text.subtle"
    }, content) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($0ee18ec67be4c35a$var$Container, null, content);
}
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
const $0ee18ec67be4c35a$var$Container = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_16jlkb7n _1o9zkb7n _i0dl1wug _1reo15vq _18m915vq _1e0c1txw _2lx2vrvc _1bsb1osq _o5721q9c _1bto1l2s _ca0qutpp _n3tdutpp",
            __cmplp.className
        ])
    });
});
var $0ee18ec67be4c35a$export$2e2bcd8739ae039 = $0ee18ec67be4c35a$var$Popularity;

});
parcelRegister("hYVI0", function(module, exports) {

$parcel$export(module.exports, "default", () => $40635711c961927f$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $40635711c961927f$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    popularity: {
        "id": "directories.filters-v2.main.content.cells.popularity.popularity",
        "defaultMessage": "{popularity, plural, one {{popularity} person} other {{popularity} people}}"
    }
});

});



parcelRegister("ELsnh", function(module, exports) {

$parcel$export(module.exports, "default", () => $10f817fc451fbda4$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/restricted/react-component-props

var $eJOHy = parcelRequire("eJOHy");

var $eq3Hf = parcelRequire("eq3Hf");

var $l5htz = parcelRequire("l5htz");

var $bTsWb = parcelRequire("bTsWb");

var $9M9Yb = parcelRequire("9M9Yb");

var $gnQAk = parcelRequire("gnQAk");

var $iYaR3 = parcelRequire("iYaR3");
const $10f817fc451fbda4$var$TitleLink = ({ caption: caption, href: href, onClick: onClick })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9M9Yb.TransitionComponent), {
        href: href,
        onClick: onClick
    }, (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bTsWb.default), {
            ...props,
            caption: caption
        }));
const $10f817fc451fbda4$var$mapStateToProps = ()=>(state, ownProps)=>({
            caption: (0, $iYaR3.getName)(state, ownProps.id),
            href: (0, $iYaR3.getViewUrl)(state, ownProps.id)
        });
var $10f817fc451fbda4$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($eq3Hf)))((0, $l5htz.default)({
    onClick: 'filter'
}), (0, $gnQAk.connect)($10f817fc451fbda4$var$mapStateToProps, {}))($10f817fc451fbda4$var$TitleLink);

});
parcelRegister("bTsWb", function(module, exports) {

$parcel$export(module.exports, "default", () => $ff8fef4b8456318c$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $k71qx = parcelRequire("k71qx");

var $hdC3k = parcelRequire("hdC3k");

var $6XJko = parcelRequire("6XJko");

var $7jTnu = parcelRequire("7jTnu");
function $ff8fef4b8456318c$export$2e2bcd8739ae039({ caption: caption, href: href, onClick: onClick, ...props }) {
    const content = (0, $eJOHy.useMemo)(()=>{
        const innerContentOld = href ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $hdC3k.default), {
            href: href,
            onClick: onClick
        }, caption) : caption;
        const innerContent = (0, $7jTnu.fg)('directories_link_cell_padding_fix') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
            paddingInline: "space.050"
        }, href ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $hdC3k.default), {
            href: href,
            onClick: onClick
        }, caption) : caption) : innerContentOld;
        if ((0, $6XJko.isVisualRefreshEnabled)()) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
            xcss: $ff8fef4b8456318c$var$containerStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
            xcss: $ff8fef4b8456318c$var$wrapperStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $k71qx.default), {
            content: caption,
            isScreenReaderAnnouncementDisabled: true,
            delay: 1000,
            position: "bottom-start"
        }, innerContent)));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($ff8fef4b8456318c$var$Container, props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $k71qx.default), {
            content: caption,
            isScreenReaderAnnouncementDisabled: true,
            delay: 1000,
            position: "bottom-start"
        }, innerContent));
    }, [
        caption,
        href,
        onClick,
        props
    ]);
    return content;
}
const $ff8fef4b8456318c$var$containerStyles = (0, $1DXK0.xcss)({
    width: '100%',
    paddingBlock: 'space.100',
    flex: '1 1 auto',
    flexDirection: 'row',
    display: 'flex',
    height: '40px'
});
const $ff8fef4b8456318c$var$wrapperStyles = (0, $1DXK0.xcss)({
    paddingBlock: 'space.025',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis'
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
const $ff8fef4b8456318c$var$Container = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_16jlkb7n _1o9zkb7n _i0dl1wug _1reo15vq _18m915vq _1e0c1txw _2lx2vrvc _1bsb1osq _o5721q9c _1bto1l2s _ca0qutpp _n3tdutpp",
            __cmplp.className
        ])
    });
});

});

parcelRegister("9M9Yb", function(module, exports) {

$parcel$export(module.exports, "TransitionComponent", () => $c8a405d1bfe18777$export$3c61ec5cd62a42f9);

var $eJOHy = parcelRequire("eJOHy");

var $lcB5K = parcelRequire("lcB5K");
const $c8a405d1bfe18777$export$3c61ec5cd62a42f9 = ({ children: children, onClick: onClick, href: href })=>__SPA__ ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lcB5K.RouterActions), null, ({ push: push })=>{
        const clickHandler = (e, analyticsEvent)=>{
            if (e.metaKey || e.ctrlKey || e.altKey || e.shiftKey || e.button === 1) return;
            e.preventDefault();
            onClick && onClick(e, analyticsEvent);
            push(href);
        };
        return children({
            href: href,
            onClick: clickHandler
        });
    }) : children({
        href: href,
        onClick: onClick
    });

});


parcelRegister("f0pMb", function(module, exports) {

$parcel$export(module.exports, "default", () => $3b5880cbb259b92a$export$2e2bcd8739ae039);

var $9hEC7 = parcelRequire("9hEC7");

var $gnQAk = parcelRequire("gnQAk");
var $3b5880cbb259b92a$export$2e2bcd8739ae039 = (0, $gnQAk.connect)(// eslint-disable-next-line @typescript-eslint/no-explicit-any
(state, ownProps)=>({
        id: ownProps.entityId,
        onCancel: ownProps.onCancel,
        onSuccess: ownProps.onUpdated,
        onInitiateSuccess: ownProps.onDialogShown,
        onInitiateFailed: ownProps.onDataRetrieveFailed
    }), {})((0, $9hEC7.default));

});

parcelRegister("glN2F", function(module, exports) {

$parcel$export(module.exports, "default", () => $68a3b429df94fb35$export$2e2bcd8739ae039);
// TODO: Should be able to clean up with nin-save-filter-dialog-entry-point

var $lljDD = parcelRequire("lljDD");

var $gnQAk = parcelRequire("gnQAk");

var $dH9V1 = parcelRequire("dH9V1");
const $68a3b429df94fb35$var$mapStateToProps = (initialState, // eslint-disable-next-line @typescript-eslint/no-explicit-any
ownProps)=>{
    const onInitiateSuccess = ()=>{
        ownProps.onDialogShown();
    };
    const onDataRetrieveFailed = ()=>{
        ownProps.onDataRetrieveFailed();
    };
    const onCopied = ()=>{
        // @ts-expect-error - TS2554 - Expected 1 arguments, but got 0.
        ownProps.onUpdated();
    };
    return (_)=>({
            id: ownProps.entityId,
            onCancel: ownProps.onCancel,
            onInitiateSuccess: onInitiateSuccess,
            onDataRetrieveFailed: onDataRetrieveFailed,
            onCopied: onCopied
        });
};
var $68a3b429df94fb35$export$2e2bcd8739ae039 = (0, $gnQAk.connect)($68a3b429df94fb35$var$mapStateToProps, {
    onCloseCopyFilterModal: (0, $dH9V1.closeCopyFilterModal)
})((0, $lljDD.default));

});
parcelRegister("lljDD", function(module, exports) {

$parcel$export(module.exports, "default", () => $64207fe3d6b36b0c$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $12DRg = parcelRequire("12DRg");

var $BwaQq = parcelRequire("BwaQq");

var $aP411 = parcelRequire("aP411");

var $5kYyR = parcelRequire("5kYyR");


var $7mx5l = parcelRequire("7mx5l");
function $64207fe3d6b36b0c$var$CreateModal(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5kYyR.default), {
        id: "unhandled",
        packageName: "jiraCopyFiltersModal",
        teamName: "jira-cosmos"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aP411.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7mx5l.default), props)));
}
$64207fe3d6b36b0c$var$CreateModal.defaultProps = {
    onCopied: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
    onCancel: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg)))
};
var $64207fe3d6b36b0c$export$2e2bcd8739ae039 = (0, $BwaQq.AnalyticsSource)('copyFilter', (0, $466f60259c330878$export$1171103ea9083ffa))($64207fe3d6b36b0c$var$CreateModal);

});
parcelRegister("7mx5l", function(module, exports) {

$parcel$export(module.exports, "default", () => $e7f3af13daf59886$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $dFtHW = parcelRequire("dFtHW");

var $bILK0 = parcelRequire("bILK0");

var $dTocu = parcelRequire("dTocu");

var $6zXPf = parcelRequire("6zXPf");

var $gZTP9 = parcelRequire("gZTP9");

var $eVs76 = parcelRequire("eVs76");

var $3Dg28 = parcelRequire("3Dg28");
// eslint-disable-next-line @typescript-eslint/no-empty-function
const $e7f3af13daf59886$var$noop = ()=>{};
function $e7f3af13daf59886$var$CopyModal(props) {
    const { id: id, onDataRetrieveFailed: onDataRetrieveFailed } = props;
    const flagService = (0, $bILK0.useFlagService)();
    const intl = (0, $dTocu.useIntlV2)();
    const isAdmin = (0, $gZTP9.useIsAdmin)();
    let emitChangedFavorite = $e7f3af13daf59886$var$noop;
    if ((0, $6zXPf.getWillShowNav4)()) {
        // eslint-disable-next-line react-hooks/react-compiler
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const hookValue = (0, $dFtHW.useChangeFavorite)();
        emitChangedFavorite = hookValue.emitChangedFavorite;
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eVs76.default), {
        id: id,
        flagService: flagService,
        onDataRetrieveFailed: onDataRetrieveFailed,
        isAdmin: isAdmin
    }, ({ error: error, data: data })=>{
        if (error) return null;
        return data ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3Dg28.default), {
            emitChangedFavorite: emitChangedFavorite,
            intl: intl,
            flagService: flagService,
            filter: data,
            isAdmin: isAdmin,
            ...props
        }) : null;
    });
}
var $e7f3af13daf59886$export$2e2bcd8739ae039 = $e7f3af13daf59886$var$CopyModal;

});
parcelRegister("eVs76", function(module, exports) {

$parcel$export(module.exports, "default", () => $9aa52ad9ae915099$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $jGzN3 = parcelRequire("jGzN3");

var $lL6Qo = parcelRequire("lL6Qo");
// eslint-disable-next-line jira/react/no-class-components
class $9aa52ad9ae915099$var$FilterDataProvider extends (0, $eJOHy.Component) {
    componentDidMount() {
        this.fetchData();
    }
    async fetchData() {
        const { id: id, isAdmin: isAdmin } = this.props;
        try {
            const data = await (0, $jGzN3.performGetRequest)(`/rest/api/2/filter/${id}${isAdmin ? '?overrideSharePermissions=true' : ''}`);
            this.setState({
                loading: false,
                error: undefined,
                data: data
            });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (e) {
            this.setState({
                loading: false,
                error: e
            }, ()=>{
                this.showErrorFlag();
            });
        }
    }
    showErrorFlag() {
        const { flagService: flagService, onDataRetrieveFailed: onDataRetrieveFailed } = this.props;
        flagService.showFlag((0, $lL6Qo.default)());
        onDataRetrieveFailed();
    }
    render() {
        const { children: children } = this.props;
        const { loading: loading, error: error, data: data } = this.state;
        return children({
            loading: loading,
            error: error,
            data: data
        });
    }
    constructor(...args){
        super(...args), this.state = {
            loading: true,
            error: undefined,
            data: undefined
        };
    }
}
var $9aa52ad9ae915099$export$2e2bcd8739ae039 = $9aa52ad9ae915099$var$FilterDataProvider;

});
parcelRegister("lL6Qo", function(module, exports) {

$parcel$export(module.exports, "default", () => $020eb45063ef79aa$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $020eb45063ef79aa$var$messages = (0, $7qGN1.defineMessages)({
    title: {
        "id": "copy-filters-modal.common.flags.filter-loading-failed.title",
        "defaultMessage": "Filter loading failed."
    }
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$020eb45063ef79aa$export$2e2bcd8739ae039 = ()=>({
        type: 'error',
        title: $020eb45063ef79aa$var$messages.title,
        isAutoDismiss: true,
        messageId: 'copy-filters-modal.common.ui.flags.filter-loading-failed.flag.error',
        messageType: 'transactional'
    });

});


parcelRegister("3Dg28", function(module, exports) {

$parcel$export(module.exports, "default", () => $c90f7d8f467a8b4f$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $jtIA2 = parcelRequire("jtIA2");

var $2ZYsz = parcelRequire("2ZYsz");

var $ksMI6 = parcelRequire("ksMI6");

var $eSnSE = parcelRequire("eSnSE");

var $1uIew = parcelRequire("1uIew");

var $gCeeo = parcelRequire("gCeeo");

var $56UKu = parcelRequire("56UKu");


var $5iMG1 = parcelRequire("5iMG1");

var $fPH8V = parcelRequire("fPH8V");

var $gEkj6 = parcelRequire("gEkj6");

var $4WWoF = parcelRequire("4WWoF");
const $c90f7d8f467a8b4f$var$getServerSideValidationErrors = (0, $ksMI6.createServerSideValidationErrorsGetter)({
    filterName: (0, $22859e611426c88f$export$b85469cbf362db42),
    shares: (0, $22859e611426c88f$export$378fd4cd7d69440f),
    edit_permissions: (0, $22859e611426c88f$export$fb465a1f4d511f87)
});
// eslint-disable-next-line jira/react/no-class-components
class $c90f7d8f467a8b4f$var$CopyModal extends (0, $eJOHy.Component) {
    componentDidMount() {
        this.props.onInitiateSuccess();
    }
    render() {
        const { intl: { formatMessage: formatMessage } } = this.props;
        const { name: name, description: description, editPermissions: editPermissions, sharePermissions: sharePermissions } = this.props.filter;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $56UKu.SharingPermissionAwareShareableEntityModal), {
            sharingPermissionType: "filter",
            avoidInitialPublicSharePermission: true,
            sharePermissions: sharePermissions,
            editPermissions: editPermissions,
            title: formatMessage((0, $4WWoF.default).header, {
                name: name
            }),
            actionButtonCaption: formatMessage((0, $4WWoF.default).saveButtonCaption),
            initialName: name,
            initialDescription: description,
            initialOwner: undefined,
            onCancel: this.onCancel,
            onOperationSucceed: this.onOperationSucceed,
            onOperationFailed: this.onOperationFailed,
            getServerSideValidationErrors: $c90f7d8f467a8b4f$var$getServerSideValidationErrors,
            operation: this.onOperation
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jtIA2.default), null));
    }
    constructor(...args){
        super(...args), this.onOperation = (filter)=>{
            const { isAdmin: isAdmin, filter: { favourite: favourite, jql: jql } } = this.props;
            return (0, $gEkj6.default)(filter, jql, favourite, isAdmin);
        }, this.onOperationSucceed = (filter, result, analyticsEvent)=>{
            const { flagService: flagService, onCopied: onCopied, id: id } = this.props;
            (0, $gCeeo.fireUIAnalytics)(analyticsEvent, 'copiedFilter', {
                isViewerPrivate: filter.sharePermissions.length === 0,
                isEditorPrivate: filter.editPermissions && filter.editPermissions.length === 0
            });
            flagService.showFlag((0, $fPH8V.default)(filter.name));
            // Emit an event to notify consumers that there is a newly favourited entity
            if (result.favourite) this.props.emitChangedFavorite({
                id: result?.id,
                type: 'filters',
                value: result.favourite
            });
            onCopied();
            (0, $2ZYsz.fireTrackAnalytics)(analyticsEvent, {
                action: 'copied',
                actionSubjectId: `${id}`
            });
            this.props.onCloseCopyFilterModal();
        }, // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.onOperationFailed = (error, analyticsEvent)=>{
            const { flagService: flagService, id: id } = this.props;
            const isValidationError = error.name && error.name === (0, $1uIew.VALIDATION_ERROR_NAME);
            if (!isValidationError) (0, $eSnSE.default).safeErrorWithoutCustomerData('directories.filters.copy-modal.submit', `copy filter has failed, id=${id}`, error);
            flagService.showFlag((0, $5iMG1.default)());
            (0, $gCeeo.fireOperationalAnalytics)(analyticsEvent, 'copy failed', id, {
                isValidationError: isValidationError
            });
        }, this.onCancel = ()=>{
            this.props.onCancel();
            this.props.onCloseCopyFilterModal();
        };
    }
}
var $c90f7d8f467a8b4f$export$2e2bcd8739ae039 = $c90f7d8f467a8b4f$var$CopyModal;

});
parcelRegister("ksMI6", function(module, exports) {

$parcel$export(module.exports, "createServerSideValidationErrorsGetter", () => $a49c506b13dc2835$export$eba34c1c9e48e66a);

var $38vCZ = parcelRequire("38vCZ");
const $a49c506b13dc2835$export$eba34c1c9e48e66a = (errorFieldToFormFieldDictionary)=>(validationError)=>{
        if (!validationError.errors) // @ts-expect-error(PARTIAL_RECORD) TS2739 - Type '{}' is missing the following properties from type 'ServerValidationErrors': description, name, sharePermissions, editPermissions
        return {};
        // @ts-expect-error(PARTIAL_RECORD) TS2739 - Type 'Record<string, any>' is missing the following properties from type 'ServerValidationErrors': description, name, sharePermissions, editPermissions
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return validationError.errors.reduce((validationErrors, error)=>{
            const formFieldName = errorFieldToFormFieldDictionary[error.field];
            if (formFieldName) // Assigning is fine in .reduce() from a new object
            // eslint-disable-next-line no-param-reassign
            validationErrors[formFieldName] = (0, $38vCZ.toServerValidationError)(error.error);
            return validationErrors;
        }, {});
    };

});
parcelRegister("38vCZ", function(module, exports) {

$parcel$export(module.exports, "toServerValidationError", () => $667f4c6a1e0f944d$export$567171750b320ae6);
// suppressed to allow migration to typescript-eslint v8 - this is a new error reported with v8 and is only used as a type
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const $667f4c6a1e0f944d$var$FilterSharingPermissionKey = 'filter';
// suppressed to allow migration to typescript-eslint v8 - this is a new error reported with v8 and is only used as a type
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const $667f4c6a1e0f944d$var$DashboardSharingPermissionKey = 'dashboard';
const $667f4c6a1e0f944d$export$567171750b320ae6 = (value)=>value;

});


parcelRegister("56UKu", function(module, exports) {

$parcel$export(module.exports, "SharingPermissionAwareShareableEntityDialog", () => $be3401aad8f407d0$export$da33277a49efaed2);
$parcel$export(module.exports, "SharingPermissionAwareShareableEntityModal", () => $be3401aad8f407d0$export$e563fb6c5adbcd15);

var $eJOHy = parcelRequire("eJOHy");

var $aC4Bh = parcelRequire("aC4Bh");

var $7iHUq = parcelRequire("7iHUq");

var $aP411 = parcelRequire("aP411");

var $2ZGUP = parcelRequire("2ZGUP");

var $fgJkD = parcelRequire("fgJkD");

var $bJscI = parcelRequire("bJscI");

var $eZnyh = parcelRequire("eZnyh");

var $aGVkS = parcelRequire("aGVkS");

var $jbLMg = parcelRequire("jbLMg");

var $brOfz = parcelRequire("brOfz");



const $be3401aad8f407d0$var$ModalDialog = (0, $bJscI.componentWithFG)('jfp_a11y_fix_dashboard_actions_modal_accessibility', (0, $fgJkD.ModalDialog), (0, $aC4Bh.JiraModal));
// eslint-disable-next-line jira/react/no-class-components
class $be3401aad8f407d0$var$ShareableEntityDialog extends (0, $eJOHy.Component) {
    static{
        this.defaultProps = {
            isNameReadOnly: false,
            isShareScopeLoading: false,
            initialOwner: undefined,
            shareeOptions: $eZnyh.shareeOptions,
            editOptions: $eZnyh.editOptions
        };
    }
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7iHUq.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aP411.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $brOfz.default), this.props)));
    }
}
const $be3401aad8f407d0$export$da33277a49efaed2 = ({ avoidInitialPublicSharePermission: avoidInitialPublicSharePermission = false, sharingPermissionType: sharingPermissionType, sharePermissions: sharePermissions = [], viewersCustomMessage: viewersCustomMessage = '', nameTooltip: nameTooltip = '', allowSharePublicOrganizationOnly: allowSharePublicOrganizationOnly = false, editPermissions: editPermissions = [], forceHideEditors: forceHideEditors = false, isShareScopeLoading: isShareScopeLoading = false, isNameReadOnly: isNameReadOnly = false, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aGVkS.default), null, ({ data: data, sharedObjectsPermission: sharedObjectsPermission, loading: loading })=>{
        const shareeOptionsFiltered = (0, $jbLMg.getShareeOptions)({
            data: data,
            sharedObjectsPermission: sharedObjectsPermission,
            loading: loading
        }, sharePermissions, sharingPermissionType, allowSharePublicOrganizationOnly);
        const entitySharePermissions = (0, $jbLMg.getSharePermissions)({
            data: data,
            sharedObjectsPermission: sharedObjectsPermission,
            loading: loading
        }, sharePermissions, avoidInitialPublicSharePermission);
        const canCreateSharedObjectsPermission = (0, $jbLMg.isCreateSharedObjectsPermission)(sharedObjectsPermission);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($be3401aad8f407d0$var$ShareableEntityDialog, {
            ...props,
            isEditorListShown: !forceHideEditors && (sharingPermissionType === 'dashboard' || sharingPermissionType === 'filter'),
            isNameReadOnly: isNameReadOnly,
            sharePermissions: entitySharePermissions,
            viewersCustomMessage: viewersCustomMessage,
            nameTooltip: nameTooltip,
            shareeOptions: shareeOptionsFiltered,
            editPermissions: canCreateSharedObjectsPermission === false || loading ? [] : editPermissions,
            editOptions: (0, $eZnyh.editOptions),
            isShareScopeLoading: isShareScopeLoading || loading
        });
    });
const $be3401aad8f407d0$export$e563fb6c5adbcd15 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2ZGUP.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($be3401aad8f407d0$var$ModalDialog, {
        messageId: "shareable-entity-dialog.modal-dialog",
        messageType: "transactional",
        width: "medium",
        onClose: props.onCancel,
        shouldScrollInViewport: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($be3401aad8f407d0$export$da33277a49efaed2, props)));
var $be3401aad8f407d0$export$2e2bcd8739ae039 = $be3401aad8f407d0$var$ShareableEntityDialog;

});
parcelRegister("fgJkD", function(module, exports) {

$parcel$export(module.exports, "ModalDialog", () => $dfae8fefc4710a7e$export$1fa217be60c2f188);

var $eJOHy = parcelRequire("eJOHy");

var $aC4Bh = parcelRequire("aC4Bh");

var $4aSRi = parcelRequire("4aSRi");
const $dfae8fefc4710a7e$export$1fa217be60c2f188 = ({ shouldReturnFocus: shouldReturnFocus, ...rest })=>{
    const returnFocusTarget = (0, $4aSRi.useReturnFocusTo)();
    const { setReturnFocusTo: setReturnFocusTo } = (0, $4aSRi.useModalDialogActions)();
    (0, $eJOHy.useEffect)(()=>()=>{
            if (returnFocusTarget?.current) {
                !shouldReturnFocus && returnFocusTarget.current.focus();
                setReturnFocusTo(null);
            }
        }, [
        returnFocusTarget,
        setReturnFocusTo,
        shouldReturnFocus
    ]);
    /**
	 *  when shouldReturnFocus is defined,
	 * 	we won't handle passing focus back to this element
	 *	we will ignore the returnFocusTarget
	 */ const returnFocus = shouldReturnFocus ?? !returnFocusTarget;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aC4Bh.JiraModal), {
        shouldReturnFocus: returnFocus,
        ...rest,
        messageId: rest.messageId ?? 'software.modal-dialog.ui.ak-modal-dialog',
        messageType: rest.messageType ?? 'transactional'
    });
};

});

parcelRegister("eZnyh", function(module, exports) {

$parcel$export(module.exports, "isPublicOrOpenOrPrivate", () => $b7ccf8f03ba3000d$export$e08b925cf70f767b);
$parcel$export(module.exports, "areSharePermissionsEqual", () => $b7ccf8f03ba3000d$export$8c0ff6f403e15e9c);
$parcel$export(module.exports, "mapAccessTypeFromPermissions", () => $b7ccf8f03ba3000d$export$1c2ded3e2d5331b3);
$parcel$export(module.exports, "allShareTypesProperties", () => $b7ccf8f03ba3000d$export$4de258fee4f5aca0);
$parcel$export(module.exports, "shareeOptions", () => $b7ccf8f03ba3000d$export$9db6e6707f968cf1);
$parcel$export(module.exports, "editOptions", () => $b7ccf8f03ba3000d$export$dfc3fbb12e12e5a2);
$parcel$export(module.exports, "shareeOptionsWithPublicAccessDisabled", () => $b7ccf8f03ba3000d$export$c47f666f037e39f1);
$parcel$export(module.exports, "shareeOptionsWithoutPublicAccess", () => $b7ccf8f03ba3000d$export$927a4a38aa2e02e7);
$parcel$export(module.exports, "sharingTypeToPermissionsMap", () => $b7ccf8f03ba3000d$export$fba0af8514fddf9f);

var $eJOHy = parcelRequire("eJOHy");

var $8sbs2 = parcelRequire("8sbs2");

var $LFmXM = parcelRequire("LFmXM");

var $ifn8T = parcelRequire("ifn8T");

var $rZPcB = parcelRequire("rZPcB");

var $lG2jM = parcelRequire("lG2jM");

var $58frP = parcelRequire("58frP");

var $amvLf = parcelRequire("amvLf");



var $cODZN = parcelRequire("cODZN");
const $b7ccf8f03ba3000d$export$e08b925cf70f767b = (type)=>// @ts-expect-error - TS2345 - Argument of type 'ShareType' is not assignable to parameter of type '"loggedin" | "global" | "private"'.
    [
        (0, $f461f432d18e9f64$export$86517eb0163ef745),
        (0, $22859e611426c88f$export$52e14e112503bf52),
        (0, $f461f432d18e9f64$export$b0a0e62d9b1a8269)
    ].includes(type);
const $b7ccf8f03ba3000d$export$8c0ff6f403e15e9c = (share1, share2)=>{
    if (share1.type !== share2.type) return false;
    if (share1.type === (0, $22859e611426c88f$export$52e14e112503bf52) || share1.type === (0, $f461f432d18e9f64$export$86517eb0163ef745) || share1.type === (0, $f461f432d18e9f64$export$b0a0e62d9b1a8269)) return true;
    if (share1.type === (0, $f461f432d18e9f64$export$b02d7412182d1bce) && share2.type === (0, $f461f432d18e9f64$export$b02d7412182d1bce)) {
        if (share1.group.groupId && share2.group.groupId) return share1.group.groupId === share2.group.groupId;
        // second check is just for flow
        return share1.group.name === share2.group.name;
    }
    if (share1.type === (0, $f461f432d18e9f64$export$aea0835048e1c730) && share2.type === (0, $f461f432d18e9f64$export$aea0835048e1c730)) // second check is just for flow
    return share1.user.accountId === share2.user.accountId;
    if (share1.type === (0, $f461f432d18e9f64$export$5ef95a67b8fd1ff6) && share2.type === (0, $f461f432d18e9f64$export$5ef95a67b8fd1ff6)) return share1.project.id === share2.project.id && (share1.role && share1.role.id) === (share2.role && share2.role.id);
    return false;
};
const $b7ccf8f03ba3000d$export$1c2ded3e2d5331b3 = (0, $LFmXM.default)((sharePermissions)=>{
    if (sharePermissions.length === 0) return 0, $22859e611426c88f$export$52e14e112503bf52;
    return sharePermissions.length === 1 ? sharePermissions[0].type // PUBLIC_SHARE or OPEN_SHARE,
     : undefined;
});
const $b7ccf8f03ba3000d$export$4de258fee4f5aca0 = {
    [(0, $f461f432d18e9f64$export$5ef95a67b8fd1ff6)]: {
        messageDescriptor: (0, $cODZN.default).project,
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ifn8T))), {
            spacing: "spacious",
            label: ""
        })
    },
    [(0, $f461f432d18e9f64$export$487da0972e3459fe)]: {
        messageDescriptor: (0, $cODZN.default).unknownProject,
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ifn8T))), {
            spacing: "spacious",
            label: ""
        })
    },
    [(0, $f461f432d18e9f64$export$b02d7412182d1bce)]: {
        messageDescriptor: (0, $cODZN.default).group,
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($lG2jM))), {
            spacing: "spacious",
            label: ""
        })
    },
    [(0, $f461f432d18e9f64$export$b0a0e62d9b1a8269)]: {
        messageDescriptor: (0, $cODZN.default).myOrganization,
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($rZPcB))), {
            spacing: "spacious",
            label: ""
        })
    },
    [(0, $f461f432d18e9f64$export$86517eb0163ef745)]: {
        messageDescriptor: (0, $cODZN.default).public,
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($amvLf))), {
            spacing: "spacious",
            label: ""
        })
    },
    [(0, $f461f432d18e9f64$export$aea0835048e1c730)]: {
        messageDescriptor: (0, $cODZN.default).user,
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($58frP))), {
            spacing: "spacious",
            label: ""
        })
    },
    [(0, $22859e611426c88f$export$52e14e112503bf52)]: {
        messageDescriptor: (0, $cODZN.default).private,
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($58frP))), {
            spacing: "spacious",
            label: ""
        })
    }
};
const $b7ccf8f03ba3000d$export$9b1f09fb42db6641 = (0, (/*@__PURE__*/$parcel$interopDefault($8sbs2)))($b7ccf8f03ba3000d$export$4de258fee4f5aca0, (0, $f461f432d18e9f64$export$5ef95a67b8fd1ff6), (0, $f461f432d18e9f64$export$b02d7412182d1bce), (0, $f461f432d18e9f64$export$b0a0e62d9b1a8269), (0, $f461f432d18e9f64$export$86517eb0163ef745), (0, $f461f432d18e9f64$export$aea0835048e1c730), (0, $22859e611426c88f$export$52e14e112503bf52));
const $b7ccf8f03ba3000d$export$d26c8129d623af6c = (0, (/*@__PURE__*/$parcel$interopDefault($8sbs2)))($b7ccf8f03ba3000d$export$4de258fee4f5aca0, (0, $f461f432d18e9f64$export$5ef95a67b8fd1ff6), (0, $f461f432d18e9f64$export$b02d7412182d1bce), (0, $f461f432d18e9f64$export$aea0835048e1c730), (0, $22859e611426c88f$export$52e14e112503bf52));
const $b7ccf8f03ba3000d$export$9db6e6707f968cf1 = // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
Object.keys($b7ccf8f03ba3000d$export$9b1f09fb42db6641).map((shareType)=>({
        ...$b7ccf8f03ba3000d$export$9b1f09fb42db6641[shareType],
        isDisabled: false,
        value: shareType
    }));
const $b7ccf8f03ba3000d$export$dfc3fbb12e12e5a2 = // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
Object.keys($b7ccf8f03ba3000d$export$d26c8129d623af6c).map((shareType)=>({
        ...$b7ccf8f03ba3000d$export$d26c8129d623af6c[shareType],
        isDisabled: false,
        value: shareType
    }));
const $b7ccf8f03ba3000d$export$c47f666f037e39f1 = $b7ccf8f03ba3000d$export$9db6e6707f968cf1.map((option)=>({
        ...option,
        isDisabled: option.value === (0, $f461f432d18e9f64$export$86517eb0163ef745)
    }));
const $b7ccf8f03ba3000d$export$927a4a38aa2e02e7 = $b7ccf8f03ba3000d$export$9db6e6707f968cf1.filter((option)=>option.value !== (0, $f461f432d18e9f64$export$86517eb0163ef745));
const $b7ccf8f03ba3000d$export$fba0af8514fddf9f = {
    filter: 'globalsharing',
    dashboard: 'globalsharing'
};

});
const $22859e611426c88f$export$52e14e112503bf52 = 'private';
const $22859e611426c88f$export$b85469cbf362db42 = 'name';
const $22859e611426c88f$export$a1d4ae33ba772a5b = 'description';
const $22859e611426c88f$export$378fd4cd7d69440f = 'sharePermissions';
const $22859e611426c88f$export$fb465a1f4d511f87 = 'editPermissions';

parcelRegister("cODZN", function(module, exports) {

$parcel$export(module.exports, "default", () => $f7bec96ab48c5847$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $f7bec96ab48c5847$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    group: {
        "id": "shareable-entity-dialog.model.group",
        "defaultMessage": "Group"
    },
    project: {
        "id": "shareable-entity-dialog.model.project",
        "defaultMessage": "Project"
    },
    private: {
        "id": "shareable-entity-dialog.model.private",
        "defaultMessage": "Private"
    },
    user: {
        "id": "shareable-entity-dialog.model.user",
        "defaultMessage": "User"
    },
    myOrganization: {
        "id": "shareable-entity-dialog.model.my-organization",
        "defaultMessage": "My organization"
    },
    public: {
        "id": "shareable-entity-dialog.model.public",
        "defaultMessage": "Public"
    },
    unknownProject: {
        "id": "shareable-entity-dialog.model.unknown-project",
        "defaultMessage": "Unknown project"
    },
    projectGalaxia: {
        "id": "shareable-entity-dialog.model.project-galaxia",
        "defaultMessage": "Space"
    },
    unknownProjectGalaxia: {
        "id": "shareable-entity-dialog.model.unknown-project-galaxia",
        "defaultMessage": "Unknown space"
    }
});

});


parcelRegister("aGVkS", function(module, exports) {

$parcel$export(module.exports, "default", () => $e504ab00dfc5f88a$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $4J0ad = parcelRequire("4J0ad");

var $gYnSx = parcelRequire("gYnSx");

var $jGzN3 = parcelRequire("jGzN3");
class $e504ab00dfc5f88a$export$471356de977a9b27 extends (0, $eJOHy.Component) {
    componentDidMount() {
        this.fetchData();
        this.fetchPermissions();
    }
    render() {
        const { children: children } = this.props;
        const { loading: loading, error: error, data: data, sharedObjectsPermission: sharedObjectsPermission, sharedObjectError: sharedObjectError, sharedObjectPermissionLoading: sharedObjectPermissionLoading } = this.state;
        return children({
            loading: loading || sharedObjectPermissionLoading,
            error: error,
            data: data,
            sharedObjectError: sharedObjectError,
            sharedObjectsPermission: sharedObjectsPermission
        });
    }
    constructor(...args){
        super(...args), this.state = {
            loading: false,
            error: undefined,
            data: undefined,
            sharedObjectError: undefined,
            sharedObjectPermissionLoading: false,
            sharedObjectsPermission: undefined
        }, // eslint-disable-next-line jira/react-arrow-function-property-naming, jira/react-no-unneeded-arrow-function-properties
        this.fetchData = async ()=>{
            this.setState({
                loading: true
            });
            try {
                const url = '/rest/internal/2/sharing-permissions';
                const permissions = await (0, $jGzN3.performGetRequest)(url);
                this.setState({
                    loading: false,
                    error: undefined,
                    data: permissions
                });
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (e) {
                this.setState({
                    loading: false,
                    error: e,
                    data: undefined
                });
                const event = this.props.createAnalyticsEvent({});
                (0, $gYnSx.default)({
                    error: e,
                    event: event,
                    meta: {
                        id: 'fetchData',
                        packageName: 'jiraShareableEntityDialog'
                    }
                });
            }
        }, // eslint-disable-next-line jira/react-arrow-function-property-naming, jira/react-no-unneeded-arrow-function-properties
        this.fetchPermissions = async ()=>{
            this.setState({
                sharedObjectPermissionLoading: true
            });
            try {
                const sharedObjectsPermission = await (0, $jGzN3.performGetRequest)('/rest/api/3/mypermissions?permissions=CREATE_SHARED_OBJECTS');
                this.setState({
                    sharedObjectPermissionLoading: false,
                    sharedObjectError: undefined,
                    sharedObjectsPermission: sharedObjectsPermission
                });
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (e) {
                this.setState({
                    sharedObjectPermissionLoading: false,
                    sharedObjectError: e,
                    sharedObjectsPermission: undefined
                });
                const event = this.props.createAnalyticsEvent({});
                (0, $gYnSx.default)({
                    event: event,
                    error: e,
                    meta: {
                        id: 'fetchPermissions',
                        packageName: 'jiraShareableEntityDialog'
                    },
                    sendToPrivacyUnsafeSplunk: true
                });
            }
        };
    }
}
var $e504ab00dfc5f88a$export$2e2bcd8739ae039 = (0, $4J0ad.default)()($e504ab00dfc5f88a$export$471356de977a9b27);

});

parcelRegister("jbLMg", function(module, exports) {

$parcel$export(module.exports, "isCreateSharedObjectsPermission", () => $e8e727780a8581d8$export$af4fc7cee18c1f8a);
$parcel$export(module.exports, "getSharePermissions", () => $e8e727780a8581d8$export$96717b662cf0e6e8);
$parcel$export(module.exports, "getShareeOptions", () => $e8e727780a8581d8$export$2b470b7fa9b9f6ca);



var $eZnyh = parcelRequire("eZnyh");
const $e8e727780a8581d8$var$getShareeOptionsIfPublicSharingDisabled = (isEntitySharePermissionSetAsPublic)=>isEntitySharePermissionSetAsPublic ? (0, $eZnyh.shareeOptionsWithPublicAccessDisabled) : (0, $eZnyh.shareeOptionsWithoutPublicAccess);
const $e8e727780a8581d8$var$getShareOptionsPublicOrganizationOnly = (isPublicSharingEnabled, isEntitySharePermissionSetAsPublic)=>{
    const publicOrganizationOnlyShareOptions = (0, $eZnyh.shareeOptions).filter((option)=>option.value === (0, $f461f432d18e9f64$export$86517eb0163ef745) || option.value === (0, $f461f432d18e9f64$export$b0a0e62d9b1a8269));
    if (isPublicSharingEnabled === true) return publicOrganizationOnlyShareOptions;
    return isEntitySharePermissionSetAsPublic ? publicOrganizationOnlyShareOptions.map((option)=>({
            ...option,
            isDisabled: option.value === (0, $f461f432d18e9f64$export$86517eb0163ef745)
        })) : publicOrganizationOnlyShareOptions.filter((option)=>option.value !== (0, $f461f432d18e9f64$export$86517eb0163ef745));
};
const $e8e727780a8581d8$export$56bc389f739d17f8 = (sharePermissions)=>Boolean((0, $eZnyh.mapAccessTypeFromPermissions)(sharePermissions) === (0, $f461f432d18e9f64$export$86517eb0163ef745));
const $e8e727780a8581d8$export$af4fc7cee18c1f8a = (sharedObjectsPermission)=>sharedObjectsPermission?.permissions?.CREATE_SHARED_OBJECTS?.havePermission;
const $e8e727780a8581d8$export$96717b662cf0e6e8 = ({ sharedObjectsPermission: sharedObjectsPermission, loading: loading }, sharePermissions, avoidInitialPublicSharePermission = false)=>{
    if ($e8e727780a8581d8$export$af4fc7cee18c1f8a(sharedObjectsPermission) === false || loading) return [];
    const isEntitySharePermissionSetAsPublic = (0, $eZnyh.mapAccessTypeFromPermissions)(sharePermissions) === (0, $f461f432d18e9f64$export$86517eb0163ef745);
    return isEntitySharePermissionSetAsPublic && avoidInitialPublicSharePermission ? [] : sharePermissions;
};
const $e8e727780a8581d8$export$2b470b7fa9b9f6ca = ({ data: data, sharedObjectsPermission: sharedObjectsPermission, loading: loading }, sharePermissions, sharingPermissionType, allowSharePublicOrganizationOnly = false)=>{
    const isPublicSharingEnabled = data && data[(0, $eZnyh.sharingTypeToPermissionsMap)[sharingPermissionType]];
    const isEntitySharePermissionSetAsPublic = $e8e727780a8581d8$export$56bc389f739d17f8(sharePermissions);
    let dialogShareeOptions;
    if (allowSharePublicOrganizationOnly) dialogShareeOptions = $e8e727780a8581d8$var$getShareOptionsPublicOrganizationOnly(isPublicSharingEnabled, isEntitySharePermissionSetAsPublic);
    else dialogShareeOptions = isPublicSharingEnabled === true ? (0, $eZnyh.shareeOptions) : $e8e727780a8581d8$var$getShareeOptionsIfPublicSharingDisabled(isEntitySharePermissionSetAsPublic);
    if ($e8e727780a8581d8$export$af4fc7cee18c1f8a(sharedObjectsPermission) === false || loading) return dialogShareeOptions.filter((option)=>option.value === (allowSharePublicOrganizationOnly ? (0, $f461f432d18e9f64$export$b0a0e62d9b1a8269) : (0, $22859e611426c88f$export$52e14e112503bf52)));
    return dialogShareeOptions;
};

});

parcelRegister("brOfz", function(module, exports) {

$parcel$export(module.exports, "default", () => $ecba56bf17cbe422$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $l5htz = parcelRequire("l5htz");

var $1uIew = parcelRequire("1uIew");


var $fucyK = parcelRequire("fucyK");


var $brCV5 = parcelRequire("brCV5");

var $16Zyv = parcelRequire("16Zyv");
const $ecba56bf17cbe422$var$UserPickerWithAnalytics = (0, $l5htz.default)({
    onChange: 'owner'
})((0, $fucyK.default));
const $ecba56bf17cbe422$var$isNameEmpty = (name)=>!name.trim();
const $ecba56bf17cbe422$var$transformToUser = ({ accountId: accountId, displayName: displayName, avatarUrl: avatarUrl, label: label })=>({
        accountId: accountId,
        displayName: displayName,
        avatarUrl: avatarUrl,
        label: label
    });
class $ecba56bf17cbe422$export$2e2bcd8739ae039 extends (0, $eJOHy.Component) {
    constructor(props){
        super(props), this.nameInputRef = /*#__PURE__*/ (0, $eJOHy.createRef)(), this.onNameChange = (event)=>{
            const name = event.target.value;
            this.setState({
                name: name,
                isNameRequiredError: $ecba56bf17cbe422$var$isNameEmpty(name),
                serverValidationErrors: {
                    ...this.state.serverValidationErrors,
                    // @ts-expect-error(PARTIAL_RECORD) TS2418 - Type of computed property's value is 'undefined', which is not assignable to type 'string'.
                    [(0, $22859e611426c88f$export$b85469cbf362db42)]: undefined
                }
            });
        }, this.onDescriptionChange = (event)=>{
            this.setState({
                description: event.target.value,
                serverValidationErrors: {
                    ...this.state.serverValidationErrors,
                    // @ts-expect-error(PARTIAL_RECORD) TS2418 - Type of computed property's value is 'undefined', which is not assignable to type 'string'.
                    [(0, $22859e611426c88f$export$a1d4ae33ba772a5b)]: undefined
                }
            });
        }, this.onOwnerChange = (selectedUser)=>{
            const { initialOwner: initialOwner } = this.props;
            const owner = selectedUser ? $ecba56bf17cbe422$var$transformToUser(selectedUser) : initialOwner;
            this.setState({
                owner: owner
            });
        }, this.onAction = (event, analyticsEvent)=>{
            const { operation: operation, onOperationSucceed: onOperationSucceed, onOperationFailed: onOperationFailed, getServerSideValidationErrors: getServerSideValidationErrors } = this.props;
            const { name: name, description: description, owner: owner, jql: jql, sharePermissions: sharePermissions, editPermissions: editPermissions } = this.state;
            this.setState({
                isPending: true
            });
            // Filter out project unknown shares as they cannot be saved. Filters backend ignores them,
            // while dashboards backend throws a 400 error.
            const filteredSharePermissions = sharePermissions.filter((share)=>share.type !== (0, $f461f432d18e9f64$export$487da0972e3459fe));
            const filteredEditPermissions = editPermissions.filter((share)=>share.type !== (0, $f461f432d18e9f64$export$487da0972e3459fe));
            const operationData = {
                name: name,
                description: description,
                owner: owner,
                jql: jql,
                sharePermissions: filteredSharePermissions,
                editPermissions: filteredEditPermissions
            };
            operation(operationData).then((operationResult)=>{
                this.setStateIfMounted({
                    isPending: false,
                    // @ts-expect-error(PARTIAL_RECORD) TS2739 - Type '{}' is missing the following properties from type 'ServerValidationErrors': description, name, sharePermissions, editPermissions
                    serverValidationErrors: {}
                });
                onOperationSucceed(operationData, operationResult, analyticsEvent);
            }, (error)=>{
                this.setStateIfMounted({
                    isPending: false
                });
                if (error instanceof (0, $1uIew.ValidationError)) {
                    const newServerValidationErrors = getServerSideValidationErrors(error);
                    this.setStateIfMounted({
                        serverValidationErrors: newServerValidationErrors // set or reset
                    });
                    // setting the focus to name field on error (implemented as a part of JCA11Y-1635)
                    if (newServerValidationErrors.name) requestAnimationFrame(()=>this.nameInputRef.current?.focus());
                }
                onOperationFailed(error, analyticsEvent);
            });
        }, this.onSharePermissionChange = (sharePermissions)=>{
            this.setState({
                sharePermissions: sharePermissions,
                serverValidationErrors: {
                    ...this.state.serverValidationErrors,
                    // @ts-expect-error(PARTIAL_RECORD) TS2418 - Type of computed property's value is 'undefined', which is not assignable to type 'string'.
                    [(0, $22859e611426c88f$export$378fd4cd7d69440f)]: undefined
                }
            });
        }, this.onEditPermissionChange = (editPermissions)=>{
            this.setState({
                editPermissions: editPermissions,
                serverValidationErrors: {
                    ...this.state.serverValidationErrors,
                    // @ts-expect-error(PARTIAL_RECORD) TS2418 - Type of computed property's value is 'undefined', which is not assignable to type 'string'.
                    [(0, $22859e611426c88f$export$fb465a1f4d511f87)]: undefined
                }
            });
        };
        const { initialName: initialName, initialDescription: initialDescription, initialOwner: initialOwner, initialJql: initialJql, sharePermissions: sharePermissions, editPermissions: editPermissions, viewersCustomMessage: viewersCustomMessage, nameTooltip: nameTooltip } = props;
        this.state = {
            name: initialName || '',
            description: initialDescription || '',
            owner: initialOwner,
            jql: initialJql,
            isPending: false,
            isNameRequiredError: false,
            // @ts-expect-error(PARTIAL_RECORD) TS2739 - Type '{}' is missing the following properties from type 'ServerValidationErrors': description, name, sharePermissions, editPermissions
            serverValidationErrors: {},
            sharePermissions: sharePermissions || [],
            viewersCustomMessage: viewersCustomMessage || '',
            nameTooltip: nameTooltip || '',
            editPermissions: editPermissions || []
        };
    }
    componentDidMount() {
        this.isComponentMounted = true;
    }
    componentDidUpdate(prevProps) {
        if (prevProps.isShareScopeLoading && !this.props.isShareScopeLoading) this.setState({
            // @ts-expect-error - TS2322 - Type 'SharePermission[] | undefined' is not assignable to type 'SharePermission[]'.
            sharePermissions: this.props.sharePermissions,
            // @ts-expect-error - TS2322 - Type 'SharePermission[] | undefined' is not assignable to type 'SharePermission[]'.
            editPermissions: this.props.editPermissions
        });
    }
    componentWillUnmount() {
        this.isComponentMounted = false;
    }
    setStateIfMounted(stateUpdates) {
        if (this.isComponentMounted) // @ts-expect-error - TS2345 - Argument of type 'Partial<State>' is not assignable to parameter of type 'State | ((prevState: Readonly<State>, props: Readonly<AppProps<OR>>) => State | Pick<State, keyof State> | null) | Pick<...> | null'.
        this.setState(stateUpdates);
    }
    render() {
        const { isShareScopeLoading: isShareScopeLoading, onCancel: onCancel, title: title, headingTitleLevel: headingTitleLevel, shareeOptions: shareeOptions, editOptions: editOptions, actionButtonCaption: actionButtonCaption, isEditorListShown: isEditorListShown, isNameReadOnly: isNameReadOnly } = this.props;
        const { name: name, description: description, owner: owner, isPending: isPending, isNameRequiredError: isNameRequiredError, sharePermissions: sharePermissions, viewersCustomMessage: viewersCustomMessage, nameTooltip: nameTooltip, editPermissions: editPermissions, serverValidationErrors: serverValidationErrors } = this.state;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $16Zyv.default), {
            isPending: isPending,
            isNameRequiredError: isNameRequiredError,
            isShareScopeLoading: isShareScopeLoading,
            title: title,
            headingTitleLevel: headingTitleLevel,
            shareeOptions: shareeOptions,
            editOptions: editOptions,
            name: name,
            nameTooltip: nameTooltip,
            description: description,
            owner: owner,
            serverValidationErrors: serverValidationErrors,
            actionButtonCaption: actionButtonCaption,
            // @ts-expect-error - Type 'WithUIAnalyticsEvent<Omit<{ label: string | undefined; placeholder: string | undefined; suggestedAccountId: string | undefined; selectedUser: User | undefined; onChange: (arg1: User | undefined, args_1: UIAnalyticsEvent) => void; ... 6 more ...; forwardedRef?: Ref<...> | undefined; }, keyof WithAnal...' is not assignable to type 'ComponentType<{ selectedUser: User; ariaLabel?: string | undefined; ariaLabelledby?: string | undefined; onChange: (arg1: User) => void; }>'.
            UserPicker: $ecba56bf17cbe422$var$UserPickerWithAnalytics,
            Access: (0, $brCV5.default),
            isEditorListShown: isEditorListShown,
            isNameReadOnly: isNameReadOnly,
            onNameChange: this.onNameChange,
            onDescriptionChange: this.onDescriptionChange,
            onOwnerChange: this.onOwnerChange,
            onAction: this.onAction,
            onCancel: onCancel,
            sharePermissions: sharePermissions,
            viewersCustomMessage: viewersCustomMessage,
            editPermissions: editPermissions,
            onSharePermissionChange: this.onSharePermissionChange,
            onEditPermissionChange: this.onEditPermissionChange,
            nameInputRef: this.nameInputRef
        });
    }
}
const $ecba56bf17cbe422$export$f99395d0d1e1a10e = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_19pk1i6y _18u010v4 _n3tdv77o",
            __cmplp.className
        ])
    });
});
const $ecba56bf17cbe422$export$1005c9f9ab7599e8 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_otyr1i6y _2hwx10v4 _ca0qv77o",
            __cmplp.className
        ])
    });
});

});
parcelRegister("brCV5", function(module, exports) {

$parcel$export(module.exports, "default", () => $7cce47b530ee46f1$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $LFmXM = parcelRequire("LFmXM");

var $6svxr = parcelRequire("6svxr");

var $9cbmy = parcelRequire("9cbmy");

var $1nkcA = parcelRequire("1nkcA");

var $idGBm = parcelRequire("idGBm");



var $eZnyh = parcelRequire("eZnyh");

var $fPszn = parcelRequire("fPszn");

var $hqg3Q = parcelRequire("hqg3Q");
const $7cce47b530ee46f1$export$b704bccf33aa8fc7 = (0, $LFmXM.default)((sharePermissions)=>{
    const accessType = (0, $eZnyh.mapAccessTypeFromPermissions)(sharePermissions);
    const sharePermissionRows = accessType === (0, $22859e611426c88f$export$52e14e112503bf52) ? [
        {
            type: (0, $22859e611426c88f$export$52e14e112503bf52)
        }
    ] : [
        ...sharePermissions
    ];
    return {
        accessType: accessType,
        sharePermissionRows: sharePermissionRows
    };
});
const $7cce47b530ee46f1$export$42cefa6463604ece = (0, $LFmXM.default)((sharePermissions)=>{
    const editAccessType = (0, $eZnyh.mapAccessTypeFromPermissions)(sharePermissions);
    const editPermissionRows = editAccessType === (0, $22859e611426c88f$export$52e14e112503bf52) ? [
        {
            type: (0, $22859e611426c88f$export$52e14e112503bf52)
        }
    ] : [
        ...sharePermissions
    ];
    return {
        editAccessType: editAccessType,
        editPermissionRows: editPermissionRows
    };
});
// eslint-disable-next-line jira/react/no-class-components
class $7cce47b530ee46f1$var$AccessWrapper extends (0, $eJOHy.Component) {
    setSharePermission(sharePermission, analyticsEvent) {
        const { onSharePermissionChange: onSharePermissionChange } = this.props;
        const { type: type } = sharePermission;
        const attributes = {
            shareeType: type,
            shareesCount: undefined,
            allRoles: undefined
        };
        switch(sharePermission.type){
            case 0, $f461f432d18e9f64$export$86517eb0163ef745:
            case 0, $f461f432d18e9f64$export$b0a0e62d9b1a8269:
                onSharePermissionChange([
                    sharePermission
                ]);
                break;
            case 0, $22859e611426c88f$export$52e14e112503bf52:
                onSharePermissionChange([]);
                break;
            default:
                {
                    const newPermissions = this.props.sharePermissions.filter((element)=>!(0, $eZnyh.isPublicOrOpenOrPrivate)(element.type)) // remove possible PUBLIC_SHARE or OPEN_SHARE permissions
                    .concat(sharePermission);
                    // @ts-expect-error - TS2322 - Type 'number' is not assignable to type 'undefined'.
                    attributes.shareesCount = newPermissions.length;
                    // @ts-expect-error - TS2322 - Type 'boolean | undefined' is not assignable to type 'undefined'.
                    attributes.allRoles = sharePermission.type === (0, $f461f432d18e9f64$export$5ef95a67b8fd1ff6) ? !sharePermission.role : undefined; // If it is a project, we may want to know if all roles where given access
                    onSharePermissionChange(newPermissions);
                }
                break;
        }
        (0, $1nkcA.fireUiAnalytics)(analyticsEvent, {
            name: 'shareeRowAddButton',
            attributes: attributes
        });
    }
    setEditPermission(sharePermission, analyticsEvent) {
        const { onEditPermissionChange: onEditPermissionChange } = this.props;
        const { type: type } = sharePermission;
        const attributes = {
            shareeType: type,
            shareesCount: undefined,
            allRoles: undefined
        };
        switch(sharePermission.type){
            case 0, $f461f432d18e9f64$export$86517eb0163ef745:
            case 0, $f461f432d18e9f64$export$b0a0e62d9b1a8269:
                onEditPermissionChange([
                    sharePermission
                ]);
                break;
            case 0, $22859e611426c88f$export$52e14e112503bf52:
                onEditPermissionChange([]);
                break;
            default:
                {
                    const newPermissions = this.props.editPermissions.filter((element)=>!(0, $eZnyh.isPublicOrOpenOrPrivate)(element.type)) // remove possible PUBLIC_SHARE or OPEN_SHARE permissions
                    .concat(sharePermission);
                    // @ts-expect-error - TS2322 - Type 'number' is not assignable to type 'undefined'.
                    attributes.shareesCount = newPermissions.length;
                    // @ts-expect-error - TS2322 - Type 'boolean | undefined' is not assignable to type 'undefined'.
                    attributes.allRoles = sharePermission.type === (0, $f461f432d18e9f64$export$5ef95a67b8fd1ff6) ? !sharePermission.role : undefined; // If it is a project, we may want to know if all roles where given access
                    onEditPermissionChange(newPermissions);
                }
                break;
        }
        (0, $1nkcA.fireUiAnalytics)(analyticsEvent, {
            name: 'editorRowAddButton',
            attributes: attributes
        });
    }
    render() {
        const { intl: { formatMessage: formatMessage }, shareeOptions: shareeOptions, editOptions: editOptions, editPermissions: editPermissions, sharePermissions: sharePermissions, viewersCustomMessage: viewersCustomMessage, isShareScopeLoading: isShareScopeLoading, isEditorListShown: isEditorListShown, sharePermissionsServerValidationError: sharePermissionsServerValidationError, editPermissionsServerValidationError: editPermissionsServerValidationError } = this.props;
        const { accessType: accessType, sharePermissionRows: sharePermissionRows } = $7cce47b530ee46f1$export$b704bccf33aa8fc7(sharePermissions);
        const { editAccessType: editAccessType, editPermissionRows: editPermissionRows } = $7cce47b530ee46f1$export$42cefa6463604ece(editPermissions);
        const { duplicatedIndex: duplicatedIndex, duplicatedEditIndex: duplicatedEditIndex, revokePermissionMessage: revokePermissionMessage } = this.state;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9cbmy.ScreenReaderText), {
            "aria-live": "polite",
            "data-testid": "shareable-entity-dialog.access.screen"
        }, revokePermissionMessage), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6svxr.default), {
            label: formatMessage((0, $fPszn.default).access),
            // @ts-expect-error - TS2322 - Type '{ children: () => Element; label: string; isInvalid: boolean; invalidMessage: string; name: string; }' is not assignable to type 'IntrinsicAttributes & FieldComponentProps<string, HTMLInputElement>'.
            isInvalid: !!sharePermissionsServerValidationError,
            invalidMessage: sharePermissionsServerValidationError,
            name: "access"
        }, ({ fieldProps: { //  @ts-expect-error - TS7053: Element implicitly has an 'any' type because expression of type '"aria-label"' can't be used to index type 'FieldProps<string, HTMLInputElement>'.
        'aria-label': ariaLabel, 'aria-labelledby': ariaLabelledby } })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $hqg3Q.default), {
                ariaLabel: ariaLabel,
                ariaLabelledby: ariaLabelledby,
                type: accessType,
                duplicatedIndex: duplicatedIndex,
                isShareScopeLoading: isShareScopeLoading,
                shareeOptions: shareeOptions,
                customMessage: viewersCustomMessage,
                sharePermissionRows: sharePermissionRows,
                onAddSharePermission: this.onAddSharePermission,
                onRemove: this.onRemove,
                errorMessage: sharePermissionsServerValidationError
            })), ' ', isEditorListShown && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6svxr.default), {
            label: formatMessage((0, $fPszn.default).editor),
            // @ts-expect-error - TS2322 - Type '{ children: () => Element; label: string; isInvalid: boolean; invalidMessage: string; name: string; }' is not assignable to type 'IntrinsicAttributes & FieldComponentProps<string, HTMLInputElement>'.
            isInvalid: !!editPermissionsServerValidationError,
            invalidMessage: editPermissionsServerValidationError,
            name: "editor"
        }, ({ fieldProps: { //  @ts-expect-error - TS7053: Element implicitly has an 'any' type because expression of type '"aria-label"' can't be used to index type 'FieldProps<string, HTMLInputElement>'.
        'aria-label': ariaLabel, 'aria-labelledby': ariaLabelledby } })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $hqg3Q.default), {
                ariaLabel: ariaLabel,
                ariaLabelledby: ariaLabelledby,
                isEditorList: true,
                type: editAccessType,
                duplicatedIndex: duplicatedEditIndex,
                isShareScopeLoading: isShareScopeLoading,
                shareeOptions: editOptions,
                sharePermissionRows: editPermissionRows,
                onAddSharePermission: this.onAddEditPermission,
                onRemove: this.onEditRemove,
                errorMessage: editPermissionsServerValidationError
            })));
    }
    constructor(...args){
        super(...args), this.state = {
            duplicatedIndex: undefined,
            duplicatedEditIndex: undefined,
            revokePermissionMessage: undefined
        }, this.onRemove = (index, analyticsEvent)=>{
            const { sharePermissions: sharePermissions, onSharePermissionChange: onSharePermissionChange } = this.props;
            const newPermissions = sharePermissions.filter((_, i)=>i !== index);
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            const permission = sharePermissions[index];
            const { type: type } = permission;
            (0, $1nkcA.fireUiAnalytics)(analyticsEvent, {
                name: 'shareeRowRemoveButton',
                attributes: {
                    shareeType: type,
                    shareeIndex: index,
                    shareesRemaining: newPermissions.length
                }
            });
            this.setState({
                duplicatedIndex: undefined,
                duplicatedEditIndex: undefined
            });
            const { formatMessage: formatMessage } = this.props.intl;
            let title;
            switch(type){
                case 0, $f461f432d18e9f64$export$b02d7412182d1bce:
                    title = permission.group.name;
                    break;
                case 0, $f461f432d18e9f64$export$5ef95a67b8fd1ff6:
                    title = permission.project.name;
                    break;
                case 0, $f461f432d18e9f64$export$487da0972e3459fe:
                    title = formatMessage((0, $eZnyh.allShareTypesProperties)[type].messageDescriptor);
                    break;
                case 0, $f461f432d18e9f64$export$aea0835048e1c730:
                    title = permission.user.displayName;
                    break;
                case 0, $f461f432d18e9f64$export$b0a0e62d9b1a8269:
                case 0, $f461f432d18e9f64$export$86517eb0163ef745:
                case 0, $22859e611426c88f$export$52e14e112503bf52:
                    title = formatMessage((0, $eZnyh.allShareTypesProperties)[type].messageDescriptor);
                    break;
                default:
                    title = 'none';
            }
            this.setState({
                revokePermissionMessage: formatMessage((0, $fPszn.default).permissionsRevoke, {
                    title: title
                })
            });
            onSharePermissionChange(newPermissions);
        }, this.onEditRemove = (index, analyticsEvent)=>{
            const { editPermissions: editPermissions, onEditPermissionChange: onEditPermissionChange } = this.props;
            const newPermissions = editPermissions.filter((_, i)=>i !== index);
            (0, $1nkcA.fireUiAnalytics)(analyticsEvent, {
                name: 'editorRowRemoveButton',
                attributes: {
                    shareeType: editPermissions[index].type,
                    shareeIndex: index,
                    shareesRemaining: newPermissions.length
                }
            });
            this.setState({
                duplicatedIndex: undefined,
                duplicatedEditIndex: undefined
            });
            onEditPermissionChange(newPermissions);
        }, this.onAddSharePermission = (sharePermission, analyticsEvent)=>{
            const { sharePermissions: sharePermissions, editPermissions: editPermissions, isEditorListShown: isEditorListShown } = this.props;
            const { type: type } = sharePermission;
            this.setState({
                duplicatedIndex: undefined
            });
            if ((0, $eZnyh.isPublicOrOpenOrPrivate)(type)) this.setSharePermission(sharePermission, analyticsEvent);
            else {
                // If the sharePermission already exists in sharePermissions then it should not be added.
                const duplicatedIndex = sharePermissions.findIndex((element)=>(0, $eZnyh.areSharePermissionsEqual)(sharePermission, element));
                if (duplicatedIndex >= 0) this.setState({
                    duplicatedIndex: duplicatedIndex
                });
                else if (isEditorListShown) {
                    // If the sharePermission already exists in editPermissions then it should not be added.
                    const duplicatedEditIndex = editPermissions.findIndex((element)=>(0, $eZnyh.areSharePermissionsEqual)(sharePermission, element));
                    if (duplicatedEditIndex >= 0) this.setState({
                        duplicatedEditIndex: duplicatedEditIndex
                    });
                    else this.setSharePermission(sharePermission, analyticsEvent);
                } else this.setSharePermission(sharePermission, analyticsEvent);
            }
        }, this.onAddEditPermission = (sharePermission, analyticsEvent)=>{
            const { sharePermissions: sharePermissions, editPermissions: editPermissions } = this.props;
            const { type: type } = sharePermission;
            this.setState({
                duplicatedIndex: undefined
            });
            if ((0, $eZnyh.isPublicOrOpenOrPrivate)(type)) this.setEditPermission(sharePermission, analyticsEvent);
            else {
                // If the editPermissions take preference over editPermissions.
                const duplicatedIndex = sharePermissions.findIndex((element)=>(0, $eZnyh.areSharePermissionsEqual)(sharePermission, element));
                if (duplicatedIndex >= 0) this.onRemove(duplicatedIndex, analyticsEvent);
                // If the sharePermission already exists in editPermissions, then it should not be added.
                const duplicatedEditIndex = editPermissions.findIndex((element)=>(0, $eZnyh.areSharePermissionsEqual)(sharePermission, element));
                if (duplicatedEditIndex >= 0) this.setState({
                    duplicatedEditIndex: duplicatedEditIndex
                });
                else this.setEditPermission(sharePermission, analyticsEvent);
            }
        };
    }
}
var $7cce47b530ee46f1$export$2e2bcd8739ae039 = (0, $idGBm.injectIntlV2)($7cce47b530ee46f1$var$AccessWrapper);

});
parcelRegister("9cbmy", function(module, exports) {

$parcel$export(module.exports, "visuallyHiddenStyles", () => $f808b80c4ecef983$export$8dd524ceb40e3d16);
$parcel$export(module.exports, "ScreenReaderText", () => $f808b80c4ecef983$export$88fad6aa294f111c);
$parcel$export(module.exports, "ScreenReaderCaption", () => $f808b80c4ecef983$export$200c8e5d652aa9af);
$parcel$export(module.exports, "ScreenReaderLegend", () => $f808b80c4ecef983$export$dabfb48aa98ffd97);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ /**
 * Visible only to screenreaders. Use when there is a need
 * to provide more context to a non-sighted user.
 * Styled copied from @atlaskit/visually-hidden
 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
const $f808b80c4ecef983$export$8dd524ceb40e3d16 = {
    width: '1px',
    height: '1px',
    padding: 0,
    position: 'absolute',
    border: '0',
    clip: 'rect(1px, 1px, 1px, 1px)',
    overflow: 'hidden',
    whiteSpace: 'nowrap'
};
const $f808b80c4ecef983$export$88fad6aa294f111c = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eJOHy.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19itidpf _1reo15vq _18m915vq _1bsbt94y _4t3it94y _kqswstnw _ogto7mnp _o5721q9c",
            __cmplp.className
        ])
    });
});
const $f808b80c4ecef983$export$200c8e5d652aa9af = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "caption", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eJOHy.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19itidpf _1reo15vq _18m915vq _1bsbt94y _4t3it94y _kqswstnw _ogto7mnp _o5721q9c",
            __cmplp.className
        ])
    });
});
const $f808b80c4ecef983$export$dabfb48aa98ffd97 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "legend", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eJOHy.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19itidpf _1reo15vq _18m915vq _1bsbt94y _4t3it94y _kqswstnw _ogto7mnp _o5721q9c",
            __cmplp.className
        ])
    });
});

});

parcelRegister("1nkcA", function(module, exports) {

$parcel$export(module.exports, "fireUiAnalytics", () => $cf5f26e81f7d5e54$export$4909253b5bf1eed7);

var $9pL9Y = parcelRequire("9pL9Y");

var $iM63C = parcelRequire("iM63C");

var $5nSuO = parcelRequire("5nSuO");
// @ts-expect-error - TS7006 - Parameter 'a' implicitly has an 'any' type.
const $cf5f26e81f7d5e54$var$isNotUndefined = (a)=>a !== undefined;
const $cf5f26e81f7d5e54$var$mapPayload = (payload)=>{
    const context = (0, $5nSuO.default)(payload);
    const { name: name } = payload;
    return (0, (/*@__PURE__*/$parcel$interopDefault($9pL9Y)))({
        ...context,
        ...context.attributes,
        attributes: undefined,
        name: name
    }, $cf5f26e81f7d5e54$var$isNotUndefined);
};
const $cf5f26e81f7d5e54$export$4909253b5bf1eed7 = (event, payload)=>{
    event.update({
        ...$cf5f26e81f7d5e54$var$mapPayload(payload),
        analyticsType: (0, $iM63C.UI_EVENT_TYPE)
    }).fire();
};

});

parcelRegister("fPszn", function(module, exports) {

$parcel$export(module.exports, "default", () => $7d01b556e7dd0c74$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $7d01b556e7dd0c74$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    name: {
        "id": "shareable-entity-dialog.name",
        "defaultMessage": "Name"
    },
    description: {
        "id": "shareable-entity-dialog.description",
        "defaultMessage": "Description"
    },
    access: {
        "id": "shareable-entity-dialog.access",
        "defaultMessage": "Viewers"
    },
    editor: {
        "id": "shareable-entity-dialog.editor",
        "defaultMessage": "Editors"
    },
    owner: {
        "id": "shareable-entity-dialog.owner",
        "defaultMessage": "Owner"
    },
    nameIsRequired: {
        "id": "shareable-entity-dialog.name-is-required",
        "defaultMessage": "Name field is required"
    },
    permissionsRevoke: {
        "id": "shareable-entity-dialog.permissions-revoke",
        "defaultMessage": "Permission to share revoked for {title}"
    },
    requiredFieldsSummary: {
        "id": "shareable-entity-dialog.required-fields-summary",
        "defaultMessage": "Required fields are marked with an asterisk"
    }
});

});

parcelRegister("hqg3Q", function(module, exports) {

$parcel$export(module.exports, "default", () => $ac09d465698b9f14$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $fKXve = parcelRequire("fKXve");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");


var $j6YYU = parcelRequire("j6YYU");

var $ky6Bv = parcelRequire("ky6Bv");
class $ac09d465698b9f14$export$2e2bcd8739ae039 extends (0, $eJOHy.Component) {
    static{
        this.defaultProps = {
            isEditorList: false,
            type: undefined,
            duplicatedIndex: undefined,
            customMessage: undefined,
            errorMessage: undefined
        };
    }
    render() {
        const { isEditorList: isEditorList, isShareScopeLoading: isShareScopeLoading, type: type, shareeOptions: shareeOptions, sharePermissionRows: sharePermissionRows, duplicatedIndex: duplicatedIndex, onRemove: onRemove, onAddSharePermission: onAddSharePermission, customMessage: customMessage, errorMessage: errorMessage, ariaLabel: ariaLabel, ariaLabelledby: ariaLabelledby } = this.props;
        const isOnlyPublicAndOrganization = shareeOptions.length === 2 && shareeOptions.every((i)=>i.value === (0, $f461f432d18e9f64$export$b0a0e62d9b1a8269) || i.value === (0, $f461f432d18e9f64$export$86517eb0163ef745));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, customMessage ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($ac09d465698b9f14$var$CustomMessage, null, customMessage) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ky6Bv.default), {
            ariaLabel: ariaLabel,
            ariaLabelledby: ariaLabelledby,
            isEditorList: isEditorList,
            isShareScopeLoading: isShareScopeLoading,
            type: type,
            options: shareeOptions,
            onAddSharePermission: onAddSharePermission
        }), errorMessage && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
            xcss: $ac09d465698b9f14$var$errorMessageContainerStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fKXve.ErrorMessage), null, errorMessage)), isShareScopeLoading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($ac09d465698b9f14$var$EmptyRow, null) : !!sharePermissionRows.length && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $j6YYU.default), {
            isEditorList: isEditorList,
            sharePermissionRows: sharePermissionRows,
            duplicatedIndex: duplicatedIndex,
            forceHideRemoveButton: isOnlyPublicAndOrganization,
            onRemove: onRemove
        }));
    }
}
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $ac09d465698b9f14$var$EmptyRow = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_x3doudwz _4t3i1wpv",
            __cmplp.className
        ])
    });
});
const $ac09d465698b9f14$var$CustomMessage = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_11c81o8v _19pkidpf _syaz131l",
            __cmplp.className
        ])
    });
});
const $ac09d465698b9f14$var$errorMessageContainerStyles = (0, $1DXK0.xcss)({
    paddingBottom: 'space.100'
});

});
parcelRegister("j6YYU", function(module, exports) {

$parcel$export(module.exports, "default", () => $b109efbf126ce15d$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $6XJko = parcelRequire("6XJko");

var $ieBTn = parcelRequire("ieBTn");
function $b109efbf126ce15d$export$2e2bcd8739ae039(props) {
    const { sharePermissionRows: sharePermissionRows, onRemove: onRemove, duplicatedIndex: duplicatedIndex, forceHideRemoveButton: forceHideRemoveButton, isEditorList: isEditorList } = props;
    const content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, sharePermissionRows.map((sharePermission, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ieBTn.default), {
            index: index,
            key: index,
            sharePermission: sharePermission,
            onRemove: onRemove,
            isDuplicated: duplicatedIndex === index,
            forceHideRemoveButton: forceHideRemoveButton,
            isEditorRow: isEditorList
        })));
    if ((0, $6XJko.isVisualRefreshEnabled)()) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $b109efbf126ce15d$var$shareeListStyles,
        role: "list"
    }, content);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($b109efbf126ce15d$var$ShareeListContainer, {
        role: "list"
    }, content);
}
$b109efbf126ce15d$export$2e2bcd8739ae039.defaultProps = {
    duplicatedIndex: undefined,
    forceHideRemoveButton: false
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b109efbf126ce15d$var$ShareeListContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_x3doudwz _ca0qu2gc",
            __cmplp.className
        ])
    });
});
const $b109efbf126ce15d$var$shareeListStyles = (0, $1DXK0.xcss)({
    paddingTop: 'space.100'
});

});
parcelRegister("ieBTn", function(module, exports) {

$parcel$export(module.exports, "default", () => $d60bc6f16887c2fe$export$2e2bcd8739ae039);

var $idGBm = parcelRequire("idGBm");

var $3aYvM = parcelRequire("3aYvM");
var $d60bc6f16887c2fe$export$2e2bcd8739ae039 = (0, $idGBm.injectIntlV2)((0, $3aYvM.default));

});
parcelRegister("3aYvM", function(module, exports) {

$parcel$export(module.exports, "default", () => $400d57c1b8c52078$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $goZPP = parcelRequire("goZPP");

var $6J9k6 = parcelRequire("6J9k6");


var $6XJko = parcelRequire("6XJko");


var $eZnyh = parcelRequire("eZnyh");

var $itsPh = parcelRequire("itsPh");

var $8dSGC = parcelRequire("8dSGC");

var $2vEYB = parcelRequire("2vEYB");

var $4JE4Q = parcelRequire("4JE4Q");

var $kbNeB = parcelRequire("kbNeB");

var $h1L4N = parcelRequire("h1L4N");

var $4ht2c = parcelRequire("4ht2c");
const $400d57c1b8c52078$var$assertUnreachable = (_x)=>{
    throw new Error("Didn't expect to get here");
};
const $400d57c1b8c52078$var$RemoveIcon = ({ sharePermission: sharePermission, isEditorRow: isEditorRow, intl: intl })=>{
    const { type: type } = sharePermission;
    let sharePermissionMessage;
    switch(type){
        case 0, $f461f432d18e9f64$export$b02d7412182d1bce:
            sharePermissionMessage = intl.formatMessage((0, $2vEYB.default).groupPermission, {
                groupName: sharePermission.group.name
            });
            break;
        case 0, $f461f432d18e9f64$export$5ef95a67b8fd1ff6:
            sharePermissionMessage = intl.formatMessage((0, $2vEYB.default).projectPermission, {
                projectName: sharePermission.project.name,
                projectRole: sharePermission.role?.name ?? intl.formatMessage((0, $4JE4Q.default).allRoles)
            });
            break;
        case 0, $f461f432d18e9f64$export$aea0835048e1c730:
            sharePermissionMessage = intl.formatMessage((0, $2vEYB.default).userPermission, {
                displayName: sharePermission.user.displayName
            });
            break;
        case 0, $f461f432d18e9f64$export$b0a0e62d9b1a8269:
        case 0, $f461f432d18e9f64$export$86517eb0163ef745:
        case 0, $22859e611426c88f$export$52e14e112503bf52:
        case 0, $f461f432d18e9f64$export$487da0972e3459fe:
            sharePermissionMessage = intl.formatMessage((0, $eZnyh.allShareTypesProperties)[sharePermission.type].messageDescriptor);
            break;
        default:
            $400d57c1b8c52078$var$assertUnreachable(type);
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6J9k6))), {
        spacing: "spacious",
        label: intl.formatMessage(isEditorRow ? (0, $2vEYB.default).removeEditorSharePermissionButton : (0, $2vEYB.default).removeViewerSharePermissionButton, {
            sharePermission: sharePermissionMessage
        })
    });
};
class $400d57c1b8c52078$export$2e2bcd8739ae039 extends (0, $eJOHy.Component) {
    static{
        this.defaultProps = {
            forceHideRemoveButton: false
        };
    }
    renderSharePermission() {
        const { sharePermission: sharePermission, intl: intl } = this.props;
        const { type: type } = sharePermission;
        switch(type){
            case 0, $f461f432d18e9f64$export$b02d7412182d1bce:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8dSGC.default), {
                    sharePermission: sharePermission
                });
            case 0, $f461f432d18e9f64$export$5ef95a67b8fd1ff6:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kbNeB.default), {
                    sharePermission: sharePermission
                });
            case 0, $f461f432d18e9f64$export$487da0972e3459fe:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $h1L4N.default), null);
            case 0, $f461f432d18e9f64$export$aea0835048e1c730:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4ht2c.default), {
                    sharePermission: sharePermission
                });
            case 0, $f461f432d18e9f64$export$b0a0e62d9b1a8269:
            case 0, $f461f432d18e9f64$export$86517eb0163ef745:
            case 0, $22859e611426c88f$export$52e14e112503bf52:
                {
                    const shareTypeProperties = (0, $eZnyh.allShareTypesProperties)[sharePermission.type];
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $itsPh.IconWrapper), null, shareTypeProperties.icon), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $itsPh.NameWrapper), null, intl.formatMessage(shareTypeProperties.messageDescriptor)));
                }
            default:
                $400d57c1b8c52078$var$assertUnreachable(type);
                return null;
        }
    }
    renderRow() {
        const shouldShowRemoveButton = !this.props.forceHideRemoveButton && this.props.sharePermission.type !== (0, $22859e611426c88f$export$52e14e112503bf52);
        const content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, (0, $6XJko.isVisualRefreshEnabled)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
            className: (0, $hcewu.default)([
                "_16jlkb7n _1o9zkb7n _i0dl1wug _zulpu2gc _1e0c1txw _4cvr1h6o _1ul9idpf"
            ])
        }, this.renderSharePermission()) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($400d57c1b8c52078$var$NameContainer, null, this.renderSharePermission()), shouldShowRemoveButton && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($400d57c1b8c52078$var$RemoveButtonWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
            appearance: "subtle",
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($400d57c1b8c52078$var$RemoveIcon, {
                intl: this.props.intl,
                isEditorRow: this.props.isEditorRow,
                sharePermission: this.props.sharePermission
            }),
            onClick: this.onRemove
        })));
        if ((0, $6XJko.isVisualRefreshEnabled)()) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
            "data-testid": "shareable-entity-dialog.access.sharee-list.sharee-list-row.group-permission",
            role: "listitem",
            className: (0, $hcewu.default)([
                "_1e0c1txw _4cvr1h6o _1tkexy5q"
            ])
        }, content);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($400d57c1b8c52078$var$RowContainer, {
            "data-testid": "shareable-entity-dialog.access.sharee-list.sharee-list-row.group-permission",
            role: "listitem"
        }, content);
    }
    render() {
        const { isDuplicated: isDuplicated } = this.props;
        const row = this.renderRow();
        return isDuplicated ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($400d57c1b8c52078$var$BlinkWrapper, null, row) : row;
    }
    constructor(...args){
        super(...args), this.onRemove = (event, analyticsEvent)=>{
            const { index: index, onRemove: onRemove } = this.props;
            onRemove(index, analyticsEvent);
        };
    }
}
const $400d57c1b8c52078$var$groupPermissionStyles = null;
const $400d57c1b8c52078$var$sharePermissionStyles = null;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $400d57c1b8c52078$var$RowContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_p12f1osq _1e0c1txw _4cvr1h6o",
            __cmplp.className
        ])
    });
});
const $400d57c1b8c52078$var$NameContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_16jlkb7n _1o9zkb7n _i0dl1wug _1e0c1txw _4cvr1h6o _1ul9idpf",
            __cmplp.className
        ])
    });
});
const $400d57c1b8c52078$var$RemoveButtonWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_16jlidpf _1o9zidpf _i0dl1wug",
            __cmplp.className
        ])
    });
});
const $400d57c1b8c52078$var$blinkKeyFrames = null;
// position: is specified for z-index to work. z-index is needed to show box-shadow on top of sibling elements
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $400d57c1b8c52078$var$BlinkWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_2rkogqwt _y44vcdbo _kqswh2mm _1pby15gg",
            __cmplp.className
        ])
    });
});

});
parcelRegister("itsPh", function(module, exports) {

$parcel$export(module.exports, "NameWrapper", () => $2c24380225b8d794$export$45df02f361199409);
$parcel$export(module.exports, "IconWrapper", () => $2c24380225b8d794$export$be58b4326e23250f);
/* styled.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $f2JN3 = parcelRequire("f2JN3");

var $6XJko = parcelRequire("6XJko");
const $2c24380225b8d794$export$41fb1a16a8428b08 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_16jlkb7n _1o9zkb7n _i0dl1wug _1reo15vq _18m915vq _o5721q9c _1bto1l2s _18u0u2gc _1ul9idpf",
            __cmplp.className
        ])
    });
});
const $2c24380225b8d794$var$NameWrapperNew = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $2c24380225b8d794$var$nameWrapperStyles
    }, children);
const $2c24380225b8d794$var$nameWrapperStyles = (0, $1DXK0.xcss)({
    flex: '1 1 auto',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    minWidth: '0'
});
const $2c24380225b8d794$export$45df02f361199409 = (0, $f2JN3.componentWithCondition)((0, $6XJko.isVisualRefreshEnabled), $2c24380225b8d794$var$NameWrapperNew, $2c24380225b8d794$export$41fb1a16a8428b08);
const $2c24380225b8d794$export$61485171f59c8ecb = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_16jlidpf _1o9zidpf _i0dl1wug _ca0qv77o _u5f3v77o _n3tdv77o _19bvv77o",
            __cmplp.className
        ])
    });
});
const $2c24380225b8d794$var$IconWrapperNew = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $2c24380225b8d794$var$iconWrapperStyles
    }, children);
const $2c24380225b8d794$var$iconWrapperStyles = (0, $1DXK0.xcss)({
    display: 'flex',
    flex: '0 0 auto',
    // Match the padding of the Avatar component
    padding: 'space.025'
});
const $2c24380225b8d794$export$be58b4326e23250f = (0, $f2JN3.componentWithCondition)((0, $6XJko.isVisualRefreshEnabled), $2c24380225b8d794$var$IconWrapperNew, $2c24380225b8d794$export$61485171f59c8ecb);

});

parcelRegister("8dSGC", function(module, exports) {

$parcel$export(module.exports, "default", () => $27f2e13f442b397b$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $hxN6p = parcelRequire("hxN6p");

var $hh8BY = parcelRequire("hh8BY");

var $itsPh = parcelRequire("itsPh");
function $27f2e13f442b397b$export$2e2bcd8739ae039({ sharePermission: { group: group } }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $itsPh.IconWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hxN6p))), {
        label: "",
        spacing: "spacious",
        LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($hh8BY)))
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $itsPh.NameWrapper), null, group.name));
}

});

parcelRegister("2vEYB", function(module, exports) {

$parcel$export(module.exports, "default", () => $8cb4bcf517beab6f$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $8cb4bcf517beab6f$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    groupPermission: {
        "id": "shareable-entity-dialog.access.sharee-list.sharee-list-row.group-permission",
        "defaultMessage": "Group {groupName}"
    },
    projectPermission: {
        "id": "shareable-entity-dialog.access.sharee-list.sharee-list-row.project-permission",
        "defaultMessage": "Project {projectName}, {projectRole}"
    },
    userPermission: {
        "id": "shareable-entity-dialog.access.sharee-list.sharee-list-row.user-permission",
        "defaultMessage": "User {displayName}"
    },
    removeViewerSharePermissionButton: {
        "id": "shareable-entity-dialog.access.sharee-list.sharee-list-row.remove-viewer-share-permission-button",
        "defaultMessage": "Remove viewer permission for {sharePermission}"
    },
    removeEditorSharePermissionButton: {
        "id": "shareable-entity-dialog.access.sharee-list.sharee-list-row.remove-editor-share-permission-button",
        "defaultMessage": "Remove editor permission for {sharePermission}"
    },
    projectPermissionGalaxia: {
        "id": "shareable-entity-dialog.access.sharee-list.sharee-list-row.project-permission-galaxia",
        "defaultMessage": "Space {projectName}, {projectRole}"
    }
});

});

parcelRegister("4JE4Q", function(module, exports) {

$parcel$export(module.exports, "default", () => $a9d2e5377ccd9e40$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $a9d2e5377ccd9e40$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    allRoles: {
        "id": "shareable-entity-dialog.access.sharee-list.sharee-list-row.project-name.all-roles",
        "defaultMessage": "All roles"
    }
});

});

parcelRegister("kbNeB", function(module, exports) {

$parcel$export(module.exports, "default", () => $4fdf86cb8be3142f$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $5DgXR = parcelRequire("5DgXR");

var $jfAbl = parcelRequire("jfAbl");

var $idGBm = parcelRequire("idGBm");

var $6XJko = parcelRequire("6XJko");

var $f2JN3 = parcelRequire("f2JN3");

var $5MMQd = parcelRequire("5MMQd");

var $4JE4Q = parcelRequire("4JE4Q");
function $4fdf86cb8be3142f$export$e9c1012e93a9bbb8(props) {
    const { intl: { formatMessage: formatMessage }, sharePermission: { project: project, role: role } } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, !project.avatarUrl ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5MMQd.AvatarIllustrationContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jfAbl.default), {
        alt: ""
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5DgXR.default), {
        appearance: "square",
        src: project.avatarUrl,
        size: "small"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($4fdf86cb8be3142f$var$ProjectNameContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($4fdf86cb8be3142f$var$ProjectNameWrapper, null, project.name), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($4fdf86cb8be3142f$var$RoleNameWrapper, null, `, ${role && role.name || formatMessage((0, $4JE4Q.default).allRoles)}`)));
}
var $4fdf86cb8be3142f$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = (0, $idGBm.injectIntlV2)($4fdf86cb8be3142f$export$e9c1012e93a9bbb8);
const $4fdf86cb8be3142f$var$ProjectNameContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1txw _4cvr1h6o _1ul9idpf",
            __cmplp.className
        ])
    });
});
const $4fdf86cb8be3142f$var$RoleNameWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1reo15vq _18m915vq _o5721q9c _1bto1l2s _1ul9idpf",
            __cmplp.className
        ])
    });
});
const $4fdf86cb8be3142f$var$ProjectNameWrapperOld = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = $4fdf86cb8be3142f$var$RoleNameWrapper, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_18u0u2gc",
            __cmplp.className
        ])
    });
});
const $4fdf86cb8be3142f$var$ProjectNameWrapper = (0, $f2JN3.componentWithCondition)((0, $6XJko.isVisualRefreshEnabled), $4fdf86cb8be3142f$var$RoleNameWrapper, $4fdf86cb8be3142f$var$ProjectNameWrapperOld);

});
parcelRegister("jfAbl", function(module, exports) {

$parcel$export(module.exports, "default", () => $2ca11261fe712b20$export$2e2bcd8739ae039);
// THIS FILE WAS AUTO-GENERATED. MODIFY WITH CAUTION. See README.md

var $c4huj = parcelRequire("c4huj");

var $28aZb = parcelRequire("28aZb");
const $2ca11261fe712b20$export$abdf1e325e38b834 = (0, (/*@__PURE__*/$parcel$interopDefault($28aZb)));
const $2ca11261fe712b20$export$87ec2877821a8f12 = (0, (/*@__PURE__*/$parcel$interopDefault($28aZb)));
const $2ca11261fe712b20$var$Illustration = (0, $c4huj.createIllustration)({
    srcLight: $2ca11261fe712b20$export$abdf1e325e38b834,
    srcDark: $2ca11261fe712b20$export$87ec2877821a8f12,
    autoDark: false
});
var $2ca11261fe712b20$export$2e2bcd8739ae039 = $2ca11261fe712b20$var$Illustration;
// for advanced use only
const $2ca11261fe712b20$export$a179c88182cb9d56 = [
    0,
    0,
    256,
    145
];

});
parcelRegister("28aZb", function(module, exports) {
module.exports = new URL("default-project-avatar.6f6d91f9.svg", import.meta.url).toString();

});


parcelRegister("5MMQd", function(module, exports) {

$parcel$export(module.exports, "AvatarIllustrationContainer", () => $d08ea67266c0ce49$export$eb8ddf7dfea2a0d4);

var $eJOHy = parcelRequire("eJOHy");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");
const $d08ea67266c0ce49$export$eb8ddf7dfea2a0d4 = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $d08ea67266c0ce49$var$containerStyles
    }, children);
const $d08ea67266c0ce49$var$containerStyles = (0, $1DXK0.xcss)({
    borderRadius: 'border.radius.050',
    display: 'inline-block',
    height: '24px',
    margin: 'space.025',
    overflow: 'hidden',
    width: '24px'
});

});


parcelRegister("h1L4N", function(module, exports) {

$parcel$export(module.exports, "default", () => $7dc042ba97fa7920$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $jkYbX = parcelRequire("jkYbX");

var $k71qx = parcelRequire("k71qx");

var $epTsa = parcelRequire("epTsa");

var $lRq8t = parcelRequire("lRq8t");


var $eZnyh = parcelRequire("eZnyh");

var $itsPh = parcelRequire("itsPh");

var $1Gjaw = parcelRequire("1Gjaw");
const $7dc042ba97fa7920$export$9dc8ff4861a5b6ef = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1o8l _19bv1b66 _s7n4nkob",
            __cmplp.className
        ])
    });
});
const $7dc042ba97fa7920$var$UnknownProject = ()=>{
    const unknownProjectWarningGalaxia = (0, $epTsa.expVal)('project-terminology-refresh', 'isEnabled', false) ? (0, $1Gjaw.default).unknownProjectWarningGalaxia : (0, $1Gjaw.default).unknownProjectWarning;
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const shareTypeProperties = (0, $eZnyh.allShareTypesProperties)[0, $f461f432d18e9f64$export$487da0972e3459fe];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $itsPh.IconWrapper), null, shareTypeProperties.icon), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $itsPh.NameWrapper), null, formatMessage(shareTypeProperties.messageDescriptor), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $k71qx.default), {
        content: formatMessage(unknownProjectWarningGalaxia),
        /* @ts-expect-error Incompatible ref type in tooltip */ tag: $7dc042ba97fa7920$export$9dc8ff4861a5b6ef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jkYbX))), {
        label: formatMessage(unknownProjectWarningGalaxia),
        LEGACY_size: "medium",
        spacing: "spacious",
        color: "var(--ds-icon-accent-gray, #758195)"
    }))));
};
var $7dc042ba97fa7920$export$2e2bcd8739ae039 = $7dc042ba97fa7920$var$UnknownProject;

});
parcelRegister("1Gjaw", function(module, exports) {

$parcel$export(module.exports, "default", () => $c32cf267f8aadcc6$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $c32cf267f8aadcc6$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    unknownProjectWarning: {
        "id": "shareable-entity-dialog.access.sharee-list.sharee-list-row.unknown-project.unknown-project-warning",
        "defaultMessage": "You do not have access to this project. Saving will remove this share."
    },
    unknownProjectWarningGalaxia: {
        "id": "shareable-entity-dialog.access.sharee-list.sharee-list-row.unknown-project.unknown-project-warning-galaxia",
        "defaultMessage": "You do not have access to this space. Saving will remove this share."
    }
});

});


parcelRegister("4ht2c", function(module, exports) {

$parcel$export(module.exports, "default", () => $0b286a4c043777e8$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $5DgXR = parcelRequire("5DgXR");

var $58frP = parcelRequire("58frP");

var $6XJko = parcelRequire("6XJko");

var $f2JN3 = parcelRequire("f2JN3");

var $5MMQd = parcelRequire("5MMQd");
const $0b286a4c043777e8$var$UserName = (props)=>{
    const { sharePermission: { user: user } } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, !user.avatarUrl ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5MMQd.AvatarIllustrationContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($58frP))), {
        spacing: "spacious",
        label: ""
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5DgXR.default), {
        appearance: (0, $6XJko.isVisualRefreshEnabled)() ? 'circle' : 'square',
        src: user.avatarUrl,
        size: "small"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($0b286a4c043777e8$var$UserNameContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($0b286a4c043777e8$var$UserNameWrapper, null, user.displayName)));
};
var $0b286a4c043777e8$export$2e2bcd8739ae039 = $0b286a4c043777e8$var$UserName;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $0b286a4c043777e8$var$UserNameContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1txw _4cvr1h6o _1ul9idpf",
            __cmplp.className
        ])
    });
});
const $0b286a4c043777e8$var$RoleNameWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1reo15vq _18m915vq _o5721q9c _1bto1l2s _1ul9idpf",
            __cmplp.className
        ])
    });
});
const $0b286a4c043777e8$var$UserNameWrapperOld = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = $0b286a4c043777e8$var$RoleNameWrapper, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_18u0u2gc",
            __cmplp.className
        ])
    });
});
const $0b286a4c043777e8$var$UserNameWrapper = (0, $f2JN3.componentWithCondition)((0, $6XJko.isVisualRefreshEnabled), $0b286a4c043777e8$var$RoleNameWrapper, $0b286a4c043777e8$var$UserNameWrapperOld);

});




parcelRegister("ky6Bv", function(module, exports) {

$parcel$export(module.exports, "default", () => $853649422c3386dc$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $ljej9 = parcelRequire("ljej9");

var $lvKO5 = parcelRequire("lvKO5");

var $fFfFB = parcelRequire("fFfFB");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$853649422c3386dc$export$2e2bcd8739ae039 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lvKO5.TenantContextSubscriber), null, ({ tenantContext: { atlassianAccountId: atlassianAccountId, isAdmin: isAdmin } })=>atlassianAccountId != null && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fFfFB.default), {
            accountId: (0, $ljej9.toAccountId)(atlassianAccountId),
            isAdmin: isAdmin,
            ...props
        }));

});
parcelRegister("fFfFB", function(module, exports) {

$parcel$export(module.exports, "default", () => $e3f5821d567f1758$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $LFmXM = parcelRequire("LFmXM");

var $goZPP = parcelRequire("goZPP");

var $fKXve = parcelRequire("fKXve");

var $2sLVw = parcelRequire("2sLVw");

var $dPMMf = parcelRequire("dPMMf");

var $jubdf = parcelRequire("jubdf");

var $kDaaB = parcelRequire("kDaaB");

var $idGBm = parcelRequire("idGBm");

var $k3q7u = parcelRequire("k3q7u");

var $j0ZYT = parcelRequire("j0ZYT");


var $fucyK = parcelRequire("fucyK");

var $6XJko = parcelRequire("6XJko");


var $drTeo = parcelRequire("drTeo");

var $hzDyV = parcelRequire("hzDyV");
const $e3f5821d567f1758$var$mapToPickerProject = (0, $LFmXM.default)((project)=>{
    if (!project) return undefined;
    return {
        value: project.id,
        name: project.name,
        avatarUrl: project.avatarUrl
    };
});
const $e3f5821d567f1758$var$mapFromPickerProject = (0, $LFmXM.default)((project)=>({
        id: project.value,
        name: project.name,
        avatarUrl: project.avatarUrl
    }));
const $e3f5821d567f1758$var$defaultPickerType = (0, $f461f432d18e9f64$export$b02d7412182d1bce);
const $e3f5821d567f1758$var$getStateChangesOnTypeChange = (type)=>({
        selectedType: type,
        selectedGroup: undefined,
        selectedProject: undefined,
        selectedRole: undefined,
        selectedUser: undefined
    }); // eslint-disable-next-line jira/react/no-class-components
class $e3f5821d567f1758$export$aa7f7f1ebf5525ed extends (0, $eJOHy.Component) {
    static{
        this.defaultProps = {
            type: undefined
        };
    }
    static getDerivedStateFromProps(props, state) {
        const { type: type } = props;
        const { selectedType: selectedType, previousPropsType: previousPropsType } = state;
        if (!type || type === previousPropsType || type === selectedType) return {
            previousPropsType: type
        };
        return {
            previousPropsType: type,
            ...$e3f5821d567f1758$var$getStateChangesOnTypeChange(type || selectedType || $e3f5821d567f1758$var$defaultPickerType) // type can be undefined e.g. when user clicked Add to add a new row. If it is not passed via props - preserve currently selected dropdown value
        };
    }
    getShareTypeHelperMessage() {
        const { selectedType: selectedType } = this.state;
        if (this.props.isShareScopeLoading) return (0, $drTeo.default).shareScopeLoadingHelperMessage;
        switch(selectedType){
            case 0, $22859e611426c88f$export$52e14e112503bf52:
                return (0, $drTeo.default).privateShareHelperMessage;
            case 0, $f461f432d18e9f64$export$86517eb0163ef745:
                return (0, $drTeo.default).safePublicShareHelperMessage;
            case 0, $f461f432d18e9f64$export$b0a0e62d9b1a8269:
                return (0, $drTeo.default).openShareHelperMessage;
            default:
                return undefined;
        }
    }
    getOptionsWithHelperMessage() {
        const { options: options, intl: { formatMessage: formatMessage } } = this.props;
        const { selectedType: selectedType } = this.state;
        const message = this.getShareTypeHelperMessage();
        return options.map((option)=>{
            if (message && option.value === selectedType) return {
                ...option,
                // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
                label: formatMessage(message, {
                    website: window.location.host
                })
            };
            return option;
        });
    }
    onKeyDown(event) {
        if (event.key === 'Escape') event.stopPropagation();
    }
    renderPicker() {
        const { accountId: accountId, isAdmin: isAdmin, intl: { formatMessage: formatMessage } } = this.props;
        const { selectedType: selectedType, selectedGroup: selectedGroup, selectedProject: selectedProject, selectedRole: selectedRole, selectedUser: selectedUser } = this.state;
        switch(selectedType){
            case 0, $f461f432d18e9f64$export$b02d7412182d1bce:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jubdf.default), {
                    placeholder: formatMessage((0, $drTeo.default).groupPlaceholderText),
                    onChange: this.onGroupChange,
                    fetchOnce: false,
                    withMember: isAdmin ? undefined : accountId || undefined,
                    selectedGroup: selectedGroup,
                    width: (0, $dPMMf.gridSize) * 40,
                    isCompact: true,
                    onKeyDown: this.onKeyDown
                });
            case 0, $f461f432d18e9f64$export$aea0835048e1c730:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fucyK.default), {
                    placeholder: formatMessage((0, $drTeo.default).userPlaceholderText),
                    onChange: this.onUserChange,
                    selectedUser: selectedUser,
                    width: (0, $dPMMf.gridSize) * 40,
                    isCompact: true,
                    onKeyDown: this.onKeyDown
                });
            case 0, $f461f432d18e9f64$export$5ef95a67b8fd1ff6:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($e3f5821d567f1758$var$ColumnWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $k3q7u.default), {
                    placeholder: formatMessage((0, $drTeo.default).projectPlaceholderText),
                    onChange: this.onProjectChange,
                    selectedProject: $e3f5821d567f1758$var$mapToPickerProject(selectedProject),
                    width: (0, $dPMMf.gridSize) * 20,
                    isCompact: true,
                    requireBrowsePermission: !isAdmin,
                    onKeyDown: this.onKeyDown
                })), selectedProject ? /* passing key to rerender and therefore refetch options when new project is selected  */ /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($e3f5821d567f1758$var$ColumnWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $j0ZYT.default // @ts-expect-error - TS2339 - Property 'id' does not exist on type 'never'.
                ), {
                    key: selectedProject.id,
                    placeholder: formatMessage((0, $drTeo.default).rolePlaceholderText),
                    projectId: selectedProject.id,
                    onChange: this.onRoleChange,
                    selectedRole: selectedRole,
                    width: (0, $dPMMf.gridSize) * 20,
                    isCompact: true,
                    isCurrentMember: !isAdmin,
                    onKeyDown: this.onKeyDown
                })) : null);
            default:
                return null;
        }
    }
    render() {
        const { intl: { formatMessage: formatMessage }, options: options, isShareScopeLoading: isShareScopeLoading, isEditorList: isEditorList, ariaLabel: ariaLabel, ariaLabelledby: ariaLabelledby } = this.props;
        const isOnlyPublicAndOrganization = options.length === 2 && options.every((i)=>i.value === (0, $f461f432d18e9f64$export$b0a0e62d9b1a8269) || i.value === (0, $f461f432d18e9f64$export$86517eb0163ef745));
        const { selectedType: selectedType } = this.state;
        const shareTypeHelperMessage = this.getShareTypeHelperMessage();
        const optionsWithLabelsForScreenReader = this.getOptionsWithHelperMessage();
        const content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($e3f5821d567f1758$var$PickerContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($e3f5821d567f1758$var$ColumnWrapper, null, isEditorList ? /* @ts-expect-error - Property 'isEditorList' is missing in type '{ ariaLabel: string | undefined; ariaLabelledby: string | undefined; type: ShareType; isShareScopeLoading: boolean; options: Option[]; onChange: (type: ShareType) => void; }' but required in type 'Pick<Omit<{ isShareScopeLoading: boolean; isEditorList: boolean; ariaLabel?: string | undefined; ariaLabelledby?: string | undefined; } & Intl & { type: ShareType; options: Option[]; onChange: (arg1: ShareType, arg2: UIAnalyticsEvent) => void; }, "intl">, "onChange" | ... 5 more ... | "options">'. */ /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $hzDyV.EditorTypePicker), {
            ariaLabel: ariaLabel,
            ariaLabelledby: ariaLabelledby,
            type: selectedType,
            isShareScopeLoading: isShareScopeLoading,
            options: optionsWithLabelsForScreenReader,
            onChange: this.onTypeChange
        }) : /* @ts-expect-error - Property 'isEditorList' is missing in type '{ ariaLabel: string | undefined; ariaLabelledby: string | undefined; type: ShareType; isShareScopeLoading: boolean; options: Option[]; onChange: (type: ShareType) => void; }' but required in type 'Pick<Omit<{ isShareScopeLoading: boolean; isEditorList: boolean; ariaLabel?: string | undefined; ariaLabelledby?: string | undefined; } & Intl & { type: ShareType; options: Option[]; onChange: (arg1: ShareType, arg2: UIAnalyticsEvent) => void; }, "intl">, "onChange" | ... 5 more ... | "options">'. */ /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $hzDyV.default), {
            ariaLabel: ariaLabel,
            ariaLabelledby: ariaLabelledby,
            type: selectedType,
            isShareScopeLoading: isShareScopeLoading,
            options: optionsWithLabelsForScreenReader,
            onChange: this.onTypeChange
        })), shareTypeHelperMessage && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($e3f5821d567f1758$var$ColumnWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fKXve.HelperMessage), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kDaaB.default), {
            ...shareTypeHelperMessage,
            values: {
                // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
                website: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("b", null, window.location.host)
            }
        }))), !isShareScopeLoading && this.renderPicker()), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($e3f5821d567f1758$var$AddButtonWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
            isDisabled: isShareScopeLoading,
            onClick: this.onAdd,
            "aria-label": formatMessage(isEditorList ? (0, $drTeo.default).addEditors : (0, $drTeo.default).addViewers)
        }, isOnlyPublicAndOrganization ? formatMessage((0, $drTeo.default).update) : formatMessage((0, $drTeo.default).add))));
        if ((0, $6XJko.isVisualRefreshEnabled)()) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2sLVw.default), {
            alignItems: "center"
        }, content);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($e3f5821d567f1758$var$ShareePickerContainer, null, content);
    }
    constructor(...args){
        super(...args), this.state = {
            // disabling unused state checks due to https://github.com/yannickcr/eslint-plugin-react/issues/1759
            previousPropsType: undefined,
            selectedType: $e3f5821d567f1758$var$defaultPickerType,
            selectedGroup: undefined,
            selectedProject: undefined,
            selectedRole: undefined,
            selectedUser: undefined
        }, this.onTypeChange = (type)=>{
            // @ts-expect-error - TS2345 - Argument of type 'Partial<State>' is not assignable to parameter of type 'State | ((prevState: Readonly<State>, props: Readonly<Props>) => State | Pick<State, keyof State> | null) | Pick<...> | null'.
            this.setState($e3f5821d567f1758$var$getStateChangesOnTypeChange(type));
        }, this.onUserChange = (value)=>{
            this.setState({
                selectedUser: value
            });
        }, this.onGroupChange = (value)=>{
            this.setState({
                selectedGroup: value
            });
        }, this.onProjectChange = (value)=>{
            this.setState({
                selectedProject: value && $e3f5821d567f1758$var$mapFromPickerProject(value),
                selectedRole: undefined
            });
        }, this.onRoleChange = (role)=>{
            this.setState({
                selectedRole: role
            });
        }, this.onAdd = (event, analyticsEvent)=>{
            const { onAddSharePermission: onAddSharePermission } = this.props;
            const { selectedType: selectedType, selectedGroup: selectedGroup, selectedProject: selectedProject, selectedRole: selectedRole, selectedUser: selectedUser } = this.state;
            switch(selectedType){
                case 0, $f461f432d18e9f64$export$b02d7412182d1bce:
                    if (selectedGroup) onAddSharePermission({
                        type: (0, $f461f432d18e9f64$export$b02d7412182d1bce),
                        group: selectedGroup
                    }, analyticsEvent);
                    break;
                case 0, $f461f432d18e9f64$export$aea0835048e1c730:
                    if (selectedUser) onAddSharePermission({
                        type: (0, $f461f432d18e9f64$export$aea0835048e1c730),
                        user: selectedUser
                    }, analyticsEvent);
                    break;
                case 0, $f461f432d18e9f64$export$5ef95a67b8fd1ff6:
                    if (selectedProject) onAddSharePermission({
                        type: (0, $f461f432d18e9f64$export$5ef95a67b8fd1ff6),
                        project: selectedProject,
                        role: selectedRole
                    }, analyticsEvent);
                    break;
                case 0, $22859e611426c88f$export$52e14e112503bf52:
                    onAddSharePermission({
                        type: (0, $22859e611426c88f$export$52e14e112503bf52)
                    }, analyticsEvent);
                    break;
                case 0, $f461f432d18e9f64$export$86517eb0163ef745:
                    onAddSharePermission({
                        type: (0, $f461f432d18e9f64$export$86517eb0163ef745)
                    }, analyticsEvent);
                    break;
                case 0, $f461f432d18e9f64$export$b0a0e62d9b1a8269:
                    onAddSharePermission({
                        type: (0, $f461f432d18e9f64$export$b0a0e62d9b1a8269)
                    }, analyticsEvent);
                    break;
                default:
                    return undefined;
            }
            return undefined;
        };
    }
}
var $e3f5821d567f1758$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = (0, $idGBm.injectIntlV2)($e3f5821d567f1758$export$aa7f7f1ebf5525ed);
const $e3f5821d567f1758$var$ShareePickerContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1txw _4cvr1h6o _ca0qu2gc _u5f3idpf _n3tdu2gc _19bvidpf",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $e3f5821d567f1758$var$PickerContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_16jlkb7n _1o9zkb7n _i0dl1wug _1e0c1txw _4cvr1h6o",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $e3f5821d567f1758$var$ColumnWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_2hwxu2gc",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $e3f5821d567f1758$var$AddButtonWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_16jlidpf _1o9zidpf _i0dl1wug",
            __cmplp.className
        ])
    });
});

});
parcelRegister("j0ZYT", function(module, exports) {

$parcel$export(module.exports, "default", () => $d889d705d5d1ed18$export$2e2bcd8739ae039);

var $aBFKZ = parcelRequire("aBFKZ");

var $hZq8R = parcelRequire("hZq8R");
var $d889d705d5d1ed18$export$2e2bcd8739ae039 = (0, $aBFKZ.default)('RolePicker', {
    onChange: 'changed'
})((0, $hZq8R.default));

});
parcelRegister("hZq8R", function(module, exports) {

$parcel$export(module.exports, "default", () => $656d549491ea0797$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $aXKmr = parcelRequire("aXKmr");

var $fJTOm = parcelRequire("fJTOm");

var $idGBm = parcelRequire("idGBm");

var $2kFDr = parcelRequire("2kFDr");

var $1VPf9 = parcelRequire("1VPf9");
const $656d549491ea0797$var$filterOptions = (filter = '')=>{
    const lowerCaseFilter = filter.toLowerCase();
    // @ts-expect-error - TS7006 - Parameter 'option' implicitly has an 'any' type.
    return (option)=>option.label && option.label.toLowerCase().includes(lowerCaseFilter);
};
const $656d549491ea0797$var$transformRoleIntoOption = (role)=>role && {
        label: role.name,
        value: role.id,
        url: role.url,
        description: role.description
    };
const $656d549491ea0797$var$transformOptionIntoRole = (option)=>option && {
        name: option.label,
        id: option.value,
        url: option.url,
        description: option.description
    };
class $656d549491ea0797$export$fcd75734e151a80 extends (0, $eJOHy.Component) {
    static{
        this.defaultProps = {
            isRequired: false,
            isDisabled: false,
            isClearable: true,
            isCompact: false,
            isCurrentMember: true,
            width: 200
        };
    }
    constructor(props){
        super(props), this.state = {
            selectedRole: $656d549491ea0797$var$transformRoleIntoOption(this.props.selectedRole),
            prevSelectedRole: $656d549491ea0797$var$transformRoleIntoOption(this.props.selectedRole),
            options: []
        }, this.onSelected = (selectedOption)=>{
            this.setState({
                selectedRole: selectedOption
            });
            this.props.onChange($656d549491ea0797$var$transformOptionIntoRole(selectedOption));
        }, /* eslint-disable jira/react-arrow-function-property-naming */ this.fetchOptions = (filter)=>{
            const { projectId: projectId, isCurrentMember: isCurrentMember } = this.props;
            const { options: options } = this.state;
            return new Promise((resolve, reject)=>{
                if (options.length) return resolve(options.filter($656d549491ea0797$var$filterOptions(filter)));
                return (0, $2kFDr.requestRoles)(projectId, isCurrentMember).then((newOptions)=>{
                    this.setState({
                        options: newOptions
                    });
                    return resolve(newOptions.filter($656d549491ea0797$var$filterOptions(filter)));
                }, reject);
            });
        };
        this.rolePickerId = `project-picker.label.id-${(0, $aXKmr.v4)()}`;
    }
    static getDerivedStateFromProps(props, state) {
        const { selectedRole: selectedRole } = props;
        const currentRole = selectedRole && selectedRole.id;
        const prevRole = state.prevSelectedRole && state.prevSelectedRole.value;
        if (currentRole !== prevRole) {
            const selectedRoleOption = $656d549491ea0797$var$transformRoleIntoOption(selectedRole);
            return {
                ...state,
                selectedRole: selectedRoleOption,
                prevSelectedRole: selectedRoleOption
            };
        }
        return null;
    }
    componentDidMount() {
        const { selectedRole: selectedRole } = this.state;
        if (selectedRole && !selectedRole.label) this.fetchRole(selectedRole);
    }
    componentDidUpdate() {
        const { selectedRole: selectedRole } = this.state;
        if (selectedRole && !selectedRole.label) this.fetchRole(selectedRole);
    }
    fetchRole(selectedRole) {
        const { projectId: projectId } = this.props;
        const optionValue = selectedRole.value;
        const updateSelectedRole = (newRole)=>{
            const currentRole = this.state.selectedRole;
            const currentRoleValue = currentRole && currentRole.value;
            // Update the state only in case the project wasn't changed
            if (currentRoleValue === optionValue) this.setState({
                selectedRole: newRole
            });
        };
        return (0, $2kFDr.requestRole)(projectId, optionValue).then((role)=>updateSelectedRole(role)).catch(()=>updateSelectedRole(undefined));
    }
    render() {
        const { intl: { formatMessage: formatMessage }, onChange: onChange, projectId: projectId, selectedRole: selectedRole, ...props } = this.props;
        const { selectedRole: role } = this.state;
        return /* @ts-expect-error - Type '{ inputId: string; errorMessage: string; placeholder: string; onSelected: (selectedOption?: RoleOption | undefined) => void; options: (filter: string) => Promise<RoleOptions>; ... 8 more ...; "aria-label": string | undefined; }' is not assignable to type 'InexactPartial<Pick<Omit<ViewProps<RoleOption>, "intl">, "isRequired" | "isDisabled" | "isClearable" | "isCompact" | "label" | "width" | "isCreatable" | "isCheckbox" | ... 4 more ... | "noPortal">>'. */ /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fJTOm.default), {
            "aria-label": !this.props.label ? formatMessage((0, $1VPf9.default).labelText) : undefined,
            ...props,
            inputId: !this.props.inputId ? this.rolePickerId : this.props.inputId,
            errorMessage: formatMessage((0, $1VPf9.default).error),
            placeholder: formatMessage((0, $1VPf9.default).placeholder),
            onSelected: this.onSelected,
            options: this.fetchOptions,
            value: role && role.label ? role : null
        });
    }
}
var $656d549491ea0797$export$2e2bcd8739ae039 = (0, $idGBm.injectIntlV2)($656d549491ea0797$export$fcd75734e151a80);

});
parcelRegister("2kFDr", function(module, exports) {

$parcel$export(module.exports, "requestRoles", () => $cec62427b00ff26b$export$81b6bcb1593f7ad8);
$parcel$export(module.exports, "requestRole", () => $cec62427b00ff26b$export$258bff876f7723cb);

var $ldRNy = parcelRequire("ldRNy");

var $37zg9 = parcelRequire("37zg9");
const $cec62427b00ff26b$export$81b6bcb1593f7ad8 = (projectId, isCurrentMember)=>(0, $ldRNy.getRoles)(projectId, isCurrentMember).then((0, $37zg9.transformRoles));
const $cec62427b00ff26b$export$258bff876f7723cb = (projectId, RoleId)=>(0, $ldRNy.getRole)(projectId, RoleId).then((0, $37zg9.transformRole));

});
parcelRegister("ldRNy", function(module, exports) {

$parcel$export(module.exports, "getRoles", () => $f01b6ee90b6ac353$export$57690667ea6b189b);
$parcel$export(module.exports, "getRole", () => $f01b6ee90b6ac353$export$d1c3a5ff834adfa2);

var $1Ozm9 = parcelRequire("1Ozm9");
const $f01b6ee90b6ac353$export$29d3dfcf36fbbba5 = (projectId)=>`/rest/api/2/project/${encodeURIComponent(projectId)}`;
const $f01b6ee90b6ac353$export$1eec61a4fdaceca = (projectId, isCurrentMember)=>`${$f01b6ee90b6ac353$export$29d3dfcf36fbbba5(projectId)}/roledetails${isCurrentMember ? '?currentMember=true' : ''}`;
const $f01b6ee90b6ac353$export$177b7e5a782e5173 = (projectId, roleId)=>`${$f01b6ee90b6ac353$export$29d3dfcf36fbbba5(projectId)}/role/${encodeURIComponent(roleId)}`;
const $f01b6ee90b6ac353$export$57690667ea6b189b = (projectId, isCurrentMember)=>(0, $1Ozm9.default)($f01b6ee90b6ac353$export$1eec61a4fdaceca(projectId, isCurrentMember));
const $f01b6ee90b6ac353$export$d1c3a5ff834adfa2 = (projectId, roleId)=>(0, $1Ozm9.default)($f01b6ee90b6ac353$export$177b7e5a782e5173(projectId, roleId));

});

parcelRegister("37zg9", function(module, exports) {

$parcel$export(module.exports, "transformRole", () => $9a352231c526e93c$export$4f8aa0fda592cc8e);
$parcel$export(module.exports, "transformRoles", () => $9a352231c526e93c$export$18407dd0d4132046);
const $9a352231c526e93c$export$4f8aa0fda592cc8e = (role)=>({
        value: role.id,
        label: role.name,
        description: role.description,
        url: role.self
    });
const $9a352231c526e93c$export$18407dd0d4132046 = (roles)=>roles && roles.map($9a352231c526e93c$export$4f8aa0fda592cc8e) || [];

});


parcelRegister("1VPf9", function(module, exports) {

$parcel$export(module.exports, "default", () => $a93b599e87bb461e$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $a93b599e87bb461e$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    error: {
        "id": "role-picker.error",
        "defaultMessage": "We couldn't retrieve roles"
    },
    placeholder: {
        "id": "role-picker.placeholder",
        "defaultMessage": "All roles"
    },
    labelText: {
        "id": "role-picker.label-text",
        "defaultMessage": "Role"
    }
});

});



parcelRegister("drTeo", function(module, exports) {

$parcel$export(module.exports, "default", () => $060d88c1b17f747b$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $060d88c1b17f747b$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    add: {
        "id": "shareable-entity-dialog.access.sharee-picker.add",
        "defaultMessage": "Add"
    },
    update: {
        "id": "shareable-entity-dialog.access.sharee-picker.update",
        "defaultMessage": "Update"
    },
    openShareHelperMessage: {
        "id": "shareable-entity-dialog.access.sharee-picker.open-share-helper-message",
        "defaultMessage": "Any logged in user on {website}"
    },
    safePublicShareHelperMessage: {
        "id": "shareable-entity-dialog.access.sharee-picker.safe-public-share-helper-message",
        "defaultMessage": "Anyone on the internet. No sign-in required"
    },
    privateShareHelperMessage: {
        "id": "shareable-entity-dialog.access.sharee-picker.private-share-helper-message",
        "defaultMessage": "Only you"
    },
    shareScopeLoadingHelperMessage: {
        "id": "shareable-entity-dialog.access.sharee-picker.share-scope-loading-helper-message",
        "defaultMessage": "Checking for the default user preference"
    },
    addViewers: {
        "id": "shareable-entity-dialog.access.sharee-picker.add-viewers",
        "defaultMessage": "Add viewers"
    },
    addEditors: {
        "id": "shareable-entity-dialog.access.sharee-picker.add-editors",
        "defaultMessage": "Add editors"
    },
    projectPlaceholderText: {
        "id": "shareable-entity-dialog.access.sharee-picker.project-placeholder-text",
        "defaultMessage": "Select project"
    },
    userPlaceholderText: {
        "id": "shareable-entity-dialog.access.sharee-picker.user-placeholder-text",
        "defaultMessage": "Select user"
    },
    groupPlaceholderText: {
        "id": "shareable-entity-dialog.access.sharee-picker.group-placeholder-text",
        "defaultMessage": "Select group"
    },
    rolePlaceholderText: {
        "id": "shareable-entity-dialog.access.sharee-picker.role-placeholder-text",
        "defaultMessage": "Select role"
    },
    projectPlaceholderTextGalaxia: {
        "id": "shareable-entity-dialog.access.sharee-picker.project-placeholder-text-galaxia",
        "defaultMessage": "Select space"
    }
});

});

parcelRegister("hzDyV", function(module, exports) {

$parcel$export(module.exports, "default", () => $323dbd90bf120430$export$2e2bcd8739ae039);
$parcel$export(module.exports, "EditorTypePicker", () => $323dbd90bf120430$export$79b74763bbaf2964);

var $l5htz = parcelRequire("l5htz");

var $a28BS = parcelRequire("a28BS");
var $323dbd90bf120430$export$2e2bcd8739ae039 = (0, $l5htz.default)({
    onChange: 'pickShareeType'
})((0, $a28BS.default));
const $323dbd90bf120430$export$79b74763bbaf2964 = (0, $l5htz.default)({
    onChange: 'pickEditorType'
})((0, $a28BS.default));

});
parcelRegister("a28BS", function(module, exports) {

$parcel$export(module.exports, "default", () => $165f49cdc9ad0dd3$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $LFmXM = parcelRequire("LFmXM");

var $2sHLK = parcelRequire("2sHLK");

var $dPMMf = parcelRequire("dPMMf");

var $idGBm = parcelRequire("idGBm");


var $7Gt0G = parcelRequire("7Gt0G");
const $165f49cdc9ad0dd3$var$getOption = (options, type)=>options.find((option)=>option.value === type) || options[0];
const $165f49cdc9ad0dd3$var$getNormalizedOptions = (0, $LFmXM.default)((options, formatMessage)=>options.map((option)=>{
        const returnOption = {
            ...option,
            label: formatMessage(option.messageDescriptor)
        };
        if (!returnOption.isDisabled) return returnOption;
        if (returnOption.value === (0, $f461f432d18e9f64$export$86517eb0163ef745)) return {
            ...returnOption,
            disableReason: formatMessage((0, $7Gt0G.default).globalDisableReason)
        };
        return returnOption;
    }));
class $165f49cdc9ad0dd3$export$60cbee36e1a5d2a2 extends (0, $eJOHy.Component) {
    static getDerivedStateFromProps(props, state) {
        const { options: options, type: type } = props;
        if (state.selectedOption && state.selectedOption.value === type) return null;
        return {
            selectedOption: $165f49cdc9ad0dd3$var$getOption(options, type)
        };
    }
    render() {
        const { isShareScopeLoading: isShareScopeLoading, options: options, intl: { formatMessage: formatMessage }, ariaLabel: ariaLabel, ariaLabelledby: ariaLabelledby } = this.props;
        const normalizedOptions = $165f49cdc9ad0dd3$var$getNormalizedOptions(options, formatMessage);
        const normalizedSelectOption = $165f49cdc9ad0dd3$var$getOption(normalizedOptions, this.props.type);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2sHLK.PickerWithAvatarAndAnalytics), {
            // @ts-expect-error - Type '(option: Option, analyticsEvent: UIAnalyticsEvent) => void' is not assignable to type '(arg1: unknown, arg2: UIAnalyticsEvent | undefined, args_2: UIAnalyticsEvent) => any'.
            onSelected: this.onChange,
            options: normalizedOptions,
            // @ts-expect-error - Type '(option: Option) => { avatar: React.ReactNode; label: string; }' is not assignable to type 'FormatOptionDataTransformer<unknown>'.
            formatOptionDataTransformer: this.formatOptionDataTransformer,
            // @ts-expect-error - Type 'number' is not assignable to type 'string'.
            width: (0, $dPMMf.gridSize) * 20,
            listItemCustomStyles: {
                // Custom internal styling API for PickerWithAvatarAndAnalytics
                marginBottom: 2
            },
            isRequired: false,
            isDisabled: isShareScopeLoading,
            isClearable: false,
            isCompact: true,
            ...isShareScopeLoading ? {
                placeholder: ''
            } : {
                value: normalizedSelectOption
            },
            "aria-label": ariaLabel,
            "aria-labelledby": ariaLabelledby,
            getOptionLabel: this.screenReaderLabelForOption,
            // @ts-expect-error - Type '(event: KeyboardEvent<HTMLDivElement>) => void' is not assignable to type '(arg1: KeyboardEvent<HTMLElement>) => void'.
            onKeyDown: this.onKeyDown
        });
    }
    constructor(...args){
        super(...args), this.state = {
            selectedOption: $165f49cdc9ad0dd3$var$getOption(this.props.options, this.props.type)
        }, this.onChange = (option, analyticsEvent)=>{
            const { onChange: onChange } = this.props;
            onChange(option.value, analyticsEvent);
        }, this.onKeyDown = (event)=>{
            if (event.key === 'Escape') event.stopPropagation();
        }, // eslint-disable-next-line jira/react-arrow-function-property-naming
        this.screenReaderLabelForOption = (option)=>{
            const { options: options } = this.props;
            const currentOption = options?.length && options.find((optionFromList)=>optionFromList.value === option.value);
            if (currentOption && currentOption.label) return `${option.label}, ${currentOption.label}`;
            return option.label;
        }, /* eslint-disable jira/react-arrow-function-property-naming */ this.formatOptionDataTransformer = (option)=>{
            const { intl: { formatMessage: formatMessage } } = this.props;
            return {
                avatar: option.icon,
                label: formatMessage(option.messageDescriptor)
            };
        };
    }
}
var $165f49cdc9ad0dd3$export$2e2bcd8739ae039 = (0, $idGBm.injectIntlV2)($165f49cdc9ad0dd3$export$60cbee36e1a5d2a2);

});
parcelRegister("7Gt0G", function(module, exports) {

$parcel$export(module.exports, "default", () => $6ed8984367d593b7$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $6ed8984367d593b7$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    globalDisableReason: {
        "id": "shareable-entity-dialog.access.sharee-picker.sharee-type-picker.global-disable-reason",
        "defaultMessage": "This option has been disabled by your Jira administrator"
    }
});

});







parcelRegister("16Zyv", function(module, exports) {

$parcel$export(module.exports, "default", () => $52e00f58712079cf$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $LFmXM = parcelRequire("LFmXM");

var $fKXve = parcelRequire("fKXve");
var $6svxr = parcelRequire("6svxr");
var $lP4Q7 = parcelRequire("lP4Q7");

var $ik0CA = parcelRequire("ik0CA");
var $2qG7I = parcelRequire("2qG7I");
var $5a9Ro = parcelRequire("5a9Ro");

var $dQmi3 = parcelRequire("dQmi3");

var $sY9BV = parcelRequire("sY9BV");

var $k71qx = parcelRequire("k71qx");

var $jtIA2 = parcelRequire("jtIA2");

var $idGBm = parcelRequire("idGBm");


var $leZjE = parcelRequire("leZjE");

var $aqoIG = parcelRequire("aqoIG");

var $fPszn = parcelRequire("fPszn");
const $52e00f58712079cf$export$f3336396f1d7e7f0 = 'shareable-entity-dialog.input-name';
const $52e00f58712079cf$export$4ec563c550ebe302 = 'shareable-entity-dialog.text-field';
const $52e00f58712079cf$var$toPickerUser = (0, $LFmXM.default)(({ accountId: accountId, displayName: displayName, avatarUrl: avatarUrl })=>({
        accountId: accountId,
        value: accountId,
        displayName: displayName,
        label: displayName,
        avatarUrl: avatarUrl
    })); // eslint-disable-next-line jira/react/no-class-components
class $52e00f58712079cf$export$4e8eacd46550c748 extends (0, $eJOHy.Component) {
    static{
        this.defaultProps = {
            isPending: false,
            isEditorListShown: false,
            isNameReadOnly: false,
            owner: undefined
        };
    }
    renderFooter() {
        const { onCancel: onCancel, actionButtonCaption: actionButtonCaption, onAction: onAction, isPending: isPending, isNameRequiredError: isNameRequiredError, isShareScopeLoading: isShareScopeLoading = false } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aqoIG.default), {
            isActionEnabled: !isPending && !isNameRequiredError && !isShareScopeLoading,
            isActionInProgress: isPending,
            actionButtonCaption: actionButtonCaption,
            onAction: onAction,
            onCancel: onCancel
        });
    }
    renderModalBody() {
        const { isNameRequiredError: isNameRequiredError, isShareScopeLoading: isShareScopeLoading = false, intl: { formatMessage: formatMessage }, isEditorListShown: isEditorListShown, isNameReadOnly: isNameReadOnly, editOptions: editOptions, editPermissions: editPermissions, name: name, nameInputRef: nameInputRef, nameTooltip: nameTooltip, description: description, owner: owner, sharePermissions: sharePermissions, viewersCustomMessage: viewersCustomMessage, UserPicker: UserPicker, Access: Access, onDescriptionChange: onDescriptionChange, onEditPermissionChange: onEditPermissionChange, onNameChange: onNameChange, onOwnerChange: onOwnerChange, onSharePermissionChange: onSharePermissionChange, shareeOptions: shareeOptions, serverValidationErrors: serverValidationErrors } = this.props;
        const nameServerValidationError = serverValidationErrors[0, $22859e611426c88f$export$b85469cbf362db42];
        const descriptionServerValidationError = serverValidationErrors[0, $22859e611426c88f$export$a1d4ae33ba772a5b];
        const sharePermissionsServerValidationError = serverValidationErrors[0, $22859e611426c88f$export$378fd4cd7d69440f];
        const editPermissionsServerValidationError = serverValidationErrors[0, $22859e611426c88f$export$fb465a1f4d511f87];
        const nameValidationErrorMessage = isNameRequiredError ? formatMessage((0, $fPszn.default).nameIsRequired) : nameServerValidationError;
        const renderNameField = (fieldProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $sY9BV.default), {
                ...fieldProps,
                testId: $52e00f58712079cf$export$4ec563c550ebe302,
                value: name,
                isDisabled: isNameReadOnly,
                onChange: onNameChange,
                isInvalid: !!nameValidationErrorMessage,
                ref: nameInputRef,
                "aria-describedby": `${$52e00f58712079cf$export$f3336396f1d7e7f0}-error`
            });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6svxr.default), {
            label: formatMessage((0, $fPszn.default).name),
            isRequired: true,
            name: "name",
            id: $52e00f58712079cf$export$f3336396f1d7e7f0
        }, ({ fieldProps: fieldProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, nameTooltip ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $k71qx.default), {
                content: nameTooltip
            }, renderNameField(fieldProps)) : renderNameField(fieldProps), nameValidationErrorMessage && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fKXve.ErrorMessage), null, nameValidationErrorMessage))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6svxr.default), {
            label: formatMessage((0, $fPszn.default).description),
            name: "description"
        }, ({ fieldProps: fieldProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dQmi3.default), {
                ...fieldProps,
                value: description,
                onChange: onDescriptionChange,
                isInvalid: !!descriptionServerValidationError
            }), descriptionServerValidationError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fKXve.ErrorMessage), null, descriptionServerValidationError))), owner && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6svxr.default), {
            label: formatMessage((0, $fPszn.default).owner),
            name: "owner"
        }, ({ fieldProps: { //  @ts-expect-error - TS7053: Element implicitly has an 'any' type because expression of type '"aria-label"' can't be used to index type 'FieldProps<string, HTMLInputElement>'.
        'aria-label': ariaLabel, 'aria-labelledby': ariaLabelledby } })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(UserPicker, {
                "aria-label": ariaLabel,
                "aria-labelledby": ariaLabelledby,
                selectedUser: $52e00f58712079cf$var$toPickerUser(owner),
                onChange: onOwnerChange
            }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(Access, {
            isShareScopeLoading: isShareScopeLoading,
            shareeOptions: shareeOptions,
            editOptions: editOptions,
            sharePermissions: sharePermissions,
            viewersCustomMessage: viewersCustomMessage,
            editPermissions: editPermissions,
            onSharePermissionChange: onSharePermissionChange,
            onEditPermissionChange: onEditPermissionChange,
            isEditorListShown: isEditorListShown,
            sharePermissionsServerValidationError: sharePermissionsServerValidationError,
            editPermissionsServerValidationError: editPermissionsServerValidationError
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jtIA2.default), null));
    }
    render() {
        const { title: title, headingTitleLevel: headingTitleLevel, intl: intl } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, title && (headingTitleLevel ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $leZjE.default), {
            headingLevel: headingTitleLevel,
            title: title
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2qG7I.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5a9Ro.default), null, title))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ik0CA.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($52e00f58712079cf$var$RequiredMessage, null, intl.formatMessage((0, $fPszn.default).requiredFieldsSummary), " ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lP4Q7.default), null)), this.renderModalBody()), this.renderFooter());
    }
}
var $52e00f58712079cf$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = (0, $idGBm.injectIntlV2)($52e00f58712079cf$export$4e8eacd46550c748);
const $52e00f58712079cf$var$RequiredMessage = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "p", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_syaz1gjq",
            __cmplp.className
        ])
    });
});

});
parcelRegister("dQmi3", function(module, exports) {

$parcel$export(module.exports, "default", () => $ef995104f62942f4$export$2e2bcd8739ae039);
/* text-area.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $hcewu = parcelRequire("hcewu");
var $awdRS = parcelRequire("awdRS");

var $eJOHy = parcelRequire("eJOHy");

var $jrFnt = parcelRequire("jrFnt");

var $eGOwo = parcelRequire("eGOwo");
const $ef995104f62942f4$var$packageName = "platform-pkg";
const $ef995104f62942f4$var$packageVersion = "0.0.0-use.local";
const $ef995104f62942f4$var$analyticsParams = {
    componentName: 'textArea',
    packageName: $ef995104f62942f4$var$packageName,
    packageVersion: $ef995104f62942f4$var$packageVersion
};
const $ef995104f62942f4$var$lineHeightBase = 20;
const $ef995104f62942f4$var$lineHeightCompact = 16;
const $ef995104f62942f4$var$compactVerticalPadding = 2;
const $ef995104f62942f4$var$verticalPadding = 6;
const $ef995104f62942f4$var$transitionDuration = '0.2s';
const $ef995104f62942f4$var$borderWidth = 2;
const $ef995104f62942f4$var$baseStyles = null;
const $ef995104f62942f4$var$appearanceStyles = {
    standard: "_1dqonqa1 _kp821elr _1ltx1j9a _1bqs13gt _z1pvsyzs _19wt1elr _12ym1d5g _19qkv77o _1dbiv77o _1etu1v6z _zedr1v6z _1itd12x7 _1a4912x7 _17km1v6z _wg601v6z _858u1p6i _jomrr01l _7ehiq049 _186j1p6i _qu18syzs",
    subtle: "_1dqonqa1 _kp823acm _1ltx18uv _19wt1elr _12ym1d5g _19qkv77o _1dbiv77o _1etu1v6z _zedr1v6z _1itd12x7 _1a4912x7 _wg601v6z _17km1v6z _858u1p6i _jomrr01l _7ehiq049",
    none: "_1dqoglyw _kp823acm _1ltx18uv _19wt3acm _12ym18uv _19qkv77o _zedr12x7 _1dbiv77o _1etu12x7 _1itd12x7 _wg6012x7 _1a4912x7 _17km12x7 _858u3acm _jomr18uv _7ehinruj"
};
const $ef995104f62942f4$var$fontStyles = {
    default: "_ect41gqc",
    monospace: "_ect41odn _1tn22smr _14mdudxr",
    large: "_11c81ixg _1tn22smr"
};
const $ef995104f62942f4$var$resizeStyles = {
    horizontal: "_14zg1e08",
    vertical: "_14zg1e54",
    auto: "_14zg1hrf",
    smart: "_14zgglyw",
    none: "_14zgglyw"
};
const $ef995104f62942f4$var$setSmartHeight = (el)=>{
    // Always reset height to auto before calculating new height
    el.style.height = 'auto';
    const borderHeight = $ef995104f62942f4$var$borderWidth;
    const paddingBoxHeight = el.scrollHeight;
    const borderBoxHeight = paddingBoxHeight + borderHeight * 2;
    el.style.height = `${borderBoxHeight}px`;
};
const $ef995104f62942f4$var$InnerTextArea = /*#__PURE__*/ (0, $eJOHy.forwardRef)((props, ref)=>{
    const ourRef = (0, $eJOHy.useRef)(null);
    const { resize: resize = 'smart', appearance: appearance = 'standard', isCompact: isCompact = false, isRequired: isRequired = false, isReadOnly: isReadOnly = false, isDisabled: isDisabled = false, isInvalid: isInvalid = false, isMonospaced: isMonospaced = false, minimumRows: minimumRows = 2, testId: testId, maxHeight: maxHeight = '50vh', onBlur: onBlur, onFocus: onFocus, onChange: onChange, value: value, style: style, ...rest } = props;
    const borderHeight = (0, $eJOHy.useMemo)(()=>appearance === 'none' ? 2 : 1, [
        appearance
    ]);
    (0, $eJOHy.useEffect)(()=>{
        const el = ourRef.current;
        if (resize === 'smart' && el) $ef995104f62942f4$var$setSmartHeight(el);
    }, [
        resize,
        value
    ]);
    const onBlurWithAnalytics = (0, $jrFnt.usePlatformLeafEventHandler)({
        fn: (event)=>{
            onBlur && onBlur(event);
        },
        action: 'blurred',
        ...$ef995104f62942f4$var$analyticsParams
    });
    const onFocusWithAnalytics = (0, $jrFnt.usePlatformLeafEventHandler)({
        fn: (event)=>{
            onFocus && onFocus(event);
        },
        action: 'focused',
        ...$ef995104f62942f4$var$analyticsParams
    });
    const getTextAreaRef = (elementRef)=>{
        ourRef.current = elementRef;
        if (ref && typeof ref === 'object') // @ts-ignore
        ref.current = elementRef;
        if (ref && typeof ref === 'function') ref(elementRef);
    };
    const handleOnChange = (0, $eJOHy.useCallback)((e)=>{
        const el = ourRef.current;
        if (resize === 'smart' && el) $ef995104f62942f4$var$setSmartHeight(el);
        onChange && onChange(e);
    }, [
        onChange,
        resize
    ]);
    const controlProps = {
        'data-invalid': isInvalid ? isInvalid : undefined,
        'data-compact': isCompact ? isCompact : undefined,
        'data-testid': testId ? testId : undefined
    };
    const compactMinHeightStyles = null;
    return /*#__PURE__*/ (0, $gt9Am.jsx)("textarea", {
        ...controlProps,
        value: value,
        disabled: isDisabled,
        readOnly: isReadOnly,
        required: isRequired,
        ref: getTextAreaRef,
        onChange: handleOnChange,
        onBlur: onBlurWithAnalytics,
        onFocus: onFocusWithAnalytics,
        rows: minimumRows,
        ...rest,
        className: (0, $hcewu.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _16jlkb7n _1o9zkb7n _i0dl1osq _2rko1sit _11c82smr _12ji1r31 _1qu2glyw _12y31o36 _1reo1wug _18m91wug _v564r5cv _189ee4h9 _1e0c1ule _vchhusvi _1bsb1osq _1ul9idpf _p12f1osq _kqswh2mm _syazj3m3 _slp31hna _153g78r2 _usy4mag2 _1a2sr6rt _vbqb9jg2 _j5dh13gf _cfjqkb7n _k3o7n7od _1goxglyw _13xeglyw _1fra78r2 _ibjd10ko _6zpvr6rt _19k01y1w _1idr1wmz _1lep9jg2 _nmhq1fiz _1n388sxn _1luh194a _ndzbr01l _1vj01cu8",
            $ef995104f62942f4$var$appearanceStyles[appearance],
            (0, $eGOwo.fg)('platform_design_system_team_safari_input_fix') && $ef995104f62942f4$var$fontStyles['large'],
            $ef995104f62942f4$var$fontStyles[isMonospaced ? 'monospace' : 'default'],
            $ef995104f62942f4$var$resizeStyles[resize],
            "_uzq71i7i _16lwuel1"
        ]),
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            ...style,
            maxHeight: maxHeight,
            "--_6ny3x7": (0, $awdRS.default)($ef995104f62942f4$var$lineHeightCompact * minimumRows + $ef995104f62942f4$var$compactVerticalPadding * 2 + borderHeight * 2, "px"),
            "--_eorxnz": (0, $awdRS.default)($ef995104f62942f4$var$lineHeightBase * minimumRows + $ef995104f62942f4$var$verticalPadding * 2 + borderHeight * 2, "px")
        }
    });
}); /**
     * __Text area__
     *
     * A text area lets users enter long form text which spans over multiple lines.
     *
     * - [Examples](https://atlassian.design/components/textarea/examples)
     * - [Code](https://atlassian.design/components/textarea/code)
     * - [Usage](https://atlassian.design/components/textarea/usage)
     */ 
const $ef995104f62942f4$var$TextArea = /*#__PURE__*/ (0, $eJOHy.memo)(/*#__PURE__*/ (0, $eJOHy.forwardRef)(function TextArea(props, ref) {
    return /*#__PURE__*/ (0, $gt9Am.jsx)($ef995104f62942f4$var$InnerTextArea, {
        ref: ref,
        ...props
    });
}));
$ef995104f62942f4$var$TextArea.displayName = 'TextArea';
var $ef995104f62942f4$export$2e2bcd8739ae039 = $ef995104f62942f4$var$TextArea;

});

parcelRegister("leZjE", function(module, exports) {

$parcel$export(module.exports, "default", () => $bcff5eba4852e020$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
const $bcff5eba4852e020$var$ActionModalCustomHeader = ({ headingLevel: headingLevel = 1, title: title })=>{
    // Dynamically render the heading tag based on the level
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const Heading = `h${headingLevel}`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($bcff5eba4852e020$var$CustomHeaderWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($bcff5eba4852e020$var$DynamicHeading, {
        as: Heading
    }, title));
};
var $bcff5eba4852e020$export$2e2bcd8739ae039 = $bcff5eba4852e020$var$ActionModalCustomHeader;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $bcff5eba4852e020$var$DynamicHeading = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_11c8lodh",
            __cmplp.className
        ])
    });
});
const $bcff5eba4852e020$var$headerStyles = {
    display: 'flex',
    padding: `${"var(--ds-space-300, 24px)"} ${"var(--ds-space-300, 24px)"} 22px`,
    alignItems: 'center',
    justifyContent: 'space-between'
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
const $bcff5eba4852e020$var$CustomHeaderWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1yt4npc0 _1e0c1txw _4cvr1h6o _1bah1yb4",
            __cmplp.className
        ])
    });
});

});

parcelRegister("aqoIG", function(module, exports) {

$parcel$export(module.exports, "default", () => $6a86736dd33c659e$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $12DRg = parcelRequire("12DRg");

var $goZPP = parcelRequire("goZPP");

var $48q59 = parcelRequire("48q59");

var $kseeK = parcelRequire("kseeK");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $7ep4S = parcelRequire("7ep4S");

var $idGBm = parcelRequire("idGBm");

var $6XJko = parcelRequire("6XJko");

var $1fY75 = parcelRequire("1fY75");
function $6a86736dd33c659e$export$1784e93004806671(props) {
    const { isActionEnabled: isActionEnabled, isActionInProgress: isActionInProgress, actionButtonCaption: actionButtonCaption, actionButtonAppearance: actionButtonAppearance, onCancel: onCancel, onAction: onAction, intl: { formatMessage: formatMessage } } = props;
    const SaveBtn = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
        appearance: actionButtonAppearance,
        type: "submit",
        isDisabled: !isActionEnabled,
        onClick: onAction
    }, actionButtonCaption);
    const CancelBtn = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
        appearance: "subtle-link",
        isDisabled: isActionInProgress,
        onClick: onCancel
    }, formatMessage((0, $1fY75.default).cancelButtonCaption));
    const footerGroup = (0, $6XJko.isVisualRefreshEnabled)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, CancelBtn, SaveBtn) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, SaveBtn, CancelBtn);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kseeK.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($6a86736dd33c659e$var$Container, null, isActionInProgress && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $6a86736dd33c659e$var$spinnerContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7ep4S.default), {
        size: "small"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $48q59.default), null, footerGroup)));
}
$6a86736dd33c659e$export$1784e93004806671.defaultProps = {
    isActionEnabled: true,
    isActionInProgress: false,
    actionButtonAppearance: 'primary',
    onAction: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
    onCancel: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg)))
};
var $6a86736dd33c659e$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = (0, $idGBm.injectIntlV2)($6a86736dd33c659e$export$1784e93004806671);
const $6a86736dd33c659e$var$Container = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1txw _1bahesu3 _4cvr1h6o _16jlkb7n",
            __cmplp.className
        ])
    });
});
const $6a86736dd33c659e$var$spinnerContainerStyles = (0, $1DXK0.xcss)({
    marginRight: 'space.200'
});

});
parcelRegister("1fY75", function(module, exports) {

$parcel$export(module.exports, "default", () => $5da3ad601cc8d1f7$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $5da3ad601cc8d1f7$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    cancelButtonCaption: {
        "id": "shareable-entity-dialog.action-modal-footer.cancel-button-caption",
        "defaultMessage": "Cancel"
    }
});

});





parcelRegister("5iMG1", function(module, exports) {

$parcel$export(module.exports, "default", () => $0a59b4b6f32b954e$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $0a59b4b6f32b954e$var$messages = (0, $7qGN1.defineMessages)({
    title: {
        "id": "copy-filters-modal.common.flags.error.title",
        "defaultMessage": "We couldn't copy a filter"
    },
    description: {
        "id": "copy-filters-modal.common.flags.error.description",
        "defaultMessage": "There was an error, please try again."
    }
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$0a59b4b6f32b954e$export$2e2bcd8739ae039 = ()=>({
        type: 'error',
        title: $0a59b4b6f32b954e$var$messages.title,
        description: $0a59b4b6f32b954e$var$messages.description,
        messageId: 'copy-filters-modal.common.ui.flags.error',
        messageType: 'transactional'
    });

});

parcelRegister("fPH8V", function(module, exports) {

$parcel$export(module.exports, "default", () => $a410c7f639808d7c$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $a410c7f639808d7c$var$messages = (0, $7qGN1.defineMessages)({
    title: {
        "id": "copy-filters-modal.common.flags.success.title",
        "defaultMessage": "A copy of {name} was successfully created."
    }
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$a410c7f639808d7c$export$2e2bcd8739ae039 = (name)=>({
        type: 'success',
        title: [
            $a410c7f639808d7c$var$messages.title,
            {
                name: name
            }
        ],
        isAutoDismiss: true,
        messageId: 'copy-filters-modal.common.ui.flags.success',
        messageType: 'transactional'
    });

});

parcelRegister("gEkj6", function(module, exports) {

$parcel$export(module.exports, "default", () => $d83da3458914ba56$export$2e2bcd8739ae039);

var $jGzN3 = parcelRequire("jGzN3");

var $f4mVN = parcelRequire("f4mVN");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$d83da3458914ba56$export$2e2bcd8739ae039 = (filter, jql, isFavourite, overrideSharePermissions)=>{
    const body = (0, $f4mVN.transformCopyFilter)(filter, jql, isFavourite);
    return (0, $jGzN3.performPostRequest)(`/rest/api/2/filter${overrideSharePermissions ? '?overrideSharePermissions=true' : ''}`, {
        body: JSON.stringify(body)
    });
};

});
parcelRegister("f4mVN", function(module, exports) {

$parcel$export(module.exports, "transformCopyFilter", () => $846e5703e0ed12e6$export$bf8cb54494b88c10);

var $5DL51 = parcelRequire("5DL51");
const $846e5703e0ed12e6$export$bf8cb54494b88c10 = (filter, jql, isFavourite)=>{
    const { description: description, name: name, owner: owner, editPermissions: editPermissions, sharePermissions: sharePermissions } = filter;
    const result = {
        name: name,
        description: description,
        favourite: isFavourite,
        jql: jql,
        sharePermissions: (0, $5DL51.transformSharePermissionsToServer)(sharePermissions || [], true),
        editPermissions: (0, $5DL51.transformSharePermissionsToServer)(editPermissions || [], true)
    };
    if (owner) result.owner = {
        accountId: owner.accountId
    };
    return result;
};

});


parcelRegister("4WWoF", function(module, exports) {

$parcel$export(module.exports, "default", () => $35329fd3dcecf138$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $35329fd3dcecf138$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    header: {
        "id": "copy-filters-modal.content.header",
        "defaultMessage": "Copy filter {name}"
    },
    saveButtonCaption: {
        "id": "copy-filters-modal.content.save-button-caption",
        "defaultMessage": "Copy"
    }
});

});





parcelRegister("82d1f", function(module, exports) {

$parcel$export(module.exports, "default", () => $1048b687db6ffcb5$export$2e2bcd8739ae039);

var $7NseJ = parcelRequire("7NseJ");

var $gnQAk = parcelRequire("gnQAk");

var $6dsEx = parcelRequire("6dsEx");

var $iYaR3 = parcelRequire("iYaR3");
const $1048b687db6ffcb5$var$mapStateToProps = (state, ownProps)=>({
        filter: (0, $iYaR3.getFilter)(state, ownProps.entityId)
    });
const $1048b687db6ffcb5$var$mapDispatchToProps = (dispatch, ownProps)=>({
        onInitialised: ownProps.onDialogShown,
        onFilterDeleted: (filter)=>{
            dispatch((0, $6dsEx.deleted)(filter.name));
            // @ts-expect-error - TS2554 - Expected 1 arguments, but got 0.
            ownProps.onUpdated();
        },
        onFilterDeleteFailed: (filter)=>dispatch((0, $6dsEx.deleteFailed)(filter.name)),
        onFilterInitiateFailed: (filter)=>{
            dispatch((0, $6dsEx.deleteFailed)(filter.name));
            ownProps.onDataRetrieveFailed();
        },
        onCancel: ownProps.onCancel
    });
var // @ts-expect-error - TS2345 - Type 'undefined' is not assignable to type 'Filter'.
$1048b687db6ffcb5$export$2e2bcd8739ae039 = (0, $gnQAk.connect)($1048b687db6ffcb5$var$mapStateToProps, $1048b687db6ffcb5$var$mapDispatchToProps)((0, $7NseJ.default));

});

parcelRegister("9CQfK", function(module, exports) {

$parcel$export(module.exports, "default", () => $c76dab806c96a889$export$2e2bcd8739ae039);
// TODO: Should be able to clean up with nin-save-filter-dialog-entry-point

var $ecsqp = parcelRequire("ecsqp");

var $f2JN3 = parcelRequire("f2JN3");
var $hbF3h = parcelRequire("hbF3h");

var $6zXPf = parcelRequire("6zXPf");

var $gnQAk = parcelRequire("gnQAk");

var $j0saC = parcelRequire("j0saC");

var $iYaR3 = parcelRequire("iYaR3");
const $c76dab806c96a889$var$mapStateToPropsOld = (initialState, ownProps)=>{
    const onEdited = (_updatedData)=>{
        // @ts-expect-error - TS2554 - Expected 1 arguments, but got 0.
        ownProps.onUpdated();
    };
    const onInitiateSuccess = ()=>{
        ownProps.onDialogShown();
    };
    return (state)=>({
            id: ownProps.entityId,
            name: (0, $iYaR3.getName)(state, ownProps.entityId),
            description: (0, $iYaR3.getDescription)(state, ownProps.entityId),
            sharePermissions: (0, $iYaR3.getShares)(state, ownProps.entityId),
            editPermissions: (0, $iYaR3.getEdits)(state, ownProps.entityId),
            onCancel: ownProps.onCancel,
            onInitiateSuccess: onInitiateSuccess,
            onEdited: // onEditFailed: noop, // do NOT send .onUpdateFailed() - it will remove operation from `operations` array, even though modal is still open
            onEdited
        });
};
const $c76dab806c96a889$var$mapStateToPropsNewModal = (initialState, ownProps)=>{
    const onEdited = (_updatedData)=>{
        // @ts-expect-error - TS2554 - Expected 1 arguments, but got 0.
        ownProps.onUpdated();
    };
    return ()=>({
            onDialogShown: ownProps.onDialogShown,
            filterId: ownProps.entityId,
            onClose: ownProps.onCancel,
            onSuccess: onEdited,
            // onEditFailed: noop, // do NOT send .onUpdateFailed() - it will remove operation from `operations` array, even though modal is still open
            isOpen: true
        });
};
const $c76dab806c96a889$var$FilterDialog = (0, $f2JN3.componentWithCondition)((0, $6zXPf.getWillShowNav4), (0, $j0saC.AsyncUpdateFilterDialog), (0, $ecsqp.default));
const $c76dab806c96a889$var$mapStateToProps = (0, $hbF3h.functionWithCondition)((0, $6zXPf.getWillShowNav4), $c76dab806c96a889$var$mapStateToPropsNewModal, // @ts-expect-error - TS2345 - Target signature provides too few arguments. Expected 1 or more, but got 0.
$c76dab806c96a889$var$mapStateToPropsOld);
var $c76dab806c96a889$export$2e2bcd8739ae039 = (0, $gnQAk.connect)($c76dab806c96a889$var$mapStateToProps, {})($c76dab806c96a889$var$FilterDialog);

});
parcelRegister("ecsqp", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $1f6b8601e66a8550$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $12DRg = parcelRequire("12DRg");

var $BwaQq = parcelRequire("BwaQq");

var $aP411 = parcelRequire("aP411");

var $5kYyR = parcelRequire("5kYyR");


var $gZTP9 = parcelRequire("gZTP9");

var $iQlpe = parcelRequire("iQlpe");
function $1f6b8601e66a8550$var$EditFilterModal(props) {
    const isAdmin = (0, $gZTP9.useIsAdmin)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5kYyR.default), {
        id: "unhandled",
        packageName: "jiraEditFiltersModal",
        teamName: "jira-cosmos"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aP411.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $iQlpe.default), {
        isAdmin: isAdmin,
        ...props
    })));
}
$1f6b8601e66a8550$var$EditFilterModal.defaultProps = {
    onEdited: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
    onEditFailed: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
    onCancel: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg)))
};
var $1f6b8601e66a8550$export$2e2bcd8739ae039 = (0, $BwaQq.AnalyticsSource)('editFilter', (0, $466f60259c330878$export$1171103ea9083ffa))((0, $BwaQq.AnalyticsSubject)('filter')($1f6b8601e66a8550$var$EditFilterModal));

});
parcelRegister("iQlpe", function(module, exports) {

$parcel$export(module.exports, "default", () => $e509c7f9e21545fb$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $2ZYsz = parcelRequire("2ZYsz");

var $ksMI6 = parcelRequire("ksMI6");

var $eSnSE = parcelRequire("eSnSE");

var $gYnSx = parcelRequire("gYnSx");

var $1uIew = parcelRequire("1uIew");

var $bdG9p = parcelRequire("bdG9p");

var $idGBm = parcelRequire("idGBm");

var $gCeeo = parcelRequire("gCeeo");


var $hijy3 = parcelRequire("hijy3");

var $jDKsM = parcelRequire("jDKsM");

var $3shmq = parcelRequire("3shmq");

var $6pMew = parcelRequire("6pMew");
const $e509c7f9e21545fb$var$getServerSideValidationErrors = (0, $ksMI6.createServerSideValidationErrorsGetter)({
    filterName: (0, $22859e611426c88f$export$b85469cbf362db42),
    shares: (0, $22859e611426c88f$export$378fd4cd7d69440f),
    edit_permissions: (0, $22859e611426c88f$export$fb465a1f4d511f87)
});
class $e509c7f9e21545fb$export$c4b945a6bafc6ddb extends (0, $eJOHy.Component) {
    componentDidMount() {
        this.props.onInitiateSuccess();
    }
    render() {
        const { onCancel: onCancel, name: name, description: description, editPermissions: editPermissions, sharePermissions: sharePermissions, intl: intl } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6pMew.default), {
            intl: intl,
            onCancel: onCancel,
            name: name,
            description: description,
            sharePermissions: sharePermissions,
            editPermissions: editPermissions,
            operation: this.onOperation,
            onOperationSucceed: this.onOperationSucceed,
            onOperationFailed: this.onOperationFailed,
            getServerSideValidationErrors: $e509c7f9e21545fb$var$getServerSideValidationErrors
        });
    }
    constructor(...args){
        super(...args), this.onOperation = (filter)=>{
            const { id: id, isAdmin: isAdmin } = this.props;
            return (0, $3shmq.default)(id, filter, isAdmin);
        }, this.onOperationSucceed = (filter, _, analyticsEvent)=>{
            const { id: id, onEdited: onEdited, flagService: flagService } = this.props;
            (0, $gCeeo.fireUIAnalytics)(analyticsEvent, 'editedFilter', {
                isViewerPrivate: filter.sharePermissions.length === 0,
                isEditorPrivate: filter.editPermissions && filter.editPermissions.length === 0
            });
            flagService.showFlag((0, $jDKsM.default)(filter.name));
            (0, $2ZYsz.fireTrackAnalytics)(analyticsEvent, {
                action: 'updated',
                actionSubjectId: `${id}`
            });
            onEdited(filter);
        }, // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.onOperationFailed = (error, analyticsEvent)=>{
            const { id: id, onEditFailed: onEditFailed, flagService: flagService } = this.props;
            (0, $eSnSE.default).safeErrorWithoutCustomerData('directories.filters.edit-modal.submit', `edit filter has failed, id=${this.props.id}`, error);
            if (!(error instanceof (0, $1uIew.ValidationError))) flagService.showFlag((0, $hijy3.default)());
            onEditFailed();
            (0, $gYnSx.default)({
                event: analyticsEvent,
                error: error,
                meta: {
                    id: 'operationFailedHandler',
                    packageName: 'jiraEditFiltersModal',
                    teamName: 'jira-cosmos'
                },
                attributes: {
                    action: 'updated',
                    actionSubjectId: `${id}`
                }
            });
        };
    }
}
var $e509c7f9e21545fb$export$2e2bcd8739ae039 = (0, $bdG9p.default)((0, $idGBm.injectIntlV2)($e509c7f9e21545fb$export$c4b945a6bafc6ddb));

});
parcelRegister("bdG9p", function(module, exports) {

$parcel$export(module.exports, "default", () => $8eb30b9664410926$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $bILK0 = parcelRequire("bILK0");
const $8eb30b9664410926$var$withFlagService = (WrappedComponent)=>{
    return (props)=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(WrappedComponent, {
            ...props,
            flagService: (0, $bILK0.flagService)
        });
};
var $8eb30b9664410926$export$2e2bcd8739ae039 = $8eb30b9664410926$var$withFlagService;

});

parcelRegister("hijy3", function(module, exports) {

$parcel$export(module.exports, "default", () => $3d3c74decb0358b8$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $3d3c74decb0358b8$var$messages = (0, $7qGN1.defineMessages)({
    genericTitle: {
        "id": "directories.filters-v2.edit-modal.flags.error.generic-title",
        "defaultMessage": "There was an error, please try again."
    }
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$3d3c74decb0358b8$export$2e2bcd8739ae039 = ()=>({
        type: 'error',
        title: $3d3c74decb0358b8$var$messages.genericTitle,
        messageId: 'edit-filters-modal.flags.error',
        messageType: 'transactional'
    });

});

parcelRegister("jDKsM", function(module, exports) {

$parcel$export(module.exports, "default", () => $ecb83e810b3ea795$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $ecb83e810b3ea795$var$messages = (0, $7qGN1.defineMessages)({
    title: {
        "id": "directories.filters-v2.edit-modal.flags.success.title",
        "defaultMessage": "{name} was successfully updated."
    }
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$ecb83e810b3ea795$export$2e2bcd8739ae039 = (name)=>({
        type: 'success',
        title: [
            $ecb83e810b3ea795$var$messages.title,
            {
                name: name
            }
        ],
        isAutoDismiss: true,
        messageId: 'edit-filters-modal.flags.success',
        messageType: 'transactional'
    });

});

parcelRegister("3shmq", function(module, exports) {

$parcel$export(module.exports, "default", () => $455d199cba0d2359$export$2e2bcd8739ae039);

var $eSnSE = parcelRequire("eSnSE");

var $4rr25 = parcelRequire("4rr25");

var $1g7fx = parcelRequire("1g7fx");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$455d199cba0d2359$export$2e2bcd8739ae039 = async (id, filter, overrideSharePermissions)=>{
    const body = (0, $1g7fx.transformEditableFilter)(filter);
    try {
        await (0, $4rr25.default)(id, body, overrideSharePermissions);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $eSnSE.default).safeErrorWithoutCustomerData('directories.filters-v2.edit-modal.edit-filter', error.message, error);
        throw error;
    }
};

});
parcelRegister("4rr25", function(module, exports) {

$parcel$export(module.exports, "default", () => $3cea528163da660e$export$2e2bcd8739ae039);

var $jGzN3 = parcelRequire("jGzN3");
const $3cea528163da660e$export$4a8805dc45e0d1a2 = (filterId, overrideSharePermissions)=>`/rest/api/3/filter/${filterId}${overrideSharePermissions ? '?overrideSharePermissions=true' : ''}`;
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$3cea528163da660e$export$2e2bcd8739ae039 = async (filterId, body, overrideSharePermissions)=>{
    const url = $3cea528163da660e$export$4a8805dc45e0d1a2(filterId, overrideSharePermissions);
    return (0, $jGzN3.performPutRequest)(url, {
        body: JSON.stringify(body)
    });
};

});

parcelRegister("1g7fx", function(module, exports) {

$parcel$export(module.exports, "transformEditableFilter", () => $d673cc8ca49986bc$export$29126713ffd80950);

var $5DL51 = parcelRequire("5DL51");
const $d673cc8ca49986bc$export$29126713ffd80950 = (filter)=>{
    const { description: description, name: name, owner: owner, sharePermissions: sharePermissions, editPermissions: editPermissions } = filter;
    const result = {
        name: name,
        description: description,
        sharePermissions: (0, $5DL51.transformSharePermissionsToServer)(sharePermissions || [], true),
        editPermissions: editPermissions ? (0, $5DL51.transformSharePermissionsToServer)(editPermissions, true) : undefined
    };
    if (owner) result.owner = {
        accountId: owner.accountId
    };
    return result;
};

});


parcelRegister("6pMew", function(module, exports) {

$parcel$export(module.exports, "default", () => $0fb1fe4040f6986d$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $56UKu = parcelRequire("56UKu");

var $cPjiD = parcelRequire("cPjiD");
function $0fb1fe4040f6986d$export$97b20acb2862c69e(props) {
    const { intl: { formatMessage: formatMessage }, name: name, description: description, onCancel: onCancel, ...restProps } = props;
    // Use sharing permission aware modal instead of one which doesn't respect global sharing setting
    return(// @ts-expect-error - TS2322 - Type '{ sharePermissions: SharePermission[]; editPermissions: SharePermission[]; getServerSideValidationErrors: (arg1: ValidationError) => Partial<...>; ... 10 more ...; onCancel: () => void; }' is not assignable to type 'Diff<AppProps<undefined>, { shareeOptions: Option[]; isEditorListShown: boolean; editOptions: Option[]; isShareScopeLoading?: boolean | undefined; }>'.
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $56UKu.SharingPermissionAwareShareableEntityModal), {
        sharingPermissionType: "filter",
        avoidInitialPublicSharePermission: false,
        title: formatMessage((0, $cPjiD.default).title),
        actionButtonCaption: formatMessage((0, $cPjiD.default).submitButtonCaption),
        initialName: name,
        initialDescription: description,
        initialOwner: undefined,
        onCancel: onCancel,
        ...restProps
    }));
}
var $0fb1fe4040f6986d$export$2e2bcd8739ae039 = $0fb1fe4040f6986d$export$97b20acb2862c69e;

});
parcelRegister("cPjiD", function(module, exports) {

$parcel$export(module.exports, "default", () => $4958e5a2d3e7b30b$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $4958e5a2d3e7b30b$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    title: {
        "id": "directories.filters-v2.edit-modal.title",
        "defaultMessage": "Edit filter"
    },
    submitButtonCaption: {
        "id": "directories.filters-v2.edit-modal.submit-button-caption",
        "defaultMessage": "Save"
    }
});

});





parcelRegister("96S5E", function(module, exports) {

$parcel$export(module.exports, "default", () => $81680acc29a7fef3$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $81680acc29a7fef3$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    headerCaption: {
        "id": "directories.filters-v2.main.header-caption",
        "defaultMessage": "Filters"
    },
    filter: {
        "id": "directories.filters-v2.main.filter",
        "defaultMessage": "Name"
    },
    popularity: {
        "id": "directories.filters-v2.main.popularity",
        "defaultMessage": "Starred by"
    },
    owner: {
        "id": "directories.filters-v2.main.owner",
        "defaultMessage": "Owner"
    },
    access: {
        "id": "directories.filters-v2.main.access",
        "defaultMessage": "Access"
    },
    viewers: {
        "id": "directories.filters-v2.main.viewers",
        "defaultMessage": "Viewers"
    },
    editors: {
        "id": "directories.filters-v2.main.editors",
        "defaultMessage": "Editors"
    },
    emptyFilterResultMessage: {
        "id": "directories.filters-v2.main.empty-filter-result-message",
        "defaultMessage": "No filters were found that match your search"
    },
    tableAriaLabel: {
        "id": "directories.filters-v2.main.table-aria-label",
        "defaultMessage": "Filters details"
    },
    filterResultsAnnouncement: {
        "id": "directories.filters-v2.main.filter-results-announcement",
        "defaultMessage": "{itemCount, plural, =0 {No filters were found that match your search} one {{itemCount} filter found} other {{itemCount} filters found}}"
    },
    actions: {
        "id": "directories.filters-v2.main.actions",
        "defaultMessage": "More actions"
    },
    aToZOrder: {
        "id": "directories.filters-v2.main.a-to-z-order",
        "defaultMessage": "Sort A to Z"
    },
    zToAOrder: {
        "id": "directories.filters-v2.main.z-to-a-order",
        "defaultMessage": "Sort Z to A"
    },
    starredToUnstarredOrder: {
        "id": "directories.filters-v2.main.starred-to-unstarred-order",
        "defaultMessage": "Sort starred to unstarred"
    },
    unstarredToStarredOrder: {
        "id": "directories.filters-v2.main.unstarred-to-starred-order",
        "defaultMessage": "Sort unstarred to starred"
    },
    lowestToHighestOrder: {
        "id": "directories.filters-v2.main.lowest-to-highest-order",
        "defaultMessage": "Sort lowest to highest"
    },
    highestToLowestOrder: {
        "id": "directories.filters-v2.main.highest-to-lowest-order",
        "defaultMessage": "Sort highest to lowest"
    }
});

});

parcelRegister("cAFyD", function(module, exports) {

$parcel$export(module.exports, "default", () => $08c349e0f7f3127b$export$2e2bcd8739ae039);

var $LFmXM = parcelRequire("LFmXM");


var $gnQAk = parcelRequire("gnQAk");

var $dH9V1 = parcelRequire("dH9V1");

var $7MYNw = parcelRequire("7MYNw");

var $a7fcJ = parcelRequire("a7fcJ");

var $iYaR3 = parcelRequire("iYaR3");

var $8BRiw = parcelRequire("8BRiw");
const $08c349e0f7f3127b$var$mapStateToPropsFactory = ()=>{
    const onCopyFactory = (0, $LFmXM.default)((onOperationRequested)=>()=>// @ts-expect-error - TS2554 - Expected 2 arguments, but got 1.
            onOperationRequested((0, $85bfce414eef38c7$export$92f9e1ed9114d3a6)));
    const onEditFactory = (0, $LFmXM.default)((onOperationRequested)=>()=>// @ts-expect-error - TS2554 - Expected 2 arguments, but got 1.
            onOperationRequested((0, $85bfce414eef38c7$export$250171a898bf7ef)));
    const onChangeOwnerFactory = (0, $LFmXM.default)((onOperationRequested)=>()=>// @ts-expect-error - TS2554 - Expected 2 arguments, but got 1.
            onOperationRequested((0, $85bfce414eef38c7$export$39d2a7fb21967424)));
    const onDeleteFactory = (0, $LFmXM.default)((onOperationRequested)=>()=>// @ts-expect-error - TS2554 - Expected 2 arguments, but got 1.
            onOperationRequested((0, $85bfce414eef38c7$export$4bd2facc4a3e6aa1)));
    return (state, ownProps)=>({
            onCopy: onCopyFactory(ownProps.onOperationRequested),
            onEdit: onEditFactory(ownProps.onOperationRequested),
            onChangeOwner: onChangeOwnerFactory(ownProps.onOperationRequested),
            onDelete: onDeleteFactory(ownProps.onOperationRequested),
            manageSubscriptionsUrl: (0, $iYaR3.manageSubscriptionsUrl)(state, ownProps.id),
            name: (0, $iYaR3.getName)(state, ownProps.id),
            owner: (0, $iYaR3.getOwner)(state, ownProps.id),
            atlassianAccountId: (0, $7MYNw.getAtlassianAccountId)(state),
            showSpinner: ownProps.isOperationInProgress,
            isCopyFilterModalOpen: (0, $a7fcJ.isCopyFilterModalOpen)(state),
            isWritable: (0, $iYaR3.getIsWritable)(state, ownProps.id),
            isAdmin: (0, $7MYNw.getIsAdmin)(state),
            popularity: (0, $iYaR3.getPopularity)(state, ownProps.id),
            filterId: ownProps.id
        });
};
const $08c349e0f7f3127b$var$mapDispatchToProps = {
    onOpenCopyFilterModal: (0, $dH9V1.openCopyFilterModal)
};
var $08c349e0f7f3127b$export$2e2bcd8739ae039 = (0, $gnQAk.connect)($08c349e0f7f3127b$var$mapStateToPropsFactory, $08c349e0f7f3127b$var$mapDispatchToProps)((0, $8BRiw.default));

});
parcelRegister("8BRiw", function(module, exports) {

$parcel$export(module.exports, "default", () => $2229cd2f5998a18d$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $2sLVw = parcelRequire("2sLVw");

var $jXOgn = parcelRequire("jXOgn");

var $cjMdM = parcelRequire("cjMdM");
function $2229cd2f5998a18d$export$2e2bcd8739ae039(props) {
    const { popularity: popularity } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2sLVw.default), {
        alignItems: "center",
        justifyContent: "space-between"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cjMdM.default), {
        popularity: popularity
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jXOgn.default), props));
}

});
parcelRegister("jXOgn", function(module, exports) {

$parcel$export(module.exports, "default", () => $ed9874f57c720bc0$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $eq3Hf = parcelRequire("eq3Hf");

var $12DRg = parcelRequire("12DRg");

var $Ay1uj = parcelRequire("Ay1uj");

var $7rjYb = parcelRequire("7rjYb");
var $jYYbf = parcelRequire("jYYbf");
var $aLJ1L = parcelRequire("aLJ1L");

var $aMdh8 = parcelRequire("aMdh8");

var $8IeH1 = parcelRequire("8IeH1");
var $2sLVw = parcelRequire("2sLVw");

var $l5htz = parcelRequire("l5htz");

var $aBFKZ = parcelRequire("aBFKZ");

var $6YFG2 = parcelRequire("6YFG2");
var $lRq8t = parcelRequire("lRq8t");

var $7jTnu = parcelRequire("7jTnu");

var $4aSRi = parcelRequire("4aSRi");

var $jd93d = parcelRequire("jd93d");

var $2FtDS = parcelRequire("2FtDS");

var $7kML2 = parcelRequire("7kML2");

var $jfZLN = parcelRequire("jfZLN");
const $ed9874f57c720bc0$var$styles = {
    container: "_1e0c1txw _1bahesu3 _ca0q1b66 _u5f3v77o _n3tdze3t _19bvze3t",
    spinnerContainer: "_4t3i7vkz _1bsb1tcg",
    dropdownWrapper: "_1rjc1b66 _19bvu2gc _u5f3utpp"
};
const $ed9874f57c720bc0$var$DropdownMenuWithAnalytics = (0, $aBFKZ.default)('dropdownMenu', {
    onOpenChange: 'open'
})((0, $7rjYb.default));
const $ed9874f57c720bc0$var$DropdownItemWithAnalytics = (0, $aBFKZ.default)('dropdownItem', {
    onClick: 'clicked'
})((0, $jYYbf.default));
function $ed9874f57c720bc0$var$Actions(props) {
    const { isWritable: isWritable = false, defaultOpen: defaultOpen = false, showSpinner: showSpinner = false, manageSubscriptionsUrl: manageSubscriptionsUrl = '', atlassianAccountId: atlassianAccountId = '', name: name, owner: owner = null, isAdmin: isAdmin = false, filterId: filterId = '', onCopy: onCopy = (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))), onChangeOwner: onChangeOwner = (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))), onEdit: onEdit = (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))), onDelete: onDelete = (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))), onEditFilterClick: onEditFilterClick = (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))), onChangeOwnerFilterClick: onChangeOwnerFilterClick = (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))), onDeleteFilterClick: onDeleteFilterClick = (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))), onManageSubscriptionsClick: onManageSubscriptionsClick = (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))), onCopyFilterClick: onCopyFilterClick = (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))), onOpenCopyFilterModal: onOpenCopyFilterModal = (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))), setReturnFocusTo: setReturnFocusTo = (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))) } = props;
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const [isDropdownOpen, setIsDropdownOpen] = (0, $eJOHy.useState)(defaultOpen);
    const [isCopyFilterModalOpen, setIsCopyFilterModalOpen] = (0, $eJOHy.useState)(false);
    const triggerButtonRef = (0, $eJOHy.useRef)(null);
    (0, $eJOHy.useEffect)(()=>{
        if (props.isCopyFilterModalOpen && !isCopyFilterModalOpen) {
            setIsCopyFilterModalOpen(false);
            if (triggerButtonRef.current) triggerButtonRef.current.focus();
        }
    }, [
        props.isCopyFilterModalOpen,
        isCopyFilterModalOpen
    ]); // @ts-expect-error - TS7031 - Binding element 'isOpen' implicitly has an 'any' type.
    const onOpenChange = ({ isOpen: isOpen })=>{
        setIsDropdownOpen(isOpen);
    }; // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const handleCopyFilterClick = (e, analytics)=>{
        onCopyFilterClick(analytics);
        onCopy();
        onOpenCopyFilterModal();
        setIsCopyFilterModalOpen(true);
    }; // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const handleManageSubscriptionsClick = (e, analytics)=>{
        onManageSubscriptionsClick(analytics);
        delayedClose();
    }; // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const handleEditFilterClick = (e, analytics)=>{
        onEditFilterClick(analytics);
        onEdit();
        triggerButtonRef.current && setReturnFocusTo(triggerButtonRef);
    }; // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const handleChangeOwnerFilterClick = (e, analytics)=>{
        onChangeOwnerFilterClick(analytics);
        onChangeOwner();
        if ((0, $7jTnu.fg)('jfp_a11y_fix_filters_change_owner_modal_focus')) triggerButtonRef.current && setReturnFocusTo(triggerButtonRef);
    }; // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const handleDeleteFilterClick = (e, analytics)=>{
        onDeleteFilterClick(analytics);
        onDelete();
        triggerButtonRef.current && setReturnFocusTo(triggerButtonRef);
    }; /**
      * Close the menu with a minimal delay so the inner handlers are able to react on keypress properly.
      * In its current implementation if we close the menu right away it won't open the focused `href`.
      * Ideally we have to get right of this and few more methods when the bug linked below is fixed.
      * @see https://ecosystem.atlassian.net/browse/AK-4467
      */ 
    const delayedClose = ()=>{
        setTimeout(()=>setIsDropdownOpen(false));
    };
    const renderActions = ()=>{
        const isOwner = owner && owner.accountId === atlassianAccountId; // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const triggerFunction = ({ triggerRef: triggerRef, ...buttonProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $Ay1uj.default), {
                ...buttonProps,
                appearance: "subtle",
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($aMdh8))),
                ref: (0, $jd93d.mergeRefs)(triggerRef, triggerButtonRef),
                isLoading: showSpinner,
                label: name ? formatMessage((0, $2FtDS.default).tooltipWithName, {
                    name: name
                }) : formatMessage((0, $2FtDS.default).tooltip),
                spacing: "compact",
                isTooltipDisabled: false,
                tooltip: {
                    content: formatMessage((0, $2FtDS.default).moreActionsTooltip),
                    hideTooltipOnClick: true
                }
            });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8IeH1.default), {
            xcss: $ed9874f57c720bc0$var$styles.container
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($ed9874f57c720bc0$var$DropdownMenuWithAnalytics // @ts-expect-error - Type '{ children: Element; position: string; isOpen: boolean; onOpenChange: ({ isOpen }: { isOpen: any; }) => void; trigger: ({ triggerRef, ...props }: { [x: string]: any; triggerRef: any; }) => Element; }' is not assignable to type 'IntrinsicAttributes & Omit<{ appearance?: "default" | "tall" | undefined; autoFocus?: boolean | undefined; children?: ReactNode; isLoading?: boolean | undefined; ... 11 more ...; label?: string | undefined; }, keyof WithAnalyticsEventsProps>'.
        , {
            position: "bottom right",
            isOpen: isDropdownOpen,
            onOpenChange: onOpenChange,
            trigger: triggerFunction,
            shouldRenderToParent: true
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aLJ1L.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($ed9874f57c720bc0$var$DropdownItemWithAnalytics, {
            href: manageSubscriptionsUrl,
            onClick: handleManageSubscriptionsClick
        }, formatMessage((0, $2FtDS.default).manageAction)), (0, $7jTnu.fg)('nin-save-filter-dialog-entry-point') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jfZLN.CopyFilterModal), {
            filterId: filterId,
            returnFocusRef: triggerButtonRef
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($ed9874f57c720bc0$var$DropdownItemWithAnalytics, {
            onClick: handleCopyFilterClick
        }, formatMessage((0, $2FtDS.default).copyAction)), (isWritable || isOwner === true) && ((0, $7jTnu.fg)('nin-save-filter-dialog-entry-point') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7kML2.UpdateFilterModal), {
            filterId: filterId,
            returnFocusRef: triggerButtonRef
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($ed9874f57c720bc0$var$DropdownItemWithAnalytics, {
            onClick: handleEditFilterClick
        }, formatMessage((0, $2FtDS.default).editFilter))), (isOwner === true || isAdmin === true) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($ed9874f57c720bc0$var$DropdownItemWithAnalytics, {
            onClick: handleChangeOwnerFilterClick
        }, formatMessage((0, $2FtDS.default).changeOwner)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($ed9874f57c720bc0$var$DropdownItemWithAnalytics, {
            onClick: handleDeleteFilterClick
        }, formatMessage((0, $2FtDS.default).deleteFilter))))));
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2sLVw.default), {
        justifyContent: "end",
        xcss: $ed9874f57c720bc0$var$styles.dropdownWrapper
    }, renderActions());
}
const $ed9874f57c720bc0$var$ActionsWithReturnToFocus = (props)=>{
    const { setReturnFocusTo: setReturnFocusTo } = (0, $4aSRi.useModalDialogActions)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($ed9874f57c720bc0$var$Actions, {
        ...props,
        setReturnFocusTo: setReturnFocusTo
    });
};
var $ed9874f57c720bc0$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($eq3Hf)))((0, $6YFG2.default), (0, $l5htz.default)({
    onManageSubscriptionsClick: 'manageSubscriptions',
    onCopyFilterClick: 'copy',
    onChangeOwnerFilterClick: 'changeOwner',
    onEditFilterClick: 'edit',
    onDeleteFilterClick: 'delete'
}))($ed9874f57c720bc0$var$ActionsWithReturnToFocus);

});
parcelRegister("jfZLN", function(module, exports) {

$parcel$export(module.exports, "CopyFilterModal", () => $aba1b0911ede9da1$export$e1a16c2627fcf92b);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $lRq8t = parcelRequire("lRq8t");

var $KwCgo = parcelRequire("KwCgo");

var $4NoAT = parcelRequire("4NoAT");

var $kEUB1 = parcelRequire("kEUB1");

var $4ihOZ = parcelRequire("4ihOZ");

var $5cBQu = parcelRequire("5cBQu");


var $91zZ6 = parcelRequire("91zZ6");

var $gCeeo = parcelRequire("gCeeo");
var $ftN6c = parcelRequire("ftN6c");

var $d1S9l = parcelRequire("d1S9l");

var $2FtDS = parcelRequire("2FtDS");
const $aba1b0911ede9da1$export$e1a16c2627fcf92b = ({ filterId: filterId, returnFocusRef: returnFocusRef })=>{
    const cloudId = (0, $kEUB1.useCloudId)();
    const activationId = (0, $4ihOZ.useActivationId)();
    const dispatch = (0, $91zZ6.useDirectoryDispatch)();
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const entryPointProps = (0, $eJOHy.useMemo)(()=>({
            filterId: filterId,
            title: formatMessage((0, $2FtDS.default).copyAction),
            onDialogShown: ()=>{
                dispatch((0, $5cBQu.initiate)({
                    id: filterId,
                    operation: (0, $85bfce414eef38c7$export$92f9e1ed9114d3a6),
                    childEntityId: undefined
                }));
                dispatch((0, $5cBQu.dialogShown)({
                    id: filterId,
                    operation: (0, $85bfce414eef38c7$export$92f9e1ed9114d3a6),
                    childEntityId: undefined
                }));
            },
            onSuccess: ()=>dispatch((0, $5cBQu.entityUpdated)({
                    id: filterId,
                    operation: (0, $85bfce414eef38c7$export$92f9e1ed9114d3a6)
                })),
            onClose: ()=>{
                dispatch((0, $5cBQu.cancelled)({
                    id: filterId,
                    operation: (0, $85bfce414eef38c7$export$92f9e1ed9114d3a6)
                }));
                requestAnimationFrame(()=>{
                    returnFocusRef.current?.focus();
                });
            }
        }), [
        filterId,
        formatMessage,
        dispatch,
        returnFocusRef
    ]);
    const entryPointParams = (0, $eJOHy.useMemo)(()=>({
            filterAri: (0, $4NoAT.JiraFilterAri).create({
                activationId: activationId,
                siteId: cloudId,
                filterId: filterId
            }).toString()
        }), [
        filterId,
        cloudId,
        activationId
    ]);
    const onClick = (0, $eJOHy.useCallback)(()=>(0, $gCeeo.fireUIAnalytics)(createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'dropdownItem'
        }), 'copyDropdownItem'), [
        createAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $d1S9l.ModalEntryPointDropdownItemTrigger), {
        onClick: onClick,
        modalProps: {
            width: 'medium',
            shouldScrollInViewport: true,
            shouldReturnFocus: false
        },
        entryPoint: (0, $KwCgo.saveFilterDialogEntryPoint),
        entryPointProps: entryPointProps,
        entryPointParams: entryPointParams,
        interactionName: "jiraSaveFilterDialog.SaveFilter",
        useInternalModal: true
    }, formatMessage((0, $2FtDS.default).copyAction));
};

});







parcelRegister("lA4uT", function(module, exports) {

$parcel$export(module.exports, "checkAndEmitApdexSignal", () => $70fb2661bfe02c7c$export$3082c88b693a5230);
$parcel$export(module.exports, "default", () => $70fb2661bfe02c7c$export$2e2bcd8739ae039);
$parcel$export(module.exports, "baseDefaultProps", () => $70fb2661bfe02c7c$export$9b3029ee6188a41f);

var $eJOHy = parcelRequire("eJOHy");

var $2gvG4 = parcelRequire("2gvG4");

var $6whQo = parcelRequire("6whQo");

var $kVpZx = parcelRequire("kVpZx");

var $ioEQd = parcelRequire("ioEQd");

var $4l9pO = parcelRequire("4l9pO");

var $2UxSQ = parcelRequire("2UxSQ");

var $jPcl6 = parcelRequire("jPcl6");

var $9j9F7 = parcelRequire("9j9F7");

var $jSrj1 = parcelRequire("jSrj1");
const $70fb2661bfe02c7c$export$3082c88b693a5230 = (appName, metricKey)=>{
    var emitSignal;
};
class $70fb2661bfe02c7c$export$2e2bcd8739ae039 extends (0, $eJOHy.Component) {
    static{
        this.defaultProps = {
            isExpectedToHaveSsr: false,
            withMarks: [],
            extra: {},
            emitOnAnimationFrame: false
        };
    }
    render() {
        const { appName: appName, metricKey: metricKey, extra: extra, metric: metric, emitOnAnimationFrame: emitOnAnimationFrame } = this.props;
        $70fb2661bfe02c7c$export$3082c88b693a5230(appName, metricKey);
        const isUFODefined = (0, $ioEQd.GlobalPageLoadExperience).loadingPageLoadId !== 'UNKNOWN';
        if (isUFODefined) (0, $9j9F7.addUFOSSRDoneAsFMPToInteraction)();
        if (metric) {
            // https://product-fabric.atlassian.net/browse/UFO-323
            (0, $jPcl6.addBM3SSRDoneAsFMPToInteraction)(metric);
            (0, $jSrj1.trackBM3FeatureFlagsAccessed)(metric);
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2gvG4.default), {
            data: extra
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6whQo.UFOBM3TimingsToUFO), {
            marks: metric?.getData()?.marks,
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            timings: metric?.getData()?.config?.timings
        }), isUFODefined ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2UxSQ.StopUfo), {
            appName: appName,
            customData: extra,
            key: (0, $kVpZx.getInteractionId)().current
        }) : metric && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4l9pO.StopBrowserMetrics3), {
            metric: metric,
            customData: extra,
            emitOnAnimationFrame: emitOnAnimationFrame
        }));
    }
}
const $70fb2661bfe02c7c$export$9b3029ee6188a41f = $70fb2661bfe02c7c$export$2e2bcd8739ae039.defaultProps;

});
parcelRegister("6whQo", function(module, exports) {

$parcel$export(module.exports, "getBm3Timings", () => $3708d872c36dd1bb$export$f02972da195a43bb);
$parcel$export(module.exports, "UFOBM3TimingsToUFO", () => $3708d872c36dd1bb$export$30f0b5e5acd268bf);
$parcel$export(module.exports, "addBM3TimingsToUFO", () => $3708d872c36dd1bb$export$d93d677ef2f33c5c);

var $eJOHy = parcelRequire("eJOHy");

var $7aoMz = parcelRequire("7aoMz");

var $kVpZx = parcelRequire("kVpZx");

var $2QO3b = parcelRequire("2QO3b");
function $3708d872c36dd1bb$export$f02972da195a43bb(marks, timingConfigs) {
    const bm3Timings = {};
    if (!marks || !timingConfigs) return bm3Timings;
    timingConfigs.forEach((item)=>{
        if (!item.startMark || !item.endMark) return;
        const startTime = marks[item.startMark];
        if (!startTime) return;
        const endTime = marks[item.endMark];
        if (!endTime) return;
        bm3Timings[item.key] = {
            startTime: startTime,
            endTime: endTime
        };
    });
    return bm3Timings;
}
function $3708d872c36dd1bb$export$30f0b5e5acd268bf({ marks: marks, timings: timings }) {
    const interactionContext = (0, $eJOHy.useContext)((0, $7aoMz.default));
    const interactionId = (0, $kVpZx.getInteractionId)().current;
    (0, $eJOHy.useMemo)(()=>{
        if (interactionContext != null && interactionId != null && marks != null && timings != null) {
            const interactionType = (0, $2QO3b.getCurrentInteractionType)(interactionId);
            if (interactionType === 'press') return;
            const bm3Timings = $3708d872c36dd1bb$export$f02972da195a43bb(marks, timings);
            interactionContext.addCustomTimings(bm3Timings);
        }
    }, [
        interactionContext,
        interactionId,
        marks,
        timings
    ]);
    return null;
}
function $3708d872c36dd1bb$export$d93d677ef2f33c5c(marks, timingsConfig) {
    const interactionId = (0, $kVpZx.getInteractionId)().current;
    if (interactionId) {
        const interactionType = (0, $2QO3b.getCurrentInteractionType)(interactionId);
        if (interactionType === 'press') return;
        const bm3Timings = $3708d872c36dd1bb$export$f02972da195a43bb(marks, timingsConfig);
        (0, $2QO3b.addCustomTiming)(interactionId, [], bm3Timings);
    }
}

});

parcelRegister("4l9pO", function(module, exports) {

$parcel$export(module.exports, "StopBrowserMetrics3", () => $4802f5e968b3fe62$export$575e93c0f9905999);

var $eJOHy = parcelRequire("eJOHy");

var $7aoMz = parcelRequire("7aoMz");

var $k04JP = parcelRequire("k04JP");

var $6uWhG = parcelRequire("6uWhG");

var $2HxHL = parcelRequire("2HxHL");

var $akiS9 = parcelRequire("akiS9");

var $dydef = parcelRequire("dydef");

var $9DwQv = parcelRequire("9DwQv");

const $4802f5e968b3fe62$var$emitMetrics = (metric, customData, stopTime)=>{
    (0, $dydef.setInitialPageLoadTimingFromPerformanceMarks)('batch-js-heritage.eval', 'jira.heritage_batch_file_eval:start', 'jira.heritage_batch_file_eval:end');
    if (stopTime !== undefined) metric.stop({
        customData: customData,
        stopTime: stopTime
    });
    else metric.stop({
        customData: customData
    });
    if ((0, $9DwQv.isAutomaticExposureCollectionEnabled)()) (0, $2HxHL.stopLowPriorityEventDelay)();
};
class $4802f5e968b3fe62$export$575e93c0f9905999 extends (0, $eJOHy.Component) {
    componentDidMount() {
        const { metric: metric, customData: customData, emitOnAnimationFrame: emitOnAnimationFrame } = this.props;
        if (!metric) return;
        const start = (0, $k04JP.browserMetrics).getPageLoadMetric()?.getData()?.start || 0;
        (0, $6uWhG.setMark)('BROWSER_METRICS_TTI_START', {
            startTime: start
        });
        (0, $6uWhG.setMark)('BROWSER_METRICS_TTI_END');
        (0, $6uWhG.setMeasure)('BROWSER_METRICS_TTI', 'BROWSER_METRICS_TTI_START', 'BROWSER_METRICS_TTI_END');
        const bm3Data = metric.getData();
        if (emitOnAnimationFrame) {
            const stopTime = performance.now();
            (0, $dydef.stopInitialPageLoadTimingFromPerformanceMarkStart)('product', (0, $akiS9.PRODUCT_START_MARK), true);
            if (bm3Data) this.context?.addApdex({
                key: bm3Data.key,
                startTime: bm3Data.start,
                stopTime: stopTime
            });
            if (typeof queueMicrotask !== 'undefined') queueMicrotask(()=>{
                (0, $6uWhG.setMark)('BROWSER_METRICS_TTI_TASK_END');
                (0, $6uWhG.setMeasure)('BROWSER_METRICS_TTI_TASK', 'BROWSER_METRICS_TTI_START', 'BROWSER_METRICS_TTI_TASK_END');
            });
            requestAnimationFrame(()=>{
                metric.mark((0, $2e47af044bce450a$export$99c08ec92759c71c));
                (0, $6uWhG.setMark)((0, $2e47af044bce450a$export$99c08ec92759c71c));
                (0, $6uWhG.setMeasure)('BROWSER_METRICS_TTI_RAF', 'BROWSER_METRICS_TTI_START', (0, $2e47af044bce450a$export$99c08ec92759c71c));
                setTimeout(()=>{
                    $4802f5e968b3fe62$var$emitMetrics(metric, customData, stopTime);
                }, 500);
            });
        } else {
            if (bm3Data) this.context?.addApdex({
                key: bm3Data.key,
                startTime: bm3Data.start,
                stopTime: performance.now()
            });
            (0, $dydef.stopInitialPageLoadTimingFromPerformanceMarkStart)('product', (0, $akiS9.PRODUCT_START_MARK), true);
            $4802f5e968b3fe62$var$emitMetrics(metric, customData);
        }
    }
    static{
        this.contextType = (0, $7aoMz.default);
    }
    render() {
        return null;
    }
}

});
const $2e47af044bce450a$export$56940a9488e85199 = 'jira.fe.spa-';
const $2e47af044bce450a$export$45c4b6bf7935c69a = `${$2e47af044bce450a$export$56940a9488e85199}start`;
const $2e47af044bce450a$export$135c96ab5afee429 = 'ssr.spa.rendered';
const $2e47af044bce450a$export$ff834eccc35b9089 = 'appBundleReady';
const $2e47af044bce450a$export$86b05e34d462ead8 = 'prefetchApiReady';
const $2e47af044bce450a$export$d6a604a7d9a390fb = 'prefetchApiStart';
const $2e47af044bce450a$export$3ae43cc1782d058f = 'jswRenderStart';
const $2e47af044bce450a$export$363f6703ffa600be = 'jswCreateReduxStoreStart';
const $2e47af044bce450a$export$e87b74567b79c8 = 'jswCreateReduxStoreEnd';
const $2e47af044bce450a$export$99fe642459a8b02 = 'jswTransformCriticalDataStart';
const $2e47af044bce450a$export$ab1f5705fc8e0571 = 'jswTransformCriticalDataEnd';
const $2e47af044bce450a$export$8c3a9046da692c35 = 'jswReduxSoftwareAppLoadedStart';
const $2e47af044bce450a$export$5aa497d1efdcc5bf = 'jswReduxSoftwareAppLoadedEnd';
const $2e47af044bce450a$export$99c08ec92759c71c = 'tti-raf-mark';
const $2e47af044bce450a$export$48552baa9db8ce1d = 'tti-raf';


parcelRegister("2UxSQ", function(module, exports) {

$parcel$export(module.exports, "StopUfo", () => $9ca3da1474781c5a$export$d91154f099475c5);

var $eJOHy = parcelRequire("eJOHy");

var $7aoMz = parcelRequire("7aoMz");

var $ioEQd = parcelRequire("ioEQd");
class $9ca3da1474781c5a$export$d91154f099475c5 extends (0, $eJOHy.Component) {
    componentDidMount() {
        const { customData: customData, appName: appName } = this.props;
        (0, $ioEQd.GlobalPageLoadExperience).success({
            force: true,
            metadata: customData
        });
        const name = appName || (0, $ioEQd.GlobalPageLoadExperience).loadingPageLoadId;
        if (name) this.context?.addApdex({
            key: name,
            stopTime: performance.now()
        });
    }
    static{
        this.contextType = (0, $7aoMz.default);
    }
    render() {
        return null;
    }
}

});

parcelRegister("jPcl6", function(module, exports) {

$parcel$export(module.exports, "addBM3SSRDoneAsFMPToInteraction", () => $9af3d786d904c43c$export$bf239ac2bfb04967);

var $kVpZx = parcelRequire("kVpZx");

var $2QO3b = parcelRequire("2QO3b");
function $9af3d786d904c43c$export$bf239ac2bfb04967(metric) {
    const interactionId = (0, $kVpZx.getInteractionId)();
    const currentInteractionId = interactionId.current;
    if (!currentInteractionId) return;
    const data = metric.getData();
    // Use BM3 SSR mark as FMP config for UFO if it exists, temporarily.
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const config = data?.config;
    if (config && data?.isInitial) (0, $2QO3b.addMetadata)(currentInteractionId, {
        __legacy__bm3ConfigSSRDoneAsFmp: config.ssr?.doneAsFmp || false
    });
}

});

parcelRegister("9j9F7", function(module, exports) {

$parcel$export(module.exports, "addUFOSSRDoneAsFMPToInteraction", () => $79450f1fef3080e8$export$e63862cd888fe05a);

var $kVpZx = parcelRequire("kVpZx");

var $2QO3b = parcelRequire("2QO3b");

var $ioEQd = parcelRequire("ioEQd");
var $8tVkR = parcelRequire("8tVkR");
async function $79450f1fef3080e8$export$e63862cd888fe05a() {
    const interactionId = (0, $kVpZx.getInteractionId)();
    const currentInteractionId = interactionId.current;
    if (!currentInteractionId) return;
    // Use UFO SSR mark as FMP config for rUFO if it exists, temporarily.
    const data = await (0, $ioEQd.GlobalPageLoadExperience).exportData();
    const fmpMark = data.metrics.marks.find((mark)=>mark.name === 'fmp') || (0, $8tVkR.payloadPublisher).ssr?.getDoneMark();
    if (data.initial && fmpMark) (0, $2QO3b.addMetadata)(currentInteractionId, {
        __legacy__ufoConfigSSRDoneAsFmp: true
    });
}

});

parcelRegister("jSrj1", function(module, exports) {

$parcel$export(module.exports, "trackBM3FeatureFlagsAccessed", () => $0af00334d248807d$export$f00f1e874ce869e9);

var $kVpZx = parcelRequire("kVpZx");

var $j500r = parcelRequire("j500r");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $0af00334d248807d$var$startsAsObject = (value)=>{
    try {
        if (value.charAt(0) === '{') return true;
    } catch (e) {
        return false;
    }
    return false;
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $0af00334d248807d$var$isObject = (value)=>value && typeof value === 'object' && value.constructor === Object;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $0af00334d248807d$var$isString = (input)=>{
    let result;
    try {
        result = typeof input === 'string' || input instanceof String;
    } catch (err) {
        // swallow any errors
        result = false;
    }
    return result;
};
const $0af00334d248807d$export$7b4abba432e57989 = (value)=>$0af00334d248807d$var$isString(value) && $0af00334d248807d$var$startsAsObject(value) || $0af00334d248807d$var$isObject(value);
const $0af00334d248807d$export$fcc03ee4c944962f = (featureFlagValue)=>$0af00334d248807d$export$7b4abba432e57989(featureFlagValue) ? 'non_boolean' : featureFlagValue;
const $0af00334d248807d$export$d2818866b4acbea4 = new Map();
const $0af00334d248807d$export$f00f1e874ce869e9 = (metric)=>{
    const interactionId = (0, $kVpZx.getInteractionId)();
    const currentInteractionId = interactionId.current;
    if (!currentInteractionId) return;
    const data = metric.getData();
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const config = data?.config;
    if (config && config?.featureFlags?.length) {
        const allFeatureFlags = (0, $j500r.default)();
        config.featureFlags.forEach((featureFlagName)=>{
            const value = allFeatureFlags[featureFlagName];
            if (value === undefined) return;
            const featureFlagValue = $0af00334d248807d$export$fcc03ee4c944962f(value);
            $0af00334d248807d$export$d2818866b4acbea4.set(featureFlagName, featureFlagValue);
        });
    }
};

});


parcelRegister("gWu57", function(module, exports) {

$parcel$export(module.exports, "ScrollablePage", () => $3970ca9ce19c6445$export$8d7a30196b47fe34);
$parcel$export(module.exports, "PageLayout", () => $3970ca9ce19c6445$export$6d1402fb58384e4f);

var $eJOHy = parcelRequire("eJOHy");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $6XJko = parcelRequire("6XJko");
const $3970ca9ce19c6445$export$8d7a30196b47fe34 = ({ children: children, ...rest })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        testId: rest['data-testid'] || 'spa-apps-page-layout.page.scrollable-page',
        xcss: $3970ca9ce19c6445$var$scrollablePageStyles,
        paddingBlock: "space.0",
        paddingInline: (0, $6XJko.isVisualRefreshEnabled)() ? 'space.300' : 'space.500'
    }, children);
const $3970ca9ce19c6445$export$6d1402fb58384e4f = ({ children: children, hideMargin: hideMargin, ...rest })=>{
    const isVisualRefresh = (0, $6XJko.isVisualRefreshEnabled)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        testId: rest['data-testid'] || 'spa-apps-page-layout.page.page-layout',
        xcss: // eslint-disable-next-line no-nested-ternary
        hideMargin ? $3970ca9ce19c6445$var$pageLayoutWithoutMarginStyles : isVisualRefresh ? $3970ca9ce19c6445$var$pageLayoutWithMarginStyles : $3970ca9ce19c6445$var$pageLayoutWithMarginStylesOld
    }, children);
};
const $3970ca9ce19c6445$var$scrollablePageStyles = (0, $1DXK0.xcss)({
    minWidth: '800px',
    margin: 'space.0'
});
const $3970ca9ce19c6445$var$pageLayoutWithoutMarginStyles = (0, $1DXK0.xcss)({
    margin: 'space.0'
});
const $3970ca9ce19c6445$var$pageLayoutWithMarginStylesOld = (0, $1DXK0.xcss)({
    marginBlock: '0',
    marginInline: 'space.500'
});
const $3970ca9ce19c6445$var$pageLayoutWithMarginStyles = (0, $1DXK0.xcss)({
    marginBlock: '0',
    marginInline: 'space.300'
});

});

parcelRegister("68uoM", function(module, exports) {

$parcel$export(module.exports, "filtersDirectoryPageLoad", () => $80146930b3fab4b6$export$4545feeca18b385d);

var $hqYEY = parcelRequire("hqYEY");
const $80146930b3fab4b6$export$4545feeca18b385d = (0, $hqYEY.metrics).pageLoad({
    key: 'filters-directory',
    ssr: {
        doneAsFmp: true
    }
});

});





//# sourceMappingURL=async-filters-directory.b451b781.js.map
